
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire01f2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire01f2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aF92j", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $7c34be22ef19438c$export$ffb0004e005737fa; }, function (v) { return $7c34be22ef19438c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $7c34be22ef19438c$export$34b9dba7ce09269b; }, function (v) { return $7c34be22ef19438c$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $7c34be22ef19438c$export$25062201e9e25d76; }, function (v) { return $7c34be22ef19438c$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7c34be22ef19438c$export$ffb0004e005737fa;
var $7c34be22ef19438c$export$34b9dba7ce09269b;
var $7c34be22ef19438c$export$25062201e9e25d76;
'use strict';

var $cQNHH = parcelRequire("cQNHH");
var $7c34be22ef19438c$var$k = Symbol.for("react.element"), $7c34be22ef19438c$var$l = Symbol.for("react.fragment"), $7c34be22ef19438c$var$m = Object.prototype.hasOwnProperty, $7c34be22ef19438c$var$n = $cQNHH.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7c34be22ef19438c$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7c34be22ef19438c$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7c34be22ef19438c$var$m.call(a, b) && !$7c34be22ef19438c$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7c34be22ef19438c$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7c34be22ef19438c$var$n.current
    };
}
$7c34be22ef19438c$export$ffb0004e005737fa = $7c34be22ef19438c$var$l;
$7c34be22ef19438c$export$34b9dba7ce09269b = $7c34be22ef19438c$var$q;
$7c34be22ef19438c$export$25062201e9e25d76 = $7c34be22ef19438c$var$q;

});
parcelRegister("cQNHH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("c2VSo"));

});
parcelRegister("c2VSo", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0243656f51a2fb4f$export$dca3b0875bd9a954; }, function (v) { return $0243656f51a2fb4f$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0243656f51a2fb4f$export$16fa2f45be04daa8; }, function (v) { return $0243656f51a2fb4f$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0243656f51a2fb4f$export$ffb0004e005737fa; }, function (v) { return $0243656f51a2fb4f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0243656f51a2fb4f$export$e2c29f18771995cb; }, function (v) { return $0243656f51a2fb4f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0243656f51a2fb4f$export$221d75b3f55bb0bd; }, function (v) { return $0243656f51a2fb4f$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0243656f51a2fb4f$export$5f8d39834fd61797; }, function (v) { return $0243656f51a2fb4f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0243656f51a2fb4f$export$74bf444e3cd11ea5; }, function (v) { return $0243656f51a2fb4f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0243656f51a2fb4f$export$ae55be85d98224ed; }, function (v) { return $0243656f51a2fb4f$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0243656f51a2fb4f$export$e530037191fcd5d7; }, function (v) { return $0243656f51a2fb4f$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0243656f51a2fb4f$export$fd42f52fd3ae1109; }, function (v) { return $0243656f51a2fb4f$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0243656f51a2fb4f$export$c8a8987d4410bf2d; }, function (v) { return $0243656f51a2fb4f$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $0243656f51a2fb4f$export$d38cd72104c1f0e9; }, function (v) { return $0243656f51a2fb4f$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $0243656f51a2fb4f$export$7d1e3a5e95ceca43; }, function (v) { return $0243656f51a2fb4f$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0243656f51a2fb4f$export$257a8862b851cb5b; }, function (v) { return $0243656f51a2fb4f$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0243656f51a2fb4f$export$a8257692ac88316c; }, function (v) { return $0243656f51a2fb4f$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0243656f51a2fb4f$export$488013bae63b21da; }, function (v) { return $0243656f51a2fb4f$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0243656f51a2fb4f$export$7c73462e0d25e514; }, function (v) { return $0243656f51a2fb4f$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0243656f51a2fb4f$export$7568632d0d33d16d; }, function (v) { return $0243656f51a2fb4f$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $0243656f51a2fb4f$export$88948ce120ea2619; }, function (v) { return $0243656f51a2fb4f$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0243656f51a2fb4f$export$35808ee640e87ca7; }, function (v) { return $0243656f51a2fb4f$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0243656f51a2fb4f$export$fae74005e78b1a27; }, function (v) { return $0243656f51a2fb4f$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0243656f51a2fb4f$export$dc8fbce3eb94dc1e; }, function (v) { return $0243656f51a2fb4f$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0243656f51a2fb4f$export$6a7bc4e911dc01cf; }, function (v) { return $0243656f51a2fb4f$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0243656f51a2fb4f$export$6d9c69b0de29b591; }, function (v) { return $0243656f51a2fb4f$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $0243656f51a2fb4f$export$f680877a34711e37; }, function (v) { return $0243656f51a2fb4f$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0243656f51a2fb4f$export$d5a552a76deda3c2; }, function (v) { return $0243656f51a2fb4f$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0243656f51a2fb4f$export$aaabe4eda9ed9969; }, function (v) { return $0243656f51a2fb4f$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0243656f51a2fb4f$export$e5c5a5f917a5871c; }, function (v) { return $0243656f51a2fb4f$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0243656f51a2fb4f$export$1538c33de8887b59; }, function (v) { return $0243656f51a2fb4f$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $0243656f51a2fb4f$export$13e3392192263954; }, function (v) { return $0243656f51a2fb4f$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0243656f51a2fb4f$export$b8f5890fc79d6aca; }, function (v) { return $0243656f51a2fb4f$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0243656f51a2fb4f$export$60241385465d0a34; }, function (v) { return $0243656f51a2fb4f$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0243656f51a2fb4f$export$306c0aa65ff9ec16; }, function (v) { return $0243656f51a2fb4f$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0243656f51a2fb4f$export$7b286972b8d8ccbf; }, function (v) { return $0243656f51a2fb4f$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0243656f51a2fb4f$export$83d89fbfd8236492; }, function (v) { return $0243656f51a2fb4f$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0243656f51a2fb4f$export$dca3b0875bd9a954;
var $0243656f51a2fb4f$export$16fa2f45be04daa8;
var $0243656f51a2fb4f$export$ffb0004e005737fa;
var $0243656f51a2fb4f$export$e2c29f18771995cb;
var $0243656f51a2fb4f$export$221d75b3f55bb0bd;
var $0243656f51a2fb4f$export$5f8d39834fd61797;
var $0243656f51a2fb4f$export$74bf444e3cd11ea5;
var $0243656f51a2fb4f$export$ae55be85d98224ed;
var $0243656f51a2fb4f$export$e530037191fcd5d7;
var $0243656f51a2fb4f$export$fd42f52fd3ae1109;
var $0243656f51a2fb4f$export$c8a8987d4410bf2d;
var $0243656f51a2fb4f$export$d38cd72104c1f0e9;
var $0243656f51a2fb4f$export$7d1e3a5e95ceca43;
var $0243656f51a2fb4f$export$257a8862b851cb5b;
var $0243656f51a2fb4f$export$a8257692ac88316c;
var $0243656f51a2fb4f$export$488013bae63b21da;
var $0243656f51a2fb4f$export$7c73462e0d25e514;
var $0243656f51a2fb4f$export$7568632d0d33d16d;
var $0243656f51a2fb4f$export$88948ce120ea2619;
var $0243656f51a2fb4f$export$35808ee640e87ca7;
var $0243656f51a2fb4f$export$fae74005e78b1a27;
var $0243656f51a2fb4f$export$dc8fbce3eb94dc1e;
var $0243656f51a2fb4f$export$6a7bc4e911dc01cf;
var $0243656f51a2fb4f$export$6d9c69b0de29b591;
var $0243656f51a2fb4f$export$f680877a34711e37;
var $0243656f51a2fb4f$export$d5a552a76deda3c2;
var $0243656f51a2fb4f$export$aaabe4eda9ed9969;
var $0243656f51a2fb4f$export$e5c5a5f917a5871c;
var $0243656f51a2fb4f$export$1538c33de8887b59;
var $0243656f51a2fb4f$export$13e3392192263954;
var $0243656f51a2fb4f$export$b8f5890fc79d6aca;
var $0243656f51a2fb4f$export$60241385465d0a34;
var $0243656f51a2fb4f$export$306c0aa65ff9ec16;
var $0243656f51a2fb4f$export$7b286972b8d8ccbf;
var $0243656f51a2fb4f$export$83d89fbfd8236492;
'use strict';
var $0243656f51a2fb4f$var$l = Symbol.for("react.element"), $0243656f51a2fb4f$var$n = Symbol.for("react.portal"), $0243656f51a2fb4f$var$p = Symbol.for("react.fragment"), $0243656f51a2fb4f$var$q = Symbol.for("react.strict_mode"), $0243656f51a2fb4f$var$r = Symbol.for("react.profiler"), $0243656f51a2fb4f$var$t = Symbol.for("react.provider"), $0243656f51a2fb4f$var$u = Symbol.for("react.context"), $0243656f51a2fb4f$var$v = Symbol.for("react.forward_ref"), $0243656f51a2fb4f$var$w = Symbol.for("react.suspense"), $0243656f51a2fb4f$var$x = Symbol.for("react.memo"), $0243656f51a2fb4f$var$y = Symbol.for("react.lazy"), $0243656f51a2fb4f$var$z = Symbol.iterator;
function $0243656f51a2fb4f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0243656f51a2fb4f$var$z && a[$0243656f51a2fb4f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0243656f51a2fb4f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0243656f51a2fb4f$var$C = Object.assign, $0243656f51a2fb4f$var$D = {};
function $0243656f51a2fb4f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0243656f51a2fb4f$var$D;
    this.updater = e || $0243656f51a2fb4f$var$B;
}
$0243656f51a2fb4f$var$E.prototype.isReactComponent = {};
$0243656f51a2fb4f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0243656f51a2fb4f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0243656f51a2fb4f$var$F() {}
$0243656f51a2fb4f$var$F.prototype = $0243656f51a2fb4f$var$E.prototype;
function $0243656f51a2fb4f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0243656f51a2fb4f$var$D;
    this.updater = e || $0243656f51a2fb4f$var$B;
}
var $0243656f51a2fb4f$var$H = $0243656f51a2fb4f$var$G.prototype = new $0243656f51a2fb4f$var$F;
$0243656f51a2fb4f$var$H.constructor = $0243656f51a2fb4f$var$G;
$0243656f51a2fb4f$var$C($0243656f51a2fb4f$var$H, $0243656f51a2fb4f$var$E.prototype);
$0243656f51a2fb4f$var$H.isPureReactComponent = !0;
var $0243656f51a2fb4f$var$I = Array.isArray, $0243656f51a2fb4f$var$J = Object.prototype.hasOwnProperty, $0243656f51a2fb4f$var$K = {
    current: null
}, $0243656f51a2fb4f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0243656f51a2fb4f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0243656f51a2fb4f$var$J.call(b, d) && !$0243656f51a2fb4f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0243656f51a2fb4f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0243656f51a2fb4f$var$K.current
    };
}
function $0243656f51a2fb4f$var$N(a, b) {
    return {
        $$typeof: $0243656f51a2fb4f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0243656f51a2fb4f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0243656f51a2fb4f$var$l;
}
function $0243656f51a2fb4f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0243656f51a2fb4f$var$P = /\/+/g;
function $0243656f51a2fb4f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0243656f51a2fb4f$var$escape("" + a.key) : b.toString(36);
}
function $0243656f51a2fb4f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0243656f51a2fb4f$var$l:
                case $0243656f51a2fb4f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0243656f51a2fb4f$var$Q(h, 0) : d, $0243656f51a2fb4f$var$I(c) ? (e = "", null != a && (e = a.replace($0243656f51a2fb4f$var$P, "$&/") + "/"), $0243656f51a2fb4f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0243656f51a2fb4f$var$O(c) && (c = $0243656f51a2fb4f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0243656f51a2fb4f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0243656f51a2fb4f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0243656f51a2fb4f$var$Q(k, g);
        h += $0243656f51a2fb4f$var$R(k, b, e, f, c);
    }
    else if (f = $0243656f51a2fb4f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0243656f51a2fb4f$var$Q(k, g++), h += $0243656f51a2fb4f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0243656f51a2fb4f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0243656f51a2fb4f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0243656f51a2fb4f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0243656f51a2fb4f$var$U = {
    current: null
}, $0243656f51a2fb4f$var$V = {
    transition: null
}, $0243656f51a2fb4f$var$W = {
    ReactCurrentDispatcher: $0243656f51a2fb4f$var$U,
    ReactCurrentBatchConfig: $0243656f51a2fb4f$var$V,
    ReactCurrentOwner: $0243656f51a2fb4f$var$K
};
$0243656f51a2fb4f$export$dca3b0875bd9a954 = {
    map: $0243656f51a2fb4f$var$S,
    forEach: function(a, b, e) {
        $0243656f51a2fb4f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0243656f51a2fb4f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0243656f51a2fb4f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0243656f51a2fb4f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0243656f51a2fb4f$export$16fa2f45be04daa8 = $0243656f51a2fb4f$var$E;
$0243656f51a2fb4f$export$ffb0004e005737fa = $0243656f51a2fb4f$var$p;
$0243656f51a2fb4f$export$e2c29f18771995cb = $0243656f51a2fb4f$var$r;
$0243656f51a2fb4f$export$221d75b3f55bb0bd = $0243656f51a2fb4f$var$G;
$0243656f51a2fb4f$export$5f8d39834fd61797 = $0243656f51a2fb4f$var$q;
$0243656f51a2fb4f$export$74bf444e3cd11ea5 = $0243656f51a2fb4f$var$w;
$0243656f51a2fb4f$export$ae55be85d98224ed = $0243656f51a2fb4f$var$W;
$0243656f51a2fb4f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0243656f51a2fb4f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0243656f51a2fb4f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0243656f51a2fb4f$var$J.call(b, f) && !$0243656f51a2fb4f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0243656f51a2fb4f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0243656f51a2fb4f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0243656f51a2fb4f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0243656f51a2fb4f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0243656f51a2fb4f$export$c8a8987d4410bf2d = $0243656f51a2fb4f$var$M;
$0243656f51a2fb4f$export$d38cd72104c1f0e9 = function(a) {
    var b = $0243656f51a2fb4f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0243656f51a2fb4f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0243656f51a2fb4f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0243656f51a2fb4f$var$v,
        render: a
    };
};
$0243656f51a2fb4f$export$a8257692ac88316c = $0243656f51a2fb4f$var$O;
$0243656f51a2fb4f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0243656f51a2fb4f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0243656f51a2fb4f$var$T
    };
};
$0243656f51a2fb4f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0243656f51a2fb4f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0243656f51a2fb4f$export$7568632d0d33d16d = function(a) {
    var b = $0243656f51a2fb4f$var$V.transition;
    $0243656f51a2fb4f$var$V.transition = {};
    try {
        a();
    } finally{
        $0243656f51a2fb4f$var$V.transition = b;
    }
};
$0243656f51a2fb4f$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$0243656f51a2fb4f$export$35808ee640e87ca7 = function(a, b) {
    return $0243656f51a2fb4f$var$U.current.useCallback(a, b);
};
$0243656f51a2fb4f$export$fae74005e78b1a27 = function(a) {
    return $0243656f51a2fb4f$var$U.current.useContext(a);
};
$0243656f51a2fb4f$export$dc8fbce3eb94dc1e = function() {};
$0243656f51a2fb4f$export$6a7bc4e911dc01cf = function(a) {
    return $0243656f51a2fb4f$var$U.current.useDeferredValue(a);
};
$0243656f51a2fb4f$export$6d9c69b0de29b591 = function(a, b) {
    return $0243656f51a2fb4f$var$U.current.useEffect(a, b);
};
$0243656f51a2fb4f$export$f680877a34711e37 = function() {
    return $0243656f51a2fb4f$var$U.current.useId();
};
$0243656f51a2fb4f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0243656f51a2fb4f$var$U.current.useImperativeHandle(a, b, e);
};
$0243656f51a2fb4f$export$aaabe4eda9ed9969 = function(a, b) {
    return $0243656f51a2fb4f$var$U.current.useInsertionEffect(a, b);
};
$0243656f51a2fb4f$export$e5c5a5f917a5871c = function(a, b) {
    return $0243656f51a2fb4f$var$U.current.useLayoutEffect(a, b);
};
$0243656f51a2fb4f$export$1538c33de8887b59 = function(a, b) {
    return $0243656f51a2fb4f$var$U.current.useMemo(a, b);
};
$0243656f51a2fb4f$export$13e3392192263954 = function(a, b, e) {
    return $0243656f51a2fb4f$var$U.current.useReducer(a, b, e);
};
$0243656f51a2fb4f$export$b8f5890fc79d6aca = function(a) {
    return $0243656f51a2fb4f$var$U.current.useRef(a);
};
$0243656f51a2fb4f$export$60241385465d0a34 = function(a) {
    return $0243656f51a2fb4f$var$U.current.useState(a);
};
$0243656f51a2fb4f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0243656f51a2fb4f$var$U.current.useSyncExternalStore(a, b, e);
};
$0243656f51a2fb4f$export$7b286972b8d8ccbf = function() {
    return $0243656f51a2fb4f$var$U.current.useTransition();
};
$0243656f51a2fb4f$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("jozO0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e1ec086d45566806$export$ae55be85d98224ed; }, function (v) { return $e1ec086d45566806$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e1ec086d45566806$export$d39a5bbd09211389; }, function (v) { return $e1ec086d45566806$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e1ec086d45566806$export$882461b6382ed46c; }, function (v) { return $e1ec086d45566806$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e1ec086d45566806$export$466bfc07425424d5; }, function (v) { return $e1ec086d45566806$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e1ec086d45566806$export$cd75ccfd720a3cd4; }, function (v) { return $e1ec086d45566806$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e1ec086d45566806$export$fa8d919ba61d84db; }, function (v) { return $e1ec086d45566806$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e1ec086d45566806$export$757ceba2d55c277e; }, function (v) { return $e1ec086d45566806$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e1ec086d45566806$export$b3890eb0ae9dca99; }, function (v) { return $e1ec086d45566806$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e1ec086d45566806$export$502457920280e6be; }, function (v) { return $e1ec086d45566806$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e1ec086d45566806$export$c78a37762a8d58e1; }, function (v) { return $e1ec086d45566806$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e1ec086d45566806$export$dc54d992c10e8a18; }, function (v) { return $e1ec086d45566806$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e1ec086d45566806$export$83d89fbfd8236492; }, function (v) { return $e1ec086d45566806$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e1ec086d45566806$export$ae55be85d98224ed;
var $e1ec086d45566806$export$d39a5bbd09211389;
var $e1ec086d45566806$export$882461b6382ed46c;
var $e1ec086d45566806$export$466bfc07425424d5;
var $e1ec086d45566806$export$cd75ccfd720a3cd4;
var $e1ec086d45566806$export$fa8d919ba61d84db;
var $e1ec086d45566806$export$757ceba2d55c277e;
var $e1ec086d45566806$export$b3890eb0ae9dca99;
var $e1ec086d45566806$export$502457920280e6be;
var $e1ec086d45566806$export$c78a37762a8d58e1;
var $e1ec086d45566806$export$dc54d992c10e8a18;
var $e1ec086d45566806$export$83d89fbfd8236492;
'use strict';

var $cQNHH = parcelRequire("cQNHH");

var $1MX31 = parcelRequire("1MX31");
function $e1ec086d45566806$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e1ec086d45566806$var$da = new Set, $e1ec086d45566806$var$ea = {};
function $e1ec086d45566806$var$fa(a, b) {
    $e1ec086d45566806$var$ha(a, b);
    $e1ec086d45566806$var$ha(a + "Capture", b);
}
function $e1ec086d45566806$var$ha(a, b) {
    $e1ec086d45566806$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e1ec086d45566806$var$da.add(b[a]);
}
var $e1ec086d45566806$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e1ec086d45566806$var$ja = Object.prototype.hasOwnProperty, $e1ec086d45566806$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e1ec086d45566806$var$la = {}, $e1ec086d45566806$var$ma = {};
function $e1ec086d45566806$var$oa(a) {
    if ($e1ec086d45566806$var$ja.call($e1ec086d45566806$var$ma, a)) return !0;
    if ($e1ec086d45566806$var$ja.call($e1ec086d45566806$var$la, a)) return !1;
    if ($e1ec086d45566806$var$ka.test(a)) return $e1ec086d45566806$var$ma[a] = !0;
    $e1ec086d45566806$var$la[a] = !0;
    return !1;
}
function $e1ec086d45566806$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e1ec086d45566806$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e1ec086d45566806$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e1ec086d45566806$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e1ec086d45566806$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e1ec086d45566806$var$z[b] = new $e1ec086d45566806$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e1ec086d45566806$var$ra = /[\-:]([a-z])/g;
function $e1ec086d45566806$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e1ec086d45566806$var$ra, $e1ec086d45566806$var$sa);
    $e1ec086d45566806$var$z[b] = new $e1ec086d45566806$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e1ec086d45566806$var$ra, $e1ec086d45566806$var$sa);
    $e1ec086d45566806$var$z[b] = new $e1ec086d45566806$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e1ec086d45566806$var$ra, $e1ec086d45566806$var$sa);
    $e1ec086d45566806$var$z[b] = new $e1ec086d45566806$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e1ec086d45566806$var$z.xlinkHref = new $e1ec086d45566806$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e1ec086d45566806$var$z[a] = new $e1ec086d45566806$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e1ec086d45566806$var$ta(a, b, c, d) {
    var e = $e1ec086d45566806$var$z.hasOwnProperty(b) ? $e1ec086d45566806$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e1ec086d45566806$var$qa(b, c, e, d) && (c = null), d || null === e ? $e1ec086d45566806$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e1ec086d45566806$var$ua = $cQNHH.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e1ec086d45566806$var$va = Symbol.for("react.element"), $e1ec086d45566806$var$wa = Symbol.for("react.portal"), $e1ec086d45566806$var$ya = Symbol.for("react.fragment"), $e1ec086d45566806$var$za = Symbol.for("react.strict_mode"), $e1ec086d45566806$var$Aa = Symbol.for("react.profiler"), $e1ec086d45566806$var$Ba = Symbol.for("react.provider"), $e1ec086d45566806$var$Ca = Symbol.for("react.context"), $e1ec086d45566806$var$Da = Symbol.for("react.forward_ref"), $e1ec086d45566806$var$Ea = Symbol.for("react.suspense"), $e1ec086d45566806$var$Fa = Symbol.for("react.suspense_list"), $e1ec086d45566806$var$Ga = Symbol.for("react.memo"), $e1ec086d45566806$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e1ec086d45566806$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e1ec086d45566806$var$Ja = Symbol.iterator;
function $e1ec086d45566806$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e1ec086d45566806$var$Ja && a[$e1ec086d45566806$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e1ec086d45566806$var$A = Object.assign, $e1ec086d45566806$var$La;
function $e1ec086d45566806$var$Ma(a) {
    if (void 0 === $e1ec086d45566806$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e1ec086d45566806$var$La = b && b[1] || "";
    }
    return "\n" + $e1ec086d45566806$var$La + a;
}
var $e1ec086d45566806$var$Na = !1;
function $e1ec086d45566806$var$Oa(a, b) {
    if (!a || $e1ec086d45566806$var$Na) return "";
    $e1ec086d45566806$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e1ec086d45566806$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e1ec086d45566806$var$Ma(a) : "";
}
function $e1ec086d45566806$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e1ec086d45566806$var$Ma(a.type);
        case 16:
            return $e1ec086d45566806$var$Ma("Lazy");
        case 13:
            return $e1ec086d45566806$var$Ma("Suspense");
        case 19:
            return $e1ec086d45566806$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e1ec086d45566806$var$Oa(a.type, !1), a;
        case 11:
            return a = $e1ec086d45566806$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e1ec086d45566806$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e1ec086d45566806$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e1ec086d45566806$var$ya:
            return "Fragment";
        case $e1ec086d45566806$var$wa:
            return "Portal";
        case $e1ec086d45566806$var$Aa:
            return "Profiler";
        case $e1ec086d45566806$var$za:
            return "StrictMode";
        case $e1ec086d45566806$var$Ea:
            return "Suspense";
        case $e1ec086d45566806$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e1ec086d45566806$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e1ec086d45566806$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e1ec086d45566806$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e1ec086d45566806$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e1ec086d45566806$var$Qa(a.type) || "Memo";
        case $e1ec086d45566806$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e1ec086d45566806$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e1ec086d45566806$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e1ec086d45566806$var$Qa(b);
        case 8:
            return b === $e1ec086d45566806$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e1ec086d45566806$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e1ec086d45566806$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e1ec086d45566806$var$Ua(a) {
    var b = $e1ec086d45566806$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e1ec086d45566806$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e1ec086d45566806$var$Ua(a));
}
function $e1ec086d45566806$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e1ec086d45566806$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e1ec086d45566806$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e1ec086d45566806$var$Ya(a, b) {
    var c = b.checked;
    return $e1ec086d45566806$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e1ec086d45566806$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e1ec086d45566806$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e1ec086d45566806$var$ab(a, b) {
    b = b.checked;
    null != b && $e1ec086d45566806$var$ta(a, "checked", b, !1);
}
function $e1ec086d45566806$var$bb(a, b) {
    $e1ec086d45566806$var$ab(a, b);
    var c = $e1ec086d45566806$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e1ec086d45566806$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e1ec086d45566806$var$cb(a, b.type, $e1ec086d45566806$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e1ec086d45566806$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e1ec086d45566806$var$cb(a, b, c) {
    if ("number" !== b || $e1ec086d45566806$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e1ec086d45566806$var$eb = Array.isArray;
function $e1ec086d45566806$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e1ec086d45566806$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e1ec086d45566806$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e1ec086d45566806$var$p(91));
    return $e1ec086d45566806$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e1ec086d45566806$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e1ec086d45566806$var$p(92));
            if ($e1ec086d45566806$var$eb(c)) {
                if (1 < c.length) throw Error($e1ec086d45566806$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e1ec086d45566806$var$Sa(c)
    };
}
function $e1ec086d45566806$var$ib(a, b) {
    var c = $e1ec086d45566806$var$Sa(b.value), d = $e1ec086d45566806$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e1ec086d45566806$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e1ec086d45566806$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e1ec086d45566806$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e1ec086d45566806$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e1ec086d45566806$var$mb, $e1ec086d45566806$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e1ec086d45566806$var$mb = $e1ec086d45566806$var$mb || document.createElement("div");
        $e1ec086d45566806$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e1ec086d45566806$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e1ec086d45566806$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e1ec086d45566806$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e1ec086d45566806$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e1ec086d45566806$var$pb).forEach(function(a) {
    $e1ec086d45566806$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e1ec086d45566806$var$pb[b] = $e1ec086d45566806$var$pb[a];
    });
});
function $e1ec086d45566806$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e1ec086d45566806$var$pb.hasOwnProperty(a) && $e1ec086d45566806$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e1ec086d45566806$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e1ec086d45566806$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e1ec086d45566806$var$tb = $e1ec086d45566806$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e1ec086d45566806$var$ub(a, b) {
    if (b) {
        if ($e1ec086d45566806$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e1ec086d45566806$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e1ec086d45566806$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e1ec086d45566806$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e1ec086d45566806$var$p(62));
    }
}
function $e1ec086d45566806$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e1ec086d45566806$var$wb = null;
function $e1ec086d45566806$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e1ec086d45566806$var$yb = null, $e1ec086d45566806$var$zb = null, $e1ec086d45566806$var$Ab = null;
function $e1ec086d45566806$var$Bb(a) {
    if (a = $e1ec086d45566806$var$Cb(a)) {
        if ("function" !== typeof $e1ec086d45566806$var$yb) throw Error($e1ec086d45566806$var$p(280));
        var b = a.stateNode;
        b && (b = $e1ec086d45566806$var$Db(b), $e1ec086d45566806$var$yb(a.stateNode, a.type, b));
    }
}
function $e1ec086d45566806$var$Eb(a) {
    $e1ec086d45566806$var$zb ? $e1ec086d45566806$var$Ab ? $e1ec086d45566806$var$Ab.push(a) : $e1ec086d45566806$var$Ab = [
        a
    ] : $e1ec086d45566806$var$zb = a;
}
function $e1ec086d45566806$var$Fb() {
    if ($e1ec086d45566806$var$zb) {
        var a = $e1ec086d45566806$var$zb, b = $e1ec086d45566806$var$Ab;
        $e1ec086d45566806$var$Ab = $e1ec086d45566806$var$zb = null;
        $e1ec086d45566806$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e1ec086d45566806$var$Bb(b[a]);
    }
}
function $e1ec086d45566806$var$Gb(a, b) {
    return a(b);
}
function $e1ec086d45566806$var$Hb() {}
var $e1ec086d45566806$var$Ib = !1;
function $e1ec086d45566806$var$Jb(a, b, c) {
    if ($e1ec086d45566806$var$Ib) return a(b, c);
    $e1ec086d45566806$var$Ib = !0;
    try {
        return $e1ec086d45566806$var$Gb(a, b, c);
    } finally{
        if ($e1ec086d45566806$var$Ib = !1, null !== $e1ec086d45566806$var$zb || null !== $e1ec086d45566806$var$Ab) $e1ec086d45566806$var$Hb(), $e1ec086d45566806$var$Fb();
    }
}
function $e1ec086d45566806$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e1ec086d45566806$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e1ec086d45566806$var$p(231, b, typeof c));
    return c;
}
var $e1ec086d45566806$var$Lb = !1;
if ($e1ec086d45566806$var$ia) try {
    var $e1ec086d45566806$var$Mb = {};
    Object.defineProperty($e1ec086d45566806$var$Mb, "passive", {
        get: function() {
            $e1ec086d45566806$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e1ec086d45566806$var$Mb, $e1ec086d45566806$var$Mb);
    window.removeEventListener("test", $e1ec086d45566806$var$Mb, $e1ec086d45566806$var$Mb);
} catch (a) {
    $e1ec086d45566806$var$Lb = !1;
}
function $e1ec086d45566806$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e1ec086d45566806$var$Ob = !1, $e1ec086d45566806$var$Pb = null, $e1ec086d45566806$var$Qb = !1, $e1ec086d45566806$var$Rb = null, $e1ec086d45566806$var$Sb = {
    onError: function(a) {
        $e1ec086d45566806$var$Ob = !0;
        $e1ec086d45566806$var$Pb = a;
    }
};
function $e1ec086d45566806$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e1ec086d45566806$var$Ob = !1;
    $e1ec086d45566806$var$Pb = null;
    $e1ec086d45566806$var$Nb.apply($e1ec086d45566806$var$Sb, arguments);
}
function $e1ec086d45566806$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e1ec086d45566806$var$Tb.apply(this, arguments);
    if ($e1ec086d45566806$var$Ob) {
        if ($e1ec086d45566806$var$Ob) {
            var l = $e1ec086d45566806$var$Pb;
            $e1ec086d45566806$var$Ob = !1;
            $e1ec086d45566806$var$Pb = null;
        } else throw Error($e1ec086d45566806$var$p(198));
        $e1ec086d45566806$var$Qb || ($e1ec086d45566806$var$Qb = !0, $e1ec086d45566806$var$Rb = l);
    }
}
function $e1ec086d45566806$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e1ec086d45566806$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e1ec086d45566806$var$Xb(a) {
    if ($e1ec086d45566806$var$Vb(a) !== a) throw Error($e1ec086d45566806$var$p(188));
}
function $e1ec086d45566806$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e1ec086d45566806$var$Vb(a);
        if (null === b) throw Error($e1ec086d45566806$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e1ec086d45566806$var$Xb(e), a;
                if (f === d) return $e1ec086d45566806$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e1ec086d45566806$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e1ec086d45566806$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e1ec086d45566806$var$p(190));
    }
    if (3 !== c.tag) throw Error($e1ec086d45566806$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e1ec086d45566806$var$Zb(a) {
    a = $e1ec086d45566806$var$Yb(a);
    return null !== a ? $e1ec086d45566806$var$$b(a) : null;
}
function $e1ec086d45566806$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e1ec086d45566806$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e1ec086d45566806$var$ac = $1MX31.unstable_scheduleCallback, $e1ec086d45566806$var$bc = $1MX31.unstable_cancelCallback, $e1ec086d45566806$var$cc = $1MX31.unstable_shouldYield, $e1ec086d45566806$var$dc = $1MX31.unstable_requestPaint, $e1ec086d45566806$var$B = $1MX31.unstable_now, $e1ec086d45566806$var$ec = $1MX31.unstable_getCurrentPriorityLevel, $e1ec086d45566806$var$fc = $1MX31.unstable_ImmediatePriority, $e1ec086d45566806$var$gc = $1MX31.unstable_UserBlockingPriority, $e1ec086d45566806$var$hc = $1MX31.unstable_NormalPriority, $e1ec086d45566806$var$ic = $1MX31.unstable_LowPriority, $e1ec086d45566806$var$jc = $1MX31.unstable_IdlePriority, $e1ec086d45566806$var$kc = null, $e1ec086d45566806$var$lc = null;
function $e1ec086d45566806$var$mc(a) {
    if ($e1ec086d45566806$var$lc && "function" === typeof $e1ec086d45566806$var$lc.onCommitFiberRoot) try {
        $e1ec086d45566806$var$lc.onCommitFiberRoot($e1ec086d45566806$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e1ec086d45566806$var$oc = Math.clz32 ? Math.clz32 : $e1ec086d45566806$var$nc, $e1ec086d45566806$var$pc = Math.log, $e1ec086d45566806$var$qc = Math.LN2;
function $e1ec086d45566806$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e1ec086d45566806$var$pc(a) / $e1ec086d45566806$var$qc | 0) | 0;
}
var $e1ec086d45566806$var$rc = 64, $e1ec086d45566806$var$sc = 4194304;
function $e1ec086d45566806$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e1ec086d45566806$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e1ec086d45566806$var$tc(h) : (f &= g, 0 !== f && (d = $e1ec086d45566806$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e1ec086d45566806$var$tc(g) : 0 !== f && (d = $e1ec086d45566806$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e1ec086d45566806$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e1ec086d45566806$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e1ec086d45566806$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e1ec086d45566806$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e1ec086d45566806$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e1ec086d45566806$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e1ec086d45566806$var$yc() {
    var a = $e1ec086d45566806$var$rc;
    $e1ec086d45566806$var$rc <<= 1;
    0 === ($e1ec086d45566806$var$rc & 4194240) && ($e1ec086d45566806$var$rc = 64);
    return a;
}
function $e1ec086d45566806$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e1ec086d45566806$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e1ec086d45566806$var$oc(b);
    a[b] = c;
}
function $e1ec086d45566806$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e1ec086d45566806$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e1ec086d45566806$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e1ec086d45566806$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e1ec086d45566806$var$C = 0;
function $e1ec086d45566806$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e1ec086d45566806$var$Ec, $e1ec086d45566806$var$Fc, $e1ec086d45566806$var$Gc, $e1ec086d45566806$var$Hc, $e1ec086d45566806$var$Ic, $e1ec086d45566806$var$Jc = !1, $e1ec086d45566806$var$Kc = [], $e1ec086d45566806$var$Lc = null, $e1ec086d45566806$var$Mc = null, $e1ec086d45566806$var$Nc = null, $e1ec086d45566806$var$Oc = new Map, $e1ec086d45566806$var$Pc = new Map, $e1ec086d45566806$var$Qc = [], $e1ec086d45566806$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e1ec086d45566806$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e1ec086d45566806$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e1ec086d45566806$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e1ec086d45566806$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e1ec086d45566806$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e1ec086d45566806$var$Pc.delete(b.pointerId);
    }
}
function $e1ec086d45566806$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e1ec086d45566806$var$Cb(b), null !== b && $e1ec086d45566806$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e1ec086d45566806$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e1ec086d45566806$var$Lc = $e1ec086d45566806$var$Tc($e1ec086d45566806$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e1ec086d45566806$var$Mc = $e1ec086d45566806$var$Tc($e1ec086d45566806$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e1ec086d45566806$var$Nc = $e1ec086d45566806$var$Tc($e1ec086d45566806$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e1ec086d45566806$var$Oc.set(f, $e1ec086d45566806$var$Tc($e1ec086d45566806$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e1ec086d45566806$var$Pc.set(f, $e1ec086d45566806$var$Tc($e1ec086d45566806$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e1ec086d45566806$var$Vc(a) {
    var b = $e1ec086d45566806$var$Wc(a.target);
    if (null !== b) {
        var c = $e1ec086d45566806$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e1ec086d45566806$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e1ec086d45566806$var$Ic(a.priority, function() {
                        $e1ec086d45566806$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e1ec086d45566806$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e1ec086d45566806$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e1ec086d45566806$var$wb = d;
            c.target.dispatchEvent(d);
            $e1ec086d45566806$var$wb = null;
        } else return b = $e1ec086d45566806$var$Cb(c), null !== b && $e1ec086d45566806$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e1ec086d45566806$var$Zc(a, b, c) {
    $e1ec086d45566806$var$Xc(a) && c.delete(b);
}
function $e1ec086d45566806$var$$c() {
    $e1ec086d45566806$var$Jc = !1;
    null !== $e1ec086d45566806$var$Lc && $e1ec086d45566806$var$Xc($e1ec086d45566806$var$Lc) && ($e1ec086d45566806$var$Lc = null);
    null !== $e1ec086d45566806$var$Mc && $e1ec086d45566806$var$Xc($e1ec086d45566806$var$Mc) && ($e1ec086d45566806$var$Mc = null);
    null !== $e1ec086d45566806$var$Nc && $e1ec086d45566806$var$Xc($e1ec086d45566806$var$Nc) && ($e1ec086d45566806$var$Nc = null);
    $e1ec086d45566806$var$Oc.forEach($e1ec086d45566806$var$Zc);
    $e1ec086d45566806$var$Pc.forEach($e1ec086d45566806$var$Zc);
}
function $e1ec086d45566806$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e1ec086d45566806$var$Jc || ($e1ec086d45566806$var$Jc = !0, $1MX31.unstable_scheduleCallback($1MX31.unstable_NormalPriority, $e1ec086d45566806$var$$c)));
}
function $e1ec086d45566806$var$bd(a) {
    function b(b) {
        return $e1ec086d45566806$var$ad(b, a);
    }
    if (0 < $e1ec086d45566806$var$Kc.length) {
        $e1ec086d45566806$var$ad($e1ec086d45566806$var$Kc[0], a);
        for(var c = 1; c < $e1ec086d45566806$var$Kc.length; c++){
            var d = $e1ec086d45566806$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e1ec086d45566806$var$Lc && $e1ec086d45566806$var$ad($e1ec086d45566806$var$Lc, a);
    null !== $e1ec086d45566806$var$Mc && $e1ec086d45566806$var$ad($e1ec086d45566806$var$Mc, a);
    null !== $e1ec086d45566806$var$Nc && $e1ec086d45566806$var$ad($e1ec086d45566806$var$Nc, a);
    $e1ec086d45566806$var$Oc.forEach(b);
    $e1ec086d45566806$var$Pc.forEach(b);
    for(c = 0; c < $e1ec086d45566806$var$Qc.length; c++)d = $e1ec086d45566806$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e1ec086d45566806$var$Qc.length && (c = $e1ec086d45566806$var$Qc[0], null === c.blockedOn);)$e1ec086d45566806$var$Vc(c), null === c.blockedOn && $e1ec086d45566806$var$Qc.shift();
}
var $e1ec086d45566806$var$cd = $e1ec086d45566806$var$ua.ReactCurrentBatchConfig, $e1ec086d45566806$var$dd = !0;
function $e1ec086d45566806$var$ed(a, b, c, d) {
    var e = $e1ec086d45566806$var$C, f = $e1ec086d45566806$var$cd.transition;
    $e1ec086d45566806$var$cd.transition = null;
    try {
        $e1ec086d45566806$var$C = 1, $e1ec086d45566806$var$fd(a, b, c, d);
    } finally{
        $e1ec086d45566806$var$C = e, $e1ec086d45566806$var$cd.transition = f;
    }
}
function $e1ec086d45566806$var$gd(a, b, c, d) {
    var e = $e1ec086d45566806$var$C, f = $e1ec086d45566806$var$cd.transition;
    $e1ec086d45566806$var$cd.transition = null;
    try {
        $e1ec086d45566806$var$C = 4, $e1ec086d45566806$var$fd(a, b, c, d);
    } finally{
        $e1ec086d45566806$var$C = e, $e1ec086d45566806$var$cd.transition = f;
    }
}
function $e1ec086d45566806$var$fd(a, b, c, d) {
    if ($e1ec086d45566806$var$dd) {
        var e = $e1ec086d45566806$var$Yc(a, b, c, d);
        if (null === e) $e1ec086d45566806$var$hd(a, b, d, $e1ec086d45566806$var$id, c), $e1ec086d45566806$var$Sc(a, d);
        else if ($e1ec086d45566806$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e1ec086d45566806$var$Sc(a, d), b & 4 && -1 < $e1ec086d45566806$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e1ec086d45566806$var$Cb(e);
                null !== f && $e1ec086d45566806$var$Ec(f);
                f = $e1ec086d45566806$var$Yc(a, b, c, d);
                null === f && $e1ec086d45566806$var$hd(a, b, d, $e1ec086d45566806$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e1ec086d45566806$var$hd(a, b, d, null, c);
    }
}
var $e1ec086d45566806$var$id = null;
function $e1ec086d45566806$var$Yc(a, b, c, d) {
    $e1ec086d45566806$var$id = null;
    a = $e1ec086d45566806$var$xb(d);
    a = $e1ec086d45566806$var$Wc(a);
    if (null !== a) {
        if (b = $e1ec086d45566806$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e1ec086d45566806$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e1ec086d45566806$var$id = a;
    return null;
}
function $e1ec086d45566806$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e1ec086d45566806$var$ec()){
                case $e1ec086d45566806$var$fc:
                    return 1;
                case $e1ec086d45566806$var$gc:
                    return 4;
                case $e1ec086d45566806$var$hc:
                case $e1ec086d45566806$var$ic:
                    return 16;
                case $e1ec086d45566806$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e1ec086d45566806$var$kd = null, $e1ec086d45566806$var$ld = null, $e1ec086d45566806$var$md = null;
function $e1ec086d45566806$var$nd() {
    if ($e1ec086d45566806$var$md) return $e1ec086d45566806$var$md;
    var a, b = $e1ec086d45566806$var$ld, c = b.length, d, e = "value" in $e1ec086d45566806$var$kd ? $e1ec086d45566806$var$kd.value : $e1ec086d45566806$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e1ec086d45566806$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e1ec086d45566806$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e1ec086d45566806$var$pd() {
    return !0;
}
function $e1ec086d45566806$var$qd() {
    return !1;
}
function $e1ec086d45566806$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e1ec086d45566806$var$pd : $e1ec086d45566806$var$qd;
        this.isPropagationStopped = $e1ec086d45566806$var$qd;
        return this;
    }
    $e1ec086d45566806$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e1ec086d45566806$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e1ec086d45566806$var$pd);
        },
        persist: function() {},
        isPersistent: $e1ec086d45566806$var$pd
    });
    return b;
}
var $e1ec086d45566806$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e1ec086d45566806$var$td = $e1ec086d45566806$var$rd($e1ec086d45566806$var$sd), $e1ec086d45566806$var$ud = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$sd, {
    view: 0,
    detail: 0
}), $e1ec086d45566806$var$vd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$ud), $e1ec086d45566806$var$wd, $e1ec086d45566806$var$xd, $e1ec086d45566806$var$yd, $e1ec086d45566806$var$Ad = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e1ec086d45566806$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e1ec086d45566806$var$yd && ($e1ec086d45566806$var$yd && "mousemove" === a.type ? ($e1ec086d45566806$var$wd = a.screenX - $e1ec086d45566806$var$yd.screenX, $e1ec086d45566806$var$xd = a.screenY - $e1ec086d45566806$var$yd.screenY) : $e1ec086d45566806$var$xd = $e1ec086d45566806$var$wd = 0, $e1ec086d45566806$var$yd = a);
        return $e1ec086d45566806$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e1ec086d45566806$var$xd;
    }
}), $e1ec086d45566806$var$Bd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Ad), $e1ec086d45566806$var$Cd = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$Ad, {
    dataTransfer: 0
}), $e1ec086d45566806$var$Dd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Cd), $e1ec086d45566806$var$Ed = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$ud, {
    relatedTarget: 0
}), $e1ec086d45566806$var$Fd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Ed), $e1ec086d45566806$var$Gd = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e1ec086d45566806$var$Hd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Gd), $e1ec086d45566806$var$Id = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e1ec086d45566806$var$Jd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Id), $e1ec086d45566806$var$Kd = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$sd, {
    data: 0
}), $e1ec086d45566806$var$Ld = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Kd), $e1ec086d45566806$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e1ec086d45566806$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e1ec086d45566806$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e1ec086d45566806$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e1ec086d45566806$var$Od[a]) ? !!b[a] : !1;
}
function $e1ec086d45566806$var$zd() {
    return $e1ec086d45566806$var$Pd;
}
var $e1ec086d45566806$var$Qd = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e1ec086d45566806$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e1ec086d45566806$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e1ec086d45566806$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e1ec086d45566806$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e1ec086d45566806$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e1ec086d45566806$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e1ec086d45566806$var$Rd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Qd), $e1ec086d45566806$var$Sd = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e1ec086d45566806$var$Td = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Sd), $e1ec086d45566806$var$Ud = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e1ec086d45566806$var$zd
}), $e1ec086d45566806$var$Vd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Ud), $e1ec086d45566806$var$Wd = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e1ec086d45566806$var$Xd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Wd), $e1ec086d45566806$var$Yd = $e1ec086d45566806$var$A({}, $e1ec086d45566806$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e1ec086d45566806$var$Zd = $e1ec086d45566806$var$rd($e1ec086d45566806$var$Yd), $e1ec086d45566806$var$$d = [
    9,
    13,
    27,
    32
], $e1ec086d45566806$var$ae = $e1ec086d45566806$var$ia && "CompositionEvent" in window, $e1ec086d45566806$var$be = null;
$e1ec086d45566806$var$ia && "documentMode" in document && ($e1ec086d45566806$var$be = document.documentMode);
var $e1ec086d45566806$var$ce = $e1ec086d45566806$var$ia && "TextEvent" in window && !$e1ec086d45566806$var$be, $e1ec086d45566806$var$de = $e1ec086d45566806$var$ia && (!$e1ec086d45566806$var$ae || $e1ec086d45566806$var$be && 8 < $e1ec086d45566806$var$be && 11 >= $e1ec086d45566806$var$be), $e1ec086d45566806$var$ee = String.fromCharCode(32), $e1ec086d45566806$var$fe = !1;
function $e1ec086d45566806$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e1ec086d45566806$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e1ec086d45566806$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e1ec086d45566806$var$ie = !1;
function $e1ec086d45566806$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e1ec086d45566806$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e1ec086d45566806$var$fe = !0;
            return $e1ec086d45566806$var$ee;
        case "textInput":
            return a = b.data, a === $e1ec086d45566806$var$ee && $e1ec086d45566806$var$fe ? null : a;
        default:
            return null;
    }
}
function $e1ec086d45566806$var$ke(a, b) {
    if ($e1ec086d45566806$var$ie) return "compositionend" === a || !$e1ec086d45566806$var$ae && $e1ec086d45566806$var$ge(a, b) ? (a = $e1ec086d45566806$var$nd(), $e1ec086d45566806$var$md = $e1ec086d45566806$var$ld = $e1ec086d45566806$var$kd = null, $e1ec086d45566806$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e1ec086d45566806$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e1ec086d45566806$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e1ec086d45566806$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e1ec086d45566806$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e1ec086d45566806$var$ne(a, b, c, d) {
    $e1ec086d45566806$var$Eb(d);
    b = $e1ec086d45566806$var$oe(b, "onChange");
    0 < b.length && (c = new $e1ec086d45566806$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e1ec086d45566806$var$pe = null, $e1ec086d45566806$var$qe = null;
function $e1ec086d45566806$var$re(a) {
    $e1ec086d45566806$var$se(a, 0);
}
function $e1ec086d45566806$var$te(a) {
    var b = $e1ec086d45566806$var$ue(a);
    if ($e1ec086d45566806$var$Wa(b)) return a;
}
function $e1ec086d45566806$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e1ec086d45566806$var$we = !1;
if ($e1ec086d45566806$var$ia) {
    var $e1ec086d45566806$var$xe;
    if ($e1ec086d45566806$var$ia) {
        var $e1ec086d45566806$var$ye = "oninput" in document;
        if (!$e1ec086d45566806$var$ye) {
            var $e1ec086d45566806$var$ze = document.createElement("div");
            $e1ec086d45566806$var$ze.setAttribute("oninput", "return;");
            $e1ec086d45566806$var$ye = "function" === typeof $e1ec086d45566806$var$ze.oninput;
        }
        $e1ec086d45566806$var$xe = $e1ec086d45566806$var$ye;
    } else $e1ec086d45566806$var$xe = !1;
    $e1ec086d45566806$var$we = $e1ec086d45566806$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e1ec086d45566806$var$Ae() {
    $e1ec086d45566806$var$pe && ($e1ec086d45566806$var$pe.detachEvent("onpropertychange", $e1ec086d45566806$var$Be), $e1ec086d45566806$var$qe = $e1ec086d45566806$var$pe = null);
}
function $e1ec086d45566806$var$Be(a) {
    if ("value" === a.propertyName && $e1ec086d45566806$var$te($e1ec086d45566806$var$qe)) {
        var b = [];
        $e1ec086d45566806$var$ne(b, $e1ec086d45566806$var$qe, a, $e1ec086d45566806$var$xb(a));
        $e1ec086d45566806$var$Jb($e1ec086d45566806$var$re, b);
    }
}
function $e1ec086d45566806$var$Ce(a, b, c) {
    "focusin" === a ? ($e1ec086d45566806$var$Ae(), $e1ec086d45566806$var$pe = b, $e1ec086d45566806$var$qe = c, $e1ec086d45566806$var$pe.attachEvent("onpropertychange", $e1ec086d45566806$var$Be)) : "focusout" === a && $e1ec086d45566806$var$Ae();
}
function $e1ec086d45566806$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e1ec086d45566806$var$te($e1ec086d45566806$var$qe);
}
function $e1ec086d45566806$var$Ee(a, b) {
    if ("click" === a) return $e1ec086d45566806$var$te(b);
}
function $e1ec086d45566806$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e1ec086d45566806$var$te(b);
}
function $e1ec086d45566806$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e1ec086d45566806$var$He = "function" === typeof Object.is ? Object.is : $e1ec086d45566806$var$Ge;
function $e1ec086d45566806$var$Ie(a, b) {
    if ($e1ec086d45566806$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e1ec086d45566806$var$ja.call(b, e) || !$e1ec086d45566806$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e1ec086d45566806$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e1ec086d45566806$var$Ke(a, b) {
    var c = $e1ec086d45566806$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e1ec086d45566806$var$Je(c);
    }
}
function $e1ec086d45566806$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e1ec086d45566806$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e1ec086d45566806$var$Me() {
    for(var a = window, b = $e1ec086d45566806$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e1ec086d45566806$var$Xa(a.document);
    }
    return b;
}
function $e1ec086d45566806$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e1ec086d45566806$var$Oe(a) {
    var b = $e1ec086d45566806$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e1ec086d45566806$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e1ec086d45566806$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e1ec086d45566806$var$Ke(c, f);
                var g = $e1ec086d45566806$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e1ec086d45566806$var$Pe = $e1ec086d45566806$var$ia && "documentMode" in document && 11 >= document.documentMode, $e1ec086d45566806$var$Qe = null, $e1ec086d45566806$var$Re = null, $e1ec086d45566806$var$Se = null, $e1ec086d45566806$var$Te = !1;
function $e1ec086d45566806$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e1ec086d45566806$var$Te || null == $e1ec086d45566806$var$Qe || $e1ec086d45566806$var$Qe !== $e1ec086d45566806$var$Xa(d) || (d = $e1ec086d45566806$var$Qe, "selectionStart" in d && $e1ec086d45566806$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e1ec086d45566806$var$Se && $e1ec086d45566806$var$Ie($e1ec086d45566806$var$Se, d) || ($e1ec086d45566806$var$Se = d, d = $e1ec086d45566806$var$oe($e1ec086d45566806$var$Re, "onSelect"), 0 < d.length && (b = new $e1ec086d45566806$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e1ec086d45566806$var$Qe)));
}
function $e1ec086d45566806$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e1ec086d45566806$var$We = {
    animationend: $e1ec086d45566806$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e1ec086d45566806$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e1ec086d45566806$var$Ve("Animation", "AnimationStart"),
    transitionend: $e1ec086d45566806$var$Ve("Transition", "TransitionEnd")
}, $e1ec086d45566806$var$Xe = {}, $e1ec086d45566806$var$Ye = {};
$e1ec086d45566806$var$ia && ($e1ec086d45566806$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e1ec086d45566806$var$We.animationend.animation, delete $e1ec086d45566806$var$We.animationiteration.animation, delete $e1ec086d45566806$var$We.animationstart.animation), "TransitionEvent" in window || delete $e1ec086d45566806$var$We.transitionend.transition);
function $e1ec086d45566806$var$Ze(a) {
    if ($e1ec086d45566806$var$Xe[a]) return $e1ec086d45566806$var$Xe[a];
    if (!$e1ec086d45566806$var$We[a]) return a;
    var b = $e1ec086d45566806$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e1ec086d45566806$var$Ye) return $e1ec086d45566806$var$Xe[a] = b[c];
    return a;
}
var $e1ec086d45566806$var$$e = $e1ec086d45566806$var$Ze("animationend"), $e1ec086d45566806$var$af = $e1ec086d45566806$var$Ze("animationiteration"), $e1ec086d45566806$var$bf = $e1ec086d45566806$var$Ze("animationstart"), $e1ec086d45566806$var$cf = $e1ec086d45566806$var$Ze("transitionend"), $e1ec086d45566806$var$df = new Map, $e1ec086d45566806$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e1ec086d45566806$var$ff(a, b) {
    $e1ec086d45566806$var$df.set(a, b);
    $e1ec086d45566806$var$fa(b, [
        a
    ]);
}
for(var $e1ec086d45566806$var$gf = 0; $e1ec086d45566806$var$gf < $e1ec086d45566806$var$ef.length; $e1ec086d45566806$var$gf++){
    var $e1ec086d45566806$var$hf = $e1ec086d45566806$var$ef[$e1ec086d45566806$var$gf], $e1ec086d45566806$var$jf = $e1ec086d45566806$var$hf.toLowerCase(), $e1ec086d45566806$var$kf = $e1ec086d45566806$var$hf[0].toUpperCase() + $e1ec086d45566806$var$hf.slice(1);
    $e1ec086d45566806$var$ff($e1ec086d45566806$var$jf, "on" + $e1ec086d45566806$var$kf);
}
$e1ec086d45566806$var$ff($e1ec086d45566806$var$$e, "onAnimationEnd");
$e1ec086d45566806$var$ff($e1ec086d45566806$var$af, "onAnimationIteration");
$e1ec086d45566806$var$ff($e1ec086d45566806$var$bf, "onAnimationStart");
$e1ec086d45566806$var$ff("dblclick", "onDoubleClick");
$e1ec086d45566806$var$ff("focusin", "onFocus");
$e1ec086d45566806$var$ff("focusout", "onBlur");
$e1ec086d45566806$var$ff($e1ec086d45566806$var$cf, "onTransitionEnd");
$e1ec086d45566806$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e1ec086d45566806$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e1ec086d45566806$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e1ec086d45566806$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e1ec086d45566806$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e1ec086d45566806$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e1ec086d45566806$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e1ec086d45566806$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e1ec086d45566806$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e1ec086d45566806$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e1ec086d45566806$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e1ec086d45566806$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e1ec086d45566806$var$lf));
function $e1ec086d45566806$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e1ec086d45566806$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e1ec086d45566806$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e1ec086d45566806$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e1ec086d45566806$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e1ec086d45566806$var$Qb) throw a = $e1ec086d45566806$var$Rb, $e1ec086d45566806$var$Qb = !1, $e1ec086d45566806$var$Rb = null, a;
}
function $e1ec086d45566806$var$D(a, b) {
    var c = b[$e1ec086d45566806$var$of];
    void 0 === c && (c = b[$e1ec086d45566806$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e1ec086d45566806$var$pf(b, a, 2, !1), c.add(d));
}
function $e1ec086d45566806$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e1ec086d45566806$var$pf(c, a, d, b);
}
var $e1ec086d45566806$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e1ec086d45566806$var$sf(a) {
    if (!a[$e1ec086d45566806$var$rf]) {
        a[$e1ec086d45566806$var$rf] = !0;
        $e1ec086d45566806$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e1ec086d45566806$var$mf.has(b) || $e1ec086d45566806$var$qf(b, !1, a), $e1ec086d45566806$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e1ec086d45566806$var$rf] || (b[$e1ec086d45566806$var$rf] = !0, $e1ec086d45566806$var$qf("selectionchange", !1, b));
    }
}
function $e1ec086d45566806$var$pf(a, b, c, d) {
    switch($e1ec086d45566806$var$jd(b)){
        case 1:
            var e = $e1ec086d45566806$var$ed;
            break;
        case 4:
            e = $e1ec086d45566806$var$gd;
            break;
        default:
            e = $e1ec086d45566806$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e1ec086d45566806$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e1ec086d45566806$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e1ec086d45566806$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e1ec086d45566806$var$Jb(function() {
        var d = f, e = $e1ec086d45566806$var$xb(c), g = [];
        a: {
            var h = $e1ec086d45566806$var$df.get(a);
            if (void 0 !== h) {
                var k = $e1ec086d45566806$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e1ec086d45566806$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e1ec086d45566806$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e1ec086d45566806$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e1ec086d45566806$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e1ec086d45566806$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e1ec086d45566806$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e1ec086d45566806$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e1ec086d45566806$var$Vd;
                        break;
                    case $e1ec086d45566806$var$$e:
                    case $e1ec086d45566806$var$af:
                    case $e1ec086d45566806$var$bf:
                        k = $e1ec086d45566806$var$Hd;
                        break;
                    case $e1ec086d45566806$var$cf:
                        k = $e1ec086d45566806$var$Xd;
                        break;
                    case "scroll":
                        k = $e1ec086d45566806$var$vd;
                        break;
                    case "wheel":
                        k = $e1ec086d45566806$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e1ec086d45566806$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e1ec086d45566806$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e1ec086d45566806$var$Kb(w, x), null != F && t.push($e1ec086d45566806$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e1ec086d45566806$var$wb && (n = c.relatedTarget || c.fromElement) && ($e1ec086d45566806$var$Wc(n) || n[$e1ec086d45566806$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e1ec086d45566806$var$Wc(n) : null, null !== n && (J = $e1ec086d45566806$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e1ec086d45566806$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e1ec086d45566806$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e1ec086d45566806$var$ue(k);
                        u = null == n ? h : $e1ec086d45566806$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e1ec086d45566806$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e1ec086d45566806$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e1ec086d45566806$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e1ec086d45566806$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e1ec086d45566806$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e1ec086d45566806$var$vf(t);
                                x = $e1ec086d45566806$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e1ec086d45566806$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e1ec086d45566806$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e1ec086d45566806$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e1ec086d45566806$var$ve;
                else if ($e1ec086d45566806$var$me(h)) {
                    if ($e1ec086d45566806$var$we) na = $e1ec086d45566806$var$Fe;
                    else {
                        na = $e1ec086d45566806$var$De;
                        var xa = $e1ec086d45566806$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e1ec086d45566806$var$Ee);
                if (na && (na = na(a, d))) {
                    $e1ec086d45566806$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e1ec086d45566806$var$cb(h, "number", h.value);
            }
            xa = d ? $e1ec086d45566806$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e1ec086d45566806$var$me(xa) || "true" === xa.contentEditable) $e1ec086d45566806$var$Qe = xa, $e1ec086d45566806$var$Re = d, $e1ec086d45566806$var$Se = null;
                    break;
                case "focusout":
                    $e1ec086d45566806$var$Se = $e1ec086d45566806$var$Re = $e1ec086d45566806$var$Qe = null;
                    break;
                case "mousedown":
                    $e1ec086d45566806$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e1ec086d45566806$var$Te = !1;
                    $e1ec086d45566806$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e1ec086d45566806$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e1ec086d45566806$var$Ue(g, c, e);
            }
            var $a;
            if ($e1ec086d45566806$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e1ec086d45566806$var$ie ? $e1ec086d45566806$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e1ec086d45566806$var$de && "ko" !== c.locale && ($e1ec086d45566806$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e1ec086d45566806$var$ie && ($a = $e1ec086d45566806$var$nd()) : ($e1ec086d45566806$var$kd = e, $e1ec086d45566806$var$ld = "value" in $e1ec086d45566806$var$kd ? $e1ec086d45566806$var$kd.value : $e1ec086d45566806$var$kd.textContent, $e1ec086d45566806$var$ie = !0)), xa = $e1ec086d45566806$var$oe(d, ba), 0 < xa.length && (ba = new $e1ec086d45566806$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e1ec086d45566806$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e1ec086d45566806$var$ce ? $e1ec086d45566806$var$je(a, c) : $e1ec086d45566806$var$ke(a, c)) d = $e1ec086d45566806$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e1ec086d45566806$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e1ec086d45566806$var$se(g, b);
    });
}
function $e1ec086d45566806$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e1ec086d45566806$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e1ec086d45566806$var$Kb(a, c), null != f && d.unshift($e1ec086d45566806$var$tf(a, f, e)), f = $e1ec086d45566806$var$Kb(a, b), null != f && d.push($e1ec086d45566806$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e1ec086d45566806$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e1ec086d45566806$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e1ec086d45566806$var$Kb(c, f), null != k && g.unshift($e1ec086d45566806$var$tf(c, k, h))) : e || (k = $e1ec086d45566806$var$Kb(c, f), null != k && g.push($e1ec086d45566806$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e1ec086d45566806$var$xf = /\r\n?/g, $e1ec086d45566806$var$yf = /\u0000|\uFFFD/g;
function $e1ec086d45566806$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e1ec086d45566806$var$xf, "\n").replace($e1ec086d45566806$var$yf, "");
}
function $e1ec086d45566806$var$Af(a, b, c) {
    b = $e1ec086d45566806$var$zf(b);
    if ($e1ec086d45566806$var$zf(a) !== b && c) throw Error($e1ec086d45566806$var$p(425));
}
function $e1ec086d45566806$var$Bf() {}
var $e1ec086d45566806$var$Cf = null, $e1ec086d45566806$var$Df = null;
function $e1ec086d45566806$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e1ec086d45566806$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e1ec086d45566806$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e1ec086d45566806$var$Hf = "function" === typeof Promise ? Promise : void 0, $e1ec086d45566806$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e1ec086d45566806$var$Hf ? function(a) {
    return $e1ec086d45566806$var$Hf.resolve(null).then(a).catch($e1ec086d45566806$var$If);
} : $e1ec086d45566806$var$Ff;
function $e1ec086d45566806$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e1ec086d45566806$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e1ec086d45566806$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e1ec086d45566806$var$bd(b);
}
function $e1ec086d45566806$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e1ec086d45566806$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e1ec086d45566806$var$Nf = Math.random().toString(36).slice(2), $e1ec086d45566806$var$Of = "__reactFiber$" + $e1ec086d45566806$var$Nf, $e1ec086d45566806$var$Pf = "__reactProps$" + $e1ec086d45566806$var$Nf, $e1ec086d45566806$var$uf = "__reactContainer$" + $e1ec086d45566806$var$Nf, $e1ec086d45566806$var$of = "__reactEvents$" + $e1ec086d45566806$var$Nf, $e1ec086d45566806$var$Qf = "__reactListeners$" + $e1ec086d45566806$var$Nf, $e1ec086d45566806$var$Rf = "__reactHandles$" + $e1ec086d45566806$var$Nf;
function $e1ec086d45566806$var$Wc(a) {
    var b = a[$e1ec086d45566806$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e1ec086d45566806$var$uf] || c[$e1ec086d45566806$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e1ec086d45566806$var$Mf(a); null !== a;){
                if (c = a[$e1ec086d45566806$var$Of]) return c;
                a = $e1ec086d45566806$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e1ec086d45566806$var$Cb(a) {
    a = a[$e1ec086d45566806$var$Of] || a[$e1ec086d45566806$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e1ec086d45566806$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e1ec086d45566806$var$p(33));
}
function $e1ec086d45566806$var$Db(a) {
    return a[$e1ec086d45566806$var$Pf] || null;
}
var $e1ec086d45566806$var$Sf = [], $e1ec086d45566806$var$Tf = -1;
function $e1ec086d45566806$var$Uf(a) {
    return {
        current: a
    };
}
function $e1ec086d45566806$var$E(a) {
    0 > $e1ec086d45566806$var$Tf || (a.current = $e1ec086d45566806$var$Sf[$e1ec086d45566806$var$Tf], $e1ec086d45566806$var$Sf[$e1ec086d45566806$var$Tf] = null, $e1ec086d45566806$var$Tf--);
}
function $e1ec086d45566806$var$G(a, b) {
    $e1ec086d45566806$var$Tf++;
    $e1ec086d45566806$var$Sf[$e1ec086d45566806$var$Tf] = a.current;
    a.current = b;
}
var $e1ec086d45566806$var$Vf = {}, $e1ec086d45566806$var$H = $e1ec086d45566806$var$Uf($e1ec086d45566806$var$Vf), $e1ec086d45566806$var$Wf = $e1ec086d45566806$var$Uf(!1), $e1ec086d45566806$var$Xf = $e1ec086d45566806$var$Vf;
function $e1ec086d45566806$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e1ec086d45566806$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e1ec086d45566806$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e1ec086d45566806$var$$f() {
    $e1ec086d45566806$var$E($e1ec086d45566806$var$Wf);
    $e1ec086d45566806$var$E($e1ec086d45566806$var$H);
}
function $e1ec086d45566806$var$ag(a, b, c) {
    if ($e1ec086d45566806$var$H.current !== $e1ec086d45566806$var$Vf) throw Error($e1ec086d45566806$var$p(168));
    $e1ec086d45566806$var$G($e1ec086d45566806$var$H, b);
    $e1ec086d45566806$var$G($e1ec086d45566806$var$Wf, c);
}
function $e1ec086d45566806$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e1ec086d45566806$var$p(108, $e1ec086d45566806$var$Ra(a) || "Unknown", e));
    return $e1ec086d45566806$var$A({}, c, d);
}
function $e1ec086d45566806$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e1ec086d45566806$var$Vf;
    $e1ec086d45566806$var$Xf = $e1ec086d45566806$var$H.current;
    $e1ec086d45566806$var$G($e1ec086d45566806$var$H, a);
    $e1ec086d45566806$var$G($e1ec086d45566806$var$Wf, $e1ec086d45566806$var$Wf.current);
    return !0;
}
function $e1ec086d45566806$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e1ec086d45566806$var$p(169));
    c ? (a = $e1ec086d45566806$var$bg(a, b, $e1ec086d45566806$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e1ec086d45566806$var$E($e1ec086d45566806$var$Wf), $e1ec086d45566806$var$E($e1ec086d45566806$var$H), $e1ec086d45566806$var$G($e1ec086d45566806$var$H, a)) : $e1ec086d45566806$var$E($e1ec086d45566806$var$Wf);
    $e1ec086d45566806$var$G($e1ec086d45566806$var$Wf, c);
}
var $e1ec086d45566806$var$eg = null, $e1ec086d45566806$var$fg = !1, $e1ec086d45566806$var$gg = !1;
function $e1ec086d45566806$var$hg(a) {
    null === $e1ec086d45566806$var$eg ? $e1ec086d45566806$var$eg = [
        a
    ] : $e1ec086d45566806$var$eg.push(a);
}
function $e1ec086d45566806$var$ig(a) {
    $e1ec086d45566806$var$fg = !0;
    $e1ec086d45566806$var$hg(a);
}
function $e1ec086d45566806$var$jg() {
    if (!$e1ec086d45566806$var$gg && null !== $e1ec086d45566806$var$eg) {
        $e1ec086d45566806$var$gg = !0;
        var a = 0, b = $e1ec086d45566806$var$C;
        try {
            var c = $e1ec086d45566806$var$eg;
            for($e1ec086d45566806$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e1ec086d45566806$var$eg = null;
            $e1ec086d45566806$var$fg = !1;
        } catch (e) {
            throw null !== $e1ec086d45566806$var$eg && ($e1ec086d45566806$var$eg = $e1ec086d45566806$var$eg.slice(a + 1)), $e1ec086d45566806$var$ac($e1ec086d45566806$var$fc, $e1ec086d45566806$var$jg), e;
        } finally{
            $e1ec086d45566806$var$C = b, $e1ec086d45566806$var$gg = !1;
        }
    }
    return null;
}
var $e1ec086d45566806$var$kg = [], $e1ec086d45566806$var$lg = 0, $e1ec086d45566806$var$mg = null, $e1ec086d45566806$var$ng = 0, $e1ec086d45566806$var$og = [], $e1ec086d45566806$var$pg = 0, $e1ec086d45566806$var$qg = null, $e1ec086d45566806$var$rg = 1, $e1ec086d45566806$var$sg = "";
function $e1ec086d45566806$var$tg(a, b) {
    $e1ec086d45566806$var$kg[$e1ec086d45566806$var$lg++] = $e1ec086d45566806$var$ng;
    $e1ec086d45566806$var$kg[$e1ec086d45566806$var$lg++] = $e1ec086d45566806$var$mg;
    $e1ec086d45566806$var$mg = a;
    $e1ec086d45566806$var$ng = b;
}
function $e1ec086d45566806$var$ug(a, b, c) {
    $e1ec086d45566806$var$og[$e1ec086d45566806$var$pg++] = $e1ec086d45566806$var$rg;
    $e1ec086d45566806$var$og[$e1ec086d45566806$var$pg++] = $e1ec086d45566806$var$sg;
    $e1ec086d45566806$var$og[$e1ec086d45566806$var$pg++] = $e1ec086d45566806$var$qg;
    $e1ec086d45566806$var$qg = a;
    var d = $e1ec086d45566806$var$rg;
    a = $e1ec086d45566806$var$sg;
    var e = 32 - $e1ec086d45566806$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e1ec086d45566806$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e1ec086d45566806$var$rg = 1 << 32 - $e1ec086d45566806$var$oc(b) + e | c << e | d;
        $e1ec086d45566806$var$sg = f + a;
    } else $e1ec086d45566806$var$rg = 1 << f | c << e | d, $e1ec086d45566806$var$sg = a;
}
function $e1ec086d45566806$var$vg(a) {
    null !== a.return && ($e1ec086d45566806$var$tg(a, 1), $e1ec086d45566806$var$ug(a, 1, 0));
}
function $e1ec086d45566806$var$wg(a) {
    for(; a === $e1ec086d45566806$var$mg;)$e1ec086d45566806$var$mg = $e1ec086d45566806$var$kg[--$e1ec086d45566806$var$lg], $e1ec086d45566806$var$kg[$e1ec086d45566806$var$lg] = null, $e1ec086d45566806$var$ng = $e1ec086d45566806$var$kg[--$e1ec086d45566806$var$lg], $e1ec086d45566806$var$kg[$e1ec086d45566806$var$lg] = null;
    for(; a === $e1ec086d45566806$var$qg;)$e1ec086d45566806$var$qg = $e1ec086d45566806$var$og[--$e1ec086d45566806$var$pg], $e1ec086d45566806$var$og[$e1ec086d45566806$var$pg] = null, $e1ec086d45566806$var$sg = $e1ec086d45566806$var$og[--$e1ec086d45566806$var$pg], $e1ec086d45566806$var$og[$e1ec086d45566806$var$pg] = null, $e1ec086d45566806$var$rg = $e1ec086d45566806$var$og[--$e1ec086d45566806$var$pg], $e1ec086d45566806$var$og[$e1ec086d45566806$var$pg] = null;
}
var $e1ec086d45566806$var$xg = null, $e1ec086d45566806$var$yg = null, $e1ec086d45566806$var$I = !1, $e1ec086d45566806$var$zg = null;
function $e1ec086d45566806$var$Ag(a, b) {
    var c = $e1ec086d45566806$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e1ec086d45566806$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e1ec086d45566806$var$xg = a, $e1ec086d45566806$var$yg = $e1ec086d45566806$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e1ec086d45566806$var$xg = a, $e1ec086d45566806$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e1ec086d45566806$var$qg ? {
                id: $e1ec086d45566806$var$rg,
                overflow: $e1ec086d45566806$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e1ec086d45566806$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e1ec086d45566806$var$xg = a, $e1ec086d45566806$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e1ec086d45566806$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e1ec086d45566806$var$Eg(a) {
    if ($e1ec086d45566806$var$I) {
        var b = $e1ec086d45566806$var$yg;
        if (b) {
            var c = b;
            if (!$e1ec086d45566806$var$Cg(a, b)) {
                if ($e1ec086d45566806$var$Dg(a)) throw Error($e1ec086d45566806$var$p(418));
                b = $e1ec086d45566806$var$Lf(c.nextSibling);
                var d = $e1ec086d45566806$var$xg;
                b && $e1ec086d45566806$var$Cg(a, b) ? $e1ec086d45566806$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e1ec086d45566806$var$I = !1, $e1ec086d45566806$var$xg = a);
            }
        } else {
            if ($e1ec086d45566806$var$Dg(a)) throw Error($e1ec086d45566806$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e1ec086d45566806$var$I = !1;
            $e1ec086d45566806$var$xg = a;
        }
    }
}
function $e1ec086d45566806$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e1ec086d45566806$var$xg = a;
}
function $e1ec086d45566806$var$Gg(a) {
    if (a !== $e1ec086d45566806$var$xg) return !1;
    if (!$e1ec086d45566806$var$I) return $e1ec086d45566806$var$Fg(a), $e1ec086d45566806$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e1ec086d45566806$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e1ec086d45566806$var$yg)) {
        if ($e1ec086d45566806$var$Dg(a)) throw $e1ec086d45566806$var$Hg(), Error($e1ec086d45566806$var$p(418));
        for(; b;)$e1ec086d45566806$var$Ag(a, b), b = $e1ec086d45566806$var$Lf(b.nextSibling);
    }
    $e1ec086d45566806$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e1ec086d45566806$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e1ec086d45566806$var$yg = $e1ec086d45566806$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e1ec086d45566806$var$yg = null;
        }
    } else $e1ec086d45566806$var$yg = $e1ec086d45566806$var$xg ? $e1ec086d45566806$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e1ec086d45566806$var$Hg() {
    for(var a = $e1ec086d45566806$var$yg; a;)a = $e1ec086d45566806$var$Lf(a.nextSibling);
}
function $e1ec086d45566806$var$Ig() {
    $e1ec086d45566806$var$yg = $e1ec086d45566806$var$xg = null;
    $e1ec086d45566806$var$I = !1;
}
function $e1ec086d45566806$var$Jg(a) {
    null === $e1ec086d45566806$var$zg ? $e1ec086d45566806$var$zg = [
        a
    ] : $e1ec086d45566806$var$zg.push(a);
}
var $e1ec086d45566806$var$Kg = $e1ec086d45566806$var$ua.ReactCurrentBatchConfig;
function $e1ec086d45566806$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e1ec086d45566806$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e1ec086d45566806$var$Mg = $e1ec086d45566806$var$Uf(null), $e1ec086d45566806$var$Ng = null, $e1ec086d45566806$var$Og = null, $e1ec086d45566806$var$Pg = null;
function $e1ec086d45566806$var$Qg() {
    $e1ec086d45566806$var$Pg = $e1ec086d45566806$var$Og = $e1ec086d45566806$var$Ng = null;
}
function $e1ec086d45566806$var$Rg(a) {
    var b = $e1ec086d45566806$var$Mg.current;
    $e1ec086d45566806$var$E($e1ec086d45566806$var$Mg);
    a._currentValue = b;
}
function $e1ec086d45566806$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e1ec086d45566806$var$Tg(a, b) {
    $e1ec086d45566806$var$Ng = a;
    $e1ec086d45566806$var$Pg = $e1ec086d45566806$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e1ec086d45566806$var$Ug = !0), a.firstContext = null);
}
function $e1ec086d45566806$var$Vg(a) {
    var b = a._currentValue;
    if ($e1ec086d45566806$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e1ec086d45566806$var$Og) {
            if (null === $e1ec086d45566806$var$Ng) throw Error($e1ec086d45566806$var$p(308));
            $e1ec086d45566806$var$Og = a;
            $e1ec086d45566806$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e1ec086d45566806$var$Og = $e1ec086d45566806$var$Og.next = a;
    }
    return b;
}
var $e1ec086d45566806$var$Wg = null;
function $e1ec086d45566806$var$Xg(a) {
    null === $e1ec086d45566806$var$Wg ? $e1ec086d45566806$var$Wg = [
        a
    ] : $e1ec086d45566806$var$Wg.push(a);
}
function $e1ec086d45566806$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e1ec086d45566806$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e1ec086d45566806$var$Zg(a, d);
}
function $e1ec086d45566806$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e1ec086d45566806$var$$g = !1;
function $e1ec086d45566806$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e1ec086d45566806$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e1ec086d45566806$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e1ec086d45566806$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e1ec086d45566806$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e1ec086d45566806$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e1ec086d45566806$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e1ec086d45566806$var$Zg(a, c);
}
function $e1ec086d45566806$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e1ec086d45566806$var$Cc(a, c);
    }
}
function $e1ec086d45566806$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e1ec086d45566806$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e1ec086d45566806$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e1ec086d45566806$var$A({}, q, r);
                            break a;
                        case 2:
                            $e1ec086d45566806$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e1ec086d45566806$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e1ec086d45566806$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e1ec086d45566806$var$p(191, e));
            e.call(d);
        }
    }
}
var $e1ec086d45566806$var$jh = (new $cQNHH.Component).refs;
function $e1ec086d45566806$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e1ec086d45566806$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e1ec086d45566806$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e1ec086d45566806$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e1ec086d45566806$var$L(), e = $e1ec086d45566806$var$lh(a), f = $e1ec086d45566806$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e1ec086d45566806$var$dh(a, f, e);
        null !== b && ($e1ec086d45566806$var$mh(b, a, e, d), $e1ec086d45566806$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e1ec086d45566806$var$L(), e = $e1ec086d45566806$var$lh(a), f = $e1ec086d45566806$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e1ec086d45566806$var$dh(a, f, e);
        null !== b && ($e1ec086d45566806$var$mh(b, a, e, d), $e1ec086d45566806$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e1ec086d45566806$var$L(), d = $e1ec086d45566806$var$lh(a), e = $e1ec086d45566806$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e1ec086d45566806$var$dh(a, e, d);
        null !== b && ($e1ec086d45566806$var$mh(b, a, d, c), $e1ec086d45566806$var$eh(b, a, d));
    }
};
function $e1ec086d45566806$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e1ec086d45566806$var$Ie(c, d) || !$e1ec086d45566806$var$Ie(e, f) : !0;
}
function $e1ec086d45566806$var$ph(a, b, c) {
    var d = !1, e = $e1ec086d45566806$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e1ec086d45566806$var$Vg(f) : (e = $e1ec086d45566806$var$Zf(b) ? $e1ec086d45566806$var$Xf : $e1ec086d45566806$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e1ec086d45566806$var$Yf(a, e) : $e1ec086d45566806$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e1ec086d45566806$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e1ec086d45566806$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e1ec086d45566806$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e1ec086d45566806$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e1ec086d45566806$var$jh;
    $e1ec086d45566806$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e1ec086d45566806$var$Vg(f) : (f = $e1ec086d45566806$var$Zf(b) ? $e1ec086d45566806$var$Xf : $e1ec086d45566806$var$H.current, e.context = $e1ec086d45566806$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e1ec086d45566806$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e1ec086d45566806$var$nh.enqueueReplaceState(e, e.state, null), $e1ec086d45566806$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e1ec086d45566806$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e1ec086d45566806$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e1ec086d45566806$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e1ec086d45566806$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e1ec086d45566806$var$p(284));
        if (!c._owner) throw Error($e1ec086d45566806$var$p(290, a));
    }
    return a;
}
function $e1ec086d45566806$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e1ec086d45566806$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e1ec086d45566806$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e1ec086d45566806$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e1ec086d45566806$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e1ec086d45566806$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e1ec086d45566806$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e1ec086d45566806$var$Ha && $e1ec086d45566806$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e1ec086d45566806$var$sh(a, b, c), d.return = a, d;
        d = $e1ec086d45566806$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e1ec086d45566806$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e1ec086d45566806$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e1ec086d45566806$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e1ec086d45566806$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e1ec086d45566806$var$va:
                    return c = $e1ec086d45566806$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e1ec086d45566806$var$sh(a, null, b), c.return = a, c;
                case $e1ec086d45566806$var$wa:
                    return b = $e1ec086d45566806$var$zh(b, a.mode, c), b.return = a, b;
                case $e1ec086d45566806$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e1ec086d45566806$var$eb(b) || $e1ec086d45566806$var$Ka(b)) return b = $e1ec086d45566806$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e1ec086d45566806$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e1ec086d45566806$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e1ec086d45566806$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e1ec086d45566806$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e1ec086d45566806$var$eb(c) || $e1ec086d45566806$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e1ec086d45566806$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e1ec086d45566806$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e1ec086d45566806$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e1ec086d45566806$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e1ec086d45566806$var$eb(d) || $e1ec086d45566806$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e1ec086d45566806$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e1ec086d45566806$var$I && $e1ec086d45566806$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e1ec086d45566806$var$I && $e1ec086d45566806$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e1ec086d45566806$var$I && $e1ec086d45566806$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e1ec086d45566806$var$Ka(h);
        if ("function" !== typeof l) throw Error($e1ec086d45566806$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e1ec086d45566806$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e1ec086d45566806$var$I && $e1ec086d45566806$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e1ec086d45566806$var$I && $e1ec086d45566806$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e1ec086d45566806$var$I && $e1ec086d45566806$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e1ec086d45566806$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e1ec086d45566806$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e1ec086d45566806$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e1ec086d45566806$var$Ha && $e1ec086d45566806$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e1ec086d45566806$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e1ec086d45566806$var$ya ? (d = $e1ec086d45566806$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e1ec086d45566806$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e1ec086d45566806$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e1ec086d45566806$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e1ec086d45566806$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e1ec086d45566806$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e1ec086d45566806$var$eb(f)) return n(a, d, f, h);
            if ($e1ec086d45566806$var$Ka(f)) return t(a, d, f, h);
            $e1ec086d45566806$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e1ec086d45566806$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e1ec086d45566806$var$Bh = $e1ec086d45566806$var$vh(!0), $e1ec086d45566806$var$Ch = $e1ec086d45566806$var$vh(!1), $e1ec086d45566806$var$Dh = {}, $e1ec086d45566806$var$Eh = $e1ec086d45566806$var$Uf($e1ec086d45566806$var$Dh), $e1ec086d45566806$var$Fh = $e1ec086d45566806$var$Uf($e1ec086d45566806$var$Dh), $e1ec086d45566806$var$Gh = $e1ec086d45566806$var$Uf($e1ec086d45566806$var$Dh);
function $e1ec086d45566806$var$Hh(a) {
    if (a === $e1ec086d45566806$var$Dh) throw Error($e1ec086d45566806$var$p(174));
    return a;
}
function $e1ec086d45566806$var$Ih(a, b) {
    $e1ec086d45566806$var$G($e1ec086d45566806$var$Gh, b);
    $e1ec086d45566806$var$G($e1ec086d45566806$var$Fh, a);
    $e1ec086d45566806$var$G($e1ec086d45566806$var$Eh, $e1ec086d45566806$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e1ec086d45566806$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e1ec086d45566806$var$lb(b, a);
    }
    $e1ec086d45566806$var$E($e1ec086d45566806$var$Eh);
    $e1ec086d45566806$var$G($e1ec086d45566806$var$Eh, b);
}
function $e1ec086d45566806$var$Jh() {
    $e1ec086d45566806$var$E($e1ec086d45566806$var$Eh);
    $e1ec086d45566806$var$E($e1ec086d45566806$var$Fh);
    $e1ec086d45566806$var$E($e1ec086d45566806$var$Gh);
}
function $e1ec086d45566806$var$Kh(a) {
    $e1ec086d45566806$var$Hh($e1ec086d45566806$var$Gh.current);
    var b = $e1ec086d45566806$var$Hh($e1ec086d45566806$var$Eh.current);
    var c = $e1ec086d45566806$var$lb(b, a.type);
    b !== c && ($e1ec086d45566806$var$G($e1ec086d45566806$var$Fh, a), $e1ec086d45566806$var$G($e1ec086d45566806$var$Eh, c));
}
function $e1ec086d45566806$var$Lh(a) {
    $e1ec086d45566806$var$Fh.current === a && ($e1ec086d45566806$var$E($e1ec086d45566806$var$Eh), $e1ec086d45566806$var$E($e1ec086d45566806$var$Fh));
}
var $e1ec086d45566806$var$M = $e1ec086d45566806$var$Uf(0);
function $e1ec086d45566806$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e1ec086d45566806$var$Nh = [];
function $e1ec086d45566806$var$Oh() {
    for(var a = 0; a < $e1ec086d45566806$var$Nh.length; a++)$e1ec086d45566806$var$Nh[a]._workInProgressVersionPrimary = null;
    $e1ec086d45566806$var$Nh.length = 0;
}
var $e1ec086d45566806$var$Ph = $e1ec086d45566806$var$ua.ReactCurrentDispatcher, $e1ec086d45566806$var$Qh = $e1ec086d45566806$var$ua.ReactCurrentBatchConfig, $e1ec086d45566806$var$Rh = 0, $e1ec086d45566806$var$N = null, $e1ec086d45566806$var$O = null, $e1ec086d45566806$var$P = null, $e1ec086d45566806$var$Sh = !1, $e1ec086d45566806$var$Th = !1, $e1ec086d45566806$var$Uh = 0, $e1ec086d45566806$var$Vh = 0;
function $e1ec086d45566806$var$Q() {
    throw Error($e1ec086d45566806$var$p(321));
}
function $e1ec086d45566806$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e1ec086d45566806$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e1ec086d45566806$var$Xh(a, b, c, d, e, f) {
    $e1ec086d45566806$var$Rh = f;
    $e1ec086d45566806$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e1ec086d45566806$var$Ph.current = null === a || null === a.memoizedState ? $e1ec086d45566806$var$Yh : $e1ec086d45566806$var$Zh;
    a = c(d, e);
    if ($e1ec086d45566806$var$Th) {
        f = 0;
        do {
            $e1ec086d45566806$var$Th = !1;
            $e1ec086d45566806$var$Uh = 0;
            if (25 <= f) throw Error($e1ec086d45566806$var$p(301));
            f += 1;
            $e1ec086d45566806$var$P = $e1ec086d45566806$var$O = null;
            b.updateQueue = null;
            $e1ec086d45566806$var$Ph.current = $e1ec086d45566806$var$$h;
            a = c(d, e);
        }while ($e1ec086d45566806$var$Th);
    }
    $e1ec086d45566806$var$Ph.current = $e1ec086d45566806$var$ai;
    b = null !== $e1ec086d45566806$var$O && null !== $e1ec086d45566806$var$O.next;
    $e1ec086d45566806$var$Rh = 0;
    $e1ec086d45566806$var$P = $e1ec086d45566806$var$O = $e1ec086d45566806$var$N = null;
    $e1ec086d45566806$var$Sh = !1;
    if (b) throw Error($e1ec086d45566806$var$p(300));
    return a;
}
function $e1ec086d45566806$var$bi() {
    var a = 0 !== $e1ec086d45566806$var$Uh;
    $e1ec086d45566806$var$Uh = 0;
    return a;
}
function $e1ec086d45566806$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e1ec086d45566806$var$P ? $e1ec086d45566806$var$N.memoizedState = $e1ec086d45566806$var$P = a : $e1ec086d45566806$var$P = $e1ec086d45566806$var$P.next = a;
    return $e1ec086d45566806$var$P;
}
function $e1ec086d45566806$var$di() {
    if (null === $e1ec086d45566806$var$O) {
        var a = $e1ec086d45566806$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e1ec086d45566806$var$O.next;
    var b = null === $e1ec086d45566806$var$P ? $e1ec086d45566806$var$N.memoizedState : $e1ec086d45566806$var$P.next;
    if (null !== b) $e1ec086d45566806$var$P = b, $e1ec086d45566806$var$O = a;
    else {
        if (null === a) throw Error($e1ec086d45566806$var$p(310));
        $e1ec086d45566806$var$O = a;
        a = {
            memoizedState: $e1ec086d45566806$var$O.memoizedState,
            baseState: $e1ec086d45566806$var$O.baseState,
            baseQueue: $e1ec086d45566806$var$O.baseQueue,
            queue: $e1ec086d45566806$var$O.queue,
            next: null
        };
        null === $e1ec086d45566806$var$P ? $e1ec086d45566806$var$N.memoizedState = $e1ec086d45566806$var$P = a : $e1ec086d45566806$var$P = $e1ec086d45566806$var$P.next = a;
    }
    return $e1ec086d45566806$var$P;
}
function $e1ec086d45566806$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e1ec086d45566806$var$fi(a) {
    var b = $e1ec086d45566806$var$di(), c = b.queue;
    if (null === c) throw Error($e1ec086d45566806$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e1ec086d45566806$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e1ec086d45566806$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e1ec086d45566806$var$N.lanes |= m;
                $e1ec086d45566806$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e1ec086d45566806$var$He(d, b.memoizedState) || ($e1ec086d45566806$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e1ec086d45566806$var$N.lanes |= f, $e1ec086d45566806$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e1ec086d45566806$var$gi(a) {
    var b = $e1ec086d45566806$var$di(), c = b.queue;
    if (null === c) throw Error($e1ec086d45566806$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e1ec086d45566806$var$He(f, b.memoizedState) || ($e1ec086d45566806$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e1ec086d45566806$var$hi() {}
function $e1ec086d45566806$var$ii(a, b) {
    var c = $e1ec086d45566806$var$N, d = $e1ec086d45566806$var$di(), e = b(), f = !$e1ec086d45566806$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e1ec086d45566806$var$Ug = !0);
    d = d.queue;
    $e1ec086d45566806$var$ji($e1ec086d45566806$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e1ec086d45566806$var$P && $e1ec086d45566806$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e1ec086d45566806$var$li(9, $e1ec086d45566806$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e1ec086d45566806$var$R) throw Error($e1ec086d45566806$var$p(349));
        0 !== ($e1ec086d45566806$var$Rh & 30) || $e1ec086d45566806$var$ni(c, b, e);
    }
    return e;
}
function $e1ec086d45566806$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e1ec086d45566806$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e1ec086d45566806$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e1ec086d45566806$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e1ec086d45566806$var$oi(b) && $e1ec086d45566806$var$pi(a);
}
function $e1ec086d45566806$var$ki(a, b, c) {
    return c(function() {
        $e1ec086d45566806$var$oi(b) && $e1ec086d45566806$var$pi(a);
    });
}
function $e1ec086d45566806$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e1ec086d45566806$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e1ec086d45566806$var$pi(a) {
    var b = $e1ec086d45566806$var$Zg(a, 1);
    null !== b && $e1ec086d45566806$var$mh(b, a, 1, -1);
}
function $e1ec086d45566806$var$qi(a) {
    var b = $e1ec086d45566806$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e1ec086d45566806$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e1ec086d45566806$var$ri.bind(null, $e1ec086d45566806$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e1ec086d45566806$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e1ec086d45566806$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e1ec086d45566806$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e1ec086d45566806$var$si() {
    return $e1ec086d45566806$var$di().memoizedState;
}
function $e1ec086d45566806$var$ti(a, b, c, d) {
    var e = $e1ec086d45566806$var$ci();
    $e1ec086d45566806$var$N.flags |= a;
    e.memoizedState = $e1ec086d45566806$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e1ec086d45566806$var$ui(a, b, c, d) {
    var e = $e1ec086d45566806$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e1ec086d45566806$var$O) {
        var g = $e1ec086d45566806$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e1ec086d45566806$var$Wh(d, g.deps)) {
            e.memoizedState = $e1ec086d45566806$var$li(b, c, f, d);
            return;
        }
    }
    $e1ec086d45566806$var$N.flags |= a;
    e.memoizedState = $e1ec086d45566806$var$li(1 | b, c, f, d);
}
function $e1ec086d45566806$var$vi(a, b) {
    return $e1ec086d45566806$var$ti(8390656, 8, a, b);
}
function $e1ec086d45566806$var$ji(a, b) {
    return $e1ec086d45566806$var$ui(2048, 8, a, b);
}
function $e1ec086d45566806$var$wi(a, b) {
    return $e1ec086d45566806$var$ui(4, 2, a, b);
}
function $e1ec086d45566806$var$xi(a, b) {
    return $e1ec086d45566806$var$ui(4, 4, a, b);
}
function $e1ec086d45566806$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e1ec086d45566806$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e1ec086d45566806$var$ui(4, 4, $e1ec086d45566806$var$yi.bind(null, b, a), c);
}
function $e1ec086d45566806$var$Ai() {}
function $e1ec086d45566806$var$Bi(a, b) {
    var c = $e1ec086d45566806$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e1ec086d45566806$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e1ec086d45566806$var$Ci(a, b) {
    var c = $e1ec086d45566806$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e1ec086d45566806$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e1ec086d45566806$var$Di(a, b, c) {
    if (0 === ($e1ec086d45566806$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e1ec086d45566806$var$Ug = !0), a.memoizedState = c;
    $e1ec086d45566806$var$He(c, b) || (c = $e1ec086d45566806$var$yc(), $e1ec086d45566806$var$N.lanes |= c, $e1ec086d45566806$var$hh |= c, a.baseState = !0);
    return b;
}
function $e1ec086d45566806$var$Ei(a, b) {
    var c = $e1ec086d45566806$var$C;
    $e1ec086d45566806$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e1ec086d45566806$var$Qh.transition;
    $e1ec086d45566806$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e1ec086d45566806$var$C = c, $e1ec086d45566806$var$Qh.transition = d;
    }
}
function $e1ec086d45566806$var$Fi() {
    return $e1ec086d45566806$var$di().memoizedState;
}
function $e1ec086d45566806$var$Gi(a, b, c) {
    var d = $e1ec086d45566806$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e1ec086d45566806$var$Hi(a)) $e1ec086d45566806$var$Ii(b, c);
    else if (c = $e1ec086d45566806$var$Yg(a, b, c, d), null !== c) {
        var e = $e1ec086d45566806$var$L();
        $e1ec086d45566806$var$mh(c, a, d, e);
        $e1ec086d45566806$var$Ji(c, b, d);
    }
}
function $e1ec086d45566806$var$ri(a, b, c) {
    var d = $e1ec086d45566806$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e1ec086d45566806$var$Hi(a)) $e1ec086d45566806$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e1ec086d45566806$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e1ec086d45566806$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e1ec086d45566806$var$Yg(a, b, e, d);
        null !== c && (e = $e1ec086d45566806$var$L(), $e1ec086d45566806$var$mh(c, a, d, e), $e1ec086d45566806$var$Ji(c, b, d));
    }
}
function $e1ec086d45566806$var$Hi(a) {
    var b = a.alternate;
    return a === $e1ec086d45566806$var$N || null !== b && b === $e1ec086d45566806$var$N;
}
function $e1ec086d45566806$var$Ii(a, b) {
    $e1ec086d45566806$var$Th = $e1ec086d45566806$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e1ec086d45566806$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e1ec086d45566806$var$Cc(a, c);
    }
}
var $e1ec086d45566806$var$ai = {
    readContext: $e1ec086d45566806$var$Vg,
    useCallback: $e1ec086d45566806$var$Q,
    useContext: $e1ec086d45566806$var$Q,
    useEffect: $e1ec086d45566806$var$Q,
    useImperativeHandle: $e1ec086d45566806$var$Q,
    useInsertionEffect: $e1ec086d45566806$var$Q,
    useLayoutEffect: $e1ec086d45566806$var$Q,
    useMemo: $e1ec086d45566806$var$Q,
    useReducer: $e1ec086d45566806$var$Q,
    useRef: $e1ec086d45566806$var$Q,
    useState: $e1ec086d45566806$var$Q,
    useDebugValue: $e1ec086d45566806$var$Q,
    useDeferredValue: $e1ec086d45566806$var$Q,
    useTransition: $e1ec086d45566806$var$Q,
    useMutableSource: $e1ec086d45566806$var$Q,
    useSyncExternalStore: $e1ec086d45566806$var$Q,
    useId: $e1ec086d45566806$var$Q,
    unstable_isNewReconciler: !1
}, $e1ec086d45566806$var$Yh = {
    readContext: $e1ec086d45566806$var$Vg,
    useCallback: function(a, b) {
        $e1ec086d45566806$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e1ec086d45566806$var$Vg,
    useEffect: $e1ec086d45566806$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e1ec086d45566806$var$ti(4194308, 4, $e1ec086d45566806$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e1ec086d45566806$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e1ec086d45566806$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e1ec086d45566806$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e1ec086d45566806$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e1ec086d45566806$var$Gi.bind(null, $e1ec086d45566806$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e1ec086d45566806$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e1ec086d45566806$var$qi,
    useDebugValue: $e1ec086d45566806$var$Ai,
    useDeferredValue: function(a) {
        return $e1ec086d45566806$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e1ec086d45566806$var$qi(!1), b = a[0];
        a = $e1ec086d45566806$var$Ei.bind(null, a[1]);
        $e1ec086d45566806$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e1ec086d45566806$var$N, e = $e1ec086d45566806$var$ci();
        if ($e1ec086d45566806$var$I) {
            if (void 0 === c) throw Error($e1ec086d45566806$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e1ec086d45566806$var$R) throw Error($e1ec086d45566806$var$p(349));
            0 !== ($e1ec086d45566806$var$Rh & 30) || $e1ec086d45566806$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e1ec086d45566806$var$vi($e1ec086d45566806$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e1ec086d45566806$var$li(9, $e1ec086d45566806$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e1ec086d45566806$var$ci(), b = $e1ec086d45566806$var$R.identifierPrefix;
        if ($e1ec086d45566806$var$I) {
            var c = $e1ec086d45566806$var$sg;
            var d = $e1ec086d45566806$var$rg;
            c = (d & ~(1 << 32 - $e1ec086d45566806$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e1ec086d45566806$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e1ec086d45566806$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e1ec086d45566806$var$Zh = {
    readContext: $e1ec086d45566806$var$Vg,
    useCallback: $e1ec086d45566806$var$Bi,
    useContext: $e1ec086d45566806$var$Vg,
    useEffect: $e1ec086d45566806$var$ji,
    useImperativeHandle: $e1ec086d45566806$var$zi,
    useInsertionEffect: $e1ec086d45566806$var$wi,
    useLayoutEffect: $e1ec086d45566806$var$xi,
    useMemo: $e1ec086d45566806$var$Ci,
    useReducer: $e1ec086d45566806$var$fi,
    useRef: $e1ec086d45566806$var$si,
    useState: function() {
        return $e1ec086d45566806$var$fi($e1ec086d45566806$var$ei);
    },
    useDebugValue: $e1ec086d45566806$var$Ai,
    useDeferredValue: function(a) {
        var b = $e1ec086d45566806$var$di();
        return $e1ec086d45566806$var$Di(b, $e1ec086d45566806$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e1ec086d45566806$var$fi($e1ec086d45566806$var$ei)[0], b = $e1ec086d45566806$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e1ec086d45566806$var$hi,
    useSyncExternalStore: $e1ec086d45566806$var$ii,
    useId: $e1ec086d45566806$var$Fi,
    unstable_isNewReconciler: !1
}, $e1ec086d45566806$var$$h = {
    readContext: $e1ec086d45566806$var$Vg,
    useCallback: $e1ec086d45566806$var$Bi,
    useContext: $e1ec086d45566806$var$Vg,
    useEffect: $e1ec086d45566806$var$ji,
    useImperativeHandle: $e1ec086d45566806$var$zi,
    useInsertionEffect: $e1ec086d45566806$var$wi,
    useLayoutEffect: $e1ec086d45566806$var$xi,
    useMemo: $e1ec086d45566806$var$Ci,
    useReducer: $e1ec086d45566806$var$gi,
    useRef: $e1ec086d45566806$var$si,
    useState: function() {
        return $e1ec086d45566806$var$gi($e1ec086d45566806$var$ei);
    },
    useDebugValue: $e1ec086d45566806$var$Ai,
    useDeferredValue: function(a) {
        var b = $e1ec086d45566806$var$di();
        return null === $e1ec086d45566806$var$O ? b.memoizedState = a : $e1ec086d45566806$var$Di(b, $e1ec086d45566806$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e1ec086d45566806$var$gi($e1ec086d45566806$var$ei)[0], b = $e1ec086d45566806$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e1ec086d45566806$var$hi,
    useSyncExternalStore: $e1ec086d45566806$var$ii,
    useId: $e1ec086d45566806$var$Fi,
    unstable_isNewReconciler: !1
};
function $e1ec086d45566806$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e1ec086d45566806$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e1ec086d45566806$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e1ec086d45566806$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e1ec086d45566806$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e1ec086d45566806$var$Oi(a, b, c) {
    c = $e1ec086d45566806$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e1ec086d45566806$var$Pi || ($e1ec086d45566806$var$Pi = !0, $e1ec086d45566806$var$Qi = d);
        $e1ec086d45566806$var$Mi(a, b);
    };
    return c;
}
function $e1ec086d45566806$var$Ri(a, b, c) {
    c = $e1ec086d45566806$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e1ec086d45566806$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e1ec086d45566806$var$Mi(a, b);
        "function" !== typeof d && (null === $e1ec086d45566806$var$Si ? $e1ec086d45566806$var$Si = new Set([
            this
        ]) : $e1ec086d45566806$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e1ec086d45566806$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e1ec086d45566806$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e1ec086d45566806$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e1ec086d45566806$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e1ec086d45566806$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e1ec086d45566806$var$ch(-1, 1), b.tag = 2, $e1ec086d45566806$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e1ec086d45566806$var$Xi = $e1ec086d45566806$var$ua.ReactCurrentOwner, $e1ec086d45566806$var$Ug = !1;
function $e1ec086d45566806$var$Yi(a, b, c, d) {
    b.child = null === a ? $e1ec086d45566806$var$Ch(b, null, c, d) : $e1ec086d45566806$var$Bh(b, a.child, c, d);
}
function $e1ec086d45566806$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e1ec086d45566806$var$Tg(b, e);
    d = $e1ec086d45566806$var$Xh(a, b, c, d, f, e);
    c = $e1ec086d45566806$var$bi();
    if (null !== a && !$e1ec086d45566806$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e1ec086d45566806$var$$i(a, b, e);
    $e1ec086d45566806$var$I && c && $e1ec086d45566806$var$vg(b);
    b.flags |= 1;
    $e1ec086d45566806$var$Yi(a, b, d, e);
    return b.child;
}
function $e1ec086d45566806$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e1ec086d45566806$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e1ec086d45566806$var$cj(a, b, f, d, e);
        a = $e1ec086d45566806$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e1ec086d45566806$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e1ec086d45566806$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e1ec086d45566806$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e1ec086d45566806$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e1ec086d45566806$var$Ie(f, d) && a.ref === b.ref) {
            if ($e1ec086d45566806$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e1ec086d45566806$var$Ug = !0);
            else return b.lanes = a.lanes, $e1ec086d45566806$var$$i(a, b, e);
        }
    }
    return $e1ec086d45566806$var$dj(a, b, c, d, e);
}
function $e1ec086d45566806$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e1ec086d45566806$var$G($e1ec086d45566806$var$fj, $e1ec086d45566806$var$gj), $e1ec086d45566806$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e1ec086d45566806$var$G($e1ec086d45566806$var$fj, $e1ec086d45566806$var$gj), $e1ec086d45566806$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e1ec086d45566806$var$G($e1ec086d45566806$var$fj, $e1ec086d45566806$var$gj);
            $e1ec086d45566806$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e1ec086d45566806$var$G($e1ec086d45566806$var$fj, $e1ec086d45566806$var$gj), $e1ec086d45566806$var$gj |= d;
    $e1ec086d45566806$var$Yi(a, b, e, c);
    return b.child;
}
function $e1ec086d45566806$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e1ec086d45566806$var$dj(a, b, c, d, e) {
    var f = $e1ec086d45566806$var$Zf(c) ? $e1ec086d45566806$var$Xf : $e1ec086d45566806$var$H.current;
    f = $e1ec086d45566806$var$Yf(b, f);
    $e1ec086d45566806$var$Tg(b, e);
    c = $e1ec086d45566806$var$Xh(a, b, c, d, f, e);
    d = $e1ec086d45566806$var$bi();
    if (null !== a && !$e1ec086d45566806$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e1ec086d45566806$var$$i(a, b, e);
    $e1ec086d45566806$var$I && d && $e1ec086d45566806$var$vg(b);
    b.flags |= 1;
    $e1ec086d45566806$var$Yi(a, b, c, e);
    return b.child;
}
function $e1ec086d45566806$var$ij(a, b, c, d, e) {
    if ($e1ec086d45566806$var$Zf(c)) {
        var f = !0;
        $e1ec086d45566806$var$cg(b);
    } else f = !1;
    $e1ec086d45566806$var$Tg(b, e);
    if (null === b.stateNode) $e1ec086d45566806$var$jj(a, b), $e1ec086d45566806$var$ph(b, c, d), $e1ec086d45566806$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e1ec086d45566806$var$Vg(l) : (l = $e1ec086d45566806$var$Zf(c) ? $e1ec086d45566806$var$Xf : $e1ec086d45566806$var$H.current, l = $e1ec086d45566806$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e1ec086d45566806$var$qh(b, g, d, l);
        $e1ec086d45566806$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e1ec086d45566806$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e1ec086d45566806$var$Wf.current || $e1ec086d45566806$var$$g ? ("function" === typeof m && ($e1ec086d45566806$var$kh(b, c, m, d), k = b.memoizedState), (h = $e1ec086d45566806$var$$g || $e1ec086d45566806$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e1ec086d45566806$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e1ec086d45566806$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e1ec086d45566806$var$Vg(k) : (k = $e1ec086d45566806$var$Zf(c) ? $e1ec086d45566806$var$Xf : $e1ec086d45566806$var$H.current, k = $e1ec086d45566806$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e1ec086d45566806$var$qh(b, g, d, k);
        $e1ec086d45566806$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e1ec086d45566806$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e1ec086d45566806$var$Wf.current || $e1ec086d45566806$var$$g ? ("function" === typeof y && ($e1ec086d45566806$var$kh(b, c, y, d), n = b.memoizedState), (l = $e1ec086d45566806$var$$g || $e1ec086d45566806$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e1ec086d45566806$var$kj(a, b, c, d, f, e);
}
function $e1ec086d45566806$var$kj(a, b, c, d, e, f) {
    $e1ec086d45566806$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e1ec086d45566806$var$dg(b, c, !1), $e1ec086d45566806$var$$i(a, b, f);
    d = b.stateNode;
    $e1ec086d45566806$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e1ec086d45566806$var$Bh(b, a.child, null, f), b.child = $e1ec086d45566806$var$Bh(b, null, h, f)) : $e1ec086d45566806$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e1ec086d45566806$var$dg(b, c, !0);
    return b.child;
}
function $e1ec086d45566806$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e1ec086d45566806$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e1ec086d45566806$var$ag(a, b.context, !1);
    $e1ec086d45566806$var$Ih(a, b.containerInfo);
}
function $e1ec086d45566806$var$mj(a, b, c, d, e) {
    $e1ec086d45566806$var$Ig();
    $e1ec086d45566806$var$Jg(e);
    b.flags |= 256;
    $e1ec086d45566806$var$Yi(a, b, c, d);
    return b.child;
}
var $e1ec086d45566806$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e1ec086d45566806$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e1ec086d45566806$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e1ec086d45566806$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e1ec086d45566806$var$G($e1ec086d45566806$var$M, e & 1);
    if (null === a) {
        $e1ec086d45566806$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e1ec086d45566806$var$qj(g, d, 0, null), a = $e1ec086d45566806$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e1ec086d45566806$var$oj(c), b.memoizedState = $e1ec086d45566806$var$nj, a) : $e1ec086d45566806$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e1ec086d45566806$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e1ec086d45566806$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e1ec086d45566806$var$wh(h, f) : (f = $e1ec086d45566806$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e1ec086d45566806$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e1ec086d45566806$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e1ec086d45566806$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e1ec086d45566806$var$rj(a, b) {
    b = $e1ec086d45566806$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e1ec086d45566806$var$tj(a, b, c, d) {
    null !== d && $e1ec086d45566806$var$Jg(d);
    $e1ec086d45566806$var$Bh(b, a.child, null, c);
    a = $e1ec086d45566806$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e1ec086d45566806$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e1ec086d45566806$var$Li(Error($e1ec086d45566806$var$p(422))), $e1ec086d45566806$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e1ec086d45566806$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e1ec086d45566806$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e1ec086d45566806$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e1ec086d45566806$var$oj(g);
        b.memoizedState = $e1ec086d45566806$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e1ec086d45566806$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e1ec086d45566806$var$p(419));
        d = $e1ec086d45566806$var$Li(f, d, void 0);
        return $e1ec086d45566806$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e1ec086d45566806$var$Ug || h) {
        d = $e1ec086d45566806$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e1ec086d45566806$var$Zg(a, e), $e1ec086d45566806$var$mh(d, a, e, -1));
        }
        $e1ec086d45566806$var$uj();
        d = $e1ec086d45566806$var$Li(Error($e1ec086d45566806$var$p(421)));
        return $e1ec086d45566806$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e1ec086d45566806$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e1ec086d45566806$var$yg = $e1ec086d45566806$var$Lf(e.nextSibling);
    $e1ec086d45566806$var$xg = b;
    $e1ec086d45566806$var$I = !0;
    $e1ec086d45566806$var$zg = null;
    null !== a && ($e1ec086d45566806$var$og[$e1ec086d45566806$var$pg++] = $e1ec086d45566806$var$rg, $e1ec086d45566806$var$og[$e1ec086d45566806$var$pg++] = $e1ec086d45566806$var$sg, $e1ec086d45566806$var$og[$e1ec086d45566806$var$pg++] = $e1ec086d45566806$var$qg, $e1ec086d45566806$var$rg = a.id, $e1ec086d45566806$var$sg = a.overflow, $e1ec086d45566806$var$qg = b);
    b = $e1ec086d45566806$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e1ec086d45566806$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e1ec086d45566806$var$Sg(a.return, b, c);
}
function $e1ec086d45566806$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e1ec086d45566806$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e1ec086d45566806$var$Yi(a, b, d.children, c);
    d = $e1ec086d45566806$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e1ec086d45566806$var$wj(a, c, b);
            else if (19 === a.tag) $e1ec086d45566806$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e1ec086d45566806$var$G($e1ec086d45566806$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e1ec086d45566806$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e1ec086d45566806$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e1ec086d45566806$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e1ec086d45566806$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e1ec086d45566806$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e1ec086d45566806$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e1ec086d45566806$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e1ec086d45566806$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e1ec086d45566806$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e1ec086d45566806$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e1ec086d45566806$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e1ec086d45566806$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e1ec086d45566806$var$lj(b);
            $e1ec086d45566806$var$Ig();
            break;
        case 5:
            $e1ec086d45566806$var$Kh(b);
            break;
        case 1:
            $e1ec086d45566806$var$Zf(b.type) && $e1ec086d45566806$var$cg(b);
            break;
        case 4:
            $e1ec086d45566806$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e1ec086d45566806$var$G($e1ec086d45566806$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e1ec086d45566806$var$G($e1ec086d45566806$var$M, $e1ec086d45566806$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e1ec086d45566806$var$pj(a, b, c);
                $e1ec086d45566806$var$G($e1ec086d45566806$var$M, $e1ec086d45566806$var$M.current & 1);
                a = $e1ec086d45566806$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e1ec086d45566806$var$G($e1ec086d45566806$var$M, $e1ec086d45566806$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e1ec086d45566806$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e1ec086d45566806$var$G($e1ec086d45566806$var$M, $e1ec086d45566806$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e1ec086d45566806$var$ej(a, b, c);
    }
    return $e1ec086d45566806$var$$i(a, b, c);
}
var $e1ec086d45566806$var$Aj, $e1ec086d45566806$var$Bj, $e1ec086d45566806$var$Cj, $e1ec086d45566806$var$Dj;
$e1ec086d45566806$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e1ec086d45566806$var$Bj = function() {};
$e1ec086d45566806$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e1ec086d45566806$var$Hh($e1ec086d45566806$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e1ec086d45566806$var$Ya(a, e);
                d = $e1ec086d45566806$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e1ec086d45566806$var$A({}, e, {
                    value: void 0
                });
                d = $e1ec086d45566806$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e1ec086d45566806$var$gb(a, e);
                d = $e1ec086d45566806$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e1ec086d45566806$var$Bf);
        }
        $e1ec086d45566806$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e1ec086d45566806$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e1ec086d45566806$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e1ec086d45566806$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e1ec086d45566806$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e1ec086d45566806$var$Ej(a, b) {
    if (!$e1ec086d45566806$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e1ec086d45566806$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e1ec086d45566806$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e1ec086d45566806$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e1ec086d45566806$var$S(b), null;
        case 1:
            return $e1ec086d45566806$var$Zf(b.type) && $e1ec086d45566806$var$$f(), $e1ec086d45566806$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e1ec086d45566806$var$Jh();
            $e1ec086d45566806$var$E($e1ec086d45566806$var$Wf);
            $e1ec086d45566806$var$E($e1ec086d45566806$var$H);
            $e1ec086d45566806$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e1ec086d45566806$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e1ec086d45566806$var$zg && ($e1ec086d45566806$var$Gj($e1ec086d45566806$var$zg), $e1ec086d45566806$var$zg = null));
            $e1ec086d45566806$var$Bj(a, b);
            $e1ec086d45566806$var$S(b);
            return null;
        case 5:
            $e1ec086d45566806$var$Lh(b);
            var e = $e1ec086d45566806$var$Hh($e1ec086d45566806$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e1ec086d45566806$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e1ec086d45566806$var$p(166));
                    $e1ec086d45566806$var$S(b);
                    return null;
                }
                a = $e1ec086d45566806$var$Hh($e1ec086d45566806$var$Eh.current);
                if ($e1ec086d45566806$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e1ec086d45566806$var$Of] = b;
                    d[$e1ec086d45566806$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e1ec086d45566806$var$D("cancel", d);
                            $e1ec086d45566806$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e1ec086d45566806$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e1ec086d45566806$var$lf.length; e++)$e1ec086d45566806$var$D($e1ec086d45566806$var$lf[e], d);
                            break;
                        case "source":
                            $e1ec086d45566806$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e1ec086d45566806$var$D("error", d);
                            $e1ec086d45566806$var$D("load", d);
                            break;
                        case "details":
                            $e1ec086d45566806$var$D("toggle", d);
                            break;
                        case "input":
                            $e1ec086d45566806$var$Za(d, f);
                            $e1ec086d45566806$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e1ec086d45566806$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e1ec086d45566806$var$hb(d, f), $e1ec086d45566806$var$D("invalid", d);
                    }
                    $e1ec086d45566806$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e1ec086d45566806$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e1ec086d45566806$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e1ec086d45566806$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e1ec086d45566806$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e1ec086d45566806$var$Va(d);
                            $e1ec086d45566806$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e1ec086d45566806$var$Va(d);
                            $e1ec086d45566806$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e1ec086d45566806$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e1ec086d45566806$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e1ec086d45566806$var$Of] = b;
                    a[$e1ec086d45566806$var$Pf] = d;
                    $e1ec086d45566806$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e1ec086d45566806$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e1ec086d45566806$var$D("cancel", a);
                                $e1ec086d45566806$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e1ec086d45566806$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e1ec086d45566806$var$lf.length; e++)$e1ec086d45566806$var$D($e1ec086d45566806$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e1ec086d45566806$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e1ec086d45566806$var$D("error", a);
                                $e1ec086d45566806$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e1ec086d45566806$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e1ec086d45566806$var$Za(a, d);
                                e = $e1ec086d45566806$var$Ya(a, d);
                                $e1ec086d45566806$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e1ec086d45566806$var$A({}, d, {
                                    value: void 0
                                });
                                $e1ec086d45566806$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e1ec086d45566806$var$hb(a, d);
                                e = $e1ec086d45566806$var$gb(a, d);
                                $e1ec086d45566806$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e1ec086d45566806$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e1ec086d45566806$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e1ec086d45566806$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e1ec086d45566806$var$ob(a, k) : "number" === typeof k && $e1ec086d45566806$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e1ec086d45566806$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e1ec086d45566806$var$D("scroll", a) : null != k && $e1ec086d45566806$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e1ec086d45566806$var$Va(a);
                                $e1ec086d45566806$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e1ec086d45566806$var$Va(a);
                                $e1ec086d45566806$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e1ec086d45566806$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e1ec086d45566806$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e1ec086d45566806$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e1ec086d45566806$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e1ec086d45566806$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e1ec086d45566806$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e1ec086d45566806$var$p(166));
                c = $e1ec086d45566806$var$Hh($e1ec086d45566806$var$Gh.current);
                $e1ec086d45566806$var$Hh($e1ec086d45566806$var$Eh.current);
                if ($e1ec086d45566806$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e1ec086d45566806$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e1ec086d45566806$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e1ec086d45566806$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e1ec086d45566806$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e1ec086d45566806$var$Of] = b, b.stateNode = d;
            }
            $e1ec086d45566806$var$S(b);
            return null;
        case 13:
            $e1ec086d45566806$var$E($e1ec086d45566806$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e1ec086d45566806$var$I && null !== $e1ec086d45566806$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e1ec086d45566806$var$Hg(), $e1ec086d45566806$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e1ec086d45566806$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e1ec086d45566806$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e1ec086d45566806$var$p(317));
                        f[$e1ec086d45566806$var$Of] = b;
                    } else $e1ec086d45566806$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e1ec086d45566806$var$S(b);
                    f = !1;
                } else null !== $e1ec086d45566806$var$zg && ($e1ec086d45566806$var$Gj($e1ec086d45566806$var$zg), $e1ec086d45566806$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e1ec086d45566806$var$M.current & 1) ? 0 === $e1ec086d45566806$var$T && ($e1ec086d45566806$var$T = 3) : $e1ec086d45566806$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e1ec086d45566806$var$S(b);
            return null;
        case 4:
            return $e1ec086d45566806$var$Jh(), $e1ec086d45566806$var$Bj(a, b), null === a && $e1ec086d45566806$var$sf(b.stateNode.containerInfo), $e1ec086d45566806$var$S(b), null;
        case 10:
            return $e1ec086d45566806$var$Rg(b.type._context), $e1ec086d45566806$var$S(b), null;
        case 17:
            return $e1ec086d45566806$var$Zf(b.type) && $e1ec086d45566806$var$$f(), $e1ec086d45566806$var$S(b), null;
        case 19:
            $e1ec086d45566806$var$E($e1ec086d45566806$var$M);
            f = b.memoizedState;
            if (null === f) return $e1ec086d45566806$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e1ec086d45566806$var$Ej(f, !1);
                else {
                    if (0 !== $e1ec086d45566806$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e1ec086d45566806$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e1ec086d45566806$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e1ec086d45566806$var$G($e1ec086d45566806$var$M, $e1ec086d45566806$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e1ec086d45566806$var$B() > $e1ec086d45566806$var$Hj && (b.flags |= 128, d = !0, $e1ec086d45566806$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e1ec086d45566806$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e1ec086d45566806$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e1ec086d45566806$var$I) return $e1ec086d45566806$var$S(b), null;
                    } else 2 * $e1ec086d45566806$var$B() - f.renderingStartTime > $e1ec086d45566806$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e1ec086d45566806$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e1ec086d45566806$var$B(), b.sibling = null, c = $e1ec086d45566806$var$M.current, $e1ec086d45566806$var$G($e1ec086d45566806$var$M, d ? c & 1 | 2 : c & 1), b;
            $e1ec086d45566806$var$S(b);
            return null;
        case 22:
        case 23:
            return $e1ec086d45566806$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e1ec086d45566806$var$gj & 1073741824) && ($e1ec086d45566806$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e1ec086d45566806$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e1ec086d45566806$var$p(156, b.tag));
}
function $e1ec086d45566806$var$Jj(a, b) {
    $e1ec086d45566806$var$wg(b);
    switch(b.tag){
        case 1:
            return $e1ec086d45566806$var$Zf(b.type) && $e1ec086d45566806$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e1ec086d45566806$var$Jh(), $e1ec086d45566806$var$E($e1ec086d45566806$var$Wf), $e1ec086d45566806$var$E($e1ec086d45566806$var$H), $e1ec086d45566806$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e1ec086d45566806$var$Lh(b), null;
        case 13:
            $e1ec086d45566806$var$E($e1ec086d45566806$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e1ec086d45566806$var$p(340));
                $e1ec086d45566806$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e1ec086d45566806$var$E($e1ec086d45566806$var$M), null;
        case 4:
            return $e1ec086d45566806$var$Jh(), null;
        case 10:
            return $e1ec086d45566806$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e1ec086d45566806$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e1ec086d45566806$var$Kj = !1, $e1ec086d45566806$var$U = !1, $e1ec086d45566806$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e1ec086d45566806$var$V = null;
function $e1ec086d45566806$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e1ec086d45566806$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e1ec086d45566806$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e1ec086d45566806$var$W(a, b, d);
    }
}
var $e1ec086d45566806$var$Oj = !1;
function $e1ec086d45566806$var$Pj(a, b) {
    $e1ec086d45566806$var$Cf = $e1ec086d45566806$var$dd;
    a = $e1ec086d45566806$var$Me();
    if ($e1ec086d45566806$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e1ec086d45566806$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e1ec086d45566806$var$dd = !1;
    for($e1ec086d45566806$var$V = b; null !== $e1ec086d45566806$var$V;)if (b = $e1ec086d45566806$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e1ec086d45566806$var$V = a;
    else for(; null !== $e1ec086d45566806$var$V;){
        b = $e1ec086d45566806$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e1ec086d45566806$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e1ec086d45566806$var$p(163));
            }
        } catch (F) {
            $e1ec086d45566806$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e1ec086d45566806$var$V = a;
            break;
        }
        $e1ec086d45566806$var$V = b.return;
    }
    n = $e1ec086d45566806$var$Oj;
    $e1ec086d45566806$var$Oj = !1;
    return n;
}
function $e1ec086d45566806$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e1ec086d45566806$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e1ec086d45566806$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e1ec086d45566806$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e1ec086d45566806$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e1ec086d45566806$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e1ec086d45566806$var$Of], delete b[$e1ec086d45566806$var$Pf], delete b[$e1ec086d45566806$var$of], delete b[$e1ec086d45566806$var$Qf], delete b[$e1ec086d45566806$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e1ec086d45566806$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e1ec086d45566806$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e1ec086d45566806$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e1ec086d45566806$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e1ec086d45566806$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e1ec086d45566806$var$Wj(a, b, c), a = a.sibling; null !== a;)$e1ec086d45566806$var$Wj(a, b, c), a = a.sibling;
}
function $e1ec086d45566806$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e1ec086d45566806$var$Xj(a, b, c), a = a.sibling; null !== a;)$e1ec086d45566806$var$Xj(a, b, c), a = a.sibling;
}
var $e1ec086d45566806$var$X = null, $e1ec086d45566806$var$Yj = !1;
function $e1ec086d45566806$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e1ec086d45566806$var$ak(a, b, c), c = c.sibling;
}
function $e1ec086d45566806$var$ak(a, b, c) {
    if ($e1ec086d45566806$var$lc && "function" === typeof $e1ec086d45566806$var$lc.onCommitFiberUnmount) try {
        $e1ec086d45566806$var$lc.onCommitFiberUnmount($e1ec086d45566806$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e1ec086d45566806$var$U || $e1ec086d45566806$var$Mj(c, b);
        case 6:
            var d = $e1ec086d45566806$var$X, e = $e1ec086d45566806$var$Yj;
            $e1ec086d45566806$var$X = null;
            $e1ec086d45566806$var$Zj(a, b, c);
            $e1ec086d45566806$var$X = d;
            $e1ec086d45566806$var$Yj = e;
            null !== $e1ec086d45566806$var$X && ($e1ec086d45566806$var$Yj ? (a = $e1ec086d45566806$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e1ec086d45566806$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e1ec086d45566806$var$X && ($e1ec086d45566806$var$Yj ? (a = $e1ec086d45566806$var$X, c = c.stateNode, 8 === a.nodeType ? $e1ec086d45566806$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e1ec086d45566806$var$Kf(a, c), $e1ec086d45566806$var$bd(a)) : $e1ec086d45566806$var$Kf($e1ec086d45566806$var$X, c.stateNode));
            break;
        case 4:
            d = $e1ec086d45566806$var$X;
            e = $e1ec086d45566806$var$Yj;
            $e1ec086d45566806$var$X = c.stateNode.containerInfo;
            $e1ec086d45566806$var$Yj = !0;
            $e1ec086d45566806$var$Zj(a, b, c);
            $e1ec086d45566806$var$X = d;
            $e1ec086d45566806$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e1ec086d45566806$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e1ec086d45566806$var$Nj(c, b, g) : 0 !== (f & 4) && $e1ec086d45566806$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e1ec086d45566806$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e1ec086d45566806$var$U && ($e1ec086d45566806$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e1ec086d45566806$var$W(c, b, h);
            }
            $e1ec086d45566806$var$Zj(a, b, c);
            break;
        case 21:
            $e1ec086d45566806$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e1ec086d45566806$var$U = (d = $e1ec086d45566806$var$U) || null !== c.memoizedState, $e1ec086d45566806$var$Zj(a, b, c), $e1ec086d45566806$var$U = d) : $e1ec086d45566806$var$Zj(a, b, c);
            break;
        default:
            $e1ec086d45566806$var$Zj(a, b, c);
    }
}
function $e1ec086d45566806$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e1ec086d45566806$var$Lj);
        b.forEach(function(b) {
            var d = $e1ec086d45566806$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e1ec086d45566806$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e1ec086d45566806$var$X = h.stateNode;
                        $e1ec086d45566806$var$Yj = !1;
                        break a;
                    case 3:
                        $e1ec086d45566806$var$X = h.stateNode.containerInfo;
                        $e1ec086d45566806$var$Yj = !0;
                        break a;
                    case 4:
                        $e1ec086d45566806$var$X = h.stateNode.containerInfo;
                        $e1ec086d45566806$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e1ec086d45566806$var$X) throw Error($e1ec086d45566806$var$p(160));
            $e1ec086d45566806$var$ak(f, g, e);
            $e1ec086d45566806$var$X = null;
            $e1ec086d45566806$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e1ec086d45566806$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e1ec086d45566806$var$ek(b, a), b = b.sibling;
}
function $e1ec086d45566806$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            if (d & 4) {
                try {
                    $e1ec086d45566806$var$Qj(3, a, a.return), $e1ec086d45566806$var$Rj(3, a);
                } catch (t) {
                    $e1ec086d45566806$var$W(a, a.return, t);
                }
                try {
                    $e1ec086d45566806$var$Qj(5, a, a.return);
                } catch (t) {
                    $e1ec086d45566806$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            d & 512 && null !== c && $e1ec086d45566806$var$Mj(c, c.return);
            break;
        case 5:
            $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            d & 512 && null !== c && $e1ec086d45566806$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e1ec086d45566806$var$ob(e, "");
                } catch (t) {
                    $e1ec086d45566806$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e1ec086d45566806$var$ab(e, f);
                    $e1ec086d45566806$var$vb(h, g);
                    var l = $e1ec086d45566806$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e1ec086d45566806$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e1ec086d45566806$var$nb(e, q) : "children" === m ? $e1ec086d45566806$var$ob(e, q) : $e1ec086d45566806$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e1ec086d45566806$var$bb(e, f);
                            break;
                        case "textarea":
                            $e1ec086d45566806$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e1ec086d45566806$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e1ec086d45566806$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e1ec086d45566806$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e1ec086d45566806$var$Pf] = f;
                } catch (t) {
                    $e1ec086d45566806$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e1ec086d45566806$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e1ec086d45566806$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e1ec086d45566806$var$bd(b.containerInfo);
            } catch (t) {
                $e1ec086d45566806$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            break;
        case 13:
            $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e1ec086d45566806$var$gk = $e1ec086d45566806$var$B()));
            d & 4 && $e1ec086d45566806$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e1ec086d45566806$var$U = (l = $e1ec086d45566806$var$U) || m, $e1ec086d45566806$var$dk(b, a), $e1ec086d45566806$var$U = l) : $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e1ec086d45566806$var$V = a, m = a.child; null !== m;){
                    for(q = $e1ec086d45566806$var$V = m; null !== $e1ec086d45566806$var$V;){
                        r = $e1ec086d45566806$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e1ec086d45566806$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e1ec086d45566806$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e1ec086d45566806$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e1ec086d45566806$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e1ec086d45566806$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e1ec086d45566806$var$V = y) : $e1ec086d45566806$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e1ec086d45566806$var$rb("display", g));
                            } catch (t) {
                                $e1ec086d45566806$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e1ec086d45566806$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e1ec086d45566806$var$dk(b, a);
            $e1ec086d45566806$var$fk(a);
            d & 4 && $e1ec086d45566806$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e1ec086d45566806$var$dk(b, a), $e1ec086d45566806$var$fk(a);
    }
}
function $e1ec086d45566806$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e1ec086d45566806$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e1ec086d45566806$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e1ec086d45566806$var$ob(e, ""), d.flags &= -33);
                    var f = $e1ec086d45566806$var$Vj(a);
                    $e1ec086d45566806$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e1ec086d45566806$var$Vj(a);
                    $e1ec086d45566806$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e1ec086d45566806$var$p(161));
            }
        } catch (k) {
            $e1ec086d45566806$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e1ec086d45566806$var$ik(a, b, c) {
    $e1ec086d45566806$var$V = a;
    $e1ec086d45566806$var$jk(a, b, c);
}
function $e1ec086d45566806$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e1ec086d45566806$var$V;){
        var e = $e1ec086d45566806$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e1ec086d45566806$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e1ec086d45566806$var$U;
                h = $e1ec086d45566806$var$Kj;
                var l = $e1ec086d45566806$var$U;
                $e1ec086d45566806$var$Kj = g;
                if (($e1ec086d45566806$var$U = k) && !l) for($e1ec086d45566806$var$V = e; null !== $e1ec086d45566806$var$V;)g = $e1ec086d45566806$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e1ec086d45566806$var$kk(e) : null !== k ? (k.return = g, $e1ec086d45566806$var$V = k) : $e1ec086d45566806$var$kk(e);
                for(; null !== f;)$e1ec086d45566806$var$V = f, $e1ec086d45566806$var$jk(f, b, c), f = f.sibling;
                $e1ec086d45566806$var$V = e;
                $e1ec086d45566806$var$Kj = h;
                $e1ec086d45566806$var$U = l;
            }
            $e1ec086d45566806$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e1ec086d45566806$var$V = f) : $e1ec086d45566806$var$lk(a, b, c);
    }
}
function $e1ec086d45566806$var$lk(a) {
    for(; null !== $e1ec086d45566806$var$V;){
        var b = $e1ec086d45566806$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e1ec086d45566806$var$U || $e1ec086d45566806$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e1ec086d45566806$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e1ec086d45566806$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e1ec086d45566806$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e1ec086d45566806$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e1ec086d45566806$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e1ec086d45566806$var$p(163));
                }
                $e1ec086d45566806$var$U || b.flags & 512 && $e1ec086d45566806$var$Sj(b);
            } catch (r) {
                $e1ec086d45566806$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e1ec086d45566806$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e1ec086d45566806$var$V = c;
            break;
        }
        $e1ec086d45566806$var$V = b.return;
    }
}
function $e1ec086d45566806$var$hk(a) {
    for(; null !== $e1ec086d45566806$var$V;){
        var b = $e1ec086d45566806$var$V;
        if (b === a) {
            $e1ec086d45566806$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e1ec086d45566806$var$V = c;
            break;
        }
        $e1ec086d45566806$var$V = b.return;
    }
}
function $e1ec086d45566806$var$kk(a) {
    for(; null !== $e1ec086d45566806$var$V;){
        var b = $e1ec086d45566806$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e1ec086d45566806$var$Rj(4, b);
                    } catch (k) {
                        $e1ec086d45566806$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e1ec086d45566806$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e1ec086d45566806$var$Sj(b);
                    } catch (k) {
                        $e1ec086d45566806$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e1ec086d45566806$var$Sj(b);
                    } catch (k) {
                        $e1ec086d45566806$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e1ec086d45566806$var$W(b, b.return, k);
        }
        if (b === a) {
            $e1ec086d45566806$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e1ec086d45566806$var$V = h;
            break;
        }
        $e1ec086d45566806$var$V = b.return;
    }
}
var $e1ec086d45566806$var$mk = Math.ceil, $e1ec086d45566806$var$nk = $e1ec086d45566806$var$ua.ReactCurrentDispatcher, $e1ec086d45566806$var$ok = $e1ec086d45566806$var$ua.ReactCurrentOwner, $e1ec086d45566806$var$pk = $e1ec086d45566806$var$ua.ReactCurrentBatchConfig, $e1ec086d45566806$var$K = 0, $e1ec086d45566806$var$R = null, $e1ec086d45566806$var$Y = null, $e1ec086d45566806$var$Z = 0, $e1ec086d45566806$var$gj = 0, $e1ec086d45566806$var$fj = $e1ec086d45566806$var$Uf(0), $e1ec086d45566806$var$T = 0, $e1ec086d45566806$var$qk = null, $e1ec086d45566806$var$hh = 0, $e1ec086d45566806$var$rk = 0, $e1ec086d45566806$var$sk = 0, $e1ec086d45566806$var$tk = null, $e1ec086d45566806$var$uk = null, $e1ec086d45566806$var$gk = 0, $e1ec086d45566806$var$Hj = Infinity, $e1ec086d45566806$var$vk = null, $e1ec086d45566806$var$Pi = !1, $e1ec086d45566806$var$Qi = null, $e1ec086d45566806$var$Si = null, $e1ec086d45566806$var$wk = !1, $e1ec086d45566806$var$xk = null, $e1ec086d45566806$var$yk = 0, $e1ec086d45566806$var$zk = 0, $e1ec086d45566806$var$Ak = null, $e1ec086d45566806$var$Bk = -1, $e1ec086d45566806$var$Ck = 0;
function $e1ec086d45566806$var$L() {
    return 0 !== ($e1ec086d45566806$var$K & 6) ? $e1ec086d45566806$var$B() : -1 !== $e1ec086d45566806$var$Bk ? $e1ec086d45566806$var$Bk : $e1ec086d45566806$var$Bk = $e1ec086d45566806$var$B();
}
function $e1ec086d45566806$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e1ec086d45566806$var$K & 2) && 0 !== $e1ec086d45566806$var$Z) return $e1ec086d45566806$var$Z & -$e1ec086d45566806$var$Z;
    if (null !== $e1ec086d45566806$var$Kg.transition) return 0 === $e1ec086d45566806$var$Ck && ($e1ec086d45566806$var$Ck = $e1ec086d45566806$var$yc()), $e1ec086d45566806$var$Ck;
    a = $e1ec086d45566806$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e1ec086d45566806$var$jd(a.type);
    return a;
}
function $e1ec086d45566806$var$mh(a, b, c, d) {
    if (50 < $e1ec086d45566806$var$zk) throw $e1ec086d45566806$var$zk = 0, $e1ec086d45566806$var$Ak = null, Error($e1ec086d45566806$var$p(185));
    $e1ec086d45566806$var$Ac(a, c, d);
    if (0 === ($e1ec086d45566806$var$K & 2) || a !== $e1ec086d45566806$var$R) a === $e1ec086d45566806$var$R && (0 === ($e1ec086d45566806$var$K & 2) && ($e1ec086d45566806$var$rk |= c), 4 === $e1ec086d45566806$var$T && $e1ec086d45566806$var$Dk(a, $e1ec086d45566806$var$Z)), $e1ec086d45566806$var$Ek(a, d), 1 === c && 0 === $e1ec086d45566806$var$K && 0 === (b.mode & 1) && ($e1ec086d45566806$var$Hj = $e1ec086d45566806$var$B() + 500, $e1ec086d45566806$var$fg && $e1ec086d45566806$var$jg());
}
function $e1ec086d45566806$var$Ek(a, b) {
    var c = a.callbackNode;
    $e1ec086d45566806$var$wc(a, b);
    var d = $e1ec086d45566806$var$uc(a, a === $e1ec086d45566806$var$R ? $e1ec086d45566806$var$Z : 0);
    if (0 === d) null !== c && $e1ec086d45566806$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e1ec086d45566806$var$bc(c);
        if (1 === b) 0 === a.tag ? $e1ec086d45566806$var$ig($e1ec086d45566806$var$Fk.bind(null, a)) : $e1ec086d45566806$var$hg($e1ec086d45566806$var$Fk.bind(null, a)), $e1ec086d45566806$var$Jf(function() {
            0 === ($e1ec086d45566806$var$K & 6) && $e1ec086d45566806$var$jg();
        }), c = null;
        else {
            switch($e1ec086d45566806$var$Dc(d)){
                case 1:
                    c = $e1ec086d45566806$var$fc;
                    break;
                case 4:
                    c = $e1ec086d45566806$var$gc;
                    break;
                case 16:
                    c = $e1ec086d45566806$var$hc;
                    break;
                case 536870912:
                    c = $e1ec086d45566806$var$jc;
                    break;
                default:
                    c = $e1ec086d45566806$var$hc;
            }
            c = $e1ec086d45566806$var$Gk(c, $e1ec086d45566806$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e1ec086d45566806$var$Hk(a, b) {
    $e1ec086d45566806$var$Bk = -1;
    $e1ec086d45566806$var$Ck = 0;
    if (0 !== ($e1ec086d45566806$var$K & 6)) throw Error($e1ec086d45566806$var$p(327));
    var c = a.callbackNode;
    if ($e1ec086d45566806$var$Ik() && a.callbackNode !== c) return null;
    var d = $e1ec086d45566806$var$uc(a, a === $e1ec086d45566806$var$R ? $e1ec086d45566806$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e1ec086d45566806$var$Jk(a, d);
    else {
        b = d;
        var e = $e1ec086d45566806$var$K;
        $e1ec086d45566806$var$K |= 2;
        var f = $e1ec086d45566806$var$Kk();
        if ($e1ec086d45566806$var$R !== a || $e1ec086d45566806$var$Z !== b) $e1ec086d45566806$var$vk = null, $e1ec086d45566806$var$Hj = $e1ec086d45566806$var$B() + 500, $e1ec086d45566806$var$Lk(a, b);
        for(;;)try {
            $e1ec086d45566806$var$Mk();
            break;
        } catch (h) {
            $e1ec086d45566806$var$Nk(a, h);
        }
        $e1ec086d45566806$var$Qg();
        $e1ec086d45566806$var$nk.current = f;
        $e1ec086d45566806$var$K = e;
        null !== $e1ec086d45566806$var$Y ? b = 0 : ($e1ec086d45566806$var$R = null, $e1ec086d45566806$var$Z = 0, b = $e1ec086d45566806$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e1ec086d45566806$var$xc(a), 0 !== e && (d = e, b = $e1ec086d45566806$var$Ok(a, e)));
        if (1 === b) throw c = $e1ec086d45566806$var$qk, $e1ec086d45566806$var$Lk(a, 0), $e1ec086d45566806$var$Dk(a, d), $e1ec086d45566806$var$Ek(a, $e1ec086d45566806$var$B()), c;
        if (6 === b) $e1ec086d45566806$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e1ec086d45566806$var$Pk(e) && (b = $e1ec086d45566806$var$Jk(a, d), 2 === b && (f = $e1ec086d45566806$var$xc(a), 0 !== f && (d = f, b = $e1ec086d45566806$var$Ok(a, f))), 1 === b)) throw c = $e1ec086d45566806$var$qk, $e1ec086d45566806$var$Lk(a, 0), $e1ec086d45566806$var$Dk(a, d), $e1ec086d45566806$var$Ek(a, $e1ec086d45566806$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e1ec086d45566806$var$p(345));
                case 2:
                    $e1ec086d45566806$var$Qk(a, $e1ec086d45566806$var$uk, $e1ec086d45566806$var$vk);
                    break;
                case 3:
                    $e1ec086d45566806$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e1ec086d45566806$var$gk + 500 - $e1ec086d45566806$var$B(), 10 < b)) {
                        if (0 !== $e1ec086d45566806$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e1ec086d45566806$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e1ec086d45566806$var$Ff($e1ec086d45566806$var$Qk.bind(null, a, $e1ec086d45566806$var$uk, $e1ec086d45566806$var$vk), b);
                        break;
                    }
                    $e1ec086d45566806$var$Qk(a, $e1ec086d45566806$var$uk, $e1ec086d45566806$var$vk);
                    break;
                case 4:
                    $e1ec086d45566806$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e1ec086d45566806$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e1ec086d45566806$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e1ec086d45566806$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e1ec086d45566806$var$Ff($e1ec086d45566806$var$Qk.bind(null, a, $e1ec086d45566806$var$uk, $e1ec086d45566806$var$vk), d);
                        break;
                    }
                    $e1ec086d45566806$var$Qk(a, $e1ec086d45566806$var$uk, $e1ec086d45566806$var$vk);
                    break;
                case 5:
                    $e1ec086d45566806$var$Qk(a, $e1ec086d45566806$var$uk, $e1ec086d45566806$var$vk);
                    break;
                default:
                    throw Error($e1ec086d45566806$var$p(329));
            }
        }
    }
    $e1ec086d45566806$var$Ek(a, $e1ec086d45566806$var$B());
    return a.callbackNode === c ? $e1ec086d45566806$var$Hk.bind(null, a) : null;
}
function $e1ec086d45566806$var$Ok(a, b) {
    var c = $e1ec086d45566806$var$tk;
    a.current.memoizedState.isDehydrated && ($e1ec086d45566806$var$Lk(a, b).flags |= 256);
    a = $e1ec086d45566806$var$Jk(a, b);
    2 !== a && (b = $e1ec086d45566806$var$uk, $e1ec086d45566806$var$uk = c, null !== b && $e1ec086d45566806$var$Gj(b));
    return a;
}
function $e1ec086d45566806$var$Gj(a) {
    null === $e1ec086d45566806$var$uk ? $e1ec086d45566806$var$uk = a : $e1ec086d45566806$var$uk.push.apply($e1ec086d45566806$var$uk, a);
}
function $e1ec086d45566806$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e1ec086d45566806$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e1ec086d45566806$var$Dk(a, b) {
    b &= ~$e1ec086d45566806$var$sk;
    b &= ~$e1ec086d45566806$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e1ec086d45566806$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e1ec086d45566806$var$Fk(a) {
    if (0 !== ($e1ec086d45566806$var$K & 6)) throw Error($e1ec086d45566806$var$p(327));
    $e1ec086d45566806$var$Ik();
    var b = $e1ec086d45566806$var$uc(a, 0);
    if (0 === (b & 1)) return $e1ec086d45566806$var$Ek(a, $e1ec086d45566806$var$B()), null;
    var c = $e1ec086d45566806$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e1ec086d45566806$var$xc(a);
        0 !== d && (b = d, c = $e1ec086d45566806$var$Ok(a, d));
    }
    if (1 === c) throw c = $e1ec086d45566806$var$qk, $e1ec086d45566806$var$Lk(a, 0), $e1ec086d45566806$var$Dk(a, b), $e1ec086d45566806$var$Ek(a, $e1ec086d45566806$var$B()), c;
    if (6 === c) throw Error($e1ec086d45566806$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e1ec086d45566806$var$Qk(a, $e1ec086d45566806$var$uk, $e1ec086d45566806$var$vk);
    $e1ec086d45566806$var$Ek(a, $e1ec086d45566806$var$B());
    return null;
}
function $e1ec086d45566806$var$Rk(a, b) {
    var c = $e1ec086d45566806$var$K;
    $e1ec086d45566806$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e1ec086d45566806$var$K = c, 0 === $e1ec086d45566806$var$K && ($e1ec086d45566806$var$Hj = $e1ec086d45566806$var$B() + 500, $e1ec086d45566806$var$fg && $e1ec086d45566806$var$jg());
    }
}
function $e1ec086d45566806$var$Sk(a) {
    null !== $e1ec086d45566806$var$xk && 0 === $e1ec086d45566806$var$xk.tag && 0 === ($e1ec086d45566806$var$K & 6) && $e1ec086d45566806$var$Ik();
    var b = $e1ec086d45566806$var$K;
    $e1ec086d45566806$var$K |= 1;
    var c = $e1ec086d45566806$var$pk.transition, d = $e1ec086d45566806$var$C;
    try {
        if ($e1ec086d45566806$var$pk.transition = null, $e1ec086d45566806$var$C = 1, a) return a();
    } finally{
        $e1ec086d45566806$var$C = d, $e1ec086d45566806$var$pk.transition = c, $e1ec086d45566806$var$K = b, 0 === ($e1ec086d45566806$var$K & 6) && $e1ec086d45566806$var$jg();
    }
}
function $e1ec086d45566806$var$Ij() {
    $e1ec086d45566806$var$gj = $e1ec086d45566806$var$fj.current;
    $e1ec086d45566806$var$E($e1ec086d45566806$var$fj);
}
function $e1ec086d45566806$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e1ec086d45566806$var$Gf(c));
    if (null !== $e1ec086d45566806$var$Y) for(c = $e1ec086d45566806$var$Y.return; null !== c;){
        var d = c;
        $e1ec086d45566806$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e1ec086d45566806$var$$f();
                break;
            case 3:
                $e1ec086d45566806$var$Jh();
                $e1ec086d45566806$var$E($e1ec086d45566806$var$Wf);
                $e1ec086d45566806$var$E($e1ec086d45566806$var$H);
                $e1ec086d45566806$var$Oh();
                break;
            case 5:
                $e1ec086d45566806$var$Lh(d);
                break;
            case 4:
                $e1ec086d45566806$var$Jh();
                break;
            case 13:
                $e1ec086d45566806$var$E($e1ec086d45566806$var$M);
                break;
            case 19:
                $e1ec086d45566806$var$E($e1ec086d45566806$var$M);
                break;
            case 10:
                $e1ec086d45566806$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e1ec086d45566806$var$Ij();
        }
        c = c.return;
    }
    $e1ec086d45566806$var$R = a;
    $e1ec086d45566806$var$Y = a = $e1ec086d45566806$var$wh(a.current, null);
    $e1ec086d45566806$var$Z = $e1ec086d45566806$var$gj = b;
    $e1ec086d45566806$var$T = 0;
    $e1ec086d45566806$var$qk = null;
    $e1ec086d45566806$var$sk = $e1ec086d45566806$var$rk = $e1ec086d45566806$var$hh = 0;
    $e1ec086d45566806$var$uk = $e1ec086d45566806$var$tk = null;
    if (null !== $e1ec086d45566806$var$Wg) {
        for(b = 0; b < $e1ec086d45566806$var$Wg.length; b++)if (c = $e1ec086d45566806$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e1ec086d45566806$var$Wg = null;
    }
    return a;
}
function $e1ec086d45566806$var$Nk(a, b) {
    do {
        var c = $e1ec086d45566806$var$Y;
        try {
            $e1ec086d45566806$var$Qg();
            $e1ec086d45566806$var$Ph.current = $e1ec086d45566806$var$ai;
            if ($e1ec086d45566806$var$Sh) {
                for(var d = $e1ec086d45566806$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e1ec086d45566806$var$Sh = !1;
            }
            $e1ec086d45566806$var$Rh = 0;
            $e1ec086d45566806$var$P = $e1ec086d45566806$var$O = $e1ec086d45566806$var$N = null;
            $e1ec086d45566806$var$Th = !1;
            $e1ec086d45566806$var$Uh = 0;
            $e1ec086d45566806$var$ok.current = null;
            if (null === c || null === c.return) {
                $e1ec086d45566806$var$T = 1;
                $e1ec086d45566806$var$qk = b;
                $e1ec086d45566806$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e1ec086d45566806$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e1ec086d45566806$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e1ec086d45566806$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e1ec086d45566806$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e1ec086d45566806$var$Ti(f, l, b);
                            $e1ec086d45566806$var$uj();
                            break a;
                        }
                        k = Error($e1ec086d45566806$var$p(426));
                    }
                } else if ($e1ec086d45566806$var$I && h.mode & 1) {
                    var J = $e1ec086d45566806$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e1ec086d45566806$var$Wi(J, g, h, f, b);
                        $e1ec086d45566806$var$Jg($e1ec086d45566806$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e1ec086d45566806$var$Ki(k, h);
                4 !== $e1ec086d45566806$var$T && ($e1ec086d45566806$var$T = 2);
                null === $e1ec086d45566806$var$tk ? $e1ec086d45566806$var$tk = [
                    f
                ] : $e1ec086d45566806$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e1ec086d45566806$var$Oi(f, k, b);
                            $e1ec086d45566806$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e1ec086d45566806$var$Si || !$e1ec086d45566806$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e1ec086d45566806$var$Ri(f, h, b);
                                $e1ec086d45566806$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e1ec086d45566806$var$Tk(c);
        } catch (na) {
            b = na;
            $e1ec086d45566806$var$Y === c && null !== c && ($e1ec086d45566806$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e1ec086d45566806$var$Kk() {
    var a = $e1ec086d45566806$var$nk.current;
    $e1ec086d45566806$var$nk.current = $e1ec086d45566806$var$ai;
    return null === a ? $e1ec086d45566806$var$ai : a;
}
function $e1ec086d45566806$var$uj() {
    if (0 === $e1ec086d45566806$var$T || 3 === $e1ec086d45566806$var$T || 2 === $e1ec086d45566806$var$T) $e1ec086d45566806$var$T = 4;
    null === $e1ec086d45566806$var$R || 0 === ($e1ec086d45566806$var$hh & 268435455) && 0 === ($e1ec086d45566806$var$rk & 268435455) || $e1ec086d45566806$var$Dk($e1ec086d45566806$var$R, $e1ec086d45566806$var$Z);
}
function $e1ec086d45566806$var$Jk(a, b) {
    var c = $e1ec086d45566806$var$K;
    $e1ec086d45566806$var$K |= 2;
    var d = $e1ec086d45566806$var$Kk();
    if ($e1ec086d45566806$var$R !== a || $e1ec086d45566806$var$Z !== b) $e1ec086d45566806$var$vk = null, $e1ec086d45566806$var$Lk(a, b);
    for(;;)try {
        $e1ec086d45566806$var$Uk();
        break;
    } catch (e) {
        $e1ec086d45566806$var$Nk(a, e);
    }
    $e1ec086d45566806$var$Qg();
    $e1ec086d45566806$var$K = c;
    $e1ec086d45566806$var$nk.current = d;
    if (null !== $e1ec086d45566806$var$Y) throw Error($e1ec086d45566806$var$p(261));
    $e1ec086d45566806$var$R = null;
    $e1ec086d45566806$var$Z = 0;
    return $e1ec086d45566806$var$T;
}
function $e1ec086d45566806$var$Uk() {
    for(; null !== $e1ec086d45566806$var$Y;)$e1ec086d45566806$var$Vk($e1ec086d45566806$var$Y);
}
function $e1ec086d45566806$var$Mk() {
    for(; null !== $e1ec086d45566806$var$Y && !$e1ec086d45566806$var$cc();)$e1ec086d45566806$var$Vk($e1ec086d45566806$var$Y);
}
function $e1ec086d45566806$var$Vk(a) {
    var b = $e1ec086d45566806$var$Wk(a.alternate, a, $e1ec086d45566806$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e1ec086d45566806$var$Tk(a) : $e1ec086d45566806$var$Y = b;
    $e1ec086d45566806$var$ok.current = null;
}
function $e1ec086d45566806$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e1ec086d45566806$var$Fj(c, b, $e1ec086d45566806$var$gj), null !== c) {
                $e1ec086d45566806$var$Y = c;
                return;
            }
        } else {
            c = $e1ec086d45566806$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e1ec086d45566806$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e1ec086d45566806$var$T = 6;
                $e1ec086d45566806$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e1ec086d45566806$var$Y = b;
            return;
        }
        $e1ec086d45566806$var$Y = b = a;
    }while (null !== b);
    0 === $e1ec086d45566806$var$T && ($e1ec086d45566806$var$T = 5);
}
function $e1ec086d45566806$var$Qk(a, b, c) {
    var d = $e1ec086d45566806$var$C, e = $e1ec086d45566806$var$pk.transition;
    try {
        $e1ec086d45566806$var$pk.transition = null, $e1ec086d45566806$var$C = 1, $e1ec086d45566806$var$Xk(a, b, c, d);
    } finally{
        $e1ec086d45566806$var$pk.transition = e, $e1ec086d45566806$var$C = d;
    }
    return null;
}
function $e1ec086d45566806$var$Xk(a, b, c, d) {
    do $e1ec086d45566806$var$Ik();
    while (null !== $e1ec086d45566806$var$xk);
    if (0 !== ($e1ec086d45566806$var$K & 6)) throw Error($e1ec086d45566806$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e1ec086d45566806$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e1ec086d45566806$var$Bc(a, f);
    a === $e1ec086d45566806$var$R && ($e1ec086d45566806$var$Y = $e1ec086d45566806$var$R = null, $e1ec086d45566806$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e1ec086d45566806$var$wk || ($e1ec086d45566806$var$wk = !0, $e1ec086d45566806$var$Gk($e1ec086d45566806$var$hc, function() {
        $e1ec086d45566806$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e1ec086d45566806$var$pk.transition;
        $e1ec086d45566806$var$pk.transition = null;
        var g = $e1ec086d45566806$var$C;
        $e1ec086d45566806$var$C = 1;
        var h = $e1ec086d45566806$var$K;
        $e1ec086d45566806$var$K |= 4;
        $e1ec086d45566806$var$ok.current = null;
        $e1ec086d45566806$var$Pj(a, c);
        $e1ec086d45566806$var$ek(c, a);
        $e1ec086d45566806$var$Oe($e1ec086d45566806$var$Df);
        $e1ec086d45566806$var$dd = !!$e1ec086d45566806$var$Cf;
        $e1ec086d45566806$var$Df = $e1ec086d45566806$var$Cf = null;
        a.current = c;
        $e1ec086d45566806$var$ik(c, a, e);
        $e1ec086d45566806$var$dc();
        $e1ec086d45566806$var$K = h;
        $e1ec086d45566806$var$C = g;
        $e1ec086d45566806$var$pk.transition = f;
    } else a.current = c;
    $e1ec086d45566806$var$wk && ($e1ec086d45566806$var$wk = !1, $e1ec086d45566806$var$xk = a, $e1ec086d45566806$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e1ec086d45566806$var$Si = null);
    $e1ec086d45566806$var$mc(c.stateNode, d);
    $e1ec086d45566806$var$Ek(a, $e1ec086d45566806$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e1ec086d45566806$var$Pi) throw $e1ec086d45566806$var$Pi = !1, a = $e1ec086d45566806$var$Qi, $e1ec086d45566806$var$Qi = null, a;
    0 !== ($e1ec086d45566806$var$yk & 1) && 0 !== a.tag && $e1ec086d45566806$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e1ec086d45566806$var$Ak ? $e1ec086d45566806$var$zk++ : ($e1ec086d45566806$var$zk = 0, $e1ec086d45566806$var$Ak = a) : $e1ec086d45566806$var$zk = 0;
    $e1ec086d45566806$var$jg();
    return null;
}
function $e1ec086d45566806$var$Ik() {
    if (null !== $e1ec086d45566806$var$xk) {
        var a = $e1ec086d45566806$var$Dc($e1ec086d45566806$var$yk), b = $e1ec086d45566806$var$pk.transition, c = $e1ec086d45566806$var$C;
        try {
            $e1ec086d45566806$var$pk.transition = null;
            $e1ec086d45566806$var$C = 16 > a ? 16 : a;
            if (null === $e1ec086d45566806$var$xk) var d = !1;
            else {
                a = $e1ec086d45566806$var$xk;
                $e1ec086d45566806$var$xk = null;
                $e1ec086d45566806$var$yk = 0;
                if (0 !== ($e1ec086d45566806$var$K & 6)) throw Error($e1ec086d45566806$var$p(331));
                var e = $e1ec086d45566806$var$K;
                $e1ec086d45566806$var$K |= 4;
                for($e1ec086d45566806$var$V = a.current; null !== $e1ec086d45566806$var$V;){
                    var f = $e1ec086d45566806$var$V, g = f.child;
                    if (0 !== ($e1ec086d45566806$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e1ec086d45566806$var$V = l; null !== $e1ec086d45566806$var$V;){
                                    var m = $e1ec086d45566806$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e1ec086d45566806$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e1ec086d45566806$var$V = q;
                                    else for(; null !== $e1ec086d45566806$var$V;){
                                        m = $e1ec086d45566806$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e1ec086d45566806$var$Tj(m);
                                        if (m === l) {
                                            $e1ec086d45566806$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e1ec086d45566806$var$V = r;
                                            break;
                                        }
                                        $e1ec086d45566806$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e1ec086d45566806$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e1ec086d45566806$var$V = g;
                    else b: for(; null !== $e1ec086d45566806$var$V;){
                        f = $e1ec086d45566806$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e1ec086d45566806$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e1ec086d45566806$var$V = x;
                            break b;
                        }
                        $e1ec086d45566806$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e1ec086d45566806$var$V = w; null !== $e1ec086d45566806$var$V;){
                    g = $e1ec086d45566806$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e1ec086d45566806$var$V = u;
                    else b: for(g = w; null !== $e1ec086d45566806$var$V;){
                        h = $e1ec086d45566806$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e1ec086d45566806$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e1ec086d45566806$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e1ec086d45566806$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e1ec086d45566806$var$V = F;
                            break b;
                        }
                        $e1ec086d45566806$var$V = h.return;
                    }
                }
                $e1ec086d45566806$var$K = e;
                $e1ec086d45566806$var$jg();
                if ($e1ec086d45566806$var$lc && "function" === typeof $e1ec086d45566806$var$lc.onPostCommitFiberRoot) try {
                    $e1ec086d45566806$var$lc.onPostCommitFiberRoot($e1ec086d45566806$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e1ec086d45566806$var$C = c, $e1ec086d45566806$var$pk.transition = b;
        }
    }
    return !1;
}
function $e1ec086d45566806$var$Yk(a, b, c) {
    b = $e1ec086d45566806$var$Ki(c, b);
    b = $e1ec086d45566806$var$Oi(a, b, 1);
    a = $e1ec086d45566806$var$dh(a, b, 1);
    b = $e1ec086d45566806$var$L();
    null !== a && ($e1ec086d45566806$var$Ac(a, 1, b), $e1ec086d45566806$var$Ek(a, b));
}
function $e1ec086d45566806$var$W(a, b, c) {
    if (3 === a.tag) $e1ec086d45566806$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e1ec086d45566806$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e1ec086d45566806$var$Si || !$e1ec086d45566806$var$Si.has(d))) {
                a = $e1ec086d45566806$var$Ki(c, a);
                a = $e1ec086d45566806$var$Ri(b, a, 1);
                b = $e1ec086d45566806$var$dh(b, a, 1);
                a = $e1ec086d45566806$var$L();
                null !== b && ($e1ec086d45566806$var$Ac(b, 1, a), $e1ec086d45566806$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e1ec086d45566806$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e1ec086d45566806$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e1ec086d45566806$var$R === a && ($e1ec086d45566806$var$Z & c) === c && (4 === $e1ec086d45566806$var$T || 3 === $e1ec086d45566806$var$T && ($e1ec086d45566806$var$Z & 130023424) === $e1ec086d45566806$var$Z && 500 > $e1ec086d45566806$var$B() - $e1ec086d45566806$var$gk ? $e1ec086d45566806$var$Lk(a, 0) : $e1ec086d45566806$var$sk |= c);
    $e1ec086d45566806$var$Ek(a, b);
}
function $e1ec086d45566806$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e1ec086d45566806$var$sc, $e1ec086d45566806$var$sc <<= 1, 0 === ($e1ec086d45566806$var$sc & 130023424) && ($e1ec086d45566806$var$sc = 4194304)));
    var c = $e1ec086d45566806$var$L();
    a = $e1ec086d45566806$var$Zg(a, b);
    null !== a && ($e1ec086d45566806$var$Ac(a, b, c), $e1ec086d45566806$var$Ek(a, c));
}
function $e1ec086d45566806$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e1ec086d45566806$var$Zk(a, c);
}
function $e1ec086d45566806$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e1ec086d45566806$var$p(314));
    }
    null !== d && d.delete(b);
    $e1ec086d45566806$var$Zk(a, c);
}
var $e1ec086d45566806$var$Wk;
$e1ec086d45566806$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e1ec086d45566806$var$Wf.current) $e1ec086d45566806$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e1ec086d45566806$var$Ug = !1, $e1ec086d45566806$var$zj(a, b, c);
            $e1ec086d45566806$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e1ec086d45566806$var$Ug = !1, $e1ec086d45566806$var$I && 0 !== (b.flags & 1048576) && $e1ec086d45566806$var$ug(b, $e1ec086d45566806$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e1ec086d45566806$var$jj(a, b);
            a = b.pendingProps;
            var e = $e1ec086d45566806$var$Yf(b, $e1ec086d45566806$var$H.current);
            $e1ec086d45566806$var$Tg(b, c);
            e = $e1ec086d45566806$var$Xh(null, b, d, a, e, c);
            var f = $e1ec086d45566806$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e1ec086d45566806$var$Zf(d) ? (f = !0, $e1ec086d45566806$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e1ec086d45566806$var$ah(b), e.updater = $e1ec086d45566806$var$nh, b.stateNode = e, e._reactInternals = b, $e1ec086d45566806$var$rh(b, d, a, c), b = $e1ec086d45566806$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e1ec086d45566806$var$I && f && $e1ec086d45566806$var$vg(b), $e1ec086d45566806$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e1ec086d45566806$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e1ec086d45566806$var$$k(d);
                a = $e1ec086d45566806$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e1ec086d45566806$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e1ec086d45566806$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e1ec086d45566806$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e1ec086d45566806$var$aj(null, b, d, $e1ec086d45566806$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e1ec086d45566806$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e1ec086d45566806$var$Lg(d, e), $e1ec086d45566806$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e1ec086d45566806$var$Lg(d, e), $e1ec086d45566806$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e1ec086d45566806$var$lj(b);
                if (null === a) throw Error($e1ec086d45566806$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e1ec086d45566806$var$bh(a, b);
                $e1ec086d45566806$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e1ec086d45566806$var$Ki(Error($e1ec086d45566806$var$p(423)), b);
                        b = $e1ec086d45566806$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e1ec086d45566806$var$Ki(Error($e1ec086d45566806$var$p(424)), b);
                        b = $e1ec086d45566806$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e1ec086d45566806$var$yg = $e1ec086d45566806$var$Lf(b.stateNode.containerInfo.firstChild), $e1ec086d45566806$var$xg = b, $e1ec086d45566806$var$I = !0, $e1ec086d45566806$var$zg = null, c = $e1ec086d45566806$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e1ec086d45566806$var$Ig();
                    if (d === e) {
                        b = $e1ec086d45566806$var$$i(a, b, c);
                        break a;
                    }
                    $e1ec086d45566806$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e1ec086d45566806$var$Kh(b), null === a && $e1ec086d45566806$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e1ec086d45566806$var$Ef(d, e) ? g = null : null !== f && $e1ec086d45566806$var$Ef(d, f) && (b.flags |= 32), $e1ec086d45566806$var$hj(a, b), $e1ec086d45566806$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e1ec086d45566806$var$Eg(b), null;
        case 13:
            return $e1ec086d45566806$var$pj(a, b, c);
        case 4:
            return $e1ec086d45566806$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e1ec086d45566806$var$Bh(b, null, d, c) : $e1ec086d45566806$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e1ec086d45566806$var$Lg(d, e), $e1ec086d45566806$var$Zi(a, b, d, e, c);
        case 7:
            return $e1ec086d45566806$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e1ec086d45566806$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e1ec086d45566806$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e1ec086d45566806$var$G($e1ec086d45566806$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e1ec086d45566806$var$He(f.value, g)) {
                        if (f.children === e.children && !$e1ec086d45566806$var$Wf.current) {
                            b = $e1ec086d45566806$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e1ec086d45566806$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e1ec086d45566806$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e1ec086d45566806$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e1ec086d45566806$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e1ec086d45566806$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e1ec086d45566806$var$Tg(b, c), e = $e1ec086d45566806$var$Vg(e), d = d(e), b.flags |= 1, $e1ec086d45566806$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e1ec086d45566806$var$Lg(d, b.pendingProps), e = $e1ec086d45566806$var$Lg(d.type, e), $e1ec086d45566806$var$aj(a, b, d, e, c);
        case 15:
            return $e1ec086d45566806$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e1ec086d45566806$var$Lg(d, e), $e1ec086d45566806$var$jj(a, b), b.tag = 1, $e1ec086d45566806$var$Zf(d) ? (a = !0, $e1ec086d45566806$var$cg(b)) : a = !1, $e1ec086d45566806$var$Tg(b, c), $e1ec086d45566806$var$ph(b, d, e), $e1ec086d45566806$var$rh(b, d, e, c), $e1ec086d45566806$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e1ec086d45566806$var$yj(a, b, c);
        case 22:
            return $e1ec086d45566806$var$ej(a, b, c);
    }
    throw Error($e1ec086d45566806$var$p(156, b.tag));
};
function $e1ec086d45566806$var$Gk(a, b) {
    return $e1ec086d45566806$var$ac(a, b);
}
function $e1ec086d45566806$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e1ec086d45566806$var$Bg(a, b, c, d) {
    return new $e1ec086d45566806$var$al(a, b, c, d);
}
function $e1ec086d45566806$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e1ec086d45566806$var$$k(a) {
    if ("function" === typeof a) return $e1ec086d45566806$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e1ec086d45566806$var$Da) return 11;
        if (a === $e1ec086d45566806$var$Ga) return 14;
    }
    return 2;
}
function $e1ec086d45566806$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e1ec086d45566806$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e1ec086d45566806$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e1ec086d45566806$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e1ec086d45566806$var$ya:
            return $e1ec086d45566806$var$Ah(c.children, e, f, b);
        case $e1ec086d45566806$var$za:
            g = 8;
            e |= 8;
            break;
        case $e1ec086d45566806$var$Aa:
            return a = $e1ec086d45566806$var$Bg(12, c, b, e | 2), a.elementType = $e1ec086d45566806$var$Aa, a.lanes = f, a;
        case $e1ec086d45566806$var$Ea:
            return a = $e1ec086d45566806$var$Bg(13, c, b, e), a.elementType = $e1ec086d45566806$var$Ea, a.lanes = f, a;
        case $e1ec086d45566806$var$Fa:
            return a = $e1ec086d45566806$var$Bg(19, c, b, e), a.elementType = $e1ec086d45566806$var$Fa, a.lanes = f, a;
        case $e1ec086d45566806$var$Ia:
            return $e1ec086d45566806$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e1ec086d45566806$var$Ba:
                    g = 10;
                    break a;
                case $e1ec086d45566806$var$Ca:
                    g = 9;
                    break a;
                case $e1ec086d45566806$var$Da:
                    g = 11;
                    break a;
                case $e1ec086d45566806$var$Ga:
                    g = 14;
                    break a;
                case $e1ec086d45566806$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e1ec086d45566806$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e1ec086d45566806$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e1ec086d45566806$var$Ah(a, b, c, d) {
    a = $e1ec086d45566806$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e1ec086d45566806$var$qj(a, b, c, d) {
    a = $e1ec086d45566806$var$Bg(22, a, d, b);
    a.elementType = $e1ec086d45566806$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e1ec086d45566806$var$xh(a, b, c) {
    a = $e1ec086d45566806$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e1ec086d45566806$var$zh(a, b, c) {
    b = $e1ec086d45566806$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e1ec086d45566806$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e1ec086d45566806$var$zc(0);
    this.expirationTimes = $e1ec086d45566806$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e1ec086d45566806$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e1ec086d45566806$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e1ec086d45566806$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e1ec086d45566806$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e1ec086d45566806$var$ah(f);
    return a;
}
function $e1ec086d45566806$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e1ec086d45566806$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e1ec086d45566806$var$el(a) {
    if (!a) return $e1ec086d45566806$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e1ec086d45566806$var$Vb(a) !== a || 1 !== a.tag) throw Error($e1ec086d45566806$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e1ec086d45566806$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e1ec086d45566806$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e1ec086d45566806$var$Zf(c)) return $e1ec086d45566806$var$bg(a, c, b);
    }
    return b;
}
function $e1ec086d45566806$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e1ec086d45566806$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e1ec086d45566806$var$el(null);
    c = a.current;
    d = $e1ec086d45566806$var$L();
    e = $e1ec086d45566806$var$lh(c);
    f = $e1ec086d45566806$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e1ec086d45566806$var$dh(c, f, e);
    a.current.lanes = e;
    $e1ec086d45566806$var$Ac(a, e, d);
    $e1ec086d45566806$var$Ek(a, d);
    return a;
}
function $e1ec086d45566806$var$gl(a, b, c, d) {
    var e = b.current, f = $e1ec086d45566806$var$L(), g = $e1ec086d45566806$var$lh(e);
    c = $e1ec086d45566806$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e1ec086d45566806$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e1ec086d45566806$var$dh(e, b, g);
    null !== a && ($e1ec086d45566806$var$mh(a, e, g, f), $e1ec086d45566806$var$eh(a, e, g));
    return g;
}
function $e1ec086d45566806$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e1ec086d45566806$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e1ec086d45566806$var$jl(a, b) {
    $e1ec086d45566806$var$il(a, b);
    (a = a.alternate) && $e1ec086d45566806$var$il(a, b);
}
function $e1ec086d45566806$var$kl() {
    return null;
}
var $e1ec086d45566806$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e1ec086d45566806$var$ml(a) {
    this._internalRoot = a;
}
$e1ec086d45566806$var$nl.prototype.render = $e1ec086d45566806$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e1ec086d45566806$var$p(409));
    $e1ec086d45566806$var$gl(a, b, null, null);
};
$e1ec086d45566806$var$nl.prototype.unmount = $e1ec086d45566806$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e1ec086d45566806$var$Sk(function() {
            $e1ec086d45566806$var$gl(null, a, null, null);
        });
        b[$e1ec086d45566806$var$uf] = null;
    }
};
function $e1ec086d45566806$var$nl(a) {
    this._internalRoot = a;
}
$e1ec086d45566806$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e1ec086d45566806$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e1ec086d45566806$var$Qc.length && 0 !== b && b < $e1ec086d45566806$var$Qc[c].priority; c++);
        $e1ec086d45566806$var$Qc.splice(c, 0, a);
        0 === c && $e1ec086d45566806$var$Vc(a);
    }
};
function $e1ec086d45566806$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e1ec086d45566806$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e1ec086d45566806$var$ql() {}
function $e1ec086d45566806$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e1ec086d45566806$var$hl(g);
                f.call(a);
            };
        }
        var g = $e1ec086d45566806$var$fl(b, d, a, 0, null, !1, !1, "", $e1ec086d45566806$var$ql);
        a._reactRootContainer = g;
        a[$e1ec086d45566806$var$uf] = g.current;
        $e1ec086d45566806$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e1ec086d45566806$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e1ec086d45566806$var$hl(k);
            h.call(a);
        };
    }
    var k = $e1ec086d45566806$var$cl(a, 0, !1, null, null, !1, !1, "", $e1ec086d45566806$var$ql);
    a._reactRootContainer = k;
    a[$e1ec086d45566806$var$uf] = k.current;
    $e1ec086d45566806$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e1ec086d45566806$var$Sk(function() {
        $e1ec086d45566806$var$gl(b, k, c, d);
    });
    return k;
}
function $e1ec086d45566806$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e1ec086d45566806$var$hl(g);
                h.call(a);
            };
        }
        $e1ec086d45566806$var$gl(b, g, a, e);
    } else g = $e1ec086d45566806$var$rl(c, b, a, e, d);
    return $e1ec086d45566806$var$hl(g);
}
$e1ec086d45566806$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e1ec086d45566806$var$tc(b.pendingLanes);
                0 !== c && ($e1ec086d45566806$var$Cc(b, c | 1), $e1ec086d45566806$var$Ek(b, $e1ec086d45566806$var$B()), 0 === ($e1ec086d45566806$var$K & 6) && ($e1ec086d45566806$var$Hj = $e1ec086d45566806$var$B() + 500, $e1ec086d45566806$var$jg()));
            }
            break;
        case 13:
            $e1ec086d45566806$var$Sk(function() {
                var b = $e1ec086d45566806$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e1ec086d45566806$var$L();
                    $e1ec086d45566806$var$mh(b, a, 1, c);
                }
            }), $e1ec086d45566806$var$jl(a, 1);
    }
};
$e1ec086d45566806$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e1ec086d45566806$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e1ec086d45566806$var$L();
            $e1ec086d45566806$var$mh(b, a, 134217728, c);
        }
        $e1ec086d45566806$var$jl(a, 134217728);
    }
};
$e1ec086d45566806$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e1ec086d45566806$var$lh(a), c = $e1ec086d45566806$var$Zg(a, b);
        if (null !== c) {
            var d = $e1ec086d45566806$var$L();
            $e1ec086d45566806$var$mh(c, a, b, d);
        }
        $e1ec086d45566806$var$jl(a, b);
    }
};
$e1ec086d45566806$var$Hc = function() {
    return $e1ec086d45566806$var$C;
};
$e1ec086d45566806$var$Ic = function(a, b) {
    var c = $e1ec086d45566806$var$C;
    try {
        return $e1ec086d45566806$var$C = a, b();
    } finally{
        $e1ec086d45566806$var$C = c;
    }
};
$e1ec086d45566806$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e1ec086d45566806$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e1ec086d45566806$var$Db(d);
                        if (!e) throw Error($e1ec086d45566806$var$p(90));
                        $e1ec086d45566806$var$Wa(d);
                        $e1ec086d45566806$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e1ec086d45566806$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e1ec086d45566806$var$fb(a, !!c.multiple, b, !1);
    }
};
$e1ec086d45566806$var$Gb = $e1ec086d45566806$var$Rk;
$e1ec086d45566806$var$Hb = $e1ec086d45566806$var$Sk;
var $e1ec086d45566806$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e1ec086d45566806$var$Cb,
        $e1ec086d45566806$var$ue,
        $e1ec086d45566806$var$Db,
        $e1ec086d45566806$var$Eb,
        $e1ec086d45566806$var$Fb,
        $e1ec086d45566806$var$Rk
    ]
}, $e1ec086d45566806$var$ul = {
    findFiberByHostInstance: $e1ec086d45566806$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e1ec086d45566806$var$vl = {
    bundleType: $e1ec086d45566806$var$ul.bundleType,
    version: $e1ec086d45566806$var$ul.version,
    rendererPackageName: $e1ec086d45566806$var$ul.rendererPackageName,
    rendererConfig: $e1ec086d45566806$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e1ec086d45566806$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e1ec086d45566806$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e1ec086d45566806$var$ul.findFiberByHostInstance || $e1ec086d45566806$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e1ec086d45566806$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e1ec086d45566806$var$wl.isDisabled && $e1ec086d45566806$var$wl.supportsFiber) try {
        $e1ec086d45566806$var$kc = $e1ec086d45566806$var$wl.inject($e1ec086d45566806$var$vl), $e1ec086d45566806$var$lc = $e1ec086d45566806$var$wl;
    } catch (a) {}
}
$e1ec086d45566806$export$ae55be85d98224ed = $e1ec086d45566806$var$tl;
$e1ec086d45566806$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e1ec086d45566806$var$ol(b)) throw Error($e1ec086d45566806$var$p(200));
    return $e1ec086d45566806$var$dl(a, b, null, c);
};
$e1ec086d45566806$export$882461b6382ed46c = function(a, b) {
    if (!$e1ec086d45566806$var$ol(a)) throw Error($e1ec086d45566806$var$p(299));
    var c = !1, d = "", e = $e1ec086d45566806$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e1ec086d45566806$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e1ec086d45566806$var$uf] = b.current;
    $e1ec086d45566806$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e1ec086d45566806$var$ml(b);
};
$e1ec086d45566806$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e1ec086d45566806$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e1ec086d45566806$var$p(268, a));
    }
    a = $e1ec086d45566806$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e1ec086d45566806$export$cd75ccfd720a3cd4 = function(a) {
    return $e1ec086d45566806$var$Sk(a);
};
$e1ec086d45566806$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e1ec086d45566806$var$pl(b)) throw Error($e1ec086d45566806$var$p(200));
    return $e1ec086d45566806$var$sl(null, a, b, !0, c);
};
$e1ec086d45566806$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e1ec086d45566806$var$ol(a)) throw Error($e1ec086d45566806$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e1ec086d45566806$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e1ec086d45566806$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e1ec086d45566806$var$uf] = b.current;
    $e1ec086d45566806$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e1ec086d45566806$var$nl(b);
};
$e1ec086d45566806$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e1ec086d45566806$var$pl(b)) throw Error($e1ec086d45566806$var$p(200));
    return $e1ec086d45566806$var$sl(null, a, b, !1, c);
};
$e1ec086d45566806$export$502457920280e6be = function(a) {
    if (!$e1ec086d45566806$var$pl(a)) throw Error($e1ec086d45566806$var$p(40));
    return a._reactRootContainer ? ($e1ec086d45566806$var$Sk(function() {
        $e1ec086d45566806$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e1ec086d45566806$var$uf] = null;
        });
    }), !0) : !1;
};
$e1ec086d45566806$export$c78a37762a8d58e1 = $e1ec086d45566806$var$Rk;
$e1ec086d45566806$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e1ec086d45566806$var$pl(c)) throw Error($e1ec086d45566806$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e1ec086d45566806$var$p(38));
    return $e1ec086d45566806$var$sl(a, b, c, !1, d);
};
$e1ec086d45566806$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1MX31", function(module, exports) {
'use strict';

module.exports = (parcelRequire("e32xz"));

});
parcelRegister("e32xz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a3a350f95ccae46a$export$c4744153514ff05d; }, function (v) { return $a3a350f95ccae46a$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a3a350f95ccae46a$export$3e506c1ccc9cc1a7; }, function (v) { return $a3a350f95ccae46a$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a3a350f95ccae46a$export$e26fe2ed2fa76875; }, function (v) { return $a3a350f95ccae46a$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a3a350f95ccae46a$export$502329bbf4b505b1; }, function (v) { return $a3a350f95ccae46a$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a3a350f95ccae46a$export$6e3807111c4874c4; }, function (v) { return $a3a350f95ccae46a$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a3a350f95ccae46a$export$c27134553091fb3a; }, function (v) { return $a3a350f95ccae46a$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a3a350f95ccae46a$export$33ee1acdc04fd2a2; }, function (v) { return $a3a350f95ccae46a$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a3a350f95ccae46a$export$b00a404bbd5edef2; }, function (v) { return $a3a350f95ccae46a$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a3a350f95ccae46a$export$8352ce38b91d0c62; }, function (v) { return $a3a350f95ccae46a$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a3a350f95ccae46a$export$d66a1c1c77bd778b; }, function (v) { return $a3a350f95ccae46a$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a3a350f95ccae46a$export$d3dfb8e4810cb555; }, function (v) { return $a3a350f95ccae46a$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a3a350f95ccae46a$export$839f9183b0465a69; }, function (v) { return $a3a350f95ccae46a$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a3a350f95ccae46a$export$72fdf0e06517287b; }, function (v) { return $a3a350f95ccae46a$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a3a350f95ccae46a$export$4b844e58a3e414b4; }, function (v) { return $a3a350f95ccae46a$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a3a350f95ccae46a$export$816d2913ae6b83b1; }, function (v) { return $a3a350f95ccae46a$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a3a350f95ccae46a$export$61bcfe829111a1d0; }, function (v) { return $a3a350f95ccae46a$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a3a350f95ccae46a$export$7ee8c9beb337bc3f; }, function (v) { return $a3a350f95ccae46a$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a3a350f95ccae46a$export$b5836b71941fa3ed; }, function (v) { return $a3a350f95ccae46a$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a3a350f95ccae46a$export$cf845f2c119da08a; }, function (v) { return $a3a350f95ccae46a$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a3a350f95ccae46a$export$c4744153514ff05d;
var $a3a350f95ccae46a$export$3e506c1ccc9cc1a7;
var $a3a350f95ccae46a$export$e26fe2ed2fa76875;
var $a3a350f95ccae46a$export$502329bbf4b505b1;
var $a3a350f95ccae46a$export$6e3807111c4874c4;
var $a3a350f95ccae46a$export$c27134553091fb3a;
var $a3a350f95ccae46a$export$33ee1acdc04fd2a2;
var $a3a350f95ccae46a$export$b00a404bbd5edef2;
var $a3a350f95ccae46a$export$8352ce38b91d0c62;
var $a3a350f95ccae46a$export$d66a1c1c77bd778b;
var $a3a350f95ccae46a$export$d3dfb8e4810cb555;
var $a3a350f95ccae46a$export$839f9183b0465a69;
var $a3a350f95ccae46a$export$72fdf0e06517287b;
var $a3a350f95ccae46a$export$4b844e58a3e414b4;
var $a3a350f95ccae46a$export$816d2913ae6b83b1;
var $a3a350f95ccae46a$export$61bcfe829111a1d0;
var $a3a350f95ccae46a$export$7ee8c9beb337bc3f;
var $a3a350f95ccae46a$export$b5836b71941fa3ed;
var $a3a350f95ccae46a$export$cf845f2c119da08a;
'use strict';
function $a3a350f95ccae46a$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a3a350f95ccae46a$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a3a350f95ccae46a$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a3a350f95ccae46a$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a3a350f95ccae46a$var$g(C, c)) n < e && 0 > $a3a350f95ccae46a$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a3a350f95ccae46a$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a3a350f95ccae46a$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a3a350f95ccae46a$var$l = performance;
    $a3a350f95ccae46a$export$c4744153514ff05d = function() {
        return $a3a350f95ccae46a$var$l.now();
    };
} else {
    var $a3a350f95ccae46a$var$p = Date, $a3a350f95ccae46a$var$q = $a3a350f95ccae46a$var$p.now();
    $a3a350f95ccae46a$export$c4744153514ff05d = function() {
        return $a3a350f95ccae46a$var$p.now() - $a3a350f95ccae46a$var$q;
    };
}
var $a3a350f95ccae46a$var$r = [], $a3a350f95ccae46a$var$t = [], $a3a350f95ccae46a$var$u = 1, $a3a350f95ccae46a$var$v = null, $a3a350f95ccae46a$var$y = 3, $a3a350f95ccae46a$var$z = !1, $a3a350f95ccae46a$var$A = !1, $a3a350f95ccae46a$var$B = !1, $a3a350f95ccae46a$var$D = "function" === typeof setTimeout ? setTimeout : null, $a3a350f95ccae46a$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a3a350f95ccae46a$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a3a350f95ccae46a$var$G(a) {
    for(var b = $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$t); null !== b;){
        if (null === b.callback) $a3a350f95ccae46a$var$k($a3a350f95ccae46a$var$t);
        else if (b.startTime <= a) $a3a350f95ccae46a$var$k($a3a350f95ccae46a$var$t), b.sortIndex = b.expirationTime, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$r, b);
        else break;
        b = $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$t);
    }
}
function $a3a350f95ccae46a$var$H(a) {
    $a3a350f95ccae46a$var$B = !1;
    $a3a350f95ccae46a$var$G(a);
    if (!$a3a350f95ccae46a$var$A) {
        if (null !== $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$r)) $a3a350f95ccae46a$var$A = !0, $a3a350f95ccae46a$var$I($a3a350f95ccae46a$var$J);
        else {
            var b = $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$t);
            null !== b && $a3a350f95ccae46a$var$K($a3a350f95ccae46a$var$H, b.startTime - a);
        }
    }
}
function $a3a350f95ccae46a$var$J(a, b) {
    $a3a350f95ccae46a$var$A = !1;
    $a3a350f95ccae46a$var$B && ($a3a350f95ccae46a$var$B = !1, $a3a350f95ccae46a$var$E($a3a350f95ccae46a$var$L), $a3a350f95ccae46a$var$L = -1);
    $a3a350f95ccae46a$var$z = !0;
    var c = $a3a350f95ccae46a$var$y;
    try {
        $a3a350f95ccae46a$var$G(b);
        for($a3a350f95ccae46a$var$v = $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$r); null !== $a3a350f95ccae46a$var$v && (!($a3a350f95ccae46a$var$v.expirationTime > b) || a && !$a3a350f95ccae46a$var$M());){
            var d = $a3a350f95ccae46a$var$v.callback;
            if ("function" === typeof d) {
                $a3a350f95ccae46a$var$v.callback = null;
                $a3a350f95ccae46a$var$y = $a3a350f95ccae46a$var$v.priorityLevel;
                var e = d($a3a350f95ccae46a$var$v.expirationTime <= b);
                b = $a3a350f95ccae46a$export$c4744153514ff05d();
                "function" === typeof e ? $a3a350f95ccae46a$var$v.callback = e : $a3a350f95ccae46a$var$v === $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$r) && $a3a350f95ccae46a$var$k($a3a350f95ccae46a$var$r);
                $a3a350f95ccae46a$var$G(b);
            } else $a3a350f95ccae46a$var$k($a3a350f95ccae46a$var$r);
            $a3a350f95ccae46a$var$v = $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$r);
        }
        if (null !== $a3a350f95ccae46a$var$v) var w = !0;
        else {
            var m = $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$t);
            null !== m && $a3a350f95ccae46a$var$K($a3a350f95ccae46a$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a3a350f95ccae46a$var$v = null, $a3a350f95ccae46a$var$y = c, $a3a350f95ccae46a$var$z = !1;
    }
}
var $a3a350f95ccae46a$var$N = !1, $a3a350f95ccae46a$var$O = null, $a3a350f95ccae46a$var$L = -1, $a3a350f95ccae46a$var$P = 5, $a3a350f95ccae46a$var$Q = -1;
function $a3a350f95ccae46a$var$M() {
    return $a3a350f95ccae46a$export$c4744153514ff05d() - $a3a350f95ccae46a$var$Q < $a3a350f95ccae46a$var$P ? !1 : !0;
}
function $a3a350f95ccae46a$var$R() {
    if (null !== $a3a350f95ccae46a$var$O) {
        var a = $a3a350f95ccae46a$export$c4744153514ff05d();
        $a3a350f95ccae46a$var$Q = a;
        var b = !0;
        try {
            b = $a3a350f95ccae46a$var$O(!0, a);
        } finally{
            b ? $a3a350f95ccae46a$var$S() : ($a3a350f95ccae46a$var$N = !1, $a3a350f95ccae46a$var$O = null);
        }
    } else $a3a350f95ccae46a$var$N = !1;
}
var $a3a350f95ccae46a$var$S;
if ("function" === typeof $a3a350f95ccae46a$var$F) $a3a350f95ccae46a$var$S = function() {
    $a3a350f95ccae46a$var$F($a3a350f95ccae46a$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a3a350f95ccae46a$var$T = new MessageChannel, $a3a350f95ccae46a$var$U = $a3a350f95ccae46a$var$T.port2;
    $a3a350f95ccae46a$var$T.port1.onmessage = $a3a350f95ccae46a$var$R;
    $a3a350f95ccae46a$var$S = function() {
        $a3a350f95ccae46a$var$U.postMessage(null);
    };
} else $a3a350f95ccae46a$var$S = function() {
    $a3a350f95ccae46a$var$D($a3a350f95ccae46a$var$R, 0);
};
function $a3a350f95ccae46a$var$I(a) {
    $a3a350f95ccae46a$var$O = a;
    $a3a350f95ccae46a$var$N || ($a3a350f95ccae46a$var$N = !0, $a3a350f95ccae46a$var$S());
}
function $a3a350f95ccae46a$var$K(a, b) {
    $a3a350f95ccae46a$var$L = $a3a350f95ccae46a$var$D(function() {
        a($a3a350f95ccae46a$export$c4744153514ff05d());
    }, b);
}
$a3a350f95ccae46a$export$3e506c1ccc9cc1a7 = 5;
$a3a350f95ccae46a$export$e26fe2ed2fa76875 = 1;
$a3a350f95ccae46a$export$502329bbf4b505b1 = 4;
$a3a350f95ccae46a$export$6e3807111c4874c4 = 3;
$a3a350f95ccae46a$export$c27134553091fb3a = null;
$a3a350f95ccae46a$export$33ee1acdc04fd2a2 = 2;
$a3a350f95ccae46a$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a3a350f95ccae46a$export$8352ce38b91d0c62 = function() {
    $a3a350f95ccae46a$var$A || $a3a350f95ccae46a$var$z || ($a3a350f95ccae46a$var$A = !0, $a3a350f95ccae46a$var$I($a3a350f95ccae46a$var$J));
};
$a3a350f95ccae46a$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a3a350f95ccae46a$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a3a350f95ccae46a$export$d3dfb8e4810cb555 = function() {
    return $a3a350f95ccae46a$var$y;
};
$a3a350f95ccae46a$export$839f9183b0465a69 = function() {
    return $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$r);
};
$a3a350f95ccae46a$export$72fdf0e06517287b = function(a) {
    switch($a3a350f95ccae46a$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a3a350f95ccae46a$var$y;
    }
    var c = $a3a350f95ccae46a$var$y;
    $a3a350f95ccae46a$var$y = b;
    try {
        return a();
    } finally{
        $a3a350f95ccae46a$var$y = c;
    }
};
$a3a350f95ccae46a$export$4b844e58a3e414b4 = function() {};
$a3a350f95ccae46a$export$816d2913ae6b83b1 = function() {};
$a3a350f95ccae46a$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a3a350f95ccae46a$var$y;
    $a3a350f95ccae46a$var$y = a;
    try {
        return b();
    } finally{
        $a3a350f95ccae46a$var$y = c;
    }
};
$a3a350f95ccae46a$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a3a350f95ccae46a$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a3a350f95ccae46a$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$t, a), null === $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$r) && a === $a3a350f95ccae46a$var$h($a3a350f95ccae46a$var$t) && ($a3a350f95ccae46a$var$B ? ($a3a350f95ccae46a$var$E($a3a350f95ccae46a$var$L), $a3a350f95ccae46a$var$L = -1) : $a3a350f95ccae46a$var$B = !0, $a3a350f95ccae46a$var$K($a3a350f95ccae46a$var$H, c - d))) : (a.sortIndex = e, $a3a350f95ccae46a$var$f($a3a350f95ccae46a$var$r, a), $a3a350f95ccae46a$var$A || $a3a350f95ccae46a$var$z || ($a3a350f95ccae46a$var$A = !0, $a3a350f95ccae46a$var$I($a3a350f95ccae46a$var$J)));
    return a;
};
$a3a350f95ccae46a$export$b5836b71941fa3ed = $a3a350f95ccae46a$var$M;
$a3a350f95ccae46a$export$cf845f2c119da08a = function(a) {
    var b = $a3a350f95ccae46a$var$y;
    return function() {
        var c = $a3a350f95ccae46a$var$y;
        $a3a350f95ccae46a$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a3a350f95ccae46a$var$y = c;
        }
    };
};

});



parcelRegister("j3WDN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $8j5uN = parcelRequire("8j5uN");
function $de0bc8fe92a13a51$var$emptyFunction() {}
function $de0bc8fe92a13a51$var$emptyFunctionWithReset() {}
$de0bc8fe92a13a51$var$emptyFunctionWithReset.resetWarningCache = $de0bc8fe92a13a51$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8j5uN) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $de0bc8fe92a13a51$var$emptyFunctionWithReset,
        resetWarningCache: $de0bc8fe92a13a51$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8j5uN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $60c45c6b0cb44b91$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $60c45c6b0cb44b91$var$ReactPropTypesSecret;

});


parcelRegister("ktOZw", function(module, exports) {
module.exports = $parcel$resolve("lDAJN");

});

var $891f868af4e5e12c$exports = {};
$parcel$extendImportMap({
    "lDAJN": "ping.a0fa0d8b.mp3"
});

var $716072e90fe46d73$exports = {};
'use strict';

$716072e90fe46d73$exports = (parcelRequire("aF92j"));


parcelRequire("cQNHH");
var $0e5729790c839e67$exports = {};

$parcel$export($0e5729790c839e67$exports, "createRoot", function () { return $0e5729790c839e67$export$882461b6382ed46c; }, function (v) { return $0e5729790c839e67$export$882461b6382ed46c = v; });
$parcel$export($0e5729790c839e67$exports, "hydrateRoot", function () { return $0e5729790c839e67$export$757ceba2d55c277e; }, function (v) { return $0e5729790c839e67$export$757ceba2d55c277e = v; });
var $0e5729790c839e67$export$882461b6382ed46c;
var $0e5729790c839e67$export$757ceba2d55c277e;
'use strict';
var $a058c85580ba5e0b$exports = {};
'use strict';
function $a058c85580ba5e0b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a058c85580ba5e0b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a058c85580ba5e0b$var$checkDCE();

$a058c85580ba5e0b$exports = (parcelRequire("jozO0"));


var $0e5729790c839e67$var$i;
$0e5729790c839e67$export$882461b6382ed46c = $a058c85580ba5e0b$exports.createRoot;
$0e5729790c839e67$export$757ceba2d55c277e = $a058c85580ba5e0b$exports.hydrateRoot;




var $cQNHH = parcelRequire("cQNHH");

parcelRequire("cQNHH");
function $a7dd764ddb4e6443$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $c9ae1c59a9c2cb2f$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $a7dd764ddb4e6443$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $3abb53145a9155ce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3abb53145a9155ce$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $3abb53145a9155ce$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $a34178b8c640f830$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $579302c8e6721842$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $a34178b8c640f830$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


var $13b3195589c46dae$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if ($13b3195589c46dae$exports) {
        classNames.default = classNames;
        $13b3195589c46dae$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $cQNHH = parcelRequire("cQNHH");
function $7fcaffa132ef3fcf$export$71511d61b312f219() {
    $7fcaffa132ef3fcf$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7fcaffa132ef3fcf$export$71511d61b312f219.apply(this, arguments);
}


function $b81b47d5ffe0be74$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}





var $cQNHH = parcelRequire("cQNHH");

"use client";
const $d344ef3e3248c0b3$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $d344ef3e3248c0b3$export$ff817e17bad2e091 = 'xs';
const $d344ef3e3248c0b3$var$ThemeContext = /*#__PURE__*/ $cQNHH.createContext({
    prefixes: {},
    breakpoints: $d344ef3e3248c0b3$export$666ad80b5007f835,
    minBreakpoint: $d344ef3e3248c0b3$export$ff817e17bad2e091
});
const { Consumer: $d344ef3e3248c0b3$export$b631efc24e9d5e2f, Provider: $d344ef3e3248c0b3$var$Provider } = $d344ef3e3248c0b3$var$ThemeContext;
function $d344ef3e3248c0b3$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $d344ef3e3248c0b3$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $d344ef3e3248c0b3$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $cQNHH.useMemo)(()=>({
            prefixes: (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, prefixes),
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)($d344ef3e3248c0b3$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $d344ef3e3248c0b3$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $cQNHH.useContext)($d344ef3e3248c0b3$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $d344ef3e3248c0b3$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $cQNHH.useContext)($d344ef3e3248c0b3$var$ThemeContext);
    return breakpoints;
}
function $d344ef3e3248c0b3$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $cQNHH.useContext)($d344ef3e3248c0b3$var$ThemeContext);
    return minBreakpoint;
}
function $d344ef3e3248c0b3$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $cQNHH.useContext)($d344ef3e3248c0b3$var$ThemeContext);
    return dir === 'rtl';
}
function $d344ef3e3248c0b3$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
        var props = (0, $7fcaffa132ef3fcf$export$71511d61b312f219)({}, (0, $b81b47d5ffe0be74$export$71511d61b312f219)(_param));
        props[forwardRefAs] = ref;
        const bsPrefix = $d344ef3e3248c0b3$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props), {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $d344ef3e3248c0b3$export$2e2bcd8739ae039 = $d344ef3e3248c0b3$var$ThemeProvider;



"use client";
const $e436d619efaf7134$var$Container = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', className: className } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "fluid",
        "as",
        "className"
    ]);
    const prefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    }));
});
$e436d619efaf7134$var$Container.displayName = 'Container';
var $e436d619efaf7134$export$2e2bcd8739ae039 = $e436d619efaf7134$var$Container;






var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");
const $9e38986a28d3c9c6$var$SelectableContext = /*#__PURE__*/ $cQNHH.createContext(null);
const $9e38986a28d3c9c6$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $9e38986a28d3c9c6$export$2e2bcd8739ae039 = $9e38986a28d3c9c6$var$SelectableContext;


function $bc57db8a5dfd3d99$export$2e2bcd8739ae039() {
    return $bc57db8a5dfd3d99$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bc57db8a5dfd3d99$export$2e2bcd8739ae039.apply(null, arguments);
}


function $407e1b6a8d307018$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $cQNHH = parcelRequire("cQNHH");
var $e5f9c2c26e21f232$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $e5f9c2c26e21f232$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$e5f9c2c26e21f232$exports = $e5f9c2c26e21f232$var$invariant;


var $1bfffd2952024065$var$noop = function noop() {};
function $1bfffd2952024065$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $1bfffd2952024065$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $1bfffd2952024065$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$1bfffd2952024065$export$26cbf8c37e721e67(prop)] = $1bfffd2952024065$var$noop;
        var handler;
    });
    return propTypes;
}
function $1bfffd2952024065$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $1bfffd2952024065$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $1bfffd2952024065$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $652b4200927b0439$var$_toPropertyKey(arg) {
    var key = $652b4200927b0439$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $652b4200927b0439$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $652b4200927b0439$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $cQNHH.useRef)(propValue !== undefined);
    var _useState = (0, $cQNHH.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $cQNHH.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $652b4200927b0439$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$1bfffd2952024065$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_ref, [
            $1bfffd2952024065$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($652b4200927b0439$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $652b4200927b0439$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $a814487b0bb00175$export$2e2bcd8739ae039(t, e) {
    return $a814487b0bb00175$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a814487b0bb00175$export$2e2bcd8739ae039(t, e);
}


function $011e5a01704cf426$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $a814487b0bb00175$export$2e2bcd8739ae039)(t, o);
}



var $cQNHH = parcelRequire("cQNHH");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $1a62a68a5223d40b$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $1a62a68a5223d40b$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $1a62a68a5223d40b$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$1a62a68a5223d40b$var$componentWillMount.__suppressDeprecationWarning = true;
$1a62a68a5223d40b$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$1a62a68a5223d40b$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $1a62a68a5223d40b$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $1a62a68a5223d40b$var$componentWillMount;
        prototype.componentWillReceiveProps = $1a62a68a5223d40b$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $1a62a68a5223d40b$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $59726e5d5f6db38b$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $59726e5d5f6db38b$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $1bfffd2952024065$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($1bfffd2952024065$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($e5f9c2c26e21f232$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $011e5a01704cf426$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$1bfffd2952024065$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$1bfffd2952024065$export$12ae2baa35bd9b8b(props, key) && $1bfffd2952024065$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$1bfffd2952024065$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(Component, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
    (0, $1a62a68a5223d40b$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $1bfffd2952024065$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement(UncontrolledComponent, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $59726e5d5f6db38b$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $59726e5d5f6db38b$export$2e2bcd8739ae039(newComponent, (0, $bc57db8a5dfd3d99$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}









var $cQNHH = parcelRequire("cQNHH");


"use client";
const $4342c93854d88c15$var$NavbarBrand = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, as: as } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }));
});
$4342c93854d88c15$var$NavbarBrand.displayName = 'NavbarBrand';
var $4342c93854d88c15$export$2e2bcd8739ae039 = $4342c93854d88c15$var$NavbarBrand;






var $cQNHH = parcelRequire("cQNHH");




/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $7df48d49a4f6302c$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $6682f03fb5ec32ac$export$2e2bcd8739ae039(node) {
    var doc = (0, $7df48d49a4f6302c$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $4486dc4af296df7e$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $6682f03fb5ec32ac$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $9714d49a63a47185$var$rUpper = /([A-Z])/g;
function $9714d49a63a47185$export$2e2bcd8739ae039(string) {
    return string.replace($9714d49a63a47185$var$rUpper, '-$1').toLowerCase();
}


var $2e0a2d72978d6399$var$msPattern = /^ms-/;
function $2e0a2d72978d6399$export$2e2bcd8739ae039(string) {
    return (0, $9714d49a63a47185$export$2e2bcd8739ae039)(string).replace($2e0a2d72978d6399$var$msPattern, '-ms-');
}


var $3807b94dae491176$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $3807b94dae491176$export$2e2bcd8739ae039(value) {
    return !!(value && $3807b94dae491176$var$supportedTransforms.test(value));
}


function $3958a890a0461dae$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $2e0a2d72978d6399$export$2e2bcd8739ae039)(property)) || (0, $4486dc4af296df7e$export$2e2bcd8739ae039)(node).getPropertyValue((0, $2e0a2d72978d6399$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $2e0a2d72978d6399$export$2e2bcd8739ae039)(key));
        else if ((0, $3807b94dae491176$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $2e0a2d72978d6399$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $3958a890a0461dae$export$2e2bcd8739ae039 = $3958a890a0461dae$var$style;



var $cQNHH = parcelRequire("cQNHH");




var $cQNHH = parcelRequire("cQNHH");

var $a32642db752054c4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $cQNHH = parcelRequire("cQNHH");
var $83be37a334a682ab$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createContext(null);


var $5c5a46399572be6d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $e02d12f128aebaec$export$bb38bb9a1161268 = 'unmounted';
var $e02d12f128aebaec$export$84cbff306f539230 = 'exited';
var $e02d12f128aebaec$export$df38205c966be359 = 'entering';
var $e02d12f128aebaec$export$78e9e6e3e014d60a = 'entered';
var $e02d12f128aebaec$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $e02d12f128aebaec$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $011e5a01704cf426$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $e02d12f128aebaec$export$84cbff306f539230;
                _this.appearStatus = $e02d12f128aebaec$export$df38205c966be359;
            } else initialStatus = $e02d12f128aebaec$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $e02d12f128aebaec$export$bb38bb9a1161268;
        else initialStatus = $e02d12f128aebaec$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $e02d12f128aebaec$export$bb38bb9a1161268) return {
            status: $e02d12f128aebaec$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $e02d12f128aebaec$export$df38205c966be359 && status !== $e02d12f128aebaec$export$78e9e6e3e014d60a) nextStatus = $e02d12f128aebaec$export$df38205c966be359;
            } else if (status === $e02d12f128aebaec$export$df38205c966be359 || status === $e02d12f128aebaec$export$78e9e6e3e014d60a) nextStatus = $e02d12f128aebaec$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $e02d12f128aebaec$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($a058c85580ba5e0b$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $5c5a46399572be6d$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $e02d12f128aebaec$export$84cbff306f539230) this.setState({
            status: $e02d12f128aebaec$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($a058c85580ba5e0b$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $a32642db752054c4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e02d12f128aebaec$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $e02d12f128aebaec$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $e02d12f128aebaec$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($a058c85580ba5e0b$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $a32642db752054c4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $e02d12f128aebaec$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $e02d12f128aebaec$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $e02d12f128aebaec$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($a058c85580ba5e0b$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $e02d12f128aebaec$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $407e1b6a8d307018$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).createElement((0, $83be37a334a682ab$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).Component);
$e02d12f128aebaec$var$Transition.contextType = (0, $83be37a334a682ab$export$2e2bcd8739ae039);
$e02d12f128aebaec$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $e02d12f128aebaec$var$noop() {}
$e02d12f128aebaec$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $e02d12f128aebaec$var$noop,
    onEntering: $e02d12f128aebaec$var$noop,
    onEntered: $e02d12f128aebaec$var$noop,
    onExit: $e02d12f128aebaec$var$noop,
    onExiting: $e02d12f128aebaec$var$noop,
    onExited: $e02d12f128aebaec$var$noop
};
$e02d12f128aebaec$var$Transition.UNMOUNTED = $e02d12f128aebaec$export$bb38bb9a1161268;
$e02d12f128aebaec$var$Transition.EXITED = $e02d12f128aebaec$export$84cbff306f539230;
$e02d12f128aebaec$var$Transition.ENTERING = $e02d12f128aebaec$export$df38205c966be359;
$e02d12f128aebaec$var$Transition.ENTERED = $e02d12f128aebaec$export$78e9e6e3e014d60a;
$e02d12f128aebaec$var$Transition.EXITING = $e02d12f128aebaec$export$4aacc83d4d59139f;
var $e02d12f128aebaec$export$2e2bcd8739ae039 = $e02d12f128aebaec$var$Transition;



var $cQNHH = parcelRequire("cQNHH");
function $b95e9aa5e3e8865a$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $b95e9aa5e3e8865a$export$13e065f3a74cfe36() {
    const parts = $cQNHH.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $b95e9aa5e3e8865a$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $b95e9aa5e3e8865a$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}




/* eslint-disable no-return-assign */ var $123b6114b54e95dd$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $c9d787f1b0659277$export$63fefd044b2bc624 = false;
var $c9d787f1b0659277$export$a614c6b395900f69 = false;
try {
    var $c9d787f1b0659277$var$options = {
        get passive () {
            return $c9d787f1b0659277$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $c9d787f1b0659277$export$a614c6b395900f69 = $c9d787f1b0659277$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $123b6114b54e95dd$export$2e2bcd8739ae039) {
        window.addEventListener('test', $c9d787f1b0659277$var$options, $c9d787f1b0659277$var$options);
        window.removeEventListener('test', $c9d787f1b0659277$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $c9d787f1b0659277$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$c9d787f1b0659277$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$c9d787f1b0659277$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $c9d787f1b0659277$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $c9d787f1b0659277$export$2e2bcd8739ae039 = $c9d787f1b0659277$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $5545ecd5b8617486$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $5545ecd5b8617486$export$2e2bcd8739ae039 = $5545ecd5b8617486$var$removeEventListener;


function $53cf08a18cfb2af4$var$listen(node, eventName, handler, options) {
    (0, $c9d787f1b0659277$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $5545ecd5b8617486$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $53cf08a18cfb2af4$export$2e2bcd8739ae039 = $53cf08a18cfb2af4$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $e8d21e625427d585$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $84c46953ce51ca52$var$parseDuration(node) {
    var str = (0, $3958a890a0461dae$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $84c46953ce51ca52$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $e8d21e625427d585$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $53cf08a18cfb2af4$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $84c46953ce51ca52$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $84c46953ce51ca52$var$parseDuration(element) || 0;
    var removeEmulate = $84c46953ce51ca52$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $53cf08a18cfb2af4$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $b6a25d5e3e9a5dbf$var$parseDuration(node, property) {
    const str = (0, $3958a890a0461dae$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $b6a25d5e3e9a5dbf$export$2e2bcd8739ae039(element, handler) {
    const duration = $b6a25d5e3e9a5dbf$var$parseDuration(element, 'transitionDuration');
    const delay = $b6a25d5e3e9a5dbf$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $84c46953ce51ca52$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $50e70bd4f0686a9c$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $50e70bd4f0686a9c$export$2e2bcd8739ae039 = $50e70bd4f0686a9c$var$createChainedFunction;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $be2ac794c4d224bb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}






var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");
const $a57a09a1fdf41a48$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $a57a09a1fdf41a48$export$c9058316764c140e(refA, refB) {
    const a = $a57a09a1fdf41a48$var$toFnRef(refA);
    const b = $a57a09a1fdf41a48$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $a57a09a1fdf41a48$var$useMergedRefs(refA, refB) {
    return (0, $cQNHH.useMemo)(()=>$a57a09a1fdf41a48$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $a57a09a1fdf41a48$export$2e2bcd8739ae039 = $a57a09a1fdf41a48$var$useMergedRefs;



function $94307e7ed79305db$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($a058c85580ba5e0b$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $4f424d8179975d2e$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef((_param, ref)=>{
    var { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited",
        "addEndListener",
        "children",
        "childRef"
    ]);
    const nodeRef = (0, $cQNHH.useRef)(null);
    const mergedRef = (0, $a57a09a1fdf41a48$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $94307e7ed79305db$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $cQNHH.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $cQNHH.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $cQNHH.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $cQNHH.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $cQNHH.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $cQNHH.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $cQNHH.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $e02d12f128aebaec$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, innerProps), {
                ref: attachRef
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).cloneElement(children, {
            ref: attachRef
        })
    }));
});
$4f424d8179975d2e$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $4f424d8179975d2e$export$2e2bcd8739ae039 = $4f424d8179975d2e$var$TransitionWrapper;



const $7a39850fed264cfd$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $7a39850fed264cfd$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $7a39850fed264cfd$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $3958a890a0461dae$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $3958a890a0461dae$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $7a39850fed264cfd$var$collapseStyles = {
    [(0, $e02d12f128aebaec$export$84cbff306f539230)]: 'collapse',
    [(0, $e02d12f128aebaec$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $e02d12f128aebaec$export$df38205c966be359)]: 'collapsing',
    [(0, $e02d12f128aebaec$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $7a39850fed264cfd$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).forwardRef((_param, ref)=>{
    var { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $7a39850fed264cfd$var$getDefaultDimensionValue } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "className",
        "children",
        "dimension",
        "in",
        "timeout",
        "mountOnEnter",
        "unmountOnExit",
        "appear",
        "getDimensionValue"
    ]);
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $cQNHH.useMemo)(()=>(0, $50e70bd4f0686a9c$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $cQNHH.useMemo)(()=>(0, $50e70bd4f0686a9c$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $cQNHH.useMemo)(()=>(0, $50e70bd4f0686a9c$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $cQNHH.useMemo)(()=>(0, $50e70bd4f0686a9c$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $be2ac794c4d224bb$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $cQNHH.useMemo)(()=>(0, $50e70bd4f0686a9c$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4f424d8179975d2e$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        addEndListener: (0, $b6a25d5e3e9a5dbf$export$2e2bcd8739ae039)
    }, props), {
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $b95e9aa5e3e8865a$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).cloneElement(children, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, children.props.className, $7a39850fed264cfd$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            }))
    }));
});
$7a39850fed264cfd$var$Collapse.displayName = 'Collapse';
var $7a39850fed264cfd$export$2e2bcd8739ae039 = $7a39850fed264cfd$var$Collapse;




var $cQNHH = parcelRequire("cQNHH");
"use client";
// TODO: check
const $ee35c0e7bb7c02a7$var$context = /*#__PURE__*/ $cQNHH.createContext(null);
$ee35c0e7bb7c02a7$var$context.displayName = 'NavbarContext';
var $ee35c0e7bb7c02a7$export$2e2bcd8739ae039 = $ee35c0e7bb7c02a7$var$context;



"use client";
const $cf44fd6bec04626b$var$NavbarCollapse = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { children: children, bsPrefix: bsPrefix } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "children",
        "bsPrefix"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $cQNHH.useContext)((0, $ee35c0e7bb7c02a7$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7a39850fed264cfd$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        in: !!(context && context.expanded)
    }, props), {
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    }));
});
$cf44fd6bec04626b$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $cf44fd6bec04626b$export$2e2bcd8739ae039 = $cf44fd6bec04626b$var$NavbarCollapse;







var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $c8a441000e63d6ea$var$useCommittedRef(value) {
    const ref = (0, $cQNHH.useRef)(value);
    (0, $cQNHH.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $c8a441000e63d6ea$export$2e2bcd8739ae039 = $c8a441000e63d6ea$var$useCommittedRef;


function $69b21c98023fc358$export$2e2bcd8739ae039(fn) {
    const ref = (0, $c8a441000e63d6ea$export$2e2bcd8739ae039)(fn);
    return (0, $cQNHH.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}





"use client";
const $8148a69f40f08169$var$NavbarToggle = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'button', onClick: onClick } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "children",
        "label",
        "as",
        "onClick"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $cQNHH.useContext)((0, $ee35c0e7bb7c02a7$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $69b21c98023fc358$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props), {
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    }));
});
$8148a69f40f08169$var$NavbarToggle.displayName = 'NavbarToggle';
var $8148a69f40f08169$export$2e2bcd8739ae039 = $8148a69f40f08169$var$NavbarToggle;






var $cQNHH = parcelRequire("cQNHH");






var $cQNHH = parcelRequire("cQNHH");
const $df515f8e15a26b7b$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $df515f8e15a26b7b$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $df515f8e15a26b7b$export$2e2bcd8739ae039 = $df515f8e15a26b7b$var$isDOM || $df515f8e15a26b7b$var$isReactNative ? (0, $cQNHH.useLayoutEffect) : (0, $cQNHH.useEffect);



var $cQNHH = parcelRequire("cQNHH");
const $620c13348dd37454$var$matchersByWindow = new WeakMap();
const $620c13348dd37454$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $620c13348dd37454$var$matchersByWindow.get(targetWindow) || new Map();
    $620c13348dd37454$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $620c13348dd37454$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $620c13348dd37454$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $cQNHH.useState)(()=>mql ? mql.matches : false);
    (0, $df515f8e15a26b7b$export$2e2bcd8739ae039)(()=>{
        let mql = $620c13348dd37454$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $620c13348dd37454$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $cQNHH = parcelRequire("cQNHH");
function $427f3e8282f9ff4d$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $cQNHH.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $620c13348dd37454$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $427f3e8282f9ff4d$var$useBreakpoint = $427f3e8282f9ff4d$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $427f3e8282f9ff4d$export$2e2bcd8739ae039 = $427f3e8282f9ff4d$var$useBreakpoint;




var $cQNHH = parcelRequire("cQNHH");

function $eadc1002ff3b63bc$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $7df48d49a4f6302c$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $2aa39436a780c338$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");
function $03ca2165f7f54734$export$2e2bcd8739ae039() {
    const mounted = (0, $cQNHH.useRef)(true);
    const isMounted = (0, $cQNHH.useRef)(()=>mounted.current);
    (0, $cQNHH.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $cQNHH = parcelRequire("cQNHH");
function $c29091ca7c372bab$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $cQNHH.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $cQNHH = parcelRequire("cQNHH");
function $e481ebda7dc1470e$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $c29091ca7c372bab$export$2e2bcd8739ae039)(fn);
    (0, $cQNHH.useEffect)(()=>()=>onUnmount.current(), []);
}



var $cQNHH = parcelRequire("cQNHH");
function $a1430c233914c57b$export$2e2bcd8739ae039(value) {
    const ref = (0, $cQNHH.useRef)(null);
    (0, $cQNHH.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $962edf4bc5c6fe72$var$useCommittedRef(value) {
    const ref = (0, $cQNHH.useRef)(value);
    (0, $cQNHH.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $962edf4bc5c6fe72$export$2e2bcd8739ae039 = $962edf4bc5c6fe72$var$useCommittedRef;


function $10beb7154eb705d3$export$2e2bcd8739ae039(fn) {
    const ref = (0, $962edf4bc5c6fe72$export$2e2bcd8739ae039)(fn);
    return (0, $cQNHH.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



const $e6cbf14051c5a16b$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $e6cbf14051c5a16b$export$635202801f9383a0 = `rrUi`;
function $e6cbf14051c5a16b$export$5cc3b7b83e34ade7(property) {
    return `${$e6cbf14051c5a16b$export$fd7bcb7e9bef4e8a}${property}`;
}
function $e6cbf14051c5a16b$export$7776c0a7cd2eb3e0(property) {
    return `${$e6cbf14051c5a16b$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $c3d6fcf11802a080$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $ad40526eddf9d7bf$export$1a88c12b8b979fa0 = (0, $e6cbf14051c5a16b$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $ad40526eddf9d7bf$var$ModalManager {
    getScrollbarWidth() {
        return (0, $c3d6fcf11802a080$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $3958a890a0461dae$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($ad40526eddf9d7bf$export$1a88c12b8b979fa0, '');
        (0, $3958a890a0461dae$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($ad40526eddf9d7bf$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
}
var $ad40526eddf9d7bf$export$2e2bcd8739ae039 = $ad40526eddf9d7bf$var$ModalManager;





var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");

const $11ae4e217954f3cc$var$Context = /*#__PURE__*/ (0, $cQNHH.createContext)((0, $123b6114b54e95dd$export$2e2bcd8739ae039) ? window : undefined);
const $11ae4e217954f3cc$export$f7d306aeb1cf5fbc = $11ae4e217954f3cc$var$Context.Provider;
function $11ae4e217954f3cc$export$2e2bcd8739ae039() {
    return (0, $cQNHH.useContext)($11ae4e217954f3cc$var$Context);
}


const $e57a3d3af1ccbb25$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $123b6114b54e95dd$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $7df48d49a4f6302c$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $e57a3d3af1ccbb25$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $11ae4e217954f3cc$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $cQNHH.useState)(()=>$e57a3d3af1ccbb25$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $e57a3d3af1ccbb25$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $cQNHH.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $cQNHH.useEffect)(()=>{
        const nextRef = $e57a3d3af1ccbb25$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}




var $cQNHH = parcelRequire("cQNHH");
const $1b5655dcae36b210$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $1b5655dcae36b210$export$c9058316764c140e(refA, refB) {
    const a = $1b5655dcae36b210$var$toFnRef(refA);
    const b = $1b5655dcae36b210$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $1b5655dcae36b210$var$useMergedRefs(refA, refB) {
    return (0, $cQNHH.useMemo)(()=>$1b5655dcae36b210$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $1b5655dcae36b210$export$2e2bcd8739ae039 = $1b5655dcae36b210$var$useMergedRefs;




var $cQNHH = parcelRequire("cQNHH");
const $9ef41493109869e4$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $9ef41493109869e4$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $9ef41493109869e4$export$2e2bcd8739ae039 = $9ef41493109869e4$var$isDOM || $9ef41493109869e4$var$isReactNative ? (0, $cQNHH.useLayoutEffect) : (0, $cQNHH.useEffect);



var $cQNHH = parcelRequire("cQNHH");



var $cQNHH = parcelRequire("cQNHH");

function $ca72d2dc9df2e0a5$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $cQNHH.useRef)(null);
    const hasEnteredRef = (0, $cQNHH.useRef)(inProp);
    const handleExited = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)(onExited);
    (0, $cQNHH.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $1b5655dcae36b210$export$2e2bcd8739ae039)(ref, (0, $b95e9aa5e3e8865a$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $cQNHH.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $ca72d2dc9df2e0a5$export$2e2bcd8739ae039 = $ca72d2dc9df2e0a5$var$NoopTransition;



var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");


const $93c91e70eaeeca41$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $93c91e70eaeeca41$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $93c91e70eaeeca41$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $93c91e70eaeeca41$var$_objectWithoutPropertiesLoose(_ref, $93c91e70eaeeca41$var$_excluded);
    const nodeRef = (0, $cQNHH.useRef)(null);
    const mergedRef = (0, $1b5655dcae36b210$export$2e2bcd8739ae039)(nodeRef, (0, $b95e9aa5e3e8865a$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $cQNHH.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $cQNHH.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $cQNHH.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $cQNHH.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $cQNHH.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $cQNHH.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $cQNHH.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $cQNHH.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $9505a38643ad1226$var$_excluded = [
    "component"
];
function $9505a38643ad1226$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $9505a38643ad1226$var$RTGTransition = /*#__PURE__*/ $cQNHH.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $9505a38643ad1226$var$_objectWithoutPropertiesLoose(_ref, $9505a38643ad1226$var$_excluded);
    const transitionProps = (0, $93c91e70eaeeca41$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $9505a38643ad1226$export$2e2bcd8739ae039 = $9505a38643ad1226$var$RTGTransition;




function $9d4d572234f08811$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $cQNHH.useRef)(null);
    const isInitialRef = (0, $cQNHH.useRef)(true);
    const handleTransition = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)(onTransition);
    (0, $9ef41493109869e4$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $9ef41493109869e4$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $9d4d572234f08811$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $cQNHH.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $9d4d572234f08811$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $1b5655dcae36b210$export$2e2bcd8739ae039)(ref, (0, $b95e9aa5e3e8865a$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $cQNHH.cloneElement)(children, {
        ref: combinedRef
    });
}
function $9d4d572234f08811$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $9505a38643ad1226$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)($9d4d572234f08811$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $ca72d2dc9df2e0a5$export$2e2bcd8739ae039), Object.assign({}, props));
}




const $fcec9fe8620d23d9$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $fcec9fe8620d23d9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $fcec9fe8620d23d9$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $fcec9fe8620d23d9$var$getManager(window) {
    if (!$fcec9fe8620d23d9$var$manager) $fcec9fe8620d23d9$var$manager = new (0, $ad40526eddf9d7bf$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $fcec9fe8620d23d9$var$manager;
}
function $fcec9fe8620d23d9$var$useModalManager(provided) {
    const window = (0, $11ae4e217954f3cc$export$2e2bcd8739ae039)();
    const modalManager = provided || $fcec9fe8620d23d9$var$getManager(window);
    const modal = (0, $cQNHH.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $cQNHH.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $cQNHH.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $fcec9fe8620d23d9$var$Modal = /*#__PURE__*/ (0, $cQNHH.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $fcec9fe8620d23d9$var$_objectWithoutPropertiesLoose(_ref, $fcec9fe8620d23d9$var$_excluded);
    const ownerWindow = (0, $11ae4e217954f3cc$export$2e2bcd8739ae039)();
    const container = (0, $e57a3d3af1ccbb25$export$2e2bcd8739ae039)(containerRef);
    const modal = $fcec9fe8620d23d9$var$useModalManager(providedManager);
    const isMounted = (0, $03ca2165f7f54734$export$2e2bcd8739ae039)();
    const prevShow = (0, $a1430c233914c57b$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $cQNHH.useState)(!show);
    const lastFocusRef = (0, $cQNHH.useRef)(null);
    (0, $cQNHH.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $123b6114b54e95dd$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $eadc1002ff3b63bc$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $53cf08a18cfb2af4$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $53cf08a18cfb2af4$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $eadc1002ff3b63bc$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $2aa39436a780c338$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $cQNHH.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $cQNHH.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $e481ebda7dc1470e$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $eadc1002ff3b63bc$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $2aa39436a780c338$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $b95e9aa5e3e8865a$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $cQNHH.useRef)();
    const removeKeydownListenerRef = (0, $cQNHH.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $cQNHH.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $9d4d572234f08811$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $9d4d572234f08811$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $716072e90fe46d73$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a058c85580ba5e0b$exports))).createPortal(/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$fcec9fe8620d23d9$var$Modal.displayName = 'Modal';
var $fcec9fe8620d23d9$export$2e2bcd8739ae039 = Object.assign($fcec9fe8620d23d9$var$Modal, {
    Manager: (0, $ad40526eddf9d7bf$export$2e2bcd8739ae039)
});







var $cQNHH = parcelRequire("cQNHH");






const $ee06ef704e32ed95$var$fadeStyles = {
    [(0, $e02d12f128aebaec$export$df38205c966be359)]: 'show',
    [(0, $e02d12f128aebaec$export$78e9e6e3e014d60a)]: 'show'
};
const $ee06ef704e32ed95$var$Fade = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter } = _param, rest = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "children",
        "transitionClasses",
        "onEnter"
    ]);
    const props = (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false
    }, rest);
    const handleEnter = (0, $cQNHH.useCallback)((node, isAppearing)=>{
        (0, $be2ac794c4d224bb$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4f424d8179975d2e$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        addEndListener: (0, $b6a25d5e3e9a5dbf$export$2e2bcd8739ae039)
    }, props), {
        onEnter: handleEnter,
        childRef: (0, $b95e9aa5e3e8865a$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $cQNHH.cloneElement(children, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))('fade', className, children.props.className, $ee06ef704e32ed95$var$fadeStyles[status], transitionClasses[status])
            }))
    }));
});
$ee06ef704e32ed95$var$Fade.displayName = 'Fade';
var $ee06ef704e32ed95$export$2e2bcd8739ae039 = $ee06ef704e32ed95$var$Fade;





var $cQNHH = parcelRequire("cQNHH");



"use client";
const $6a4054a51bb7e305$var$OffcanvasBody = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$6a4054a51bb7e305$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $6a4054a51bb7e305$export$2e2bcd8739ae039 = $6a4054a51bb7e305$var$OffcanvasBody;







var $cQNHH = parcelRequire("cQNHH");






"use client";
const $f5be34665c0e74fb$var$transitionStyles = {
    [(0, $e02d12f128aebaec$export$df38205c966be359)]: 'show',
    [(0, $e02d12f128aebaec$export$78e9e6e3e014d60a)]: 'show'
};
const $f5be34665c0e74fb$var$OffcanvasToggling = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "children",
        "in",
        "mountOnEnter",
        "unmountOnExit",
        "appear"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4f424d8179975d2e$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        addEndListener: (0, $b6a25d5e3e9a5dbf$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear
    }, props), {
        childRef: (0, $b95e9aa5e3e8865a$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $cQNHH.cloneElement(children, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, innerProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, children.props.className, (status === (0, $e02d12f128aebaec$export$df38205c966be359) || status === (0, $e02d12f128aebaec$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $f5be34665c0e74fb$var$transitionStyles[status])
            }))
    }));
});
$f5be34665c0e74fb$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $f5be34665c0e74fb$export$2e2bcd8739ae039 = $f5be34665c0e74fb$var$OffcanvasToggling;



var $cQNHH = parcelRequire("cQNHH");
"use client";
const $dc7033eda9f30ed4$var$ModalContext = /*#__PURE__*/ $cQNHH.createContext({
    onHide () {}
});
var $dc7033eda9f30ed4$export$2e2bcd8739ae039 = $dc7033eda9f30ed4$var$ModalContext;







var $cQNHH = parcelRequire("cQNHH");





var $cQNHH = parcelRequire("cQNHH");



var $11f8a89d85a36f13$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11f8a89d85a36f13$var$ReactIs, $11f8a89d85a36f13$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$11f8a89d85a36f13$exports = (parcelRequire("j3WDN"))();



var $cQNHH = parcelRequire("cQNHH");


const $4e6b8c63d5a92020$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).oneOf([
        'white'
    ])
};
const $4e6b8c63d5a92020$var$CloseButton = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, variant: variant, 'aria-label': ariaLabel = 'Close' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "variant",
        'aria-label'
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("button", (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel
    }, props));
});
$4e6b8c63d5a92020$var$CloseButton.displayName = 'CloseButton';
$4e6b8c63d5a92020$var$CloseButton.propTypes = $4e6b8c63d5a92020$var$propTypes;
var $4e6b8c63d5a92020$export$2e2bcd8739ae039 = $4e6b8c63d5a92020$var$CloseButton;




"use client";
const $ae3aa136efbf73f0$var$AbstractModalHeader = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "closeLabel",
        "closeVariant",
        "closeButton",
        "onHide",
        "children"
    ]);
    const context = (0, $cQNHH.useContext)((0, $dc7033eda9f30ed4$export$2e2bcd8739ae039));
    const handleClick = (0, $69b21c98023fc358$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4e6b8c63d5a92020$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    }));
});
$ae3aa136efbf73f0$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $ae3aa136efbf73f0$export$2e2bcd8739ae039 = $ae3aa136efbf73f0$var$AbstractModalHeader;



"use client";
const $50b75f609e7a91ed$var$OffcanvasHeader = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $ae3aa136efbf73f0$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$50b75f609e7a91ed$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $50b75f609e7a91ed$export$2e2bcd8739ae039 = $50b75f609e7a91ed$var$OffcanvasHeader;





var $cQNHH = parcelRequire("cQNHH");




var $cQNHH = parcelRequire("cQNHH");


var $e8eeaa4582252c3a$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $cQNHH.forwardRef((p, ref)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, p), {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(p.className, className)
        })));




"use client";
const $47e6b6c963b0a6ab$var$DivStyledAsH5 = (0, $e8eeaa4582252c3a$export$2e2bcd8739ae039)('h5');
const $47e6b6c963b0a6ab$var$OffcanvasTitle = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $47e6b6c963b0a6ab$var$DivStyledAsH5 } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$47e6b6c963b0a6ab$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $47e6b6c963b0a6ab$export$2e2bcd8739ae039 = $47e6b6c963b0a6ab$var$OffcanvasTitle;



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $95b43f390fe90af1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $a59aa42aaccfbf28$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $95b43f390fe90af1$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}



var $f2f152a0256e8d5f$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $f2f152a0256e8d5f$export$2e2bcd8739ae039(element, selector) {
    return $f2f152a0256e8d5f$var$toArray(element.querySelectorAll(selector));
}


function $ca31985fd3aa56c8$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $ca31985fd3aa56c8$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $ca31985fd3aa56c8$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $ca31985fd3aa56c8$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $d8a058b1a0e80cb5$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $d8a058b1a0e80cb5$var$BootstrapModalManager extends (0, $ad40526eddf9d7bf$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $3958a890a0461dae$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $3958a890a0461dae$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $3958a890a0461dae$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $a59aa42aaccfbf28$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $f2f152a0256e8d5f$export$2e2bcd8739ae039)(container, $d8a058b1a0e80cb5$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $f2f152a0256e8d5f$export$2e2bcd8739ae039)(container, $d8a058b1a0e80cb5$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $f2f152a0256e8d5f$export$2e2bcd8739ae039)(container, $d8a058b1a0e80cb5$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $ca31985fd3aa56c8$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $f2f152a0256e8d5f$export$2e2bcd8739ae039)(container, $d8a058b1a0e80cb5$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $f2f152a0256e8d5f$export$2e2bcd8739ae039)(container, $d8a058b1a0e80cb5$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $f2f152a0256e8d5f$export$2e2bcd8739ae039)(container, $d8a058b1a0e80cb5$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $d8a058b1a0e80cb5$var$sharedManager;
function $d8a058b1a0e80cb5$export$a03641438014b436(options) {
    if (!$d8a058b1a0e80cb5$var$sharedManager) $d8a058b1a0e80cb5$var$sharedManager = new $d8a058b1a0e80cb5$var$BootstrapModalManager(options);
    return $d8a058b1a0e80cb5$var$sharedManager;
}
var $d8a058b1a0e80cb5$export$2e2bcd8739ae039 = $d8a058b1a0e80cb5$var$BootstrapModalManager;



"use client";
function $78dfbc09b8c75af9$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $f5be34665c0e74fb$export$2e2bcd8739ae039), (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props));
}
function $78dfbc09b8c75af9$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $ee06ef704e32ed95$export$2e2bcd8739ae039), (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props));
}
const $78dfbc09b8c75af9$var$Offcanvas = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "children",
        'aria-labelledby',
        "placement",
        "responsive",
        "show",
        "backdrop",
        "keyboard",
        "scroll",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager",
        "renderStaticNode"
    ]);
    const modalManager = (0, $cQNHH.useRef)();
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $cQNHH.useState)(false);
    const handleHide = (0, $69b21c98023fc358$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $427f3e8282f9ff4d$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $cQNHH.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $cQNHH.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $d8a058b1a0e80cb5$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $d8a058b1a0e80cb5$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $cQNHH.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        })), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, dialogProps, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        }));
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $dc7033eda9f30ed4$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $fcec9fe8620d23d9$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $78dfbc09b8c75af9$var$DialogTransition,
                    backdropTransition: $78dfbc09b8c75af9$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$78dfbc09b8c75af9$var$Offcanvas.displayName = 'Offcanvas';
var $78dfbc09b8c75af9$export$2e2bcd8739ae039 = Object.assign($78dfbc09b8c75af9$var$Offcanvas, {
    Body: (0, $6a4054a51bb7e305$export$2e2bcd8739ae039),
    Header: (0, $50b75f609e7a91ed$export$2e2bcd8739ae039),
    Title: (0, $47e6b6c963b0a6ab$export$2e2bcd8739ae039)
});




"use client";
const $205217850dd6c188$var$NavbarOffcanvas = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { onHide: onHide } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "onHide"
    ]);
    const context = (0, $cQNHH.useContext)((0, $ee35c0e7bb7c02a7$export$2e2bcd8739ae039));
    const handleHide = (0, $69b21c98023fc358$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $78dfbc09b8c75af9$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        show: !!(context != null && context.expanded)
    }, props), {
        renderStaticNode: true,
        onHide: handleHide
    }));
});
$205217850dd6c188$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $205217850dd6c188$export$2e2bcd8739ae039 = $205217850dd6c188$var$NavbarOffcanvas;







var $cQNHH = parcelRequire("cQNHH");



"use client";
const $a8d7876652c20f71$var$NavbarText = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'span' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$a8d7876652c20f71$var$NavbarText.displayName = 'NavbarText';
var $a8d7876652c20f71$export$2e2bcd8739ae039 = $a8d7876652c20f71$var$NavbarText;



"use client";
const $7fed85a9c36a659f$var$Navbar = /*#__PURE__*/ $cQNHH.forwardRef((props, ref)=>{
    const _useUncontrolled = (0, $652b4200927b0439$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    }), { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false } = _useUncontrolled, controlledProps = (0, $579302c8e6721842$export$71511d61b312f219)(_useUncontrolled, [
        "bsPrefix",
        "expand",
        "variant",
        "bg",
        "fixed",
        "sticky",
        "className",
        "as",
        "expanded",
        "onToggle",
        "onSelect",
        "collapseOnSelect"
    ]);
    const bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $cQNHH.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $cQNHH.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $ee35c0e7bb7c02a7$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $9e38986a28d3c9c6$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
                ref: ref
            }, controlledProps), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            }))
        })
    });
});
$7fed85a9c36a659f$var$Navbar.displayName = 'Navbar';
var $7fed85a9c36a659f$export$2e2bcd8739ae039 = Object.assign($7fed85a9c36a659f$var$Navbar, {
    Brand: (0, $4342c93854d88c15$export$2e2bcd8739ae039),
    Collapse: (0, $cf44fd6bec04626b$export$2e2bcd8739ae039),
    Offcanvas: (0, $205217850dd6c188$export$2e2bcd8739ae039),
    Text: (0, $a8d7876652c20f71$export$2e2bcd8739ae039),
    Toggle: (0, $8148a69f40f08169$export$2e2bcd8739ae039)
});


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $cQNHH = parcelRequire("cQNHH");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $09a8f90f65bdbd99$var$_extends() {
    $09a8f90f65bdbd99$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $09a8f90f65bdbd99$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $09a8f90f65bdbd99$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($09a8f90f65bdbd99$export$e19cd5f9376f8cee || ($09a8f90f65bdbd99$export$e19cd5f9376f8cee = {}));
const $09a8f90f65bdbd99$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $09a8f90f65bdbd99$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $09a8f90f65bdbd99$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $09a8f90f65bdbd99$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $09a8f90f65bdbd99$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $09a8f90f65bdbd99$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $09a8f90f65bdbd99$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $09a8f90f65bdbd99$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $09a8f90f65bdbd99$export$fe53371bee54353d(to);
    }
    return $09a8f90f65bdbd99$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $09a8f90f65bdbd99$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $09a8f90f65bdbd99$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $09a8f90f65bdbd99$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $09a8f90f65bdbd99$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $09a8f90f65bdbd99$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $09a8f90f65bdbd99$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $09a8f90f65bdbd99$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $09a8f90f65bdbd99$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $09a8f90f65bdbd99$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $09a8f90f65bdbd99$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $09a8f90f65bdbd99$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $09a8f90f65bdbd99$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $09a8f90f65bdbd99$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $09a8f90f65bdbd99$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $09a8f90f65bdbd99$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $09a8f90f65bdbd99$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $09a8f90f65bdbd99$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($09a8f90f65bdbd99$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Push;
        let location = $09a8f90f65bdbd99$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $09a8f90f65bdbd99$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Replace;
        let location = $09a8f90f65bdbd99$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $09a8f90f65bdbd99$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $09a8f90f65bdbd99$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $09a8f90f65bdbd99$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($09a8f90f65bdbd99$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($09a8f90f65bdbd99$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $09a8f90f65bdbd99$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($09a8f90f65bdbd99$var$ResultType || ($09a8f90f65bdbd99$var$ResultType = {}));
const $09a8f90f65bdbd99$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $09a8f90f65bdbd99$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $09a8f90f65bdbd99$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $09a8f90f65bdbd99$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $09a8f90f65bdbd99$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($09a8f90f65bdbd99$var$isIndexRoute(route)) {
            let indexRoute = $09a8f90f65bdbd99$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $09a8f90f65bdbd99$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $09a8f90f65bdbd99$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $09a8f90f65bdbd99$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $09a8f90f65bdbd99$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $09a8f90f65bdbd99$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $09a8f90f65bdbd99$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $09a8f90f65bdbd99$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $09a8f90f65bdbd99$var$flattenRoutes(routes);
    $09a8f90f65bdbd99$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $09a8f90f65bdbd99$export$30d21fd6d7295f52(pathname);
        matches = $09a8f90f65bdbd99$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $09a8f90f65bdbd99$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $09a8f90f65bdbd99$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $09a8f90f65bdbd99$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $09a8f90f65bdbd99$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $09a8f90f65bdbd99$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $09a8f90f65bdbd99$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $09a8f90f65bdbd99$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $09a8f90f65bdbd99$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $09a8f90f65bdbd99$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $09a8f90f65bdbd99$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $09a8f90f65bdbd99$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $09a8f90f65bdbd99$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $09a8f90f65bdbd99$var$paramRe = /^:[\w-]+$/;
const $09a8f90f65bdbd99$var$dynamicSegmentValue = 3;
const $09a8f90f65bdbd99$var$indexRouteValue = 2;
const $09a8f90f65bdbd99$var$emptySegmentValue = 1;
const $09a8f90f65bdbd99$var$staticSegmentValue = 10;
const $09a8f90f65bdbd99$var$splatPenalty = -2;
const $09a8f90f65bdbd99$var$isSplat = (s)=>s === "*";
function $09a8f90f65bdbd99$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($09a8f90f65bdbd99$var$isSplat)) initialScore += $09a8f90f65bdbd99$var$splatPenalty;
    if (index) initialScore += $09a8f90f65bdbd99$var$indexRouteValue;
    return segments.filter((s)=>!$09a8f90f65bdbd99$var$isSplat(s)).reduce((score, segment)=>score + ($09a8f90f65bdbd99$var$paramRe.test(segment) ? $09a8f90f65bdbd99$var$dynamicSegmentValue : segment === "" ? $09a8f90f65bdbd99$var$emptySegmentValue : $09a8f90f65bdbd99$var$staticSegmentValue), initialScore);
}
function $09a8f90f65bdbd99$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $09a8f90f65bdbd99$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $09a8f90f65bdbd99$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $09a8f90f65bdbd99$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $09a8f90f65bdbd99$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $09a8f90f65bdbd99$export$a5c6d149b50c1d86($09a8f90f65bdbd99$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $09a8f90f65bdbd99$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $09a8f90f65bdbd99$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $09a8f90f65bdbd99$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $09a8f90f65bdbd99$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $09a8f90f65bdbd99$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $09a8f90f65bdbd99$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $09a8f90f65bdbd99$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $09a8f90f65bdbd99$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $09a8f90f65bdbd99$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $09a8f90f65bdbd99$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $09a8f90f65bdbd99$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $09a8f90f65bdbd99$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $09a8f90f65bdbd99$var$isAbsoluteUrl = (url)=>$09a8f90f65bdbd99$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $09a8f90f65bdbd99$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $09a8f90f65bdbd99$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($09a8f90f65bdbd99$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $09a8f90f65bdbd99$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $09a8f90f65bdbd99$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $09a8f90f65bdbd99$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $09a8f90f65bdbd99$var$normalizeSearch(search),
        hash: $09a8f90f65bdbd99$var$normalizeHash(hash)
    };
}
function $09a8f90f65bdbd99$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $09a8f90f65bdbd99$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $09a8f90f65bdbd99$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $09a8f90f65bdbd99$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $09a8f90f65bdbd99$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $09a8f90f65bdbd99$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $09a8f90f65bdbd99$export$8ccf933b0513f8d0(toArg);
    else {
        to = $09a8f90f65bdbd99$var$_extends({}, toArg);
        $09a8f90f65bdbd99$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $09a8f90f65bdbd99$var$getInvalidPathError("?", "pathname", "search", to));
        $09a8f90f65bdbd99$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $09a8f90f65bdbd99$var$getInvalidPathError("#", "pathname", "hash", to));
        $09a8f90f65bdbd99$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $09a8f90f65bdbd99$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $09a8f90f65bdbd99$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $09a8f90f65bdbd99$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $09a8f90f65bdbd99$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $09a8f90f65bdbd99$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $09a8f90f65bdbd99$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $09a8f90f65bdbd99$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $09a8f90f65bdbd99$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $09a8f90f65bdbd99$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $09a8f90f65bdbd99$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $09a8f90f65bdbd99$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $09a8f90f65bdbd99$export$4051a07651545597(data, init) {
    return new $09a8f90f65bdbd99$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $09a8f90f65bdbd99$export$42a99a7a4bc0e76a extends Error {
}
class $09a8f90f65bdbd99$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $09a8f90f65bdbd99$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $09a8f90f65bdbd99$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $09a8f90f65bdbd99$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $09a8f90f65bdbd99$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $09a8f90f65bdbd99$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $09a8f90f65bdbd99$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $09a8f90f65bdbd99$var$unwrapTrackedPromise(value) {
    if (!$09a8f90f65bdbd99$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $09a8f90f65bdbd99$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $09a8f90f65bdbd99$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $09a8f90f65bdbd99$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $09a8f90f65bdbd99$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $09a8f90f65bdbd99$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $09a8f90f65bdbd99$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $09a8f90f65bdbd99$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $09a8f90f65bdbd99$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $09a8f90f65bdbd99$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $09a8f90f65bdbd99$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $09a8f90f65bdbd99$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $09a8f90f65bdbd99$var$validMutationMethods = new Set($09a8f90f65bdbd99$var$validMutationMethodsArr);
const $09a8f90f65bdbd99$var$validRequestMethodsArr = [
    "get",
    ...$09a8f90f65bdbd99$var$validMutationMethodsArr
];
const $09a8f90f65bdbd99$var$validRequestMethods = new Set($09a8f90f65bdbd99$var$validRequestMethodsArr);
const $09a8f90f65bdbd99$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $09a8f90f65bdbd99$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $09a8f90f65bdbd99$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $09a8f90f65bdbd99$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $09a8f90f65bdbd99$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $09a8f90f65bdbd99$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $09a8f90f65bdbd99$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $09a8f90f65bdbd99$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $09a8f90f65bdbd99$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $09a8f90f65bdbd99$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $09a8f90f65bdbd99$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $09a8f90f65bdbd99$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $09a8f90f65bdbd99$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $09a8f90f65bdbd99$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $09a8f90f65bdbd99$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $09a8f90f65bdbd99$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $09a8f90f65bdbd99$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$09a8f90f65bdbd99$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$09a8f90f65bdbd99$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $09a8f90f65bdbd99$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $09a8f90f65bdbd99$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $09a8f90f65bdbd99$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $09a8f90f65bdbd99$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$09a8f90f65bdbd99$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $09a8f90f65bdbd99$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $09a8f90f65bdbd99$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $09a8f90f65bdbd99$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $09a8f90f65bdbd99$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $09a8f90f65bdbd99$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($09a8f90f65bdbd99$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $09a8f90f65bdbd99$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $09a8f90f65bdbd99$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $09a8f90f65bdbd99$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $09a8f90f65bdbd99$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $09a8f90f65bdbd99$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $09a8f90f65bdbd99$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $09a8f90f65bdbd99$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $09a8f90f65bdbd99$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $09a8f90f65bdbd99$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $09a8f90f65bdbd99$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $09a8f90f65bdbd99$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $09a8f90f65bdbd99$var$findNearestBoundary(matches).route.id,
            {
                type: $09a8f90f65bdbd99$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $09a8f90f65bdbd99$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($09a8f90f65bdbd99$var$isErrorResult(result) && $09a8f90f65bdbd99$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $09a8f90f65bdbd99$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $09a8f90f65bdbd99$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $09a8f90f65bdbd99$var$_extends({
            matches: updatedMatches || matches
        }, $09a8f90f65bdbd99$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $09a8f90f65bdbd99$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $09a8f90f65bdbd99$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $09a8f90f65bdbd99$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $09a8f90f65bdbd99$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $09a8f90f65bdbd99$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $09a8f90f65bdbd99$var$ResultType.error,
            error: $09a8f90f65bdbd99$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($09a8f90f65bdbd99$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $09a8f90f65bdbd99$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($09a8f90f65bdbd99$var$isDeferredResult(result)) throw $09a8f90f65bdbd99$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($09a8f90f65bdbd99$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $09a8f90f65bdbd99$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $09a8f90f65bdbd99$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $09a8f90f65bdbd99$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($09a8f90f65bdbd99$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $09a8f90f65bdbd99$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $09a8f90f65bdbd99$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $09a8f90f65bdbd99$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $09a8f90f65bdbd99$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $09a8f90f65bdbd99$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $09a8f90f65bdbd99$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $09a8f90f65bdbd99$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $09a8f90f65bdbd99$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $09a8f90f65bdbd99$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $09a8f90f65bdbd99$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$09a8f90f65bdbd99$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $09a8f90f65bdbd99$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $09a8f90f65bdbd99$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $09a8f90f65bdbd99$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $09a8f90f65bdbd99$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $09a8f90f65bdbd99$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $09a8f90f65bdbd99$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $09a8f90f65bdbd99$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $09a8f90f65bdbd99$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $09a8f90f65bdbd99$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $09a8f90f65bdbd99$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $09a8f90f65bdbd99$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $09a8f90f65bdbd99$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($09a8f90f65bdbd99$var$isRedirectResult(actionResult) || $09a8f90f65bdbd99$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $09a8f90f65bdbd99$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($09a8f90f65bdbd99$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $09a8f90f65bdbd99$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $09a8f90f65bdbd99$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($09a8f90f65bdbd99$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($09a8f90f65bdbd99$var$isDeferredResult(actionResult)) throw $09a8f90f65bdbd99$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $09a8f90f65bdbd99$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $09a8f90f65bdbd99$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $09a8f90f65bdbd99$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $09a8f90f65bdbd99$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $09a8f90f65bdbd99$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $09a8f90f65bdbd99$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $09a8f90f65bdbd99$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $09a8f90f65bdbd99$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $09a8f90f65bdbd99$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $09a8f90f65bdbd99$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $09a8f90f65bdbd99$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $09a8f90f65bdbd99$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $09a8f90f65bdbd99$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $09a8f90f65bdbd99$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $09a8f90f65bdbd99$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $09a8f90f65bdbd99$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($09a8f90f65bdbd99$var$isDeferredResult(result)) result = await $09a8f90f65bdbd99$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $09a8f90f65bdbd99$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($09a8f90f65bdbd99$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $09a8f90f65bdbd99$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($09a8f90f65bdbd99$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $09a8f90f65bdbd99$export$3e9cee6b33872309(!$09a8f90f65bdbd99$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $09a8f90f65bdbd99$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $09a8f90f65bdbd99$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $09a8f90f65bdbd99$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $09a8f90f65bdbd99$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($09a8f90f65bdbd99$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $09a8f90f65bdbd99$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Replace : $09a8f90f65bdbd99$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $09a8f90f65bdbd99$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($09a8f90f65bdbd99$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $09a8f90f65bdbd99$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $09a8f90f65bdbd99$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $09a8f90f65bdbd99$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $09a8f90f65bdbd99$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $09a8f90f65bdbd99$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($09a8f90f65bdbd99$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $09a8f90f65bdbd99$var$ResultType.redirect,
                response: $09a8f90f65bdbd99$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $09a8f90f65bdbd99$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $09a8f90f65bdbd99$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $09a8f90f65bdbd99$var$ResultType.error,
                    error: $09a8f90f65bdbd99$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $09a8f90f65bdbd99$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $09a8f90f65bdbd99$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $09a8f90f65bdbd99$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $09a8f90f65bdbd99$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $09a8f90f65bdbd99$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $09a8f90f65bdbd99$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $09a8f90f65bdbd99$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $09a8f90f65bdbd99$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $09a8f90f65bdbd99$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $09a8f90f65bdbd99$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $09a8f90f65bdbd99$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $09a8f90f65bdbd99$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $09a8f90f65bdbd99$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $09a8f90f65bdbd99$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$09a8f90f65bdbd99$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $09a8f90f65bdbd99$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $09a8f90f65bdbd99$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $09a8f90f65bdbd99$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $09a8f90f65bdbd99$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $09a8f90f65bdbd99$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $09a8f90f65bdbd99$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $09a8f90f65bdbd99$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $09a8f90f65bdbd99$export$4d0306f8f6a4585b = Symbol("deferred");
function $09a8f90f65bdbd99$export$3336b097a6fbc59a(routes, opts) {
    $09a8f90f65bdbd99$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $09a8f90f65bdbd99$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $09a8f90f65bdbd99$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $09a8f90f65bdbd99$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $09a8f90f65bdbd99$var$createLocation("", $09a8f90f65bdbd99$export$fe53371bee54353d(url), null, "default");
        let matches = $09a8f90f65bdbd99$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$09a8f90f65bdbd99$var$isValidMethod(method) && method !== "HEAD") {
            let error = $09a8f90f65bdbd99$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $09a8f90f65bdbd99$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $09a8f90f65bdbd99$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $09a8f90f65bdbd99$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($09a8f90f65bdbd99$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $09a8f90f65bdbd99$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $09a8f90f65bdbd99$var$createLocation("", $09a8f90f65bdbd99$export$fe53371bee54353d(url), null, "default");
        let matches = $09a8f90f65bdbd99$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$09a8f90f65bdbd99$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $09a8f90f65bdbd99$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $09a8f90f65bdbd99$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $09a8f90f65bdbd99$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $09a8f90f65bdbd99$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $09a8f90f65bdbd99$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($09a8f90f65bdbd99$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$09a8f90f65bdbd99$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $09a8f90f65bdbd99$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($09a8f90f65bdbd99$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $09a8f90f65bdbd99$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $09a8f90f65bdbd99$var$isResponse(result) ? result : $09a8f90f65bdbd99$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($09a8f90f65bdbd99$var$isDataStrategyResult(e) && $09a8f90f65bdbd99$var$isResponse(e.result)) {
                if (e.type === $09a8f90f65bdbd99$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($09a8f90f65bdbd99$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $09a8f90f65bdbd99$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $09a8f90f65bdbd99$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $09a8f90f65bdbd99$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($09a8f90f65bdbd99$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($09a8f90f65bdbd99$var$isDeferredResult(result)) {
            let error = $09a8f90f65bdbd99$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $09a8f90f65bdbd99$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($09a8f90f65bdbd99$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($09a8f90f65bdbd99$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $09a8f90f65bdbd99$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $09a8f90f65bdbd99$var$_extends({}, context, {
                statusCode: $09a8f90f65bdbd99$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $09a8f90f65bdbd99$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $09a8f90f65bdbd99$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $09a8f90f65bdbd99$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $09a8f90f65bdbd99$var$isErrorResult(pendingActionResult[1]) ? $09a8f90f65bdbd99$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $09a8f90f65bdbd99$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $09a8f90f65bdbd99$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $09a8f90f65bdbd99$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $09a8f90f65bdbd99$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $09a8f90f65bdbd99$var$callDataStrategyImpl(dataStrategy || $09a8f90f65bdbd99$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($09a8f90f65bdbd99$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $09a8f90f65bdbd99$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($09a8f90f65bdbd99$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $09a8f90f65bdbd99$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $09a8f90f65bdbd99$export$fec11da027c70692(routes, context, error) {
    let newContext = $09a8f90f65bdbd99$var$_extends({}, context, {
        statusCode: $09a8f90f65bdbd99$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $09a8f90f65bdbd99$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $09a8f90f65bdbd99$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $09a8f90f65bdbd99$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $09a8f90f65bdbd99$export$cae722b0cc860f13(to ? to : ".", $09a8f90f65bdbd99$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $09a8f90f65bdbd99$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $09a8f90f65bdbd99$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $09a8f90f65bdbd99$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $09a8f90f65bdbd99$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $09a8f90f65bdbd99$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$09a8f90f65bdbd99$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$09a8f90f65bdbd99$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $09a8f90f65bdbd99$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $09a8f90f65bdbd99$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $09a8f90f65bdbd99$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$09a8f90f65bdbd99$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$09a8f90f65bdbd99$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $09a8f90f65bdbd99$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $09a8f90f65bdbd99$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $09a8f90f65bdbd99$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $09a8f90f65bdbd99$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $09a8f90f65bdbd99$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($09a8f90f65bdbd99$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $09a8f90f65bdbd99$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $09a8f90f65bdbd99$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $09a8f90f65bdbd99$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $09a8f90f65bdbd99$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $09a8f90f65bdbd99$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $09a8f90f65bdbd99$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $09a8f90f65bdbd99$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $09a8f90f65bdbd99$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $09a8f90f65bdbd99$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $09a8f90f65bdbd99$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($09a8f90f65bdbd99$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $09a8f90f65bdbd99$var$shouldRevalidateLoader(match, $09a8f90f65bdbd99$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $09a8f90f65bdbd99$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $09a8f90f65bdbd99$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $09a8f90f65bdbd99$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $09a8f90f65bdbd99$var$shouldRevalidateLoader(fetcherMatch, $09a8f90f65bdbd99$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $09a8f90f65bdbd99$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $09a8f90f65bdbd99$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $09a8f90f65bdbd99$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $09a8f90f65bdbd99$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $09a8f90f65bdbd99$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $09a8f90f65bdbd99$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$09a8f90f65bdbd99$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $09a8f90f65bdbd99$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $09a8f90f65bdbd99$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$09a8f90f65bdbd99$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $09a8f90f65bdbd99$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $09a8f90f65bdbd99$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $09a8f90f65bdbd99$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$09a8f90f65bdbd99$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $09a8f90f65bdbd99$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $09a8f90f65bdbd99$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $09a8f90f65bdbd99$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $09a8f90f65bdbd99$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $09a8f90f65bdbd99$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $09a8f90f65bdbd99$var$ResultType.data,
                result: undefined
            });
        };
        return $09a8f90f65bdbd99$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $09a8f90f65bdbd99$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $09a8f90f65bdbd99$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $09a8f90f65bdbd99$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $09a8f90f65bdbd99$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $09a8f90f65bdbd99$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $09a8f90f65bdbd99$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $09a8f90f65bdbd99$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($09a8f90f65bdbd99$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $09a8f90f65bdbd99$var$ResultType.error,
                error: e
            };
        }
        if (type === $09a8f90f65bdbd99$var$ResultType.error) return {
            type: $09a8f90f65bdbd99$var$ResultType.error,
            error: new $09a8f90f65bdbd99$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $09a8f90f65bdbd99$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $09a8f90f65bdbd99$var$ResultType.error) {
        if ($09a8f90f65bdbd99$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $09a8f90f65bdbd99$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $09a8f90f65bdbd99$var$ResultType.error,
                error: new $09a8f90f65bdbd99$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $09a8f90f65bdbd99$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $09a8f90f65bdbd99$var$ResultType.error,
            error: result,
            statusCode: $09a8f90f65bdbd99$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($09a8f90f65bdbd99$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $09a8f90f65bdbd99$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($09a8f90f65bdbd99$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $09a8f90f65bdbd99$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $09a8f90f65bdbd99$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $09a8f90f65bdbd99$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $09a8f90f65bdbd99$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$09a8f90f65bdbd99$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $09a8f90f65bdbd99$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $09a8f90f65bdbd99$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($09a8f90f65bdbd99$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $09a8f90f65bdbd99$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $09a8f90f65bdbd99$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($09a8f90f65bdbd99$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $09a8f90f65bdbd99$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $09a8f90f65bdbd99$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $09a8f90f65bdbd99$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $09a8f90f65bdbd99$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $09a8f90f65bdbd99$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $09a8f90f65bdbd99$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $09a8f90f65bdbd99$export$3e9cee6b33872309(!$09a8f90f65bdbd99$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($09a8f90f65bdbd99$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $09a8f90f65bdbd99$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $09a8f90f65bdbd99$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($09a8f90f65bdbd99$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $09a8f90f65bdbd99$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $09a8f90f65bdbd99$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $09a8f90f65bdbd99$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($09a8f90f65bdbd99$var$isErrorResult(result)) {
            let boundaryMatch = $09a8f90f65bdbd99$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $09a8f90f65bdbd99$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($09a8f90f65bdbd99$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $09a8f90f65bdbd99$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($09a8f90f65bdbd99$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $09a8f90f65bdbd99$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $09a8f90f65bdbd99$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $09a8f90f65bdbd99$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $09a8f90f65bdbd99$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $09a8f90f65bdbd99$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $09a8f90f65bdbd99$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $09a8f90f65bdbd99$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $09a8f90f65bdbd99$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $09a8f90f65bdbd99$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $09a8f90f65bdbd99$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $09a8f90f65bdbd99$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($09a8f90f65bdbd99$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $09a8f90f65bdbd99$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $09a8f90f65bdbd99$export$8ccf933b0513f8d0(path) : path;
    return $09a8f90f65bdbd99$export$fe53371bee54353d($09a8f90f65bdbd99$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $09a8f90f65bdbd99$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $09a8f90f65bdbd99$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $09a8f90f65bdbd99$var$ResultType.data || result.type === $09a8f90f65bdbd99$var$ResultType.error);
}
function $09a8f90f65bdbd99$var$isRedirectDataStrategyResultResult(result) {
    return $09a8f90f65bdbd99$var$isResponse(result.result) && $09a8f90f65bdbd99$var$redirectStatusCodes.has(result.result.status);
}
function $09a8f90f65bdbd99$var$isDeferredResult(result) {
    return result.type === $09a8f90f65bdbd99$var$ResultType.deferred;
}
function $09a8f90f65bdbd99$var$isErrorResult(result) {
    return result.type === $09a8f90f65bdbd99$var$ResultType.error;
}
function $09a8f90f65bdbd99$var$isRedirectResult(result) {
    return (result && result.type) === $09a8f90f65bdbd99$var$ResultType.redirect;
}
function $09a8f90f65bdbd99$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $09a8f90f65bdbd99$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $09a8f90f65bdbd99$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $09a8f90f65bdbd99$var$isRedirectResponse(result) {
    if (!$09a8f90f65bdbd99$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $09a8f90f65bdbd99$var$isValidMethod(method) {
    return $09a8f90f65bdbd99$var$validRequestMethods.has(method.toLowerCase());
}
function $09a8f90f65bdbd99$var$isMutationMethod(method) {
    return $09a8f90f65bdbd99$var$validMutationMethods.has(method.toLowerCase());
}
async function $09a8f90f65bdbd99$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$09a8f90f65bdbd99$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($09a8f90f65bdbd99$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $09a8f90f65bdbd99$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $09a8f90f65bdbd99$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($09a8f90f65bdbd99$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $09a8f90f65bdbd99$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $09a8f90f65bdbd99$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $09a8f90f65bdbd99$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $09a8f90f65bdbd99$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $09a8f90f65bdbd99$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $09a8f90f65bdbd99$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $09a8f90f65bdbd99$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $09a8f90f65bdbd99$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $09a8f90f65bdbd99$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $09a8f90f65bdbd99$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $09a8f90f65bdbd99$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $09a8f90f65bdbd99$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $09a8f90f65bdbd99$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $09a8f90f65bdbd99$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $09a8f90f65bdbd99$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $09a8f90f65bdbd99$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $09a8f90f65bdbd99$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $09a8f90f65bdbd99$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($09a8f90f65bdbd99$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $09a8f90f65bdbd99$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($09a8f90f65bdbd99$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $09a8f90f65bdbd99$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $cQNHH = parcelRequire("cQNHH");

function $0426bdd60799df9e$var$_extends() {
    $0426bdd60799df9e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0426bdd60799df9e$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $0426bdd60799df9e$export$3add0d5dce533e2e = /*#__PURE__*/ $cQNHH.createContext(null);
const $0426bdd60799df9e$export$145dfa71566a64dc = /*#__PURE__*/ $cQNHH.createContext(null);
const $0426bdd60799df9e$var$AwaitContext = /*#__PURE__*/ $cQNHH.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $0426bdd60799df9e$export$26749e8557646306 = /*#__PURE__*/ $cQNHH.createContext(null);
const $0426bdd60799df9e$export$c7914228fb69b0f5 = /*#__PURE__*/ $cQNHH.createContext(null);
const $0426bdd60799df9e$export$9072aa6dd1f93057 = /*#__PURE__*/ $cQNHH.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $0426bdd60799df9e$var$RouteErrorContext = /*#__PURE__*/ $cQNHH.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $0426bdd60799df9e$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$0426bdd60799df9e$export$9c954a9d03d32f4a() && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $cQNHH.useContext($0426bdd60799df9e$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $0426bdd60799df9e$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $09a8f90f65bdbd99$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $0426bdd60799df9e$export$9c954a9d03d32f4a() {
    return $cQNHH.useContext($0426bdd60799df9e$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $0426bdd60799df9e$export$45d76561a5302f2b() {
    !$0426bdd60799df9e$export$9c954a9d03d32f4a() && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    return $cQNHH.useContext($0426bdd60799df9e$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $0426bdd60799df9e$export$1b3f31771c5d07c() {
    return $cQNHH.useContext($0426bdd60799df9e$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $0426bdd60799df9e$export$6c330e8992e8a295(pattern) {
    !$0426bdd60799df9e$export$9c954a9d03d32f4a() && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $0426bdd60799df9e$export$45d76561a5302f2b();
    return $cQNHH.useMemo(()=>(0, $09a8f90f65bdbd99$export$81336c211d5ff295)(pattern, (0, $09a8f90f65bdbd99$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $0426bdd60799df9e$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $0426bdd60799df9e$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $cQNHH.useContext($0426bdd60799df9e$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $cQNHH.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $0426bdd60799df9e$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $cQNHH.useContext($0426bdd60799df9e$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $0426bdd60799df9e$var$useNavigateStable() : $0426bdd60799df9e$var$useNavigateUnstable();
}
function $0426bdd60799df9e$var$useNavigateUnstable() {
    !$0426bdd60799df9e$export$9c954a9d03d32f4a() && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    let dataRouterContext = $cQNHH.useContext($0426bdd60799df9e$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $cQNHH.useContext($0426bdd60799df9e$export$26749e8557646306);
    let { matches: matches } = $cQNHH.useContext($0426bdd60799df9e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0426bdd60799df9e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $09a8f90f65bdbd99$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $cQNHH.useRef(false);
    $0426bdd60799df9e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $cQNHH.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $09a8f90f65bdbd99$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $09a8f90f65bdbd99$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $0426bdd60799df9e$var$OutletContext = /*#__PURE__*/ $cQNHH.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $0426bdd60799df9e$export$4138103a3ae699cc() {
    return $cQNHH.useContext($0426bdd60799df9e$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $0426bdd60799df9e$export$a3be3530d8e40d0b(context) {
    let outlet = $cQNHH.useContext($0426bdd60799df9e$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $0426bdd60799df9e$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $cQNHH.useContext($0426bdd60799df9e$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $0426bdd60799df9e$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $cQNHH.useContext($0426bdd60799df9e$export$26749e8557646306);
    let { matches: matches } = $cQNHH.useContext($0426bdd60799df9e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0426bdd60799df9e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $09a8f90f65bdbd99$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $cQNHH.useMemo(()=>(0, $09a8f90f65bdbd99$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $0426bdd60799df9e$export$5d3fca4a98652595(routes, locationArg) {
    return $0426bdd60799df9e$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $0426bdd60799df9e$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$0426bdd60799df9e$export$9c954a9d03d32f4a() && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $cQNHH.useContext($0426bdd60799df9e$export$26749e8557646306);
    let { matches: parentMatches } = $cQNHH.useContext($0426bdd60799df9e$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $0426bdd60799df9e$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $09a8f90f65bdbd99$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $09a8f90f65bdbd99$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $0426bdd60799df9e$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $09a8f90f65bdbd99$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $09a8f90f65bdbd99$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $0426bdd60799df9e$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $09a8f90f65bdbd99$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $0426bdd60799df9e$var$DefaultErrorComponent() {
    let error = $0426bdd60799df9e$export$ed527bf60f6e05f2();
    let message = (0, $09a8f90f65bdbd99$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $cQNHH.createElement($cQNHH.Fragment, null, /*#__PURE__*/ $cQNHH.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $cQNHH.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $cQNHH.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $0426bdd60799df9e$var$defaultErrorElement = /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$DefaultErrorComponent, null);
class $0426bdd60799df9e$var$RenderErrorBoundary extends $cQNHH.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $0426bdd60799df9e$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $cQNHH.useContext($0426bdd60799df9e$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $0426bdd60799df9e$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $0426bdd60799df9e$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $0426bdd60799df9e$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $cQNHH.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $0426bdd60799df9e$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($0426bdd60799df9e$var$DataRouterHook || {});
var $0426bdd60799df9e$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($0426bdd60799df9e$var$DataRouterStateHook || {});
function $0426bdd60799df9e$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0426bdd60799df9e$var$useDataRouterContext(hookName) {
    let ctx = $cQNHH.useContext($0426bdd60799df9e$export$3add0d5dce533e2e);
    !ctx && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0426bdd60799df9e$var$useDataRouterState(hookName) {
    let state = $cQNHH.useContext($0426bdd60799df9e$export$145dfa71566a64dc);
    !state && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    return state;
}
function $0426bdd60799df9e$var$useRouteContext(hookName) {
    let route = $cQNHH.useContext($0426bdd60799df9e$export$9072aa6dd1f93057);
    !route && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $0426bdd60799df9e$var$useCurrentRouteId(hookName) {
    let route = $0426bdd60799df9e$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $0426bdd60799df9e$export$5fc8298006ad9e58() {
    return $0426bdd60799df9e$var$useCurrentRouteId($0426bdd60799df9e$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $0426bdd60799df9e$export$d0fd4b7106de2769() {
    let state = $0426bdd60799df9e$var$useDataRouterState($0426bdd60799df9e$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $0426bdd60799df9e$export$600dc272ed516c15() {
    let dataRouterContext = $0426bdd60799df9e$var$useDataRouterContext($0426bdd60799df9e$var$DataRouterHook.UseRevalidator);
    let state = $0426bdd60799df9e$var$useDataRouterState($0426bdd60799df9e$var$DataRouterStateHook.UseRevalidator);
    return $cQNHH.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $0426bdd60799df9e$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $0426bdd60799df9e$var$useDataRouterState($0426bdd60799df9e$var$DataRouterStateHook.UseMatches);
    return $cQNHH.useMemo(()=>matches.map((m)=>(0, $09a8f90f65bdbd99$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $0426bdd60799df9e$export$1448a5050d252c4d() {
    let state = $0426bdd60799df9e$var$useDataRouterState($0426bdd60799df9e$var$DataRouterStateHook.UseLoaderData);
    let routeId = $0426bdd60799df9e$var$useCurrentRouteId($0426bdd60799df9e$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $0426bdd60799df9e$export$fd5d37484eab868d(routeId) {
    let state = $0426bdd60799df9e$var$useDataRouterState($0426bdd60799df9e$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $0426bdd60799df9e$export$fdc00f3f26066d5e() {
    let state = $0426bdd60799df9e$var$useDataRouterState($0426bdd60799df9e$var$DataRouterStateHook.UseActionData);
    let routeId = $0426bdd60799df9e$var$useCurrentRouteId($0426bdd60799df9e$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $0426bdd60799df9e$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $cQNHH.useContext($0426bdd60799df9e$var$RouteErrorContext);
    let state = $0426bdd60799df9e$var$useDataRouterState($0426bdd60799df9e$var$DataRouterStateHook.UseRouteError);
    let routeId = $0426bdd60799df9e$var$useCurrentRouteId($0426bdd60799df9e$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $0426bdd60799df9e$export$78a72ddb39bdd145() {
    let value = $cQNHH.useContext($0426bdd60799df9e$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $0426bdd60799df9e$export$17f53340677d5831() {
    let value = $cQNHH.useContext($0426bdd60799df9e$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $0426bdd60799df9e$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $0426bdd60799df9e$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $0426bdd60799df9e$var$useDataRouterContext($0426bdd60799df9e$var$DataRouterHook.UseBlocker);
    let state = $0426bdd60799df9e$var$useDataRouterState($0426bdd60799df9e$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $cQNHH.useState("");
    let blockerFunction = $cQNHH.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $0426bdd60799df9e$var$_extends({}, currentLocation, {
                pathname: (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $0426bdd60799df9e$var$_extends({}, nextLocation, {
                pathname: (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $cQNHH.useEffect(()=>{
        let key = String(++$0426bdd60799df9e$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $cQNHH.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $09a8f90f65bdbd99$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $0426bdd60799df9e$var$useNavigateStable() {
    let { router: router } = $0426bdd60799df9e$var$useDataRouterContext($0426bdd60799df9e$var$DataRouterHook.UseNavigateStable);
    let id = $0426bdd60799df9e$var$useCurrentRouteId($0426bdd60799df9e$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $cQNHH.useRef(false);
    $0426bdd60799df9e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $cQNHH.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $0426bdd60799df9e$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $0426bdd60799df9e$var$alreadyWarned$1 = {};
function $0426bdd60799df9e$var$warningOnce(key, cond, message) {
    if (!cond && !$0426bdd60799df9e$var$alreadyWarned$1[key]) $0426bdd60799df9e$var$alreadyWarned$1[key] = true;
}
const $0426bdd60799df9e$var$alreadyWarned = {};
function $0426bdd60799df9e$var$warnOnce(key, message) {}
const $0426bdd60799df9e$var$logDeprecation = (flag, msg, link)=>$0426bdd60799df9e$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $0426bdd60799df9e$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $0426bdd60799df9e$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $0426bdd60799df9e$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $0426bdd60799df9e$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $0426bdd60799df9e$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $0426bdd60799df9e$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $0426bdd60799df9e$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0426bdd60799df9e$var$START_TRANSITION = "startTransition";
const $0426bdd60799df9e$var$startTransitionImpl = $cQNHH[$0426bdd60799df9e$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0426bdd60799df9e$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $cQNHH.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cQNHH.useCallback((newState)=>{
        if (v7_startTransition && $0426bdd60799df9e$var$startTransitionImpl) $0426bdd60799df9e$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $cQNHH.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $cQNHH.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $cQNHH.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $cQNHH.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $cQNHH.useEffect(()=>$0426bdd60799df9e$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $cQNHH.createElement($cQNHH.Fragment, null, /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $0426bdd60799df9e$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $0426bdd60799df9e$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $0426bdd60799df9e$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $cQNHH.useRef();
    if (historyRef.current == null) historyRef.current = (0, $09a8f90f65bdbd99$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $cQNHH.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cQNHH.useCallback((newState)=>{
        v7_startTransition && $0426bdd60799df9e$var$startTransitionImpl ? $0426bdd60799df9e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cQNHH.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cQNHH.useEffect(()=>$0426bdd60799df9e$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $0426bdd60799df9e$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$0426bdd60799df9e$export$9c954a9d03d32f4a() && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $cQNHH.useContext($0426bdd60799df9e$export$26749e8557646306);
    let { matches: matches } = $cQNHH.useContext($0426bdd60799df9e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0426bdd60799df9e$export$45d76561a5302f2b();
    let navigate = $0426bdd60799df9e$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $09a8f90f65bdbd99$export$cae722b0cc860f13)(to, (0, $09a8f90f65bdbd99$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $cQNHH.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $0426bdd60799df9e$export$910ae8079b2c2852(props) {
    return $0426bdd60799df9e$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $0426bdd60799df9e$export$e7b0ac011bb776c6(_props) {
    (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $0426bdd60799df9e$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $09a8f90f65bdbd99$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$0426bdd60799df9e$export$9c954a9d03d32f4a() && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $cQNHH.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $0426bdd60799df9e$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $09a8f90f65bdbd99$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $cQNHH.useMemo(()=>{
        let trailingPathname = (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $0426bdd60799df9e$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $0426bdd60799df9e$export$5d3fca4a98652595($0426bdd60799df9e$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $0426bdd60799df9e$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$ResolveAwait, null, children));
}
var $0426bdd60799df9e$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($0426bdd60799df9e$var$AwaitRenderStatus || {});
const $0426bdd60799df9e$var$neverSettledPromise = new Promise(()=>{});
class $0426bdd60799df9e$var$AwaitErrorBoundary extends $cQNHH.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $0426bdd60799df9e$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $0426bdd60799df9e$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $0426bdd60799df9e$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $0426bdd60799df9e$var$AwaitRenderStatus.error : "_data" in promise ? $0426bdd60799df9e$var$AwaitRenderStatus.success : $0426bdd60799df9e$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $0426bdd60799df9e$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $0426bdd60799df9e$var$AwaitRenderStatus.error && promise._error instanceof (0, $09a8f90f65bdbd99$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $0426bdd60799df9e$var$neverSettledPromise;
        if (status === $0426bdd60799df9e$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $0426bdd60799df9e$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $0426bdd60799df9e$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $cQNHH.createElement($0426bdd60799df9e$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $0426bdd60799df9e$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $0426bdd60799df9e$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $cQNHH.createElement($cQNHH.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $0426bdd60799df9e$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $cQNHH.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $cQNHH.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $cQNHH.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $0426bdd60799df9e$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $0426bdd60799df9e$export$e7b0ac011bb776c6) && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $0426bdd60799df9e$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $0426bdd60799df9e$export$daf73786167a7f72(matches) {
    return $0426bdd60799df9e$var$_renderMatches(matches);
}
function $0426bdd60799df9e$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $cQNHH.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $cQNHH.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $cQNHH.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $0426bdd60799df9e$export$f30f7e456d254e83(routes, opts) {
    return (0, $09a8f90f65bdbd99$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0426bdd60799df9e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $09a8f90f65bdbd99$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $0426bdd60799df9e$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $a77787966cb87b36$var$_extends() {
    $a77787966cb87b36$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a77787966cb87b36$var$_extends.apply(this, arguments);
}
function $a77787966cb87b36$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a77787966cb87b36$var$defaultMethod = "get";
const $a77787966cb87b36$var$defaultEncType = "application/x-www-form-urlencoded";
function $a77787966cb87b36$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a77787966cb87b36$var$isButtonElement(object) {
    return $a77787966cb87b36$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a77787966cb87b36$var$isFormElement(object) {
    return $a77787966cb87b36$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a77787966cb87b36$var$isInputElement(object) {
    return $a77787966cb87b36$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a77787966cb87b36$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a77787966cb87b36$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a77787966cb87b36$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a77787966cb87b36$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a77787966cb87b36$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a77787966cb87b36$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a77787966cb87b36$var$_formDataSupportsSubmitter = null;
function $a77787966cb87b36$var$isFormDataSubmitterSupported() {
    if ($a77787966cb87b36$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a77787966cb87b36$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a77787966cb87b36$var$_formDataSupportsSubmitter = true;
    }
    return $a77787966cb87b36$var$_formDataSupportsSubmitter;
}
const $a77787966cb87b36$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a77787966cb87b36$var$getFormEncType(encType) {
    if (encType != null && !$a77787966cb87b36$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a77787966cb87b36$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a77787966cb87b36$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a77787966cb87b36$var$defaultMethod;
        encType = $a77787966cb87b36$var$getFormEncType(target.getAttribute("enctype")) || $a77787966cb87b36$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a77787966cb87b36$var$isButtonElement(target) || $a77787966cb87b36$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a77787966cb87b36$var$defaultMethod;
        encType = $a77787966cb87b36$var$getFormEncType(target.getAttribute("formenctype")) || $a77787966cb87b36$var$getFormEncType(form.getAttribute("enctype")) || $a77787966cb87b36$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a77787966cb87b36$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a77787966cb87b36$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a77787966cb87b36$var$defaultMethod;
        action = null;
        encType = $a77787966cb87b36$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a77787966cb87b36$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a77787966cb87b36$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a77787966cb87b36$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a77787966cb87b36$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a77787966cb87b36$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a77787966cb87b36$export$1f3f55432a00e06d(routes, opts) {
    return (0, $09a8f90f65bdbd99$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a77787966cb87b36$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $09a8f90f65bdbd99$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a77787966cb87b36$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $0426bdd60799df9e$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a77787966cb87b36$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $09a8f90f65bdbd99$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a77787966cb87b36$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $09a8f90f65bdbd99$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a77787966cb87b36$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $0426bdd60799df9e$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a77787966cb87b36$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a77787966cb87b36$var$_extends({}, state, {
        errors: $a77787966cb87b36$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a77787966cb87b36$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $09a8f90f65bdbd99$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a77787966cb87b36$export$7ad602f0e94e62d1 = /*#__PURE__*/ $cQNHH.createContext({
    isTransitioning: false
});
const $a77787966cb87b36$export$148fd98d095596d4 = /*#__PURE__*/ $cQNHH.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a77787966cb87b36$var$START_TRANSITION = "startTransition";
const $a77787966cb87b36$var$startTransitionImpl = $cQNHH[$a77787966cb87b36$var$START_TRANSITION];
const $a77787966cb87b36$var$FLUSH_SYNC = "flushSync";
const $a77787966cb87b36$var$flushSyncImpl = $a058c85580ba5e0b$exports[$a77787966cb87b36$var$FLUSH_SYNC];
const $a77787966cb87b36$var$USE_ID = "useId";
const $a77787966cb87b36$var$useIdImpl = $cQNHH[$a77787966cb87b36$var$USE_ID];
function $a77787966cb87b36$var$startTransitionSafe(cb) {
    if ($a77787966cb87b36$var$startTransitionImpl) $a77787966cb87b36$var$startTransitionImpl(cb);
    else cb();
}
function $a77787966cb87b36$var$flushSyncSafe(cb) {
    if ($a77787966cb87b36$var$flushSyncImpl) $a77787966cb87b36$var$flushSyncImpl(cb);
    else cb();
}
class $a77787966cb87b36$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a77787966cb87b36$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $cQNHH.useState(router.state);
    let [pendingState, setPendingState] = $cQNHH.useState();
    let [vtContext, setVtContext] = $cQNHH.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $cQNHH.useState();
    let [transition, setTransition] = $cQNHH.useState();
    let [interruption, setInterruption] = $cQNHH.useState();
    let fetcherData = $cQNHH.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $cQNHH.useCallback((cb)=>{
        if (v7_startTransition) $a77787966cb87b36$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $cQNHH.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a77787966cb87b36$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a77787966cb87b36$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a77787966cb87b36$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a77787966cb87b36$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a77787966cb87b36$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $cQNHH.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $cQNHH.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a77787966cb87b36$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $cQNHH.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $cQNHH.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $cQNHH.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $cQNHH.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $cQNHH.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $cQNHH.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $cQNHH.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $cQNHH.useEffect(()=>(0, $0426bdd60799df9e$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $cQNHH.createElement($cQNHH.Fragment, null, /*#__PURE__*/ $cQNHH.createElement((0, $0426bdd60799df9e$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $cQNHH.createElement((0, $0426bdd60799df9e$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $cQNHH.createElement($a77787966cb87b36$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $cQNHH.createElement($a77787966cb87b36$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $cQNHH.createElement((0, $0426bdd60799df9e$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $cQNHH.createElement($a77787966cb87b36$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a77787966cb87b36$var$MemoizedDataRoutes = /*#__PURE__*/ $cQNHH.memo($a77787966cb87b36$var$DataRoutes);
function $a77787966cb87b36$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $0426bdd60799df9e$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a77787966cb87b36$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $cQNHH.useRef();
    if (historyRef.current == null) historyRef.current = (0, $09a8f90f65bdbd99$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $cQNHH.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cQNHH.useCallback((newState)=>{
        v7_startTransition && $a77787966cb87b36$var$startTransitionImpl ? $a77787966cb87b36$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cQNHH.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cQNHH.useEffect(()=>(0, $0426bdd60799df9e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $cQNHH.createElement((0, $0426bdd60799df9e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a77787966cb87b36$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $cQNHH.useRef();
    if (historyRef.current == null) historyRef.current = (0, $09a8f90f65bdbd99$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $cQNHH.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cQNHH.useCallback((newState)=>{
        v7_startTransition && $a77787966cb87b36$var$startTransitionImpl ? $a77787966cb87b36$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cQNHH.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cQNHH.useEffect(()=>(0, $0426bdd60799df9e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $cQNHH.createElement((0, $0426bdd60799df9e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a77787966cb87b36$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $cQNHH.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $cQNHH.useCallback((newState)=>{
        v7_startTransition && $a77787966cb87b36$var$startTransitionImpl ? $a77787966cb87b36$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $cQNHH.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $cQNHH.useEffect(()=>(0, $0426bdd60799df9e$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $cQNHH.createElement((0, $0426bdd60799df9e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a77787966cb87b36$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a77787966cb87b36$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a77787966cb87b36$export$a6c7ac8248d6e38a = /*#__PURE__*/ $cQNHH.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a77787966cb87b36$var$_objectWithoutPropertiesLoose(_ref7, $a77787966cb87b36$var$_excluded);
    let { basename: basename } = $cQNHH.useContext((0, $0426bdd60799df9e$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a77787966cb87b36$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a77787966cb87b36$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $0426bdd60799df9e$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a77787966cb87b36$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $cQNHH.createElement("a", $a77787966cb87b36$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a77787966cb87b36$export$b0d92dbee9b5b60d = /*#__PURE__*/ $cQNHH.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a77787966cb87b36$var$_objectWithoutPropertiesLoose(_ref8, $a77787966cb87b36$var$_excluded2);
    let path = (0, $0426bdd60799df9e$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $0426bdd60799df9e$export$45d76561a5302f2b)();
    let routerState = $cQNHH.useContext((0, $0426bdd60799df9e$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $cQNHH.useContext((0, $0426bdd60799df9e$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a77787966cb87b36$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $cQNHH.createElement($a77787966cb87b36$export$a6c7ac8248d6e38a, $a77787966cb87b36$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a77787966cb87b36$export$a7fed597f4b8afd8 = /*#__PURE__*/ $cQNHH.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a77787966cb87b36$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a77787966cb87b36$var$_objectWithoutPropertiesLoose(_ref9, $a77787966cb87b36$var$_excluded3);
    let submit = $a77787966cb87b36$export$47c85c6e3a081d3();
    let formAction = $a77787966cb87b36$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $cQNHH.createElement("form", $a77787966cb87b36$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a77787966cb87b36$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a77787966cb87b36$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a77787966cb87b36$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a77787966cb87b36$var$DataRouterHook || ($a77787966cb87b36$var$DataRouterHook = {}));
var $a77787966cb87b36$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a77787966cb87b36$var$DataRouterStateHook || ($a77787966cb87b36$var$DataRouterStateHook = {}));
// Internal hooks
function $a77787966cb87b36$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a77787966cb87b36$var$useDataRouterContext(hookName) {
    let ctx = $cQNHH.useContext((0, $0426bdd60799df9e$export$3add0d5dce533e2e));
    !ctx && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a77787966cb87b36$var$useDataRouterState(hookName) {
    let state = $cQNHH.useContext((0, $0426bdd60799df9e$export$145dfa71566a64dc));
    !state && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a77787966cb87b36$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $0426bdd60799df9e$export$9770f232ac06a008)();
    let location = (0, $0426bdd60799df9e$export$45d76561a5302f2b)();
    let path = (0, $0426bdd60799df9e$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $cQNHH.useCallback((event)=>{
        if ($a77787966cb87b36$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $09a8f90f65bdbd99$export$fe53371bee54353d)(location) === (0, $09a8f90f65bdbd99$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a77787966cb87b36$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $cQNHH.useRef($a77787966cb87b36$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $cQNHH.useRef(false);
    let location = (0, $0426bdd60799df9e$export$45d76561a5302f2b)();
    let searchParams = $cQNHH.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a77787966cb87b36$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $0426bdd60799df9e$export$9770f232ac06a008)();
    let setSearchParams = $cQNHH.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a77787966cb87b36$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a77787966cb87b36$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a77787966cb87b36$var$fetcherId = 0;
let $a77787966cb87b36$var$getUniqueFetcherId = ()=>"__" + String(++$a77787966cb87b36$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a77787966cb87b36$export$47c85c6e3a081d3() {
    let { router: router } = $a77787966cb87b36$var$useDataRouterContext($a77787966cb87b36$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $cQNHH.useContext((0, $0426bdd60799df9e$export$26749e8557646306));
    let currentRouteId = (0, $0426bdd60799df9e$export$5fc8298006ad9e58)();
    return $cQNHH.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a77787966cb87b36$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a77787966cb87b36$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a77787966cb87b36$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a77787966cb87b36$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $cQNHH.useContext((0, $0426bdd60799df9e$export$26749e8557646306));
    let routeContext = $cQNHH.useContext((0, $0426bdd60799df9e$export$9072aa6dd1f93057));
    !routeContext && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a77787966cb87b36$var$_extends({}, (0, $0426bdd60799df9e$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $0426bdd60799df9e$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $09a8f90f65bdbd99$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $09a8f90f65bdbd99$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a77787966cb87b36$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a77787966cb87b36$var$useDataRouterContext($a77787966cb87b36$var$DataRouterHook.UseFetcher);
    let state = $a77787966cb87b36$var$useDataRouterState($a77787966cb87b36$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $cQNHH.useContext($a77787966cb87b36$export$148fd98d095596d4);
    let route = $cQNHH.useContext((0, $0426bdd60799df9e$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    !route && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a77787966cb87b36$var$useIdImpl ? $a77787966cb87b36$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $cQNHH.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a77787966cb87b36$var$getUniqueFetcherId());
    // Registration/cleanup
    $cQNHH.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $cQNHH.useCallback((href, opts)=>{
        !routeId && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a77787966cb87b36$export$47c85c6e3a081d3();
    let submit = $cQNHH.useCallback((target, opts)=>{
        submitImpl(target, $a77787966cb87b36$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $cQNHH.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $cQNHH.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $cQNHH.createElement($a77787966cb87b36$export$a7fed597f4b8afd8, $a77787966cb87b36$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $09a8f90f65bdbd99$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $cQNHH.useMemo(()=>$a77787966cb87b36$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a77787966cb87b36$export$fa996778a3a31087() {
    let state = $a77787966cb87b36$var$useDataRouterState($a77787966cb87b36$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a77787966cb87b36$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a77787966cb87b36$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a77787966cb87b36$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a77787966cb87b36$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a77787966cb87b36$var$useDataRouterContext($a77787966cb87b36$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a77787966cb87b36$var$useDataRouterState($a77787966cb87b36$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $cQNHH.useContext((0, $0426bdd60799df9e$export$26749e8557646306));
    let location = (0, $0426bdd60799df9e$export$45d76561a5302f2b)();
    let matches = (0, $0426bdd60799df9e$export$2378eb7f5ff86053)();
    let navigation = (0, $0426bdd60799df9e$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $cQNHH.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a77787966cb87b36$var$usePageHide($cQNHH.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a77787966cb87b36$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a77787966cb87b36$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a77787966cb87b36$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $cQNHH.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a77787966cb87b36$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a77787966cb87b36$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $cQNHH.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a77787966cb87b36$var$_extends({}, location, {
                    pathname: (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a77787966cb87b36$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $cQNHH.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a77787966cb87b36$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $cQNHH.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a77787966cb87b36$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $cQNHH.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a77787966cb87b36$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $0426bdd60799df9e$export$b273b3273281a049)(when);
    $cQNHH.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $cQNHH.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a77787966cb87b36$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $cQNHH.useContext($a77787966cb87b36$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $09a8f90f65bdbd99$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a77787966cb87b36$var$useDataRouterContext($a77787966cb87b36$var$DataRouterHook.useViewTransitionState);
    let path = (0, $0426bdd60799df9e$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $09a8f90f65bdbd99$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $09a8f90f65bdbd99$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $09a8f90f65bdbd99$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $845c1546d33706fa$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $845c1546d33706fa$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $845c1546d33706fa$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $845c1546d33706fa$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});



var $cQNHH = parcelRequire("cQNHH");
const $c3629d4d08a213c5$var$Apikey = ({ apikey: apikey, manualApikey: manualApikey, sentinel: sentinel })=>{
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
        className: "text-white",
        id: "txt-apikey",
        onClick: manualApikey,
        children: [
            apikey,
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("br", {}),
            "R ",
            (0, (/*@__PURE__*/$parcel$interopDefault($cQNHH))).version,
            " - jQ ",
            (0, (/*@__PURE__*/$parcel$interopDefault($845c1546d33706fa$exports)))().jquery,
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("br", {}),
            "WakeLock: ",
            sentinel != null ? 'actif' : 'inactif'
        ]
    });
};
var $c3629d4d08a213c5$export$2e2bcd8739ae039 = $c3629d4d08a213c5$var$Apikey;



parcelRequire("cQNHH");
const $e1d6c0726194488a$var$Machine = ({ name: name })=>{
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $716072e90fe46d73$exports.Fragment), {
        children: name
    });
};
var $e1d6c0726194488a$export$2e2bcd8739ae039 = $e1d6c0726194488a$var$Machine;




var $cQNHH = parcelRequire("cQNHH");
const $c2283edbdb1a82d8$var$Heure = ()=>{
    const [currentTime, setCurrentTime] = (0, $cQNHH.useState)('');
    (0, $cQNHH.useEffect)(()=>{
        const interval = setInterval(()=>{
            let date = new Date();
            setCurrentTime(date.toLocaleTimeString('fr-CH'));
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("span", {
        style: {
            fontVariantNumeric: 'tabular-nums'
        },
        children: currentTime
    });
};
var $c2283edbdb1a82d8$export$2e2bcd8739ae039 = $c2283edbdb1a82d8$var$Heure;


// Fallback utilisé si process.env.CLIENT n'est pas défini (ex: `npm run dev` sans préciser de client).
var $ce17e73ceb280881$export$2e2bcd8739ae039 = {
    appTitle: 'Web Mobile',
    imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
};


var $abe3902d021acdae$export$2e2bcd8739ae039 = {
    appTitle: "Web Mobile - Carri\xe8re du Lessus",
    imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
};


var $ac39749155e146e7$export$2e2bcd8739ae039 = {
    appTitle: 'Web Mobile - Grandvillard',
    imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
};


var $6c7d830c9ef332e2$export$2e2bcd8739ae039 = {
    appTitle: 'Web Mobile - Farvagny',
    imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
};


var $b37276e07880c7f9$export$2e2bcd8739ae039 = {
    appTitle: "Web Mobile - Composti\xe8re du Gros-de-Vaud S\xe0rl",
    imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
};


var $7239801ae4881fbf$export$2e2bcd8739ae039 = {
    appTitle: "Web Mobile - Grandjean Fils SA - La Del\xe9je",
    imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
};


// process.env.CLIENT est injecté au build par Parcel via les scripts npm (ex: `npm run build:lessus`).
// Pour ajouter un client : créer ./clients/<nom>.js, l'importer ci-dessus et l'ajouter à la map.
const $d0560eaae19deb97$var$clientsMap = {
    lessus: $abe3902d021acdae$export$2e2bcd8739ae039,
    grandvillard: $ac39749155e146e7$export$2e2bcd8739ae039,
    farvagny: $6c7d830c9ef332e2$export$2e2bcd8739ae039,
    compvaud: $b37276e07880c7f9$export$2e2bcd8739ae039,
    grandjean: $7239801ae4881fbf$export$2e2bcd8739ae039
};
const $d0560eaae19deb97$var$clientConfig = $d0560eaae19deb97$var$clientsMap["grandjean"] || (0, $ce17e73ceb280881$export$2e2bcd8739ae039);
// En dev (parcel serve), on garde imagesProxyUrl='' pour laisser .proxyrc.json intercepter /api.
// En prod (parcel build), on utilise l'URL absolue définie dans la config du client.
const $d0560eaae19deb97$var$isDev = false;
const $d0560eaae19deb97$export$877c744d7e11d67a = $d0560eaae19deb97$var$clientConfig.appTitle;
const $d0560eaae19deb97$export$739733bcb6130343 = $d0560eaae19deb97$var$isDev ? '' : $d0560eaae19deb97$var$clientConfig.imagesProxyUrl;
const $d0560eaae19deb97$export$4fc60f1e9b2c3087 = 'https://webmobile.gw.mimatech.ch/ureq';
const $d0560eaae19deb97$export$572ccec9318f4611 = 30000 // 30 secondes
;


const $b77c9cd1ab7710c3$var$TopNavbar = ({ oldData: oldData, apikey: apikey, manualApikey: manualApikey, machineName: machineName, sentinel: sentinel })=>{
    const location = (0, $0426bdd60799df9e$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7fed85a9c36a659f$export$2e2bcd8739ae039), {
        fixed: "top",
        bg: "dark",
        variant: "dark",
        expand: "sm",
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $e436d619efaf7134$export$2e2bcd8739ae039), {
            fluid: true,
            children: [
                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $7fed85a9c36a659f$export$2e2bcd8739ae039).Brand, {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "48",
                            height: "48",
                            className: "me-3",
                            viewBox: "0 0 16 16",
                            fill: oldData ? '#dc3545' : '#28a745',
                            children: oldData ? // Prise déconnectée (rouge)
                            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("path", {
                                d: "M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0zM5 4v2.5A2.5 2.5 0 0 0 7.5 9h1A2.5 2.5 0 0 0 11 6.5V4H5z"
                            }) : // Prise connectée (vert)
                            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("path", {
                                d: "M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0zm4 4H5v2.5A2.5 2.5 0 0 0 7.5 9h1A2.5 2.5 0 0 0 11 6.5V4z"
                            })
                        }),
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
                            className: "d-flex flex-column",
                            children: [
                                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7fed85a9c36a659f$export$2e2bcd8739ae039).Text, {
                                    className: "lh-1",
                                    style: {
                                        fontSize: '0.8rem'
                                    },
                                    children: $d0560eaae19deb97$export$877c744d7e11d67a
                                }),
                                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7fed85a9c36a659f$export$2e2bcd8739ae039).Text, {
                                    className: "text-warning lh-1",
                                    children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $e1d6c0726194488a$export$2e2bcd8739ae039), {
                                        name: machineName
                                    })
                                })
                            ]
                        })
                    ]
                }),
                location.pathname != '/' && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7fed85a9c36a659f$export$2e2bcd8739ae039).Collapse, {
                    className: "justify-content-between",
                    children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $a77787966cb87b36$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "btn btn-primary btn-lg",
                        children: "Retour page principale"
                    })
                }),
                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $7fed85a9c36a659f$export$2e2bcd8739ae039).Collapse, {
                    className: "justify-content-end",
                    children: [
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7fed85a9c36a659f$export$2e2bcd8739ae039).Text, {
                            className: "h2 text-white mb-0 pe-4",
                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $c2283edbdb1a82d8$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7fed85a9c36a659f$export$2e2bcd8739ae039).Text, {
                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $c3629d4d08a213c5$export$2e2bcd8739ae039), {
                                apikey: apikey,
                                manualApikey: manualApikey,
                                sentinel: sentinel
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $b77c9cd1ab7710c3$export$2e2bcd8739ae039 = $b77c9cd1ab7710c3$var$TopNavbar;











var $cQNHH = parcelRequire("cQNHH");


"use client";
function $bcd8a2ae5db8f710$export$2ed43d61a0a9f5a3(_param) {
    var { as: as, bsPrefix: bsPrefix, className: className } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "as",
        "bsPrefix",
        "className"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $d344ef3e3248c0b3$export$8970c8db816a5863)();
    const minBreakpoint = (0, $d344ef3e3248c0b3$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, ...spans, ...classes)
        }),
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $bcd8a2ae5db8f710$var$Col = /*#__PURE__*/ $cQNHH.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const _useCol = $bcd8a2ae5db8f710$export$2ed43d61a0a9f5a3(props), [{ className: className }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = _useCol, colProps = (0, $579302c8e6721842$export$71511d61b312f219)(_useCol[0], [
        "className"
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, colProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, !spans.length && bsPrefix)
    }));
});
$bcd8a2ae5db8f710$var$Col.displayName = 'Col';
var $bcd8a2ae5db8f710$export$2e2bcd8739ae039 = $bcd8a2ae5db8f710$var$Col;






var $cQNHH = parcelRequire("cQNHH");


"use client";
const $51f69fc424294837$var$Row = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    const decoratedBsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $d344ef3e3248c0b3$export$8970c8db816a5863)();
    const minBreakpoint = (0, $d344ef3e3248c0b3$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, decoratedBsPrefix, ...classes)
    }));
});
$51f69fc424294837$var$Row.displayName = 'Row';
var $51f69fc424294837$export$2e2bcd8739ae039 = $51f69fc424294837$var$Row;






var $cQNHH = parcelRequire("cQNHH");






var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");

const $ed2d6a11d5a21190$var$_excluded = [
    "as",
    "disabled"
];
function $ed2d6a11d5a21190$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ed2d6a11d5a21190$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $ed2d6a11d5a21190$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $ed2d6a11d5a21190$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $ed2d6a11d5a21190$var$Button = /*#__PURE__*/ $cQNHH.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $ed2d6a11d5a21190$var$_objectWithoutPropertiesLoose(_ref, $ed2d6a11d5a21190$var$_excluded);
    const [buttonProps, { tagName: Component }] = $ed2d6a11d5a21190$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$ed2d6a11d5a21190$var$Button.displayName = 'Button';
var $ed2d6a11d5a21190$export$2e2bcd8739ae039 = $ed2d6a11d5a21190$var$Button;




"use client";
const $6ac1e09dec856e2e$var$Button = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "as",
        "bsPrefix",
        "variant",
        "size",
        "active",
        "disabled",
        "className"
    ]);
    const prefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $ed2d6a11d5a21190$export$a0ee72f2c720a5c3)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        tagName: as,
        disabled: disabled
    }, props));
    const Component = tagName;
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, buttonProps, props), {
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    }));
});
$6ac1e09dec856e2e$var$Button.displayName = 'Button';
var $6ac1e09dec856e2e$export$2e2bcd8739ae039 = $6ac1e09dec856e2e$var$Button;






var $cQNHH = parcelRequire("cQNHH");




var $cQNHH = parcelRequire("cQNHH");



"use client";
const $3c00e8d01d6499fb$var$CardBody = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$3c00e8d01d6499fb$var$CardBody.displayName = 'CardBody';
var $3c00e8d01d6499fb$export$2e2bcd8739ae039 = $3c00e8d01d6499fb$var$CardBody;





var $cQNHH = parcelRequire("cQNHH");



"use client";
const $d2b4b48774163f07$var$CardFooter = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$d2b4b48774163f07$var$CardFooter.displayName = 'CardFooter';
var $d2b4b48774163f07$export$2e2bcd8739ae039 = $d2b4b48774163f07$var$CardFooter;







var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");
"use client";
const $c733f71a74c05cd7$var$context = /*#__PURE__*/ $cQNHH.createContext(null);
$c733f71a74c05cd7$var$context.displayName = 'CardHeaderContext';
var $c733f71a74c05cd7$export$2e2bcd8739ae039 = $c733f71a74c05cd7$var$context;



"use client";
const $f26f3e9438502a64$var$CardHeader = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    const prefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $cQNHH.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $c733f71a74c05cd7$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
            ref: ref
        }, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, prefix)
        }))
    });
});
$f26f3e9438502a64$var$CardHeader.displayName = 'CardHeader';
var $f26f3e9438502a64$export$2e2bcd8739ae039 = $f26f3e9438502a64$var$CardHeader;






var $cQNHH = parcelRequire("cQNHH");


"use client";
const $530512a787d713c9$var$CardImg = /*#__PURE__*/ $cQNHH.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "variant",
        "as"
    ]);
    const prefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(variant ? `${prefix}-${variant}` : prefix, className)
    }, props));
});
$530512a787d713c9$var$CardImg.displayName = 'CardImg';
var $530512a787d713c9$export$2e2bcd8739ae039 = $530512a787d713c9$var$CardImg;





var $cQNHH = parcelRequire("cQNHH");



"use client";
const $e96973c78b23b0dd$var$CardImgOverlay = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$e96973c78b23b0dd$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $e96973c78b23b0dd$export$2e2bcd8739ae039 = $e96973c78b23b0dd$var$CardImgOverlay;





var $cQNHH = parcelRequire("cQNHH");



"use client";
const $9298b9d002fc8b6d$var$CardLink = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'a' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$9298b9d002fc8b6d$var$CardLink.displayName = 'CardLink';
var $9298b9d002fc8b6d$export$2e2bcd8739ae039 = $9298b9d002fc8b6d$var$CardLink;





var $cQNHH = parcelRequire("cQNHH");




"use client";
const $1c9be1faa6921108$var$DivStyledAsH6 = (0, $e8eeaa4582252c3a$export$2e2bcd8739ae039)('h6');
const $1c9be1faa6921108$var$CardSubtitle = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $1c9be1faa6921108$var$DivStyledAsH6 } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$1c9be1faa6921108$var$CardSubtitle.displayName = 'CardSubtitle';
var $1c9be1faa6921108$export$2e2bcd8739ae039 = $1c9be1faa6921108$var$CardSubtitle;





var $cQNHH = parcelRequire("cQNHH");



"use client";
const $d344d5212c8e32b3$var$CardText = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'p' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$d344d5212c8e32b3$var$CardText.displayName = 'CardText';
var $d344d5212c8e32b3$export$2e2bcd8739ae039 = $d344d5212c8e32b3$var$CardText;





var $cQNHH = parcelRequire("cQNHH");




"use client";
const $de79f6d7a95e002a$var$DivStyledAsH5 = (0, $e8eeaa4582252c3a$export$2e2bcd8739ae039)('h5');
const $de79f6d7a95e002a$var$CardTitle = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $de79f6d7a95e002a$var$DivStyledAsH5 } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$de79f6d7a95e002a$var$CardTitle.displayName = 'CardTitle';
var $de79f6d7a95e002a$export$2e2bcd8739ae039 = $de79f6d7a95e002a$var$CardTitle;



"use client";
const $4d3aa6254db3466d$var$Card = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children",
        "as"
    ]);
    const prefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $3c00e8d01d6499fb$export$2e2bcd8739ae039), {
            children: children
        }) : children
    }));
});
$4d3aa6254db3466d$var$Card.displayName = 'Card';
var $4d3aa6254db3466d$export$2e2bcd8739ae039 = Object.assign($4d3aa6254db3466d$var$Card, {
    Img: (0, $530512a787d713c9$export$2e2bcd8739ae039),
    Title: (0, $de79f6d7a95e002a$export$2e2bcd8739ae039),
    Subtitle: (0, $1c9be1faa6921108$export$2e2bcd8739ae039),
    Body: (0, $3c00e8d01d6499fb$export$2e2bcd8739ae039),
    Link: (0, $9298b9d002fc8b6d$export$2e2bcd8739ae039),
    Text: (0, $d344d5212c8e32b3$export$2e2bcd8739ae039),
    Header: (0, $f26f3e9438502a64$export$2e2bcd8739ae039),
    Footer: (0, $d2b4b48774163f07$export$2e2bcd8739ae039),
    ImgOverlay: (0, $e96973c78b23b0dd$export$2e2bcd8739ae039)
});






var $cQNHH = parcelRequire("cQNHH");
var $588522c4b895e932$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $588522c4b895e932$var$__DEV__ = false;
var $588522c4b895e932$var$warning = function() {};
if ($588522c4b895e932$var$__DEV__) {
    var $588522c4b895e932$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $588522c4b895e932$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $588522c4b895e932$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$588522c4b895e932$exports = $588522c4b895e932$var$warning;





var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");
function $4bb648fa83b70f75$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $cQNHH.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}




var $cQNHH = parcelRequire("cQNHH");
const $7724287a32a13de5$var$NavContext = /*#__PURE__*/ $cQNHH.createContext(null);
$7724287a32a13de5$var$NavContext.displayName = 'NavContext';
var $7724287a32a13de5$export$2e2bcd8739ae039 = $7724287a32a13de5$var$NavContext;




var $cQNHH = parcelRequire("cQNHH");
const $01bc2efa05293fcf$var$TabContext = /*#__PURE__*/ $cQNHH.createContext(null);
var $01bc2efa05293fcf$export$2e2bcd8739ae039 = $01bc2efa05293fcf$var$TabContext;




var $cQNHH = parcelRequire("cQNHH");







const $b410424d78b64dca$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $b410424d78b64dca$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $b410424d78b64dca$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $cQNHH.useContext)((0, $9e38986a28d3c9c6$export$2e2bcd8739ae039));
    const navContext = (0, $cQNHH.useContext)((0, $7724287a32a13de5$export$2e2bcd8739ae039));
    const tabContext = (0, $cQNHH.useContext)((0, $01bc2efa05293fcf$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $e6cbf14051c5a16b$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $b410424d78b64dca$var$NavItem = /*#__PURE__*/ $cQNHH.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $ed2d6a11d5a21190$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $b410424d78b64dca$var$_objectWithoutPropertiesLoose(_ref, $b410424d78b64dca$var$_excluded);
    const [props, meta] = $b410424d78b64dca$export$d7a68693710982a(Object.assign({
        key: (0, $9e38986a28d3c9c6$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $e6cbf14051c5a16b$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$b410424d78b64dca$var$NavItem.displayName = 'NavItem';
var $b410424d78b64dca$export$2e2bcd8739ae039 = $b410424d78b64dca$var$NavItem;



const $1a03468377ed1470$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $1a03468377ed1470$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $1a03468377ed1470$var$noop = ()=>{};
const $1a03468377ed1470$var$EVENT_KEY_ATTR = (0, $e6cbf14051c5a16b$export$5cc3b7b83e34ade7)('event-key');
const $1a03468377ed1470$var$Nav = /*#__PURE__*/ $cQNHH.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $1a03468377ed1470$var$_objectWithoutPropertiesLoose(_ref, $1a03468377ed1470$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $4bb648fa83b70f75$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $cQNHH.useRef)(false);
    const parentOnSelect = (0, $cQNHH.useContext)((0, $9e38986a28d3c9c6$export$2e2bcd8739ae039));
    const tabContext = (0, $cQNHH.useContext)((0, $01bc2efa05293fcf$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $cQNHH.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $f2f152a0256e8d5f$export$2e2bcd8739ae039)(currentListNode, `[${$1a03468377ed1470$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $e6cbf14051c5a16b$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $cQNHH.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$1a03468377ed1470$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $1b5655dcae36b210$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $9e38986a28d3c9c6$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7724287a32a13de5$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $9e38986a28d3c9c6$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $1a03468377ed1470$var$noop,
                getControllerId: getControllerId || $1a03468377ed1470$var$noop
            },
            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$1a03468377ed1470$var$Nav.displayName = 'Nav';
var $1a03468377ed1470$export$2e2bcd8739ae039 = Object.assign($1a03468377ed1470$var$Nav, {
    Item: (0, $b410424d78b64dca$export$2e2bcd8739ae039)
});








var $cQNHH = parcelRequire("cQNHH");






"use client";
const $9eb4697c04cdc9a1$var$ListGroupItem = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "active",
        "disabled",
        "eventKey",
        "className",
        "variant",
        "action",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $b410424d78b64dca$export$d7a68693710982a)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        key: (0, $9e38986a28d3c9c6$export$eef49b42fde998a3)(eventKey, props.href),
        active: active
    }, props));
    const handleClick = (0, $69b21c98023fc358$export$2e2bcd8739ae039)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props, navItemProps), {
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    }));
});
$9eb4697c04cdc9a1$var$ListGroupItem.displayName = 'ListGroupItem';
var $9eb4697c04cdc9a1$export$2e2bcd8739ae039 = $9eb4697c04cdc9a1$var$ListGroupItem;



"use client";
const $073e9b5c5766a919$var$ListGroup = /*#__PURE__*/ $cQNHH.forwardRef((props, ref)=>{
    const _useUncontrolled = (0, $652b4200927b0439$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    }), { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div' } = _useUncontrolled, controlledProps = (0, $579302c8e6721842$export$71511d61b312f219)(_useUncontrolled, [
        "className",
        "bsPrefix",
        "variant",
        "horizontal",
        "numbered",
        "as"
    ]);
    const bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $1a03468377ed1470$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, controlledProps), {
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    }));
});
$073e9b5c5766a919$var$ListGroup.displayName = 'ListGroup';
var $073e9b5c5766a919$export$2e2bcd8739ae039 = Object.assign($073e9b5c5766a919$var$ListGroup, {
    Item: (0, $9eb4697c04cdc9a1$export$2e2bcd8739ae039)
});










var $6d553323e8bf43d8$var$size;
function $6d553323e8bf43d8$export$2e2bcd8739ae039(recalc) {
    if (!$6d553323e8bf43d8$var$size && $6d553323e8bf43d8$var$size !== 0 || recalc) {
        if (0, $123b6114b54e95dd$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $6d553323e8bf43d8$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $6d553323e8bf43d8$var$size;
}



var $cQNHH = parcelRequire("cQNHH");
function $5d02d8102108ee39$export$2e2bcd8739ae039() {
    return (0, $cQNHH.useState)(null);
}





var $cQNHH = parcelRequire("cQNHH");
function $6af058723e89245c$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $cQNHH.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $cQNHH = parcelRequire("cQNHH");
function $3b976e16857a6ec0$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $6af058723e89245c$export$2e2bcd8739ae039)(fn);
    (0, $cQNHH.useEffect)(()=>()=>onUnmount.current(), []);
}




var $cQNHH = parcelRequire("cQNHH");






var $cQNHH = parcelRequire("cQNHH");



"use client";
const $4b85e4128d0f62a3$var$ModalBody = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$4b85e4128d0f62a3$var$ModalBody.displayName = 'ModalBody';
var $4b85e4128d0f62a3$export$2e2bcd8739ae039 = $4b85e4128d0f62a3$var$ModalBody;








var $cQNHH = parcelRequire("cQNHH");


"use client";
const $dd6c983db9d26487$var$ModalDialog = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "contentClassName",
        "centered",
        "size",
        "fullscreen",
        "children",
        "scrollable"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    }));
});
$dd6c983db9d26487$var$ModalDialog.displayName = 'ModalDialog';
var $dd6c983db9d26487$export$2e2bcd8739ae039 = $dd6c983db9d26487$var$ModalDialog;





var $cQNHH = parcelRequire("cQNHH");



"use client";
const $19a3843940190877$var$ModalFooter = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$19a3843940190877$var$ModalFooter.displayName = 'ModalFooter';
var $19a3843940190877$export$2e2bcd8739ae039 = $19a3843940190877$var$ModalFooter;







var $cQNHH = parcelRequire("cQNHH");



"use client";
const $e48286986f064d19$var$ModalHeader = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "closeLabel",
        "closeButton"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $ae3aa136efbf73f0$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    }));
});
$e48286986f064d19$var$ModalHeader.displayName = 'ModalHeader';
var $e48286986f064d19$export$2e2bcd8739ae039 = $e48286986f064d19$var$ModalHeader;





var $cQNHH = parcelRequire("cQNHH");




"use client";
const $83b29fcff4453f1d$var$DivStyledAsH4 = (0, $e8eeaa4582252c3a$export$2e2bcd8739ae039)('h4');
const $83b29fcff4453f1d$var$ModalTitle = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $83b29fcff4453f1d$var$DivStyledAsH4 } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$83b29fcff4453f1d$var$ModalTitle.displayName = 'ModalTitle';
var $83b29fcff4453f1d$export$2e2bcd8739ae039 = $83b29fcff4453f1d$var$ModalTitle;




"use client";
function $94042df3f259011c$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $ee06ef704e32ed95$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props), {
        timeout: null
    }));
}
function $94042df3f259011c$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $ee06ef704e32ed95$export$2e2bcd8739ae039), (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props), {
        timeout: null
    }));
}
const $94042df3f259011c$var$Modal = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $dd6c983db9d26487$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "style",
        "dialogClassName",
        "contentClassName",
        "children",
        "dialogAs",
        'data-bs-theme',
        'aria-labelledby',
        'aria-describedby',
        'aria-label',
        "show",
        "animation",
        "backdrop",
        "keyboard",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager"
    ]);
    const [modalStyle, setStyle] = (0, $cQNHH.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $cQNHH.useState)(false);
    const waitingForMouseUpRef = (0, $cQNHH.useRef)(false);
    const ignoreBackdropClickRef = (0, $cQNHH.useRef)(false);
    const removeStaticModalAnimationRef = (0, $cQNHH.useRef)(null);
    const [modal, setModalRef] = (0, $5d02d8102108ee39$export$2e2bcd8739ae039)();
    const mergedRef = (0, $a57a09a1fdf41a48$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $69b21c98023fc358$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $d344ef3e3248c0b3$export$35e511eefa30ac5a)();
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $cQNHH.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $d8a058b1a0e80cb5$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $123b6114b54e95dd$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $7df48d49a4f6302c$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $6d553323e8bf43d8$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $6d553323e8bf43d8$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $69b21c98023fc358$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $3b976e16857a6ec0$export$2e2bcd8739ae039)(()=>{
        (0, $5545ecd5b8617486$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $84c46953ce51ca52$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $c9d787f1b0659277$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $5545ecd5b8617486$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $cQNHH.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, backdropProps), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        })), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, style, modalStyle);
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
            role: "dialog"
        }, dialogProps), {
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Dialog, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, props), {
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            }))
        }));
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $dc7033eda9f30ed4$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $fcec9fe8620d23d9$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $94042df3f259011c$var$DialogTransition : undefined,
            backdropTransition: animation ? $94042df3f259011c$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$94042df3f259011c$var$Modal.displayName = 'Modal';
var $94042df3f259011c$export$2e2bcd8739ae039 = Object.assign($94042df3f259011c$var$Modal, {
    Body: (0, $4b85e4128d0f62a3$export$2e2bcd8739ae039),
    Header: (0, $e48286986f064d19$export$2e2bcd8739ae039),
    Title: (0, $83b29fcff4453f1d$export$2e2bcd8739ae039),
    Footer: (0, $19a3843940190877$export$2e2bcd8739ae039),
    Dialog: (0, $dd6c983db9d26487$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});






var $cQNHH = parcelRequire("cQNHH");


"use client";
const $66c35161cfe3872e$var$Spinner = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', className: className } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "variant",
        "animation",
        "size",
        "as",
        "className"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    }));
});
$66c35161cfe3872e$var$Spinner.displayName = 'Spinner';
var $66c35161cfe3872e$export$2e2bcd8739ae039 = $66c35161cfe3872e$var$Spinner;



parcelRequire("cQNHH");
const $9d1837e443d4ee4f$var$LogoSVG = ({ letter: letter, color: color })=>{
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("svg", {
        width: "36",
        height: "36",
        children: [
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("circle", {
                cx: "18",
                cy: "18",
                r: "16",
                fill: color
            }),
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("text", {
                x: "50%",
                y: "50%",
                textAnchor: "middle",
                fill: "white",
                fontSize: "20px",
                fontWeight: "bold",
                fontFamily: "Arial",
                dy: ".4em",
                children: letter
            })
        ]
    });
};
var $9d1837e443d4ee4f$export$2e2bcd8739ae039 = $9d1837e443d4ee4f$var$LogoSVG;


class $3e4bd38f075a01a7$export$2e2bcd8739ae039 extends (0, $cQNHH.Component) {
    componentDidMount() {
        this.timerInterval = setInterval(()=>{
            this.setState({
                waitingTime: this.calculateWaitingTime()
            });
        }, 1000);
    }
    componentWillUnmount() {
        if (this.timerInterval) clearInterval(this.timerInterval);
    }
    calculateWaitingTime() {
        let epoch = this.props.transaction.epoch;
        if (epoch > 1e12) epoch = epoch / 1000;
        const nowSeconds = Date.now() / 1000;
        return Math.floor(nowSeconds - epoch);
    }
    formatWaitingTime() {
        const seconds = this.state.waitingTime;
        if (seconds < 0) return '0s';
        if (seconds < 60) return `${seconds}s`;
        if (seconds < 900) {
            const mins = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${mins}:${secs.toString().padStart(2, '0')}`;
        }
        return '>15min';
    }
    btnVariant() {
        if (this.props.transaction.owner == '') return 'success';
        if (this.props.transaction.owner == 'self') return 'danger';
        return 'warning';
    }
    btnDisabled() {
        if (this.props.transaction.owner != '' && this.props.transaction.owner != 'self') return true;
        else return false;
    }
    btnText() {
        if (this.props.transaction.owner == 'self') return "Lib\xe9rer";
        if (this.props.transaction.owner == '') return "S'en occuper";
        return 'En chargement';
    }
    render() {
        const isDisabled = this.props.disabled;
        const { isValidating: isValidating } = this.state;
        const cardStyle = (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
            width: '22rem',
            position: 'relative'
        }, isDisabled && {
            opacity: 0.5,
            pointerEvents: 'none',
            filter: 'grayscale(50%)'
        });
        const overlayStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(40, 167, 69, 0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            borderRadius: 'inherit',
            animation: 'fadeIn 0.3s ease-in-out'
        };
        const checkmarkStyle = {
            color: 'white',
            fontSize: '8rem',
            fontWeight: 'bold',
            animation: 'scaleIn 0.4s ease-out'
        };
        return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("style", {
                    children: `
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes scaleIn {
              from { transform: scale(0); opacity: 0; }
              to { transform: scale(1); opacity: 1; }
            }
          `
                }),
                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $4d3aa6254db3466d$export$2e2bcd8739ae039), {
                    style: cardStyle,
                    children: [
                        isValidating && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                            style: overlayStyle,
                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("span", {
                                style: checkmarkStyle,
                                children: "\u2713"
                            })
                        }),
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4d3aa6254db3466d$export$2e2bcd8739ae039).Header, {
                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
                                className: "d-flex flex-row justify-content-between align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("h1", {
                                            children: this.props.transaction.camion
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                        className: "d-flex flex-row",
                                        children: {
                                            CHARGE: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $9d1837e443d4ee4f$export$2e2bcd8739ae039), {
                                                        letter: "C",
                                                        color: "#13eb2a"
                                                    }),
                                                    ' ',
                                                    this.props.transaction.with_decharge == true && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $9d1837e443d4ee4f$export$2e2bcd8739ae039), {
                                                        letter: "D",
                                                        color: "#eb1316"
                                                    })
                                                ]
                                            }),
                                            DECHARGE: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $9d1837e443d4ee4f$export$2e2bcd8739ae039), {
                                                letter: "D",
                                                color: "#eb1316"
                                            }),
                                            default: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $9d1837e443d4ee4f$export$2e2bcd8739ae039), {
                                                letter: "?",
                                                color: "#aeaeae"
                                            })
                                        }[this.props.transaction.transaction]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $4d3aa6254db3466d$export$2e2bcd8739ae039).Body, {
                            children: [
                                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $4d3aa6254db3466d$export$2e2bcd8739ae039).Title, {
                                    children: [
                                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                            children: this.props.transaction.quantity
                                        }),
                                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("span", {
                                                style: {
                                                    cursor: 'pointer',
                                                    color: '#0d6efd',
                                                    textDecoration: 'underline'
                                                },
                                                onClick: this.handleArticleClick,
                                                children: this.props.transaction.article
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4d3aa6254db3466d$export$2e2bcd8739ae039).Subtitle, {}),
                                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("p", {
                                    className: "mb-0",
                                    children: this.props.transaction.client
                                }),
                                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("p", {
                                    children: this.props.transaction.chantier
                                }),
                                this.props.transaction.allow_btn_ownership !== false && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
                                    className: "d-flex flex-row justify-content-between align-content-center align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                            children: this.props.transaction.owner_description == '' ? "Pas de machine attribu\xe9e" : this.props.transaction.owner_description
                                        }),
                                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $6ac1e09dec856e2e$export$2e2bcd8739ae039), {
                                                disabled: this.btnDisabled(),
                                                variant: this.btnVariant(),
                                                onClick: ()=>{
                                                    this.props.onToggleOwnership(this.props.transaction.id, this.props.transaction.id_lieu);
                                                },
                                                children: this.btnText()
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $6ac1e09dec856e2e$export$2e2bcd8739ae039), {
                                    variant: "success",
                                    disabled: isValidating || this.btnDisabled(),
                                    onClick: this.handleValidate,
                                    children: "Valider le chargement"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4d3aa6254db3466d$export$2e2bcd8739ae039).Footer, {
                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
                                className: "d-flex flex-row justify-content-between align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                                children: this.props.transaction.datetime
                                            }),
                                            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
                                                style: {
                                                    fontVariantNumeric: 'tabular-nums'
                                                },
                                                children: [
                                                    "Temps d'attente : ",
                                                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("strong", {
                                                        children: this.formatWaitingTime()
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $a77787966cb87b36$export$a6c7ac8248d6e38a), {
                                            to: "/photos",
                                            state: {
                                                images: this.props.transaction.images,
                                                id: this.props.transaction.id,
                                                id_lieu: this.props.transaction.id_lieu
                                            },
                                            children: this.props.transaction.images.length === 0 ? /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "24",
                                                fill: "#6c757d",
                                                viewBox: "0 0 16 16",
                                                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("path", {
                                                    d: "M2.146 2.854a.5.5 0 1 1 .708-.708L11.646 11l2.5 2.5a.5.5 0 0 1-.708.708l-2.5-2.5L2.146 2.854zM2 13.5A1.5 1.5 0 0 1 .5 12V4A1.5 1.5 0 0 1 2 2.5h.172a.5.5 0 0 1 .354.146L5.06 5.18a.5.5 0 0 0 .354.146H9.5a.5.5 0 0 1 .5.5v1.5l-1 1V6.5a.5.5 0 0 0-.5-.5H5.06a.5.5 0 0 1-.354-.146L2.172 3.32a.5.5 0 0 0-.354-.146H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9.086l1 1H2zm9.5-2.5L13 9.5V12a1.5 1.5 0 0 1-1.5 1.5h-1.086l-1-1H11.5a.5.5 0 0 0 .5-.5v-1zm1.5-4.5V4A1.5 1.5 0 0 0 11.5 2.5h-7L5.5 3.5h6a.5.5 0 0 1 .5.5v2l1-1z"
                                                })
                                            }) : /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $716072e90fe46d73$exports.Fragment), {
                                                children: this.props.transaction.images.length === 1 ? /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $716072e90fe46d73$exports.Fragment), {
                                                    children: "1 photo"
                                                }) : /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
                                                    children: [
                                                        this.props.transaction.images.length,
                                                        " photos"
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $94042df3f259011c$export$2e2bcd8739ae039), {
                    show: this.state.showArticleModal,
                    onHide: this.handleCloseArticleModal,
                    centered: true,
                    children: [
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $94042df3f259011c$export$2e2bcd8739ae039).Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $94042df3f259011c$export$2e2bcd8739ae039).Title, {
                                children: "Changer l'article"
                            })
                        }),
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $94042df3f259011c$export$2e2bcd8739ae039).Body, {
                            children: !this.props.availableArticles ? /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
                                className: "text-center py-4",
                                children: [
                                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $66c35161cfe3872e$export$2e2bcd8739ae039), {
                                        animation: "border",
                                        variant: "primary"
                                    }),
                                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("p", {
                                        className: "mt-2 mb-0",
                                        children: "Chargement des articles..."
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $073e9b5c5766a919$export$2e2bcd8739ae039), {
                                children: this.props.availableArticles.articles.map((article)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $073e9b5c5766a919$export$2e2bcd8739ae039).Item, {
                                        action: true,
                                        onClick: ()=>this.handleSelectArticle(article.id),
                                        active: article.description === this.props.transaction.article,
                                        children: article.description
                                    }, article.id))
                            })
                        }),
                        /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $94042df3f259011c$export$2e2bcd8739ae039).Footer, {
                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $6ac1e09dec856e2e$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                onClick: this.handleCloseArticleModal,
                                children: "Annuler"
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props), (0, $a7dd764ddb4e6443$export$71511d61b312f219)(this, "handleValidate", ()=>{
            this.setState({
                isValidating: true
            });
            setTimeout(()=>{
                this.props.onValidate(this.props.transaction.id, this.props.transaction.id_lieu);
            }, 800);
        }), (0, $a7dd764ddb4e6443$export$71511d61b312f219)(this, "handleArticleClick", ()=>{
            this.setState({
                showArticleModal: true
            });
            this.props.onRequestArticles(this.props.transaction.id, this.props.transaction.id_lieu);
        }), (0, $a7dd764ddb4e6443$export$71511d61b312f219)(this, "handleCloseArticleModal", ()=>{
            this.setState({
                showArticleModal: false
            });
            this.props.onClearArticles();
        }), (0, $a7dd764ddb4e6443$export$71511d61b312f219)(this, "handleSelectArticle", (articleId)=>{
            this.props.onChangeArticle(this.props.transaction.id, this.props.transaction.id_lieu, articleId);
            this.setState({
                showArticleModal: false
            });
            this.props.onClearArticles();
        });
        this.state = {
            waitingTime: this.calculateWaitingTime(),
            isValidating: false,
            showArticleModal: false
        };
    }
}


const $01ff746bbcd1581e$var$Transactions = ({ transactions: transactions, onToggleOwnership: onToggleOwnership, onValidate: onValidate, onAddImage: onAddImage, onRequestArticles: onRequestArticles, onChangeArticle: onChangeArticle, onClearArticles: onClearArticles, availableArticles: availableArticles, disabled: disabled })=>{
    if (transactions.length === 0) return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
        className: "d-flex flex-column align-items-center justify-content-center text-muted",
        style: {
            minHeight: '60vh'
        },
        children: [
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "120",
                height: "120",
                fill: "currentColor",
                viewBox: "0 0 16 16",
                className: "mb-4 opacity-50",
                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("path", {
                    d: "M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                })
            }),
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("h2", {
                className: "mb-2",
                children: "En attente d'un camion..."
            }),
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("p", {
                className: "opacity-75",
                children: "Les transactions appara\xeetront ici"
            })
        ]
    });
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $716072e90fe46d73$exports.Fragment), {
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $51f69fc424294837$export$2e2bcd8739ae039), {
            xs: 1,
            md: 2,
            xl: 3,
            className: "g-4 pt-4",
            children: transactions.map((t)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $bcd8a2ae5db8f710$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $3e4bd38f075a01a7$export$2e2bcd8739ae039), {
                        transaction: t,
                        onToggleOwnership: onToggleOwnership,
                        onValidate: onValidate,
                        onAddImage: onAddImage,
                        onRequestArticles: onRequestArticles,
                        onChangeArticle: onChangeArticle,
                        onClearArticles: onClearArticles,
                        availableArticles: availableArticles,
                        disabled: disabled
                    })
                }, t.id))
        })
    });
};
var $01ff746bbcd1581e$export$2e2bcd8739ae039 = $01ff746bbcd1581e$var$Transactions;







var $cQNHH = parcelRequire("cQNHH");






var $cQNHH = parcelRequire("cQNHH");




"use client";
const $55fae31100dfec0a$var$DivStyledAsH4 = (0, $e8eeaa4582252c3a$export$2e2bcd8739ae039)('h4');
$55fae31100dfec0a$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $55fae31100dfec0a$var$AlertHeading = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = $55fae31100dfec0a$var$DivStyledAsH4 } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$55fae31100dfec0a$var$AlertHeading.displayName = 'AlertHeading';
var $55fae31100dfec0a$export$2e2bcd8739ae039 = $55fae31100dfec0a$var$AlertHeading;





var $cQNHH = parcelRequire("cQNHH");


var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");
function $4d059c38d422cb8c$export$2e2bcd8739ae039() {
    return (0, $cQNHH.useState)(null);
}





var $cQNHH = parcelRequire("cQNHH");

function $789beba908b88a02$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)(listener);
    (0, $cQNHH.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $cQNHH = parcelRequire("cQNHH");
function $d06a38485feb8c4e$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $cQNHH.useCallback)(()=>document, []);
    return (0, $789beba908b88a02$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $cQNHH = parcelRequire("cQNHH");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $a4e80edbc47d9940$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $962edf4bc5c6fe72$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $962edf4bc5c6fe72$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $cQNHH.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $a4e80edbc47d9940$export$2e2bcd8739ae039 = $a4e80edbc47d9940$var$useInterval;



var $cQNHH = parcelRequire("cQNHH");

function $85d291246ee82268$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $962edf4bc5c6fe72$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $962edf4bc5c6fe72$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $cQNHH.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $85d291246ee82268$export$2e2bcd8739ae039 = $85d291246ee82268$var$useRafInterval;



var $cQNHH = parcelRequire("cQNHH");
function $03aaf0ecf4ef2d3c$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $cQNHH.useState)(initialState);
    const updater = (0, $cQNHH.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $90ab6e5a7b9fa1d9$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $03aaf0ecf4ef2d3c$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $cQNHH = parcelRequire("cQNHH");
function $e42e848aa619860b$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $cQNHH.useState)({
        image: null,
        error: null
    });
    (0, $cQNHH.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $cQNHH = parcelRequire("cQNHH");

const $f12ca0a01ad31dfc$var$targetMap = new WeakMap();
let $f12ca0a01ad31dfc$var$resizeObserver;
function $f12ca0a01ad31dfc$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $f12ca0a01ad31dfc$var$resizeObserver = $f12ca0a01ad31dfc$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $f12ca0a01ad31dfc$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $f12ca0a01ad31dfc$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $cQNHH.useState)(null);
    (0, $9ef41493109869e4$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $f12ca0a01ad31dfc$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $f12ca0a01ad31dfc$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $f12ca0a01ad31dfc$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $06c585a3e6ab5540$var$_excluded = [
    "onKeyDown"
];
function $06c585a3e6ab5540$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $06c585a3e6ab5540$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $06c585a3e6ab5540$var$Anchor = /*#__PURE__*/ $cQNHH.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $06c585a3e6ab5540$var$_objectWithoutPropertiesLoose(_ref, $06c585a3e6ab5540$var$_excluded);
    const [buttonProps] = (0, $ed2d6a11d5a21190$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $10beb7154eb705d3$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($06c585a3e6ab5540$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$06c585a3e6ab5540$var$Anchor.displayName = 'Anchor';
var $06c585a3e6ab5540$export$2e2bcd8739ae039 = $06c585a3e6ab5540$var$Anchor;




"use client";
const $1da645f8352daf4f$var$AlertLink = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = (0, $06c585a3e6ab5540$export$2e2bcd8739ae039) } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$1da645f8352daf4f$var$AlertLink.displayName = 'AlertLink';
var $1da645f8352daf4f$export$2e2bcd8739ae039 = $1da645f8352daf4f$var$AlertLink;





"use client";
const $629fe0b1bdf276d1$var$Alert = /*#__PURE__*/ $cQNHH.forwardRef((uncontrolledProps, ref)=>{
    const _useUncontrolled = (0, $652b4200927b0439$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    }), { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $ee06ef704e32ed95$export$2e2bcd8739ae039) } = _useUncontrolled, props = (0, $579302c8e6721842$export$71511d61b312f219)(_useUncontrolled, [
        "bsPrefix",
        "show",
        "closeLabel",
        "closeVariant",
        "className",
        "children",
        "variant",
        "onClose",
        "dismissible",
        "transition"
    ]);
    const prefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $69b21c98023fc358$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $ee06ef704e32ed95$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        role: "alert"
    }, !Transition ? props : undefined), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4e6b8c63d5a92020$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    }));
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Transition, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        unmountOnExit: true
    }, props), {
        ref: undefined,
        in: show,
        children: alert
    }));
});
$629fe0b1bdf276d1$var$Alert.displayName = 'Alert';
var $629fe0b1bdf276d1$export$2e2bcd8739ae039 = Object.assign($629fe0b1bdf276d1$var$Alert, {
    Link: (0, $1da645f8352daf4f$export$2e2bcd8739ae039),
    Heading: (0, $55fae31100dfec0a$export$2e2bcd8739ae039)
});




var $cQNHH = parcelRequire("cQNHH");

class $8e8a40cdebdfa979$var$WebSocketService {
    async connect(apikey) {
        if (!apikey) {
            console.warn("WebSocket: pas d'apikey, connexion ignor\xe9e");
            return;
        }
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            console.log('WebSocket already connected');
            return;
        }
        // Nouvelle apikey explicite → reset du flag unauthorized pour autoriser une nouvelle tentative
        if (apikey !== this.apikey) this.unauthorized = false;
        if (this.unauthorized) {
            console.warn("WebSocket: apikey pr\xe9c\xe9demment refus\xe9e (401), nouvelle tentative bloqu\xe9e jusqu'au prochain changement d'apikey ou reload");
            return;
        }
        this.apikey = apikey;
        this.isIntentionalClose = false;
        this._notifyListeners('connectionState', 'connecting');
        let session;
        try {
            session = await this._requestSession(apikey);
        } catch (error) {
            if (error && error.status === 401) {
                // Apikey refusée : on bloque toute nouvelle tentative pour éviter un ban d'IP
                console.error("WebSocket: /ureq a retourn\xe9 401, reconnexion d\xe9sactiv\xe9e");
                this.unauthorized = true;
                this._notifyListeners('error', {
                    code: 401,
                    message: "Tablette non autoris\xe9e"
                });
                this._notifyListeners('connectionState', 'disconnected');
                return;
            }
            console.error("WebSocket: \xe9chec de /ureq, nouvelle tentative dans 5s", error);
            this._notifyListeners('connectionState', 'error');
            this._scheduleReconnect();
            return;
        }
        try {
            this.ws = new WebSocket(session.wsUrl, [
                'bearer.' + session.token
            ]);
            this.ws.onopen = ()=>{
                console.log('WebSocket connected');
                this.reconnectAttempts = 0;
                this._startHeartbeat();
                // Send connect message with apikey
                this.send('connect', {});
            };
            this.ws.onmessage = (event)=>{
                this._handleMessage(event);
            };
            this.ws.onclose = (event)=>{
                this._handleClose(event);
            };
            this.ws.onerror = (error)=>{
                console.error('WebSocket error:', error);
                this._notifyListeners('connectionState', 'error');
            };
        } catch (error) {
            console.error('WebSocket connection error:', error);
            this._notifyListeners('connectionState', 'error');
            this._scheduleReconnect();
        }
    }
    async _requestSession(apikey) {
        const response = await fetch($d0560eaae19deb97$export$4fc60f1e9b2c3087, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                apikey: apikey
            })
        });
        if (!response.ok) {
            const err = new Error('ureq HTTP ' + response.status);
            err.status = response.status;
            throw err;
        }
        const data = await response.json();
        if (!data || !data.wsUrl || !data.token) throw new Error("ureq: r\xe9ponse invalide");
        return data;
    }
    disconnect() {
        this.isIntentionalClose = true;
        this._stopHeartbeat();
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
        }
        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
        this._notifyListeners('connectionState', 'disconnected');
    }
    send(dataType, data) {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
            console.warn('WebSocket not connected, cannot send message');
            return false;
        }
        const message = {
            apikey: this.apikey,
            data_type: dataType,
            data: data
        };
        try {
            this.ws.send(JSON.stringify(message));
            return true;
        } catch (error) {
            console.error('Failed to send WebSocket message:', error);
            return false;
        }
    }
    subscribe(messageType, callback) {
        if (!this.listeners.has(messageType)) this.listeners.set(messageType, new Set());
        this.listeners.get(messageType).add(callback);
    }
    unsubscribe(messageType, callback) {
        if (this.listeners.has(messageType)) this.listeners.get(messageType).delete(callback);
    }
    _notifyListeners(messageType, data) {
        if (this.listeners.has(messageType)) this.listeners.get(messageType).forEach((callback)=>{
            try {
                callback(data);
            } catch (error) {
                console.error('Error in listener callback:', error);
            }
        });
    }
    _startHeartbeat() {
        this._stopHeartbeat();
        this.heartbeatInterval = setInterval(()=>{
            if (this.ws && this.ws.readyState === WebSocket.OPEN) this.send('ping', {});
        }, $d0560eaae19deb97$export$572ccec9318f4611);
    }
    _stopHeartbeat() {
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
    }
    _handleMessage(event) {
        try {
            const message = JSON.parse(event.data);
            const { data_type: data_type, data: data } = message;
            switch(data_type){
                case 'pong':
                    break;
                case 'config':
                    this._notifyListeners('connectionState', 'connected');
                    this._notifyListeners('config', data);
                    break;
                case 'transactions':
                    this._notifyListeners('transactions', data);
                    break;
                case 'articles':
                    this._notifyListeners('articles', data);
                    break;
                case 'error':
                    console.error('Server error:', data);
                    this._notifyListeners('error', data);
                    // Check for authentication error
                    if (data.code === 401 || data.code === 'unauthorized') {
                        this.unauthorized = true;
                        this.isIntentionalClose = true;
                        this.disconnect();
                    }
                    break;
                default:
                    console.log('Unknown message type:', data_type, data);
            }
        } catch (error) {
            console.error('Failed to parse WebSocket message:', error);
        }
    }
    _handleClose(event) {
        console.log('WebSocket closed:', event.code, event.reason);
        this._stopHeartbeat();
        this._notifyListeners('connectionState', 'disconnected');
        if (!this.isIntentionalClose && !this.unauthorized) this._scheduleReconnect();
    }
    _scheduleReconnect() {
        if (this.unauthorized || !this.apikey) return;
        if (this.reconnectTimer) return;
        this.reconnectAttempts++;
        console.log(`Reconnecting in 5 seconds... (attempt ${this.reconnectAttempts})`);
        this.reconnectTimer = setTimeout(()=>{
            this.reconnectTimer = null;
            this.connect(this.apikey);
        }, 5000);
    }
    constructor(){
        this.ws = null;
        this.apikey = null;
        this.listeners = new Map();
        this.heartbeatInterval = null;
        this.isIntentionalClose = false;
        this.reconnectAttempts = 0;
        // Si true, on n'essaie plus de se reconnecter automatiquement (apikey refusée par /ureq).
        // Reset uniquement lorsqu'une nouvelle apikey est fournie (changement manuel) ou au reload de la page.
        this.unauthorized = false;
        this.reconnectTimer = null;
    }
}
var $8e8a40cdebdfa979$export$2e2bcd8739ae039 = new $8e8a40cdebdfa979$var$WebSocketService();


const $40a70c7aae85df93$var$WebSocketContext = /*#__PURE__*/ (0, $cQNHH.createContext)();

// Audio for new transactions
const $40a70c7aae85df93$var$pingSound = new Audio((parcelRequire("ktOZw")));
const $40a70c7aae85df93$export$bfafe629242f30bd = ({ children: children, apikey: apikey })=>{
    const [connectionState, setConnectionState] = (0, $cQNHH.useState)('disconnected');
    const [transactions, setTransactions] = (0, $cQNHH.useState)([]);
    const [config, setConfig] = (0, $cQNHH.useState)({
        name: '',
        filters: []
    });
    const [lastUpdate, setLastUpdate] = (0, $cQNHH.useState)(null);
    const [error, setError] = (0, $cQNHH.useState)(null);
    const [availableArticles, setAvailableArticles] = (0, $cQNHH.useState)(null);
    const knownTransactionIds = (0, $cQNHH.useRef)(new Set());
    const isInitialLoad = (0, $cQNHH.useRef)(true);
    // Connect to WebSocket when apikey is available
    (0, $cQNHH.useEffect)(()=>{
        if (!apikey) return;
        // Subscribe to WebSocket events
        const handleConnectionState = (state)=>{
            setConnectionState(state);
            if (state === 'disconnected' || state === 'error') setError(state === 'error' ? 'Erreur de connexion' : null);
        };
        const handleConfig = (data)=>{
            setConfig({
                name: data.name || '',
                filters: data.filters || []
            });
            setError(null);
        };
        const handleTransactions = (data)=>{
            if (data.data) {
                // Sort by epoch ascending (oldest first)
                const sortedData = [
                    ...data.data
                ].sort((a, b)=>a.epoch - b.epoch);
                // Check for new transactions (not on initial load)
                if (!isInitialLoad.current) {
                    const currentIds = new Set(sortedData.map((t)=>t.id));
                    const hasNewTransaction = sortedData.some((t)=>!knownTransactionIds.current.has(t.id));
                    if (hasNewTransaction) $40a70c7aae85df93$var$pingSound.play().catch((e)=>console.log('Audio play failed:', e));
                } else isInitialLoad.current = false;
                // Update known transaction IDs
                knownTransactionIds.current = new Set(sortedData.map((t)=>t.id));
                setTransactions(sortedData);
            }
            if (data.datetime_update) setLastUpdate(data.datetime_update);
        };
        const handleError = (data)=>{
            if (data.code === 401 || data.code === 'unauthorized') setError("Tablette non autoris\xe9e");
            else setError(data.message || 'Erreur serveur');
        };
        const handleArticles = (data)=>{
            setAvailableArticles(data);
        };
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).subscribe('connectionState', handleConnectionState);
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).subscribe('config', handleConfig);
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).subscribe('transactions', handleTransactions);
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).subscribe('error', handleError);
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).subscribe('articles', handleArticles);
        // Connect
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).connect(apikey);
        // Cleanup on unmount
        return ()=>{
            (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).unsubscribe('connectionState', handleConnectionState);
            (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).unsubscribe('config', handleConfig);
            (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).unsubscribe('transactions', handleTransactions);
            (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).unsubscribe('error', handleError);
            (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).unsubscribe('articles', handleArticles);
            (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).disconnect();
        };
    }, [
        apikey
    ]);
    // Action: validate transaction
    const validate = (0, $cQNHH.useCallback)((id, id_lieu)=>{
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).send('validation', [
            {
                id: id,
                id_lieu: id_lieu
            }
        ]);
    }, []);
    // Action: toggle ownership
    const toggleOwnership = (0, $cQNHH.useCallback)((id, id_lieu)=>{
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).send('toggleOwnership', [
            {
                id: id,
                id_lieu: id_lieu
            }
        ]);
    }, []);
    // Action: add images
    const addImages = (0, $cQNHH.useCallback)((id, id_lieu, images_uuid)=>{
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).send('addImages', [
            {
                id: id,
                id_lieu: id_lieu,
                images: images_uuid
            }
        ]);
    }, []);
    // Action: request available articles
    const requestArticles = (0, $cQNHH.useCallback)((id, id_lieu)=>{
        setAvailableArticles(null);
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).send('getArticles', [
            {
                id: id,
                id_lieu: id_lieu
            }
        ]);
    }, []);
    // Action: change article
    const changeArticle = (0, $cQNHH.useCallback)((id, id_lieu, article_id)=>{
        (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).send('changeArticle', [
            {
                id: id,
                id_lieu: id_lieu,
                article_id: article_id
            }
        ]);
    }, []);
    // Clear available articles
    const clearArticles = (0, $cQNHH.useCallback)(()=>{
        setAvailableArticles(null);
    }, []);
    // Manual reconnect
    const reconnect = (0, $cQNHH.useCallback)(()=>{
        if (apikey) {
            (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).disconnect();
            (0, $8e8a40cdebdfa979$export$2e2bcd8739ae039).connect(apikey);
        }
    }, [
        apikey
    ]);
    const value = {
        connectionState: connectionState,
        transactions: transactions,
        config: config,
        lastUpdate: lastUpdate,
        error: error,
        availableArticles: availableArticles,
        validate: validate,
        toggleOwnership: toggleOwnership,
        addImages: addImages,
        requestArticles: requestArticles,
        changeArticle: changeArticle,
        clearArticles: clearArticles,
        reconnect: reconnect
    };
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)($40a70c7aae85df93$var$WebSocketContext.Provider, {
        value: value,
        children: children
    });
};
const $40a70c7aae85df93$export$ef4944d05bd3db0 = ()=>{
    const context = (0, $cQNHH.useContext)($40a70c7aae85df93$var$WebSocketContext);
    if (!context) throw new Error('useWebSocket must be used within a WebSocketProvider');
    return context;
};
var $40a70c7aae85df93$export$2e2bcd8739ae039 = $40a70c7aae85df93$var$WebSocketContext;


const $6a772d7f25f6a077$var$MainPage = ({ apikey: apikey, error: error })=>{
    const { transactions: transactions, connectionState: connectionState, validate: validate, toggleOwnership: toggleOwnership, requestArticles: requestArticles, changeArticle: changeArticle, clearArticles: clearArticles, availableArticles: availableArticles } = (0, $40a70c7aae85df93$export$ef4944d05bd3db0)();
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
        children: [
            connectionState === 'disconnected' && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $e436d619efaf7134$export$2e2bcd8739ae039), {
                fluid: "xl",
                className: "mt-4",
                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $629fe0b1bdf276d1$export$2e2bcd8739ae039), {
                    variant: "warning",
                    children: "Connexion perdue, reconnexion..."
                })
            }),
            connectionState === 'connecting' && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $e436d619efaf7134$export$2e2bcd8739ae039), {
                fluid: "xl",
                className: "mt-4",
                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $629fe0b1bdf276d1$export$2e2bcd8739ae039), {
                    variant: "info",
                    children: "Essai de connexion..."
                })
            }),
            error && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $e436d619efaf7134$export$2e2bcd8739ae039), {
                fluid: "xl",
                className: "mt-4",
                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $629fe0b1bdf276d1$export$2e2bcd8739ae039), {
                    variant: "danger",
                    children: error
                })
            }),
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $e436d619efaf7134$export$2e2bcd8739ae039), {
                fluid: "xl",
                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $01ff746bbcd1581e$export$2e2bcd8739ae039), {
                    transactions: transactions,
                    onToggleOwnership: toggleOwnership,
                    onValidate: validate,
                    onRequestArticles: requestArticles,
                    onChangeArticle: changeArticle,
                    onClearArticles: clearArticles,
                    availableArticles: availableArticles,
                    disabled: connectionState !== 'connected'
                })
            })
        ]
    });
};
var $6a772d7f25f6a077$export$2e2bcd8739ae039 = $6a772d7f25f6a077$var$MainPage;



parcelRequire("cQNHH");





var $cQNHH = parcelRequire("cQNHH");
/**
 * Runs an effect only when the dependencies have changed, skipping the
 * initial "on mount" run. Caution, if the dependency list never changes,
 * the effect is **never run**
 *
 * ```ts
 *  const ref = useRef<HTMLInput>(null);
 *
 *  // focuses an element only if the focus changes, and not on mount
 *  useUpdateEffect(() => {
 *    const element = ref.current?.children[focusedIdx] as HTMLElement
 *
 *    element?.focus()
 *
 *  }, [focusedIndex])
 * ```
 * @param effect An effect to run on mount
 *
 * @category effects
 */ function $6ec47605b58f8473$var$useUpdateEffect(fn, deps) {
    const isFirst = (0, $cQNHH.useRef)(true);
    (0, $cQNHH.useEffect)(()=>{
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }
        return fn();
    }, deps);
}
var $6ec47605b58f8473$export$2e2bcd8739ae039 = $6ec47605b58f8473$var$useUpdateEffect;




var $cQNHH = parcelRequire("cQNHH");

var $cQNHH = parcelRequire("cQNHH");
function $9627506f51552ddc$export$2e2bcd8739ae039() {
    const mounted = (0, $cQNHH.useRef)(true);
    const isMounted = (0, $cQNHH.useRef)(()=>mounted.current);
    (0, $cQNHH.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $882b5c94384acc0c$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $882b5c94384acc0c$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $882b5c94384acc0c$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$882b5c94384acc0c$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $882b5c94384acc0c$var$MAX_DELAY_MS);
}
function $882b5c94384acc0c$export$2e2bcd8739ae039() {
    const isMounted = (0, $9627506f51552ddc$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $cQNHH.useRef)();
    (0, $3b976e16857a6ec0$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $cQNHH.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $882b5c94384acc0c$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $882b5c94384acc0c$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}





var $cQNHH = parcelRequire("cQNHH");




var $cQNHH = parcelRequire("cQNHH");



"use client";
const $b70a32db333bf721$var$CarouselCaption = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { className: className, bsPrefix: bsPrefix, as: Component = 'div' } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "className",
        "bsPrefix",
        "as"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'carousel-caption');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, bsPrefix)
    }, props));
});
$b70a32db333bf721$var$CarouselCaption.displayName = 'CarouselCaption';
var $b70a32db333bf721$export$2e2bcd8739ae039 = $b70a32db333bf721$var$CarouselCaption;







var $cQNHH = parcelRequire("cQNHH");


"use client";
const $bad9a6a35f218fbf$var$CarouselItem = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', bsPrefix: bsPrefix, className: className } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "as",
        "bsPrefix",
        "className"
    ]);
    const finalClassName = (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'carousel-item'));
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: finalClassName
    }));
});
$bad9a6a35f218fbf$var$CarouselItem.displayName = 'CarouselItem';
var $bad9a6a35f218fbf$export$2e2bcd8739ae039 = $bad9a6a35f218fbf$var$CarouselItem;



var $cQNHH = parcelRequire("cQNHH");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $92719f3d9d4d04e6$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $cQNHH.Children.map(children, (child)=>/*#__PURE__*/ $cQNHH.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $92719f3d9d4d04e6$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $cQNHH.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $cQNHH.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $92719f3d9d4d04e6$export$500fd6099226ffae(children, type) {
    return $cQNHH.Children.toArray(children).some((child)=>/*#__PURE__*/ $cQNHH.isValidElement(child) && child.type === type);
}







"use client";
const $8b2552f88dc3d5b1$var$SWIPE_THRESHOLD = 40;
function $8b2552f88dc3d5b1$var$isVisible(element) {
    if (!element || !element.style || !element.parentNode || !element.parentNode.style) return false;
    const elementStyle = getComputedStyle(element);
    return elementStyle.display !== 'none' && elementStyle.visibility !== 'hidden' && getComputedStyle(element.parentNode).display !== 'none';
}
const $8b2552f88dc3d5b1$var$Carousel = /*#__PURE__*/ // eslint-disable-next-line react/display-name
$cQNHH.forwardRef((_param, ref)=>{
    var { defaultActiveIndex: defaultActiveIndex = 0 } = _param, uncontrolledProps = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "defaultActiveIndex"
    ]);
    const _useUncontrolled = (0, $652b4200927b0439$export$2e2bcd8739ae039)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        defaultActiveIndex: defaultActiveIndex
    }, uncontrolledProps), {
        activeIndex: 'onSelect'
    }), { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', bsPrefix: bsPrefix, slide: slide = true, fade: fade = false, controls: controls = true, indicators: indicators = true, indicatorLabels: indicatorLabels = [], activeIndex: activeIndex, onSelect: onSelect, onSlide: onSlide, onSlid: onSlid, interval: interval = 5000, keyboard: keyboard = true, onKeyDown: onKeyDown, pause: pause = 'hover', onMouseOver: onMouseOver, onMouseOut: onMouseOut, wrap: wrap = true, touch: touch = true, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, prevIcon: prevIcon = /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("span", {
        "aria-hidden": "true",
        className: "carousel-control-prev-icon"
    }), prevLabel: prevLabel = 'Previous', nextIcon: nextIcon = /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("span", {
        "aria-hidden": "true",
        className: "carousel-control-next-icon"
    }), nextLabel: nextLabel = 'Next', variant: variant, className: className, children: children } = _useUncontrolled, props = (0, $579302c8e6721842$export$71511d61b312f219)(_useUncontrolled, [
        "as",
        "bsPrefix",
        "slide",
        "fade",
        "controls",
        "indicators",
        "indicatorLabels",
        "activeIndex",
        "onSelect",
        "onSlide",
        "onSlid",
        "interval",
        "keyboard",
        "onKeyDown",
        "pause",
        "onMouseOver",
        "onMouseOut",
        "wrap",
        "touch",
        "onTouchStart",
        "onTouchMove",
        "onTouchEnd",
        "prevIcon",
        "prevLabel",
        "nextIcon",
        "nextLabel",
        "variant",
        "className",
        "children"
    ]);
    const prefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'carousel');
    const isRTL = (0, $d344ef3e3248c0b3$export$35e511eefa30ac5a)();
    const nextDirectionRef = (0, $cQNHH.useRef)(null);
    const [direction, setDirection] = (0, $cQNHH.useState)('next');
    const [paused, setPaused] = (0, $cQNHH.useState)(false);
    const [isSliding, setIsSliding] = (0, $cQNHH.useState)(false);
    const [renderedActiveIndex, setRenderedActiveIndex] = (0, $cQNHH.useState)(activeIndex || 0);
    (0, $cQNHH.useEffect)(()=>{
        if (!isSliding && activeIndex !== renderedActiveIndex) {
            if (nextDirectionRef.current) setDirection(nextDirectionRef.current);
            else setDirection((activeIndex || 0) > renderedActiveIndex ? 'next' : 'prev');
            if (slide) setIsSliding(true);
            setRenderedActiveIndex(activeIndex || 0);
        }
    }, [
        activeIndex,
        isSliding,
        renderedActiveIndex,
        slide
    ]);
    (0, $cQNHH.useEffect)(()=>{
        if (nextDirectionRef.current) nextDirectionRef.current = null;
    });
    let numChildren = 0;
    let activeChildInterval;
    // Iterate to grab all of the children's interval values
    // (and count them, too)
    (0, $92719f3d9d4d04e6$export$4b80e395e36b5a56)(children, (child, index)=>{
        ++numChildren;
        if (index === activeIndex) activeChildInterval = child.props.interval;
    });
    const activeChildIntervalRef = (0, $c8a441000e63d6ea$export$2e2bcd8739ae039)(activeChildInterval);
    const prev = (0, $cQNHH.useCallback)((event)=>{
        if (isSliding) return;
        let nextActiveIndex = renderedActiveIndex - 1;
        if (nextActiveIndex < 0) {
            if (!wrap) return;
            nextActiveIndex = numChildren - 1;
        }
        nextDirectionRef.current = 'prev';
        onSelect == null || onSelect(nextActiveIndex, event);
    }, [
        isSliding,
        renderedActiveIndex,
        onSelect,
        wrap,
        numChildren
    ]);
    // This is used in the setInterval, so it should not invalidate.
    const next = (0, $69b21c98023fc358$export$2e2bcd8739ae039)((event)=>{
        if (isSliding) return;
        let nextActiveIndex = renderedActiveIndex + 1;
        if (nextActiveIndex >= numChildren) {
            if (!wrap) return;
            nextActiveIndex = 0;
        }
        nextDirectionRef.current = 'next';
        onSelect == null || onSelect(nextActiveIndex, event);
    });
    const elementRef = (0, $cQNHH.useRef)();
    (0, $cQNHH.useImperativeHandle)(ref, ()=>({
            element: elementRef.current,
            prev: prev,
            next: next
        }));
    // This is used in the setInterval, so it should not invalidate.
    const nextWhenVisible = (0, $69b21c98023fc358$export$2e2bcd8739ae039)(()=>{
        if (!document.hidden && $8b2552f88dc3d5b1$var$isVisible(elementRef.current)) {
            if (isRTL) prev();
            else next();
        }
    });
    const slideDirection = direction === 'next' ? 'start' : 'end';
    (0, $6ec47605b58f8473$export$2e2bcd8739ae039)(()=>{
        if (slide) // These callbacks will be handled by the <Transition> callbacks.
        return;
        onSlide == null || onSlide(renderedActiveIndex, slideDirection);
        onSlid == null || onSlid(renderedActiveIndex, slideDirection);
    }, [
        renderedActiveIndex
    ]);
    const orderClassName = `${prefix}-item-${direction}`;
    const directionalClassName = `${prefix}-item-${slideDirection}`;
    const handleEnter = (0, $cQNHH.useCallback)((node)=>{
        (0, $be2ac794c4d224bb$export$2e2bcd8739ae039)(node);
        onSlide == null || onSlide(renderedActiveIndex, slideDirection);
    }, [
        onSlide,
        renderedActiveIndex,
        slideDirection
    ]);
    const handleEntered = (0, $cQNHH.useCallback)(()=>{
        setIsSliding(false);
        onSlid == null || onSlid(renderedActiveIndex, slideDirection);
    }, [
        onSlid,
        renderedActiveIndex,
        slideDirection
    ]);
    const handleKeyDown = (0, $cQNHH.useCallback)((event)=>{
        if (keyboard && !/input|textarea/i.test(event.target.tagName)) switch(event.key){
            case 'ArrowLeft':
                event.preventDefault();
                if (isRTL) next(event);
                else prev(event);
                return;
            case 'ArrowRight':
                event.preventDefault();
                if (isRTL) prev(event);
                else next(event);
                return;
            default:
        }
        onKeyDown == null || onKeyDown(event);
    }, [
        keyboard,
        onKeyDown,
        prev,
        next,
        isRTL
    ]);
    const handleMouseOver = (0, $cQNHH.useCallback)((event)=>{
        if (pause === 'hover') setPaused(true);
        onMouseOver == null || onMouseOver(event);
    }, [
        pause,
        onMouseOver
    ]);
    const handleMouseOut = (0, $cQNHH.useCallback)((event)=>{
        setPaused(false);
        onMouseOut == null || onMouseOut(event);
    }, [
        onMouseOut
    ]);
    const touchStartXRef = (0, $cQNHH.useRef)(0);
    const touchDeltaXRef = (0, $cQNHH.useRef)(0);
    const touchUnpauseTimeout = (0, $882b5c94384acc0c$export$2e2bcd8739ae039)();
    const handleTouchStart = (0, $cQNHH.useCallback)((event)=>{
        touchStartXRef.current = event.touches[0].clientX;
        touchDeltaXRef.current = 0;
        if (pause === 'hover') setPaused(true);
        onTouchStart == null || onTouchStart(event);
    }, [
        pause,
        onTouchStart
    ]);
    const handleTouchMove = (0, $cQNHH.useCallback)((event)=>{
        if (event.touches && event.touches.length > 1) touchDeltaXRef.current = 0;
        else touchDeltaXRef.current = event.touches[0].clientX - touchStartXRef.current;
        onTouchMove == null || onTouchMove(event);
    }, [
        onTouchMove
    ]);
    const handleTouchEnd = (0, $cQNHH.useCallback)((event)=>{
        if (touch) {
            const touchDeltaX = touchDeltaXRef.current;
            if (Math.abs(touchDeltaX) > $8b2552f88dc3d5b1$var$SWIPE_THRESHOLD) {
                if (touchDeltaX > 0) prev(event);
                else next(event);
            }
        }
        if (pause === 'hover') touchUnpauseTimeout.set(()=>{
            setPaused(false);
        }, interval || undefined);
        onTouchEnd == null || onTouchEnd(event);
    }, [
        touch,
        pause,
        prev,
        next,
        touchUnpauseTimeout,
        interval,
        onTouchEnd
    ]);
    const shouldPlay = interval != null && !paused && !isSliding;
    const intervalHandleRef = (0, $cQNHH.useRef)();
    (0, $cQNHH.useEffect)(()=>{
        var _ref, _activeChildIntervalR;
        if (!shouldPlay) return undefined;
        const nextFunc = isRTL ? prev : next;
        intervalHandleRef.current = window.setInterval(document.visibilityState ? nextWhenVisible : nextFunc, (_ref = (_activeChildIntervalR = activeChildIntervalRef.current) != null ? _activeChildIntervalR : interval) != null ? _ref : undefined);
        return ()=>{
            if (intervalHandleRef.current !== null) clearInterval(intervalHandleRef.current);
        };
    }, [
        shouldPlay,
        prev,
        next,
        activeChildIntervalRef,
        interval,
        nextWhenVisible,
        isRTL
    ]);
    const indicatorOnClicks = (0, $cQNHH.useMemo)(()=>indicators && Array.from({
            length: numChildren
        }, (_, index)=>(event)=>{
                onSelect == null || onSelect(index, event);
            }), [
        indicators,
        numChildren,
        onSelect
    ]);
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)(Component, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: elementRef
    }, props), {
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, prefix, slide && 'slide', fade && `${prefix}-fade`, variant && `${prefix}-${variant}`),
        children: [
            indicators && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                className: `${prefix}-indicators`,
                children: (0, $92719f3d9d4d04e6$export$871de8747c9eaa88)(children, (_, index)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("button", {
                        type: "button",
                        "data-bs-target": "" // Bootstrap requires this in their css.
                        ,
                        "aria-label": indicatorLabels != null && indicatorLabels.length ? indicatorLabels[index] : `Slide ${index + 1}`,
                        className: index === renderedActiveIndex ? 'active' : undefined,
                        onClick: indicatorOnClicks ? indicatorOnClicks[index] : undefined,
                        "aria-current": index === renderedActiveIndex
                    }, index))
            }),
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                className: `${prefix}-inner`,
                children: (0, $92719f3d9d4d04e6$export$871de8747c9eaa88)(children, (child, index)=>{
                    const isActive = index === renderedActiveIndex;
                    return slide ? /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $4f424d8179975d2e$export$2e2bcd8739ae039), {
                        in: isActive,
                        onEnter: isActive ? handleEnter : undefined,
                        onEntered: isActive ? handleEntered : undefined,
                        addEndListener: (0, $b6a25d5e3e9a5dbf$export$2e2bcd8739ae039),
                        children: (status, innerProps)=>/*#__PURE__*/ $cQNHH.cloneElement(child, (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, innerProps), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(child.props.className, isActive && status !== 'entered' && orderClassName, (status === 'entered' || status === 'exiting') && 'active', (status === 'entering' || status === 'exiting') && directionalClassName)
                            }))
                    }) : /*#__PURE__*/ $cQNHH.cloneElement(child, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(child.props.className, isActive && 'active')
                    });
                })
            }),
            controls && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
                children: [
                    (wrap || activeIndex !== 0) && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $06c585a3e6ab5540$export$2e2bcd8739ae039), {
                        className: `${prefix}-control-prev`,
                        onClick: prev,
                        children: [
                            prevIcon,
                            prevLabel && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: prevLabel
                            })
                        ]
                    }),
                    (wrap || activeIndex !== numChildren - 1) && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $06c585a3e6ab5540$export$2e2bcd8739ae039), {
                        className: `${prefix}-control-next`,
                        onClick: next,
                        children: [
                            nextIcon,
                            nextLabel && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: nextLabel
                            })
                        ]
                    })
                ]
            })
        ]
    }));
});
$8b2552f88dc3d5b1$var$Carousel.displayName = 'Carousel';
var $8b2552f88dc3d5b1$export$2e2bcd8739ae039 = Object.assign($8b2552f88dc3d5b1$var$Carousel, {
    Caption: (0, $b70a32db333bf721$export$2e2bcd8739ae039),
    Item: (0, $bad9a6a35f218fbf$export$2e2bcd8739ae039)
});




const $c5de6da1aa9d12a8$var$PhotosPage = (props)=>{
    const location = (0, $0426bdd60799df9e$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $e436d619efaf7134$export$2e2bcd8739ae039), {
        fluid: "xl",
        className: "mt-4",
        children: [
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                className: "d-flex justify-content-start",
                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $a77787966cb87b36$export$a6c7ac8248d6e38a), {
                    to: "/camera",
                    role: "button",
                    className: "btn btn-primary btn-lg mb-4",
                    state: {
                        images: location.state.images,
                        id: location.state.id,
                        id_lieu: location.state.id_lieu,
                        apikey: props.apikey
                    },
                    children: "Ajouter une photo"
                })
            }),
            location.state.images.length > 0 ? /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $8b2552f88dc3d5b1$export$2e2bcd8739ae039), {
                interval: null,
                touch: false,
                controls: location.state.images.length > 1,
                indicators: location.state.images.length > 1,
                children: location.state.images.map((f)=>/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $8b2552f88dc3d5b1$export$2e2bcd8739ae039).Item, {
                        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("img", {
                            className: "d-block w-100",
                            style: {
                                minHeight: 200
                            },
                            src: $d0560eaae19deb97$export$739733bcb6130343 + '/api/manage.php?apikey=' + props.apikey + '&function=getimage&uuid=' + f
                        })
                    }))
            }) : /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("h1", {
                    children: "pas de photo disponible"
                })
            })
        ]
    });
};
var $c5de6da1aa9d12a8$export$2e2bcd8739ae039 = $c5de6da1aa9d12a8$var$PhotosPage;




var $cQNHH = parcelRequire("cQNHH");



var $2d451a4cdf0d942d$exports = {};

!function(V, t) {
    var e, n;
    $2d451a4cdf0d942d$exports = t((parcelRequire("cQNHH")));
}($2d451a4cdf0d942d$exports, function(V) {
    return function(V) {
        function t(n) {
            if (e[n]) return e[n].exports;
            var r = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return V[n].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
        }
        var e = {};
        return t.m = V, t.c = e, t.d = function(V, e, n) {
            t.o(V, e) || Object.defineProperty(V, e, {
                configurable: !1,
                enumerable: !0,
                get: n
            });
        }, t.n = function(V) {
            var e = V && V.__esModule ? function() {
                return V.default;
            } : function() {
                return V;
            };
            return t.d(e, "a", e), e;
        }, t.o = function(V, t) {
            return Object.prototype.hasOwnProperty.call(V, t);
        }, t.p = "", t(t.s = 3);
    }([
        function(t, e) {
            t.exports = V;
        },
        function(V, t, e) {
            V.exports = e(7)();
        },
        function(V, t, e) {
            !function(t, e) {
                V.exports = e();
            }(0, function() {
                return function(V) {
                    function t(n) {
                        if (e[n]) return e[n].exports;
                        var r = e[n] = {
                            i: n,
                            l: !1,
                            exports: {}
                        };
                        return V[n].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
                    }
                    var e = {};
                    return t.m = V, t.c = e, t.d = function(V, e, n) {
                        t.o(V, e) || Object.defineProperty(V, e, {
                            configurable: !1,
                            enumerable: !0,
                            get: n
                        });
                    }, t.n = function(V) {
                        var e = V && V.__esModule ? function() {
                            return V.default;
                        } : function() {
                            return V;
                        };
                        return t.d(e, "a", e), e;
                    }, t.o = function(V, t) {
                        return Object.prototype.hasOwnProperty.call(V, t);
                    }, t.p = "", t(t.s = 4);
                }([
                    function(V, t, e) {
                        "use strict";
                        e.d(t, "b", function() {
                            return i;
                        }), e.d(t, "c", function() {
                            return o;
                        });
                        var n = e(1), r = e(7);
                        e.d(t, "a", function() {
                            return r.a;
                        }), e.d(t, "d", function() {
                            return n.b;
                        });
                        var i = n.a.FACING_MODES, o = n.a.IMAGE_TYPES;
                    },
                    function(V, t, e) {
                        "use strict";
                        var n = e(6);
                        e.d(t, "a", function() {
                            return n.a;
                        });
                        var r = e(2);
                        e.d(t, "b", function() {
                            return r.a;
                        });
                    },
                    function(V, t, e) {
                        "use strict";
                        function n(V, t) {
                            if (!(t >= 0 && t <= 1)) throw new Error(t + " is invalid imageCompression, choose between: [0, 1]");
                            if (!f.f.includes(V)) throw new Error(V + " is invalid imageType, choose between: " + f.f.join(", "));
                            return !0;
                        }
                        function r(V, t) {
                            var e = {};
                            try {
                                n(V, t), e.imageType = V, e.imageCompression = t;
                            } catch (V) {
                                console.error(V), console.error("default value of " + f.c.PNG + " is used"), e.imageType = f.c.PNG, e.imageCompression = null;
                            }
                            return e;
                        }
                        function i() {
                            var V = window.navigator.platform, t = window.navigator.userAgent;
                            return V || t;
                        }
                        function o() {
                            return "ontouchend" in document;
                        }
                        function a(V, t, e) {
                            var n = V * parseFloat(e);
                            return {
                                imageWidth: n,
                                imageHeight: t / (V / n)
                            };
                        }
                        function u(V, t, e) {
                            return r(t, e).imageType === f.c.JPG ? e ? V.toDataURL(f.b[f.c.JPG], e) : V.toDataURL(f.b[f.c.JPG]) : V.toDataURL(f.b[t]);
                        }
                        function c(V, t) {
                            return V || t;
                        }
                        function A() {
                            var V = i();
                            if (/iPad|iPhone|iPod/.test(V)) return !0;
                            var t = o();
                            return !(!/Mac/.test(V) || !t);
                        }
                        function s() {
                            return {
                                userAgent: window.navigator.userAgent,
                                platform: window.navigator.platform,
                                _getStringWithPlatform: i(),
                                _getHasTouchEvents: o(),
                                getIsIOS: A()
                            };
                        }
                        t.c = a, t.b = u, t.e = c, t.d = A, t.a = s;
                        var f = e(3);
                    },
                    function(V, t, e) {
                        "use strict";
                        function n(V, t, e) {
                            return t in V ? Object.defineProperty(V, t, {
                                value: e,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : V[t] = e, V;
                        }
                        e.d(t, "e", function() {
                            return i;
                        }), e.d(t, "a", function() {
                            return o;
                        }), e.d(t, "f", function() {
                            return a;
                        }), e.d(t, "c", function() {
                            return u;
                        }), e.d(t, "b", function() {
                            return c;
                        }), e.d(t, "d", function() {
                            return A;
                        });
                        var r, i = [
                            "user",
                            "environment"
                        ], o = {
                            USER: "user",
                            ENVIRONMENT: "environment"
                        }, a = [
                            "jpg",
                            "png"
                        ], u = {
                            PNG: "png",
                            JPG: "jpg"
                        }, c = (r = {}, n(r, "jpg", "image/jpeg"), n(r, "png", "image/png"), r), A = {
                            audio: !1,
                            video: !0
                        };
                    },
                    function(V, t, e) {
                        V.exports = e(5);
                    },
                    function(V, t, e) {
                        "use strict";
                        Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                        var n = e(0);
                        e.d(t, "FACING_MODES", function() {
                            return n.b;
                        }), e.d(t, "IMAGE_TYPES", function() {
                            return n.c;
                        }), e.d(t, "_getDebugPlatformInfo", function() {
                            return n.d;
                        });
                        var r = e(9);
                        e.d(t, "downloadPhoto", function() {
                            return r.a;
                        }), t.default = n.a;
                    },
                    function(V, t, e) {
                        "use strict";
                        function n(V, t) {
                            if (!(V instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }
                        e.d(t, "a", function() {
                            return a;
                        });
                        var r = e(2), i = e(3), o = function() {
                            function V(V, t) {
                                for(var e = 0; e < t.length; e++){
                                    var n = t[e];
                                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(V, n.key, n);
                                }
                            }
                            return function(t, e, n) {
                                return e && V(t.prototype, e), n && V(t, n), t;
                            };
                        }(), a = function() {
                            function V() {
                                n(this, V);
                            }
                            return o(V, null, [
                                {
                                    key: "getDataUri",
                                    value: function(V, t) {
                                        var e = t.sizeFactor, n = t.imageType, i = t.imageCompression, o = t.isImageMirror, a = V.videoWidth, u = V.videoHeight, c = Object(r.c)(a, u, e), A = c.imageWidth, s = c.imageHeight, f = document.createElement("canvas");
                                        f.width = A, f.height = s;
                                        var l = f.getContext("2d");
                                        return o && l.setTransform(-1, 0, 0, 1, f.width, 0), l.drawImage(V, 0, 0, A, s), Object(r.b)(f, n, i);
                                    }
                                },
                                {
                                    key: "getWindowURL",
                                    value: function() {
                                        return window.URL || window.webkitURL || window.mozURL || window.msURL;
                                    }
                                },
                                {
                                    key: "getNavigatorMediaDevices",
                                    value: function() {
                                        var V = null, t = !(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia), e = !(!navigator.mozGetUserMedia && !navigator.webkitGetUserMedia);
                                        if (t) V = navigator.mediaDevices;
                                        else if (e) {
                                            var n = navigator.mozGetUserMedia || navigator.webkitGetUserMedia, r = {
                                                getUserMedia: function(V) {
                                                    return new Promise(function(t, e) {
                                                        n.call(navigator, V, t, e);
                                                    });
                                                }
                                            };
                                            V = Object.assign(n, r);
                                        }
                                        return V;
                                    }
                                },
                                {
                                    key: "isSupportedFacingMode",
                                    value: function() {
                                        return V.getNavigatorMediaDevices().getSupportedConstraints().facingMode;
                                    }
                                },
                                {
                                    key: "getIdealConstraints",
                                    value: function(t, e) {
                                        if (!Object(r.e)(t, e)) return i.d;
                                        var n = V.getNavigatorMediaDevices().getSupportedConstraints();
                                        if (!n.width || !n.height) return console.error("Constraint width or height not supported! fallback to default resolution"), i.d;
                                        var o = void 0, a = void 0;
                                        return t && (i.e.includes(t) ? o = t : a = {
                                            exact: t
                                        }), {
                                            audio: !1,
                                            video: {
                                                facingMode: o,
                                                deviceId: a,
                                                width: e && e.width,
                                                height: e && e.height
                                            }
                                        };
                                    }
                                },
                                {
                                    key: "getMaxResolutionConstraints",
                                    value: function() {
                                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", e = arguments[1];
                                        console.warn("getMaxResolutionConstraints() numberOfMaxResolutionTry:", e);
                                        var n = [
                                            {
                                                width: {
                                                    min: 640
                                                }
                                            },
                                            {
                                                width: {
                                                    min: 800
                                                }
                                            },
                                            {
                                                width: {
                                                    min: 900
                                                }
                                            },
                                            {
                                                width: {
                                                    min: 1024
                                                }
                                            },
                                            {
                                                width: {
                                                    min: 1080
                                                }
                                            },
                                            {
                                                width: {
                                                    min: 1280
                                                }
                                            },
                                            {
                                                width: {
                                                    min: 1920
                                                }
                                            },
                                            {
                                                width: {
                                                    min: 2560
                                                }
                                            },
                                            {
                                                width: {
                                                    min: 3840
                                                }
                                            }
                                        ], i = V.getIdealConstraints(t, {});
                                        if (0 === e) return Object(r.d)() ? (console.warn("fallback to iOS constraints"), V.getIdealConstraints(t, {
                                            width: {
                                                min: 640,
                                                ideal: 3840
                                            },
                                            height: {
                                                min: 480,
                                                ideal: 2160
                                            }
                                        })) : (i.video.advanced = n, i);
                                        if (e < n.length) {
                                            var o = n.slice(0, -e);
                                            return i.video.advanced = o, i;
                                        }
                                        return null;
                                    }
                                },
                                {
                                    key: "FACING_MODES",
                                    get: function() {
                                        return i.a;
                                    }
                                },
                                {
                                    key: "IMAGE_TYPES",
                                    get: function() {
                                        return i.c;
                                    }
                                }
                            ]), V;
                        }();
                    },
                    function(V, t, e) {
                        "use strict";
                        function n(V, t) {
                            if (!(V instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }
                        e.d(t, "a", function() {
                            return u;
                        });
                        var r = e(1), i = e(8), o = function() {
                            function V(V, t) {
                                for(var e = 0; e < t.length; e++){
                                    var n = t[e];
                                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(V, n.key, n);
                                }
                            }
                            return function(t, e, n) {
                                return e && V(t.prototype, e), n && V(t, n), t;
                            };
                        }(), a = r.a.IMAGE_TYPES.PNG, u = function() {
                            function V(t) {
                                n(this, V), this.videoElement = t, this.stream = null, this.numberOfMaxResolutionTry = 0, this.settings = null, this.cameras = [], this.windowURL = r.a.getWindowURL(), this.mediaDevices = r.a.getNavigatorMediaDevices();
                            }
                            return o(V, [
                                {
                                    key: "_getStreamDevice",
                                    value: function(V, t) {
                                        var e = this;
                                        return new Promise(function(n, i) {
                                            var o = r.a.getIdealConstraints(V, t);
                                            e.mediaDevices.getUserMedia(o).then(function(V) {
                                                e._gotStream(V), n(V);
                                            }).catch(function(V) {
                                                i(V);
                                            });
                                        });
                                    }
                                },
                                {
                                    key: "_getStreamDeviceMaxResolution",
                                    value: function(V) {
                                        var t = this, e = r.a.getMaxResolutionConstraints(V, this.numberOfMaxResolutionTry);
                                        if (null == e) {
                                            var n = {};
                                            return this._getStreamDevice(V, n);
                                        }
                                        return new Promise(function(n, r) {
                                            t.mediaDevices.getUserMedia(e).then(function(V) {
                                                t._gotStream(V), n(V);
                                            }).catch(function(e) {
                                                setTimeout(function() {
                                                    t.numberOfMaxResolutionTry += 1, t._getStreamDeviceMaxResolution(V).catch(function() {
                                                        r(e);
                                                    });
                                                }, 20);
                                            });
                                        });
                                    }
                                },
                                {
                                    key: "_setVideoSrc",
                                    value: function(V) {
                                        if ("srcObject" in this.videoElement) this.videoElement.srcObject = V;
                                        else {
                                            var t = this.windowURL.createObjectURL(V);
                                            this.videoElement.src = t;
                                        }
                                    }
                                },
                                {
                                    key: "_setSettings",
                                    value: function(V) {
                                        this.settings = null;
                                        var t = V && V.getTracks ? V.getTracks() : [];
                                        t.length > 0 && t[0].getSettings && (this.settings = t[0].getSettings());
                                    }
                                },
                                {
                                    key: "_enumerateCamerasPromise",
                                    value: function() {
                                        var V = this;
                                        return new Promise(function(t, e) {
                                            var n = [];
                                            V.mediaDevices.enumerateDevices().then(function(V) {
                                                V.forEach(function(V) {
                                                    "videoinput" === V.kind && V.deviceId && n.push(V);
                                                }), t(n);
                                            }).catch(function(V) {
                                                e(V);
                                            });
                                        });
                                    }
                                },
                                {
                                    key: "_gotStream",
                                    value: function(V) {
                                        this.stream = V, this._setSettings(V), this._setVideoSrc(V);
                                    }
                                },
                                {
                                    key: "getCameraSettings",
                                    value: function() {
                                        return this.settings;
                                    }
                                },
                                {
                                    key: "enumerateCameras",
                                    value: function() {
                                        var V = this;
                                        return this.stream ? this._enumerateCamerasPromise() : this.stopCamera().then(function() {}).catch(function() {}).then(function() {
                                            var t = {
                                                video: !0
                                            };
                                            return V.mediaDevices.getUserMedia(t).then(function(V) {
                                                setTimeout(function() {
                                                    V.getTracks().forEach(function(V) {
                                                        V.stop();
                                                    });
                                                }, 20);
                                            }).then(function() {}).catch(function() {}).then(function() {
                                                return V._enumerateCamerasPromise();
                                            });
                                        });
                                    }
                                },
                                {
                                    key: "startCamera",
                                    value: function(V, t) {
                                        var e = this;
                                        return this.stopCamera().then(function() {}).catch(function() {}).then(function() {
                                            return e._getStreamDevice(V, t);
                                        });
                                    }
                                },
                                {
                                    key: "startCameraMaxResolution",
                                    value: function() {
                                        var V = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                                        return this.numberOfMaxResolutionTry = 0, this.stopCamera().then(function() {}).catch(function() {}).then(function() {
                                            return V._getStreamDeviceMaxResolution(t);
                                        });
                                    }
                                },
                                {
                                    key: "getDataUri",
                                    value: function(V) {
                                        var t = {
                                            sizeFactor: void 0 === V.sizeFactor ? i.c : V.sizeFactor,
                                            imageType: void 0 === V.imageType ? a : V.imageType,
                                            imageCompression: void 0 === V.imageCompression ? i.a : V.imageCompression,
                                            isImageMirror: void 0 === V.isImageMirror ? i.b : V.isImageMirror
                                        };
                                        return r.a.getDataUri(this.videoElement, t);
                                    }
                                },
                                {
                                    key: "stopCamera",
                                    value: function() {
                                        var V = this;
                                        return new Promise(function(t, e) {
                                            V.stream && (V.stream.getTracks().forEach(function(V) {
                                                V.stop();
                                            }), V.videoElement.src = "", V.stream = null, V._setSettings(null), t()), e(Error("no stream to stop!"));
                                        });
                                    }
                                }
                            ]), V;
                        }();
                    },
                    function(V, t, e) {
                        "use strict";
                        e.d(t, "c", function() {
                            return n;
                        }), e.d(t, "a", function() {
                            return r;
                        }), e.d(t, "b", function() {
                            return i;
                        });
                        var n = 1, r = null, i = !1;
                    },
                    function(V, t, e) {
                        "use strict";
                        var n = e(10);
                        e.d(t, "a", function() {
                            return n.a;
                        });
                    },
                    function(V, t, e) {
                        "use strict";
                        function n(V) {
                            for(var t = atob(V.split(",")[1]), e = V.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(t.length), r = new Uint8Array(n), i = 0; i < t.length; i++)r[i] = t.charCodeAt(i);
                            return new Blob([
                                n
                            ], {
                                type: e
                            });
                        }
                        function r(V, t) {
                            return V += "", V.length >= t ? V : new Array(t - V.length + 1).join("0") + V;
                        }
                        function i(V) {
                            var t = c.c.PNG;
                            return "image/jpeg" === V && (t = c.c.JPG), t;
                        }
                        function o(V, t, e) {
                            return V + "-" + r(t, 4) + "." + i(e);
                        }
                        function a(V, t, e) {
                            window.URL = window.webkitURL || window.URL;
                            var n = document.createElement("a");
                            n.download = o(t, e, V.type), n.href = window.URL.createObjectURL(V);
                            var r = document.createEvent("MouseEvents");
                            r.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), n.dispatchEvent(r);
                        }
                        function u(V) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "photo", e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                            a(n(V), t, e);
                        }
                        t.a = u;
                        var c = e(0);
                    }
                ]);
            });
        },
        function(V, t, e) {
            V.exports = e(4);
        },
        function(V, t, e) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = e(5);
            e.d(t, "Camera", function() {
                return n.c;
            }), e.d(t, "FACING_MODES", function() {
                return n.a;
            }), e.d(t, "IMAGE_TYPES", function() {
                return n.b;
            }), t.default = n.c;
        },
        function(V, t, e) {
            "use strict";
            var n = e(6);
            e.d(t, "a", function() {
                return n.a;
            }), e.d(t, "b", function() {
                return n.b;
            }), t.c = n.c;
        },
        function(V, t, e) {
            "use strict";
            function n(V) {
                function t() {
                    g && clearTimeout(g);
                }
                function e() {
                    return void 0 !== V.isImageMirror ? V.isImageMirror : V.idealFacingMode === u.FACING_MODES.USER;
                }
                function n() {
                    var n = {
                        sizeFactor: V.sizeFactor,
                        imageType: V.imageType,
                        imageCompression: V.imageCompression,
                        isImageMirror: e()
                    }, r = T(n);
                    V.isSilentMode || Object(l.c)(), "function" === typeof V.onTakePhoto && V.onTakePhoto(r), p(r), w(!1), t(), g = setTimeout(function() {
                        w(!0), "function" === typeof V.onTakePhotoAnimationDone && V.onTakePhotoAnimationDone(r);
                    }, 900);
                }
                var o = Object(r.useState)(""), a = d(o, 2), h = a[0], p = a[1], m = Object(r.useState)(!0), v = d(m, 2), y = v[0], w = v[1], k = Object(r.useState)(""), E = d(k, 2), b = E[0], C = E[1], U = Object(r.useRef)(null), x = Object(c.a)(U, V.idealFacingMode, V.idealResolution, V.isMaxResolution), I = d(x, 4), S = I[0], R = I[1], j = I[2], T = I[3];
                Object(r.useEffect)(function() {
                    S ? "function" === typeof V.onCameraStart && V.onCameraStart(S) : "function" === typeof V.onCameraStop && V.onCameraStop();
                }, [
                    S
                ]), Object(r.useEffect)(function() {
                    R && (C(R.name + " " + R.message), "function" === typeof V.onCameraError && V.onCameraError(R));
                }, [
                    R
                ]), Object(r.useEffect)(function() {
                    j && Object(l.d)(j.message);
                }, [
                    j
                ]);
                var L = Object(l.b)(y, e()), O = Object(l.a)(!y), B = V.isFullscreen ? "react-html5-camera-photo-fullscreen" : "";
                return i.a.createElement("div", {
                    className: "react-html5-camera-photo " + B
                }, i.a.createElement(f.a, {
                    cssClass: "display-error",
                    isDisplayError: V.isDisplayStartCameraError,
                    errorMsg: b
                }), i.a.createElement(s.a, {
                    isShowWhiteFlash: !y
                }), i.a.createElement("img", {
                    style: O,
                    alt: "camera",
                    src: h
                }), i.a.createElement("video", {
                    style: L,
                    ref: U,
                    autoPlay: !0,
                    muted: !0,
                    playsInline: !0
                }), i.a.createElement(A.a, {
                    isClicked: !y,
                    onClick: n
                }));
            }
            var r = e(0), i = e.n(r), o = e(1), a = e.n(o), u = e(2), c = (e.n(u), e(9)), A = e(13), s = e(15), f = e(17), l = e(19), h = e(21);
            e.n(h);
            e.o(u, "FACING_MODES") && e.d(t, "a", function() {
                return u.FACING_MODES;
            }), e.o(u, "IMAGE_TYPES") && e.d(t, "b", function() {
                return u.IMAGE_TYPES;
            });
            var d = function() {
                function V(V, t) {
                    var e = [], n = !0, r = !1, i = void 0;
                    try {
                        for(var o, a = V[Symbol.iterator](); !(n = (o = a.next()).done) && (e.push(o.value), !t || e.length !== t); n = !0);
                    } catch (V) {
                        r = !0, i = V;
                    } finally{
                        try {
                            !n && a.return && a.return();
                        } finally{
                            if (r) throw i;
                        }
                    }
                    return e;
                }
                return function(t, e) {
                    if (Array.isArray(t)) return t;
                    if (Symbol.iterator in Object(t)) return V(t, e);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }(), g = null;
            t.c = n, n.propTypes = {
                onTakePhoto: a.a.func,
                onTakePhotoAnimationDone: a.a.func,
                onCameraError: a.a.func,
                idealFacingMode: a.a.string,
                idealResolution: a.a.object,
                imageType: a.a.string,
                isImageMirror: a.a.bool,
                isSilentMode: a.a.bool,
                isDisplayStartCameraError: a.a.bool,
                imageCompression: a.a.number,
                isMaxResolution: a.a.bool,
                isFullscreen: a.a.bool,
                sizeFactor: a.a.number,
                onCameraStart: a.a.func,
                onCameraStop: a.a.func
            }, n.defaultProps = {
                isDisplayStartCameraError: !0
            };
        },
        function(V, t, e) {
            "use strict";
            function n() {}
            function r() {}
            var i = e(8);
            r.resetWarningCache = n, V.exports = function() {
                function V(V, t, e, n, r, o) {
                    if (o !== i) {
                        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw a.name = "Invariant Violation", a;
                    }
                }
                function t() {
                    return V;
                }
                V.isRequired = V;
                var e = {
                    array: V,
                    bool: V,
                    func: V,
                    number: V,
                    object: V,
                    string: V,
                    symbol: V,
                    any: V,
                    arrayOf: t,
                    element: V,
                    elementType: V,
                    instanceOf: t,
                    node: V,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: r,
                    resetWarningCache: n
                };
                return e.PropTypes = e, e;
            };
        },
        function(V, t, e) {
            "use strict";
            V.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        function(V, t, e) {
            "use strict";
            function n(V) {
                return function() {
                    var t = V.apply(this, arguments);
                    return new Promise(function(V, e) {
                        function n(r, i) {
                            try {
                                var o = t[r](i), a = o.value;
                            } catch (V) {
                                return void e(V);
                            }
                            if (!o.done) return Promise.resolve(a).then(function(V) {
                                n("next", V);
                            }, function(V) {
                                n("throw", V);
                            });
                            V(a);
                        }
                        return n("next");
                    });
                };
            }
            function r(V, t, e, r) {
                function i(V) {
                    return s.getDataUri(V);
                }
                var u = Object(a.useState)(null), l = A(u, 2), h = l[0], d = l[1], g = Object(a.useState)(null), p = A(g, 2), m = p[0], v = p[1], y = Object(a.useState)(null), w = A(y, 2), k = w[0], E = w[1];
                return Object(a.useEffect)(function() {
                    V && V.current && (s = new c.a(V.current));
                }, [
                    V
                ]), Object(a.useEffect)(function() {
                    var i = function() {
                        var i = n(o.a.mark(function n() {
                            var i;
                            return o.a.wrap(function(n) {
                                for(;;)switch(n.prev = n.next){
                                    case 0:
                                        if (f = !0, n.prev = 1, i = null, !r) {
                                            n.next = 9;
                                            break;
                                        }
                                        return n.next = 6, s.startCameraMaxResolution(t);
                                    case 6:
                                        i = n.sent, n.next = 12;
                                        break;
                                    case 9:
                                        return n.next = 11, s.startCamera(t, e);
                                    case 11:
                                        i = n.sent;
                                    case 12:
                                        if (!V || !V.current) {
                                            n.next = 17;
                                            break;
                                        }
                                        d(i), v(null), n.next = 19;
                                        break;
                                    case 17:
                                        return n.next = 19, s.stopCamera();
                                    case 19:
                                        n.next = 24;
                                        break;
                                    case 21:
                                        n.prev = 21, n.t0 = n.catch(1), V && V.current && v(n.t0);
                                    case 24:
                                    case "end":
                                        return n.stop();
                                }
                            }, n, this, [
                                [
                                    1,
                                    21
                                ]
                            ]);
                        }));
                        return function() {
                            return i.apply(this, arguments);
                        };
                    }();
                    if (h) return function() {
                        function t() {
                            return e.apply(this, arguments);
                        }
                        var e = n(o.a.mark(function t() {
                            return o.a.wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        if (t.prev = 0, !f) {
                                            t.next = 5;
                                            break;
                                        }
                                        return f = !1, t.next = 5, s.stopCamera();
                                    case 5:
                                        V && V.current && (d(null), E(null)), t.next = 11;
                                        break;
                                    case 8:
                                        t.prev = 8, t.t0 = t.catch(0), E(t.t0);
                                    case 11:
                                    case "end":
                                        return t.stop();
                                }
                            }, t, this, [
                                [
                                    0,
                                    8
                                ]
                            ]);
                        }));
                        return t;
                    }();
                    i();
                }, [
                    V,
                    h,
                    t,
                    e,
                    r
                ]), [
                    h,
                    m,
                    k,
                    i
                ];
            }
            t.a = r;
            var i = e(10), o = e.n(i), a = e(0), u = (e.n(a), e(2)), c = e.n(u), A = function() {
                function V(V, t) {
                    var e = [], n = !0, r = !1, i = void 0;
                    try {
                        for(var o, a = V[Symbol.iterator](); !(n = (o = a.next()).done) && (e.push(o.value), !t || e.length !== t); n = !0);
                    } catch (V) {
                        r = !0, i = V;
                    } finally{
                        try {
                            !n && a.return && a.return();
                        } finally{
                            if (r) throw i;
                        }
                    }
                    return e;
                }
                return function(t, e) {
                    if (Array.isArray(t)) return t;
                    if (Symbol.iterator in Object(t)) return V(t, e);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }(), s = null, f = !1;
        },
        function(V, t, e) {
            V.exports = e(11);
        },
        function(V, t, e) {
            var n = function() {
                return this;
            }() || Function("return this")(), r = n.regeneratorRuntime && Object.getOwnPropertyNames(n).indexOf("regeneratorRuntime") >= 0, i = r && n.regeneratorRuntime;
            if (n.regeneratorRuntime = void 0, V.exports = e(12), r) n.regeneratorRuntime = i;
            else try {
                delete n.regeneratorRuntime;
            } catch (V) {
                n.regeneratorRuntime = void 0;
            }
        },
        function(V, t) {
            !function(t) {
                "use strict";
                function e(V, t, e, n) {
                    var i = t && t.prototype instanceof r ? t : r, o = Object.create(i.prototype), a = new l(n || []);
                    return o._invoke = c(V, e, a), o;
                }
                function n(V, t, e) {
                    try {
                        return {
                            type: "normal",
                            arg: V.call(t, e)
                        };
                    } catch (V) {
                        return {
                            type: "throw",
                            arg: V
                        };
                    }
                }
                function r() {}
                function i() {}
                function o() {}
                function a(V) {
                    [
                        "next",
                        "throw",
                        "return"
                    ].forEach(function(t) {
                        V[t] = function(V) {
                            return this._invoke(t, V);
                        };
                    });
                }
                function u(V) {
                    function t(e, r, i, o) {
                        var a = n(V[e], V, r);
                        if ("throw" !== a.type) {
                            var u = a.arg, c = u.value;
                            return c && "object" === typeof c && m.call(c, "__await") ? Promise.resolve(c.__await).then(function(V) {
                                t("next", V, i, o);
                            }, function(V) {
                                t("throw", V, i, o);
                            }) : Promise.resolve(c).then(function(V) {
                                u.value = V, i(u);
                            }, o);
                        }
                        o(a.arg);
                    }
                    function e(V, e) {
                        function n() {
                            return new Promise(function(n, r) {
                                t(V, e, n, r);
                            });
                        }
                        return r = r ? r.then(n, n) : n();
                    }
                    var r;
                    this._invoke = e;
                }
                function c(V, t, e) {
                    var r = C;
                    return function(i, o) {
                        if (r === x) throw new Error("Generator is already running");
                        if (r === I) {
                            if ("throw" === i) throw o;
                            return d();
                        }
                        for(e.method = i, e.arg = o;;){
                            var a = e.delegate;
                            if (a) {
                                var u = A(a, e);
                                if (u) {
                                    if (u === S) continue;
                                    return u;
                                }
                            }
                            if ("next" === e.method) e.sent = e._sent = e.arg;
                            else if ("throw" === e.method) {
                                if (r === C) throw r = I, e.arg;
                                e.dispatchException(e.arg);
                            } else "return" === e.method && e.abrupt("return", e.arg);
                            r = x;
                            var c = n(V, t, e);
                            if ("normal" === c.type) {
                                if (r = e.done ? I : U, c.arg === S) continue;
                                return {
                                    value: c.arg,
                                    done: e.done
                                };
                            }
                            "throw" === c.type && (r = I, e.method = "throw", e.arg = c.arg);
                        }
                    };
                }
                function A(V, t) {
                    var e = V.iterator[t.method];
                    if (e === g) {
                        if (t.delegate = null, "throw" === t.method) {
                            if (V.iterator.return && (t.method = "return", t.arg = g, A(V, t), "throw" === t.method)) return S;
                            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
                        }
                        return S;
                    }
                    var r = n(e, V.iterator, t.arg);
                    if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, S;
                    var i = r.arg;
                    return i ? i.done ? (t[V.resultName] = i.value, t.next = V.nextLoc, "return" !== t.method && (t.method = "next", t.arg = g), t.delegate = null, S) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, S);
                }
                function s(V) {
                    var t = {
                        tryLoc: V[0]
                    };
                    1 in V && (t.catchLoc = V[1]), 2 in V && (t.finallyLoc = V[2], t.afterLoc = V[3]), this.tryEntries.push(t);
                }
                function f(V) {
                    var t = V.completion || {};
                    t.type = "normal", delete t.arg, V.completion = t;
                }
                function l(V) {
                    this.tryEntries = [
                        {
                            tryLoc: "root"
                        }
                    ], V.forEach(s, this), this.reset(!0);
                }
                function h(V) {
                    if (V) {
                        var t = V[y];
                        if (t) return t.call(V);
                        if ("function" === typeof V.next) return V;
                        if (!isNaN(V.length)) {
                            var e = -1, n = function t() {
                                for(; ++e < V.length;)if (m.call(V, e)) return t.value = V[e], t.done = !1, t;
                                return t.value = g, t.done = !0, t;
                            };
                            return n.next = n;
                        }
                    }
                    return {
                        next: d
                    };
                }
                function d() {
                    return {
                        value: g,
                        done: !0
                    };
                }
                var g, p = Object.prototype, m = p.hasOwnProperty, v = "function" === typeof Symbol ? Symbol : {}, y = v.iterator || "@@iterator", w = v.asyncIterator || "@@asyncIterator", k = v.toStringTag || "@@toStringTag", E = "object" === typeof V, b = t.regeneratorRuntime;
                if (b) return void (E && (V.exports = b));
                b = t.regeneratorRuntime = E ? V.exports : {}, b.wrap = e;
                var C = "suspendedStart", U = "suspendedYield", x = "executing", I = "completed", S = {}, R = {};
                R[y] = function() {
                    return this;
                };
                var j = Object.getPrototypeOf, T = j && j(j(h([])));
                T && T !== p && m.call(T, y) && (R = T);
                var L = o.prototype = r.prototype = Object.create(R);
                i.prototype = L.constructor = o, o.constructor = i, o[k] = i.displayName = "GeneratorFunction", b.isGeneratorFunction = function(V) {
                    var t = "function" === typeof V && V.constructor;
                    return !!t && (t === i || "GeneratorFunction" === (t.displayName || t.name));
                }, b.mark = function(V) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(V, o) : (V.__proto__ = o, k in V || (V[k] = "GeneratorFunction")), V.prototype = Object.create(L), V;
                }, b.awrap = function(V) {
                    return {
                        __await: V
                    };
                }, a(u.prototype), u.prototype[w] = function() {
                    return this;
                }, b.AsyncIterator = u, b.async = function(V, t, n, r) {
                    var i = new u(e(V, t, n, r));
                    return b.isGeneratorFunction(t) ? i : i.next().then(function(V) {
                        return V.done ? V.value : i.next();
                    });
                }, a(L), L[k] = "Generator", L[y] = function() {
                    return this;
                }, L.toString = function() {
                    return "[object Generator]";
                }, b.keys = function(V) {
                    var t = [];
                    for(var e in V)t.push(e);
                    return t.reverse(), function e() {
                        for(; t.length;){
                            var n = t.pop();
                            if (n in V) return e.value = n, e.done = !1, e;
                        }
                        return e.done = !0, e;
                    };
                }, b.values = h, l.prototype = {
                    constructor: l,
                    reset: function(V) {
                        if (this.prev = 0, this.next = 0, this.sent = this._sent = g, this.done = !1, this.delegate = null, this.method = "next", this.arg = g, this.tryEntries.forEach(f), !V) for(var t in this)"t" === t.charAt(0) && m.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = g);
                    },
                    stop: function() {
                        this.done = !0;
                        var V = this.tryEntries[0], t = V.completion;
                        if ("throw" === t.type) throw t.arg;
                        return this.rval;
                    },
                    dispatchException: function(V) {
                        function t(t, n) {
                            return i.type = "throw", i.arg = V, e.next = t, n && (e.method = "next", e.arg = g), !!n;
                        }
                        if (this.done) throw V;
                        for(var e = this, n = this.tryEntries.length - 1; n >= 0; --n){
                            var r = this.tryEntries[n], i = r.completion;
                            if ("root" === r.tryLoc) return t("end");
                            if (r.tryLoc <= this.prev) {
                                var o = m.call(r, "catchLoc"), a = m.call(r, "finallyLoc");
                                if (o && a) {
                                    if (this.prev < r.catchLoc) return t(r.catchLoc, !0);
                                    if (this.prev < r.finallyLoc) return t(r.finallyLoc);
                                } else if (o) {
                                    if (this.prev < r.catchLoc) return t(r.catchLoc, !0);
                                } else {
                                    if (!a) throw new Error("try statement without catch or finally");
                                    if (this.prev < r.finallyLoc) return t(r.finallyLoc);
                                }
                            }
                        }
                    },
                    abrupt: function(V, t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var n = this.tryEntries[e];
                            if (n.tryLoc <= this.prev && m.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                var r = n;
                                break;
                            }
                        }
                        r && ("break" === V || "continue" === V) && r.tryLoc <= t && t <= r.finallyLoc && (r = null);
                        var i = r ? r.completion : {};
                        return i.type = V, i.arg = t, r ? (this.method = "next", this.next = r.finallyLoc, S) : this.complete(i);
                    },
                    complete: function(V, t) {
                        if ("throw" === V.type) throw V.arg;
                        return "break" === V.type || "continue" === V.type ? this.next = V.arg : "return" === V.type ? (this.rval = this.arg = V.arg, this.method = "return", this.next = "end") : "normal" === V.type && t && (this.next = t), S;
                    },
                    finish: function(V) {
                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                            var e = this.tryEntries[t];
                            if (e.finallyLoc === V) return this.complete(e.completion, e.afterLoc), f(e), S;
                        }
                    },
                    catch: function(V) {
                        for(var t = this.tryEntries.length - 1; t >= 0; --t){
                            var e = this.tryEntries[t];
                            if (e.tryLoc === V) {
                                var n = e.completion;
                                if ("throw" === n.type) {
                                    var r = n.arg;
                                    f(e);
                                }
                                return r;
                            }
                        }
                        throw new Error("illegal catch attempt");
                    },
                    delegateYield: function(V, t, e) {
                        return this.delegate = {
                            iterator: h(V),
                            resultName: t,
                            nextLoc: e
                        }, "next" === this.method && (this.arg = g), S;
                    }
                };
            }(function() {
                return this;
            }() || Function("return this")());
        },
        function(V, t, e) {
            "use strict";
            var n = e(0), r = e.n(n), i = e(1), o = e.n(i), a = e(14), u = (e.n(a), function(V) {
                var t = V.onClick, e = V.isClicked, n = e ? "is-clicked" : "";
                return r.a.createElement("div", {
                    id: "container-circles"
                }, r.a.createElement("div", {
                    id: "outer-circle",
                    onClick: function(V) {
                        e || t();
                    }
                }, r.a.createElement("div", {
                    id: "inner-circle",
                    className: n
                })));
            });
            u.propTypes = {
                onClick: o.a.func.isRequired,
                isClicked: o.a.bool.isRequired
            }, t.a = u;
        },
        function(V, t) {},
        function(V, t, e) {
            "use strict";
            var n = e(0), r = e.n(n), i = e(1), o = e.n(i), a = e(16), u = (e.n(a), function(V) {
                var t = V.isShowWhiteFlash, e = t ? "do-transition" : "", n = e + " normal";
                return r.a.createElement("div", {
                    id: "white-flash",
                    className: n
                });
            });
            u.propTypes = {
                isShowWhiteFlash: o.a.bool.isRequired
            }, t.a = u;
        },
        function(V, t) {},
        function(V, t, e) {
            "use strict";
            function n(V, t) {
                return V && t && t.length > 0;
            }
            var r = e(0), i = e.n(r), o = e(1), a = e.n(o), u = e(18), c = (e.n(u), function(V) {
                var t = V.isDisplayError, e = V.errorMsg, r = V.cssClass;
                return n(t, e) ? (console.log("cssClass", r), i.a.createElement("div", {
                    className: r,
                    id: "display-error"
                }, i.a.createElement("h1", null, "Camera error: ", e))) : null;
            });
            c.propTypes = {
                isDisplayError: a.a.bool,
                errorMsg: a.a.string,
                cssClass: a.a.string
            }, t.a = c;
        },
        function(V, t) {},
        function(V, t, e) {
            "use strict";
            function n(V) {
                return V ? {
                    display: "inline-block"
                } : {
                    display: "none"
                };
            }
            function r(V) {
                return V ? {
                    transform: "rotateY(180deg)"
                } : {
                    transform: "none"
                };
            }
            function i(V, t) {
                return Object.assign({}, r(t), n(V));
            }
            function o() {
                new Audio("data:audio/mp3;base64," + c.a.base64).play();
            }
            function a(V) {
                console.info("react-html5-camera-photo info:", V);
            }
            t.a = n, t.b = i, t.c = o, t.d = a;
            var u = e(20), c = e.n(u);
        },
        function(V, t) {
            V.exports = {
                base64: "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"
            };
        },
        function(V, t) {}
    ]);
});











var $cQNHH = parcelRequire("cQNHH");



"use client";
const $76e4a1ba004aadc7$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).bool
};
const $76e4a1ba004aadc7$var$Image = /*#__PURE__*/ $cQNHH.forwardRef((_param, ref)=>{
    var { bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false } = _param, props = (0, $579302c8e6721842$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "fluid",
        "rounded",
        "roundedCircle",
        "thumbnail"
    ]);
    bsPrefix = (0, $d344ef3e3248c0b3$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("img", (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($13b3195589c46dae$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    }));
});
$76e4a1ba004aadc7$var$Image.displayName = 'Image';
var $76e4a1ba004aadc7$export$2e2bcd8739ae039 = $76e4a1ba004aadc7$var$Image;


'use strict';
function $f447dd3acd4e15d9$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $f3e9057162ef2db7$var$toString } = Object.prototype;
const { getPrototypeOf: $f3e9057162ef2db7$var$getPrototypeOf } = Object;
const { iterator: $f3e9057162ef2db7$var$iterator, toStringTag: $f3e9057162ef2db7$var$toStringTag } = Symbol;
const $f3e9057162ef2db7$var$kindOf = ((cache)=>(thing)=>{
        const str = $f3e9057162ef2db7$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $f3e9057162ef2db7$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$f3e9057162ef2db7$var$kindOf(thing) === type;
};
const $f3e9057162ef2db7$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $f3e9057162ef2db7$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $f3e9057162ef2db7$var$isUndefined = $f3e9057162ef2db7$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $f3e9057162ef2db7$var$isBuffer(val) {
    return val !== null && !$f3e9057162ef2db7$var$isUndefined(val) && val.constructor !== null && !$f3e9057162ef2db7$var$isUndefined(val.constructor) && $f3e9057162ef2db7$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $f3e9057162ef2db7$var$isArrayBuffer = $f3e9057162ef2db7$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $f3e9057162ef2db7$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $f3e9057162ef2db7$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $f3e9057162ef2db7$var$isString = $f3e9057162ef2db7$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $f3e9057162ef2db7$var$isFunction = $f3e9057162ef2db7$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $f3e9057162ef2db7$var$isNumber = $f3e9057162ef2db7$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $f3e9057162ef2db7$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $f3e9057162ef2db7$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $f3e9057162ef2db7$var$isPlainObject = (val)=>{
    if ($f3e9057162ef2db7$var$kindOf(val) !== 'object') return false;
    const prototype = $f3e9057162ef2db7$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($f3e9057162ef2db7$var$toStringTag in val) && !($f3e9057162ef2db7$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $f3e9057162ef2db7$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$f3e9057162ef2db7$var$isObject(val) || $f3e9057162ef2db7$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $f3e9057162ef2db7$var$isDate = $f3e9057162ef2db7$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $f3e9057162ef2db7$var$isFile = $f3e9057162ef2db7$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $f3e9057162ef2db7$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $f3e9057162ef2db7$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $f3e9057162ef2db7$var$isBlob = $f3e9057162ef2db7$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $f3e9057162ef2db7$var$isFileList = $f3e9057162ef2db7$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $f3e9057162ef2db7$var$isStream = (val)=>$f3e9057162ef2db7$var$isObject(val) && $f3e9057162ef2db7$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $f3e9057162ef2db7$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $f3e9057162ef2db7$var$G = $f3e9057162ef2db7$var$getGlobal();
const $f3e9057162ef2db7$var$FormDataCtor = typeof $f3e9057162ef2db7$var$G.FormData !== 'undefined' ? $f3e9057162ef2db7$var$G.FormData : undefined;
const $f3e9057162ef2db7$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($f3e9057162ef2db7$var$FormDataCtor && thing instanceof $f3e9057162ef2db7$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData (GHSA-6chq-wfr3-2hj9).
    const proto = $f3e9057162ef2db7$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$f3e9057162ef2db7$var$isFunction(thing.append)) return false;
    const kind = $f3e9057162ef2db7$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $f3e9057162ef2db7$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $f3e9057162ef2db7$var$isURLSearchParams = $f3e9057162ef2db7$var$kindOfTest('URLSearchParams');
const [$f3e9057162ef2db7$var$isReadableStream, $f3e9057162ef2db7$var$isRequest, $f3e9057162ef2db7$var$isResponse, $f3e9057162ef2db7$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($f3e9057162ef2db7$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $f3e9057162ef2db7$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $f3e9057162ef2db7$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($f3e9057162ef2db7$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($f3e9057162ef2db7$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $f3e9057162ef2db7$var$findKey(obj, key) {
    if ($f3e9057162ef2db7$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $f3e9057162ef2db7$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $f3e9057162ef2db7$var$isContextDefined = (context)=>!$f3e9057162ef2db7$var$isUndefined(context) && context !== $f3e9057162ef2db7$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $f3e9057162ef2db7$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $f3e9057162ef2db7$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $f3e9057162ef2db7$var$findKey(result, key) || key;
        if ($f3e9057162ef2db7$var$isPlainObject(result[targetKey]) && $f3e9057162ef2db7$var$isPlainObject(val)) result[targetKey] = $f3e9057162ef2db7$var$merge(result[targetKey], val);
        else if ($f3e9057162ef2db7$var$isPlainObject(val)) result[targetKey] = $f3e9057162ef2db7$var$merge({}, val);
        else if ($f3e9057162ef2db7$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$f3e9057162ef2db7$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $f3e9057162ef2db7$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $f3e9057162ef2db7$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $f3e9057162ef2db7$var$forEach(b, (val, key)=>{
        if (thisArg && $f3e9057162ef2db7$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $f447dd3acd4e15d9$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $f3e9057162ef2db7$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $f3e9057162ef2db7$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $f3e9057162ef2db7$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $f3e9057162ef2db7$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $f3e9057162ef2db7$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $f3e9057162ef2db7$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($f3e9057162ef2db7$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$f3e9057162ef2db7$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $f3e9057162ef2db7$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $f3e9057162ef2db7$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $f3e9057162ef2db7$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$f3e9057162ef2db7$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $f3e9057162ef2db7$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $f3e9057162ef2db7$var$isHTMLForm = $f3e9057162ef2db7$var$kindOfTest('HTMLFormElement');
const $f3e9057162ef2db7$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $f3e9057162ef2db7$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $f3e9057162ef2db7$var$isRegExp = $f3e9057162ef2db7$var$kindOfTest('RegExp');
const $f3e9057162ef2db7$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $f3e9057162ef2db7$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $f3e9057162ef2db7$var$freezeMethods = (obj)=>{
    $f3e9057162ef2db7$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($f3e9057162ef2db7$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$f3e9057162ef2db7$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $f3e9057162ef2db7$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $f3e9057162ef2db7$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $f3e9057162ef2db7$var$noop = ()=>{};
const $f3e9057162ef2db7$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $f3e9057162ef2db7$var$isSpecCompliantForm(thing) {
    return !!(thing && $f3e9057162ef2db7$var$isFunction(thing.append) && thing[$f3e9057162ef2db7$var$toStringTag] === 'FormData' && thing[$f3e9057162ef2db7$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $f3e9057162ef2db7$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($f3e9057162ef2db7$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($f3e9057162ef2db7$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $f3e9057162ef2db7$var$isArray(source) ? [] : {};
                $f3e9057162ef2db7$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$f3e9057162ef2db7$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $f3e9057162ef2db7$var$isAsyncFn = $f3e9057162ef2db7$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $f3e9057162ef2db7$var$isThenable = (thing)=>thing && ($f3e9057162ef2db7$var$isObject(thing) || $f3e9057162ef2db7$var$isFunction(thing)) && $f3e9057162ef2db7$var$isFunction(thing.then) && $f3e9057162ef2db7$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $f3e9057162ef2db7$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $f3e9057162ef2db7$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $f3e9057162ef2db7$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $f3e9057162ef2db7$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $f3e9057162ef2db7$var$isFunction($f3e9057162ef2db7$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $f3e9057162ef2db7$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($f3e9057162ef2db7$var$_global) : $f3e9057162ef2db7$var$_setImmediate;
// *********************
const $f3e9057162ef2db7$var$isIterable = (thing)=>thing != null && $f3e9057162ef2db7$var$isFunction(thing[$f3e9057162ef2db7$var$iterator]);
var $f3e9057162ef2db7$export$2e2bcd8739ae039 = {
    isArray: $f3e9057162ef2db7$var$isArray,
    isArrayBuffer: $f3e9057162ef2db7$var$isArrayBuffer,
    isBuffer: $f3e9057162ef2db7$var$isBuffer,
    isFormData: $f3e9057162ef2db7$var$isFormData,
    isArrayBufferView: $f3e9057162ef2db7$var$isArrayBufferView,
    isString: $f3e9057162ef2db7$var$isString,
    isNumber: $f3e9057162ef2db7$var$isNumber,
    isBoolean: $f3e9057162ef2db7$var$isBoolean,
    isObject: $f3e9057162ef2db7$var$isObject,
    isPlainObject: $f3e9057162ef2db7$var$isPlainObject,
    isEmptyObject: $f3e9057162ef2db7$var$isEmptyObject,
    isReadableStream: $f3e9057162ef2db7$var$isReadableStream,
    isRequest: $f3e9057162ef2db7$var$isRequest,
    isResponse: $f3e9057162ef2db7$var$isResponse,
    isHeaders: $f3e9057162ef2db7$var$isHeaders,
    isUndefined: $f3e9057162ef2db7$var$isUndefined,
    isDate: $f3e9057162ef2db7$var$isDate,
    isFile: $f3e9057162ef2db7$var$isFile,
    isReactNativeBlob: $f3e9057162ef2db7$var$isReactNativeBlob,
    isReactNative: $f3e9057162ef2db7$var$isReactNative,
    isBlob: $f3e9057162ef2db7$var$isBlob,
    isRegExp: $f3e9057162ef2db7$var$isRegExp,
    isFunction: $f3e9057162ef2db7$var$isFunction,
    isStream: $f3e9057162ef2db7$var$isStream,
    isURLSearchParams: $f3e9057162ef2db7$var$isURLSearchParams,
    isTypedArray: $f3e9057162ef2db7$var$isTypedArray,
    isFileList: $f3e9057162ef2db7$var$isFileList,
    forEach: $f3e9057162ef2db7$var$forEach,
    merge: $f3e9057162ef2db7$var$merge,
    extend: $f3e9057162ef2db7$var$extend,
    trim: $f3e9057162ef2db7$var$trim,
    stripBOM: $f3e9057162ef2db7$var$stripBOM,
    inherits: $f3e9057162ef2db7$var$inherits,
    toFlatObject: $f3e9057162ef2db7$var$toFlatObject,
    kindOf: $f3e9057162ef2db7$var$kindOf,
    kindOfTest: $f3e9057162ef2db7$var$kindOfTest,
    endsWith: $f3e9057162ef2db7$var$endsWith,
    toArray: $f3e9057162ef2db7$var$toArray,
    forEachEntry: $f3e9057162ef2db7$var$forEachEntry,
    matchAll: $f3e9057162ef2db7$var$matchAll,
    isHTMLForm: $f3e9057162ef2db7$var$isHTMLForm,
    hasOwnProperty: $f3e9057162ef2db7$var$hasOwnProperty,
    hasOwnProp: $f3e9057162ef2db7$var$hasOwnProperty,
    reduceDescriptors: $f3e9057162ef2db7$var$reduceDescriptors,
    freezeMethods: $f3e9057162ef2db7$var$freezeMethods,
    toObjectSet: $f3e9057162ef2db7$var$toObjectSet,
    toCamelCase: $f3e9057162ef2db7$var$toCamelCase,
    noop: $f3e9057162ef2db7$var$noop,
    toFiniteNumber: $f3e9057162ef2db7$var$toFiniteNumber,
    findKey: $f3e9057162ef2db7$var$findKey,
    global: $f3e9057162ef2db7$var$_global,
    isContextDefined: $f3e9057162ef2db7$var$isContextDefined,
    isSpecCompliantForm: $f3e9057162ef2db7$var$isSpecCompliantForm,
    toJSONObject: $f3e9057162ef2db7$var$toJSONObject,
    isAsyncFn: $f3e9057162ef2db7$var$isAsyncFn,
    isThenable: $f3e9057162ef2db7$var$isThenable,
    setImmediate: $f3e9057162ef2db7$var$_setImmediate,
    asap: $f3e9057162ef2db7$var$asap,
    isIterable: $f3e9057162ef2db7$var$isIterable
};







'use strict';
class $f6bb2823c2fb0c18$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $f6bb2823c2fb0c18$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$f6bb2823c2fb0c18$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$f6bb2823c2fb0c18$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$f6bb2823c2fb0c18$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$f6bb2823c2fb0c18$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$f6bb2823c2fb0c18$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$f6bb2823c2fb0c18$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$f6bb2823c2fb0c18$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$f6bb2823c2fb0c18$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$f6bb2823c2fb0c18$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$f6bb2823c2fb0c18$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$f6bb2823c2fb0c18$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$f6bb2823c2fb0c18$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$f6bb2823c2fb0c18$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $f6bb2823c2fb0c18$export$2e2bcd8739ae039 = $f6bb2823c2fb0c18$var$AxiosError;


// eslint-disable-next-line strict
var $d62ba1ad41be4098$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $46f4e6f775f39bcc$export$a143d493d941bafc;
var $46f4e6f775f39bcc$export$e4cf37d7f6fb9e0a;
var $46f4e6f775f39bcc$export$f99ded8fe4b79145;
var $46f4e6f775f39bcc$export$599f31c3813fae4d;
'use strict';
var $9c5d6f32ba272209$export$a48f0734ac7c2329;
var $9c5d6f32ba272209$export$d622b2ad8d90c771;
var $9c5d6f32ba272209$export$6100ba28696e12de;
'use strict';
$9c5d6f32ba272209$export$a48f0734ac7c2329 = $9c5d6f32ba272209$var$byteLength;
$9c5d6f32ba272209$export$d622b2ad8d90c771 = $9c5d6f32ba272209$var$toByteArray;
$9c5d6f32ba272209$export$6100ba28696e12de = $9c5d6f32ba272209$var$fromByteArray;
var $9c5d6f32ba272209$var$lookup = [];
var $9c5d6f32ba272209$var$revLookup = [];
var $9c5d6f32ba272209$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $9c5d6f32ba272209$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $9c5d6f32ba272209$var$i = 0, $9c5d6f32ba272209$var$len = $9c5d6f32ba272209$var$code.length; $9c5d6f32ba272209$var$i < $9c5d6f32ba272209$var$len; ++$9c5d6f32ba272209$var$i){
    $9c5d6f32ba272209$var$lookup[$9c5d6f32ba272209$var$i] = $9c5d6f32ba272209$var$code[$9c5d6f32ba272209$var$i];
    $9c5d6f32ba272209$var$revLookup[$9c5d6f32ba272209$var$code.charCodeAt($9c5d6f32ba272209$var$i)] = $9c5d6f32ba272209$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9c5d6f32ba272209$var$revLookup['-'.charCodeAt(0)] = 62;
$9c5d6f32ba272209$var$revLookup['_'.charCodeAt(0)] = 63;
function $9c5d6f32ba272209$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9c5d6f32ba272209$var$byteLength(b64) {
    var lens = $9c5d6f32ba272209$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9c5d6f32ba272209$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9c5d6f32ba272209$var$toByteArray(b64) {
    var tmp;
    var lens = $9c5d6f32ba272209$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9c5d6f32ba272209$var$Arr($9c5d6f32ba272209$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i)] << 18 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i)] << 2 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i)] << 10 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9c5d6f32ba272209$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9c5d6f32ba272209$var$tripletToBase64(num) {
    return $9c5d6f32ba272209$var$lookup[num >> 18 & 0x3F] + $9c5d6f32ba272209$var$lookup[num >> 12 & 0x3F] + $9c5d6f32ba272209$var$lookup[num >> 6 & 0x3F] + $9c5d6f32ba272209$var$lookup[num & 0x3F];
}
function $9c5d6f32ba272209$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9c5d6f32ba272209$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $9c5d6f32ba272209$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9c5d6f32ba272209$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9c5d6f32ba272209$var$lookup[tmp >> 2] + $9c5d6f32ba272209$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9c5d6f32ba272209$var$lookup[tmp >> 10] + $9c5d6f32ba272209$var$lookup[tmp >> 4 & 0x3F] + $9c5d6f32ba272209$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $42ae557cc21e89b5$export$aafa59e2e03f2942;
var $42ae557cc21e89b5$export$68d8715fc104d294;
$42ae557cc21e89b5$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$42ae557cc21e89b5$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $46f4e6f775f39bcc$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$46f4e6f775f39bcc$export$a143d493d941bafc = $46f4e6f775f39bcc$var$Buffer;
$46f4e6f775f39bcc$export$e4cf37d7f6fb9e0a = $46f4e6f775f39bcc$var$SlowBuffer;
$46f4e6f775f39bcc$export$f99ded8fe4b79145 = 50;
const $46f4e6f775f39bcc$var$K_MAX_LENGTH = 0x7fffffff;
$46f4e6f775f39bcc$export$599f31c3813fae4d = $46f4e6f775f39bcc$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $46f4e6f775f39bcc$var$Buffer.TYPED_ARRAY_SUPPORT = $46f4e6f775f39bcc$var$typedArraySupport();
if (!$46f4e6f775f39bcc$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $46f4e6f775f39bcc$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($46f4e6f775f39bcc$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($46f4e6f775f39bcc$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $46f4e6f775f39bcc$var$createBuffer(length) {
    if (length > $46f4e6f775f39bcc$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $46f4e6f775f39bcc$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $46f4e6f775f39bcc$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $46f4e6f775f39bcc$var$allocUnsafe(arg);
    }
    return $46f4e6f775f39bcc$var$from(arg, encodingOrOffset, length);
}
$46f4e6f775f39bcc$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $46f4e6f775f39bcc$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $46f4e6f775f39bcc$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $46f4e6f775f39bcc$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($46f4e6f775f39bcc$var$isInstance(value, ArrayBuffer) || value && $46f4e6f775f39bcc$var$isInstance(value.buffer, ArrayBuffer)) return $46f4e6f775f39bcc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($46f4e6f775f39bcc$var$isInstance(value, SharedArrayBuffer) || value && $46f4e6f775f39bcc$var$isInstance(value.buffer, SharedArrayBuffer))) return $46f4e6f775f39bcc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $46f4e6f775f39bcc$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $46f4e6f775f39bcc$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $46f4e6f775f39bcc$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $46f4e6f775f39bcc$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $46f4e6f775f39bcc$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($46f4e6f775f39bcc$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($46f4e6f775f39bcc$var$Buffer, Uint8Array);
function $46f4e6f775f39bcc$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $46f4e6f775f39bcc$var$alloc(size, fill, encoding) {
    $46f4e6f775f39bcc$var$assertSize(size);
    if (size <= 0) return $46f4e6f775f39bcc$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $46f4e6f775f39bcc$var$createBuffer(size).fill(fill, encoding) : $46f4e6f775f39bcc$var$createBuffer(size).fill(fill);
    return $46f4e6f775f39bcc$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $46f4e6f775f39bcc$var$Buffer.alloc = function(size, fill, encoding) {
    return $46f4e6f775f39bcc$var$alloc(size, fill, encoding);
};
function $46f4e6f775f39bcc$var$allocUnsafe(size) {
    $46f4e6f775f39bcc$var$assertSize(size);
    return $46f4e6f775f39bcc$var$createBuffer(size < 0 ? 0 : $46f4e6f775f39bcc$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $46f4e6f775f39bcc$var$Buffer.allocUnsafe = function(size) {
    return $46f4e6f775f39bcc$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $46f4e6f775f39bcc$var$Buffer.allocUnsafeSlow = function(size) {
    return $46f4e6f775f39bcc$var$allocUnsafe(size);
};
function $46f4e6f775f39bcc$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$46f4e6f775f39bcc$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $46f4e6f775f39bcc$var$byteLength(string, encoding) | 0;
    let buf = $46f4e6f775f39bcc$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $46f4e6f775f39bcc$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $46f4e6f775f39bcc$var$checked(array.length) | 0;
    const buf = $46f4e6f775f39bcc$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $46f4e6f775f39bcc$var$fromArrayView(arrayView) {
    if ($46f4e6f775f39bcc$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $46f4e6f775f39bcc$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $46f4e6f775f39bcc$var$fromArrayLike(arrayView);
}
function $46f4e6f775f39bcc$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $46f4e6f775f39bcc$var$Buffer.prototype);
    return buf;
}
function $46f4e6f775f39bcc$var$fromObject(obj) {
    if ($46f4e6f775f39bcc$var$Buffer.isBuffer(obj)) {
        const len = $46f4e6f775f39bcc$var$checked(obj.length) | 0;
        const buf = $46f4e6f775f39bcc$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $46f4e6f775f39bcc$var$numberIsNaN(obj.length)) return $46f4e6f775f39bcc$var$createBuffer(0);
        return $46f4e6f775f39bcc$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $46f4e6f775f39bcc$var$fromArrayLike(obj.data);
}
function $46f4e6f775f39bcc$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $46f4e6f775f39bcc$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $46f4e6f775f39bcc$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $46f4e6f775f39bcc$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $46f4e6f775f39bcc$var$Buffer.alloc(+length);
}
$46f4e6f775f39bcc$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $46f4e6f775f39bcc$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$46f4e6f775f39bcc$var$Buffer.compare = function compare(a, b) {
    if ($46f4e6f775f39bcc$var$isInstance(a, Uint8Array)) a = $46f4e6f775f39bcc$var$Buffer.from(a, a.offset, a.byteLength);
    if ($46f4e6f775f39bcc$var$isInstance(b, Uint8Array)) b = $46f4e6f775f39bcc$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(a) || !$46f4e6f775f39bcc$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$46f4e6f775f39bcc$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$46f4e6f775f39bcc$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $46f4e6f775f39bcc$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $46f4e6f775f39bcc$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($46f4e6f775f39bcc$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(buf)) buf = $46f4e6f775f39bcc$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $46f4e6f775f39bcc$var$byteLength(string, encoding) {
    if ($46f4e6f775f39bcc$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $46f4e6f775f39bcc$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $46f4e6f775f39bcc$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $46f4e6f775f39bcc$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $46f4e6f775f39bcc$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$46f4e6f775f39bcc$var$Buffer.byteLength = $46f4e6f775f39bcc$var$byteLength;
function $46f4e6f775f39bcc$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $46f4e6f775f39bcc$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $46f4e6f775f39bcc$var$utf8Slice(this, start, end);
        case 'ascii':
            return $46f4e6f775f39bcc$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $46f4e6f775f39bcc$var$latin1Slice(this, start, end);
        case 'base64':
            return $46f4e6f775f39bcc$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $46f4e6f775f39bcc$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$46f4e6f775f39bcc$var$Buffer.prototype._isBuffer = true;
function $46f4e6f775f39bcc$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$46f4e6f775f39bcc$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$46f4e6f775f39bcc$var$swap(this, i, i + 1);
    return this;
};
$46f4e6f775f39bcc$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $46f4e6f775f39bcc$var$swap(this, i, i + 3);
        $46f4e6f775f39bcc$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$46f4e6f775f39bcc$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $46f4e6f775f39bcc$var$swap(this, i, i + 7);
        $46f4e6f775f39bcc$var$swap(this, i + 1, i + 6);
        $46f4e6f775f39bcc$var$swap(this, i + 2, i + 5);
        $46f4e6f775f39bcc$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$46f4e6f775f39bcc$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $46f4e6f775f39bcc$var$utf8Slice(this, 0, length);
    return $46f4e6f775f39bcc$var$slowToString.apply(this, arguments);
};
$46f4e6f775f39bcc$var$Buffer.prototype.toLocaleString = $46f4e6f775f39bcc$var$Buffer.prototype.toString;
$46f4e6f775f39bcc$var$Buffer.prototype.equals = function equals(b) {
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $46f4e6f775f39bcc$var$Buffer.compare(this, b) === 0;
};
$46f4e6f775f39bcc$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $46f4e6f775f39bcc$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($46f4e6f775f39bcc$var$customInspectSymbol) $46f4e6f775f39bcc$var$Buffer.prototype[$46f4e6f775f39bcc$var$customInspectSymbol] = $46f4e6f775f39bcc$var$Buffer.prototype.inspect;
$46f4e6f775f39bcc$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($46f4e6f775f39bcc$var$isInstance(target, Uint8Array)) target = $46f4e6f775f39bcc$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $46f4e6f775f39bcc$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($46f4e6f775f39bcc$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $46f4e6f775f39bcc$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($46f4e6f775f39bcc$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $46f4e6f775f39bcc$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $46f4e6f775f39bcc$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $46f4e6f775f39bcc$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$46f4e6f775f39bcc$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$46f4e6f775f39bcc$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $46f4e6f775f39bcc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$46f4e6f775f39bcc$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $46f4e6f775f39bcc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $46f4e6f775f39bcc$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($46f4e6f775f39bcc$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $46f4e6f775f39bcc$var$utf8Write(buf, string, offset, length) {
    return $46f4e6f775f39bcc$var$blitBuffer($46f4e6f775f39bcc$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $46f4e6f775f39bcc$var$asciiWrite(buf, string, offset, length) {
    return $46f4e6f775f39bcc$var$blitBuffer($46f4e6f775f39bcc$var$asciiToBytes(string), buf, offset, length);
}
function $46f4e6f775f39bcc$var$base64Write(buf, string, offset, length) {
    return $46f4e6f775f39bcc$var$blitBuffer($46f4e6f775f39bcc$var$base64ToBytes(string), buf, offset, length);
}
function $46f4e6f775f39bcc$var$ucs2Write(buf, string, offset, length) {
    return $46f4e6f775f39bcc$var$blitBuffer($46f4e6f775f39bcc$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$46f4e6f775f39bcc$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $46f4e6f775f39bcc$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $46f4e6f775f39bcc$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $46f4e6f775f39bcc$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $46f4e6f775f39bcc$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $46f4e6f775f39bcc$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$46f4e6f775f39bcc$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $46f4e6f775f39bcc$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9c5d6f32ba272209$export$6100ba28696e12de(buf);
    else return $9c5d6f32ba272209$export$6100ba28696e12de(buf.slice(start, end));
}
function $46f4e6f775f39bcc$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $46f4e6f775f39bcc$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $46f4e6f775f39bcc$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $46f4e6f775f39bcc$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $46f4e6f775f39bcc$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $46f4e6f775f39bcc$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $46f4e6f775f39bcc$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $46f4e6f775f39bcc$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $46f4e6f775f39bcc$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $46f4e6f775f39bcc$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $46f4e6f775f39bcc$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$46f4e6f775f39bcc$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $46f4e6f775f39bcc$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $46f4e6f775f39bcc$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$46f4e6f775f39bcc$var$Buffer.prototype.readUintLE = $46f4e6f775f39bcc$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUintBE = $46f4e6f775f39bcc$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint8 = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint16LE = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint16BE = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint32LE = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readUint32BE = $46f4e6f775f39bcc$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$46f4e6f775f39bcc$var$Buffer.prototype.readBigUInt64LE = $46f4e6f775f39bcc$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $46f4e6f775f39bcc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46f4e6f775f39bcc$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$46f4e6f775f39bcc$var$Buffer.prototype.readBigUInt64BE = $46f4e6f775f39bcc$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $46f4e6f775f39bcc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46f4e6f775f39bcc$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$46f4e6f775f39bcc$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$46f4e6f775f39bcc$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$46f4e6f775f39bcc$var$Buffer.prototype.readBigInt64LE = $46f4e6f775f39bcc$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $46f4e6f775f39bcc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46f4e6f775f39bcc$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$46f4e6f775f39bcc$var$Buffer.prototype.readBigInt64BE = $46f4e6f775f39bcc$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $46f4e6f775f39bcc$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46f4e6f775f39bcc$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$46f4e6f775f39bcc$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return $42ae557cc21e89b5$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$46f4e6f775f39bcc$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 4, this.length);
    return $42ae557cc21e89b5$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$46f4e6f775f39bcc$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 8, this.length);
    return $42ae557cc21e89b5$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$46f4e6f775f39bcc$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkOffset(offset, 8, this.length);
    return $42ae557cc21e89b5$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $46f4e6f775f39bcc$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$46f4e6f775f39bcc$var$Buffer.prototype.writeUintLE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $46f4e6f775f39bcc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUintBE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $46f4e6f775f39bcc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint8 = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint16LE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint16BE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint32LE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeUint32BE = $46f4e6f775f39bcc$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $46f4e6f775f39bcc$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $46f4e6f775f39bcc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $46f4e6f775f39bcc$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $46f4e6f775f39bcc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$46f4e6f775f39bcc$var$Buffer.prototype.writeBigUInt64LE = $46f4e6f775f39bcc$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $46f4e6f775f39bcc$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$46f4e6f775f39bcc$var$Buffer.prototype.writeBigUInt64BE = $46f4e6f775f39bcc$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $46f4e6f775f39bcc$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$46f4e6f775f39bcc$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $46f4e6f775f39bcc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $46f4e6f775f39bcc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeBigInt64LE = $46f4e6f775f39bcc$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $46f4e6f775f39bcc$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$46f4e6f775f39bcc$var$Buffer.prototype.writeBigInt64BE = $46f4e6f775f39bcc$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $46f4e6f775f39bcc$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $46f4e6f775f39bcc$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $46f4e6f775f39bcc$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $42ae557cc21e89b5$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$46f4e6f775f39bcc$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $46f4e6f775f39bcc$var$writeFloat(this, value, offset, true, noAssert);
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $46f4e6f775f39bcc$var$writeFloat(this, value, offset, false, noAssert);
};
function $46f4e6f775f39bcc$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46f4e6f775f39bcc$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $42ae557cc21e89b5$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$46f4e6f775f39bcc$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $46f4e6f775f39bcc$var$writeDouble(this, value, offset, true, noAssert);
};
$46f4e6f775f39bcc$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $46f4e6f775f39bcc$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$46f4e6f775f39bcc$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$46f4e6f775f39bcc$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$46f4e6f775f39bcc$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$46f4e6f775f39bcc$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $46f4e6f775f39bcc$var$Buffer.isBuffer(val) ? val : $46f4e6f775f39bcc$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $46f4e6f775f39bcc$var$errors = {};
function $46f4e6f775f39bcc$var$E(sym, getMessage, Base) {
    $46f4e6f775f39bcc$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$46f4e6f775f39bcc$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$46f4e6f775f39bcc$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$46f4e6f775f39bcc$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $46f4e6f775f39bcc$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $46f4e6f775f39bcc$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $46f4e6f775f39bcc$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $46f4e6f775f39bcc$var$checkBounds(buf, offset, byteLength) {
    $46f4e6f775f39bcc$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $46f4e6f775f39bcc$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $46f4e6f775f39bcc$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $46f4e6f775f39bcc$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $46f4e6f775f39bcc$var$checkBounds(buf, offset, byteLength);
}
function $46f4e6f775f39bcc$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $46f4e6f775f39bcc$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $46f4e6f775f39bcc$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $46f4e6f775f39bcc$var$validateNumber(value, type);
        throw new $46f4e6f775f39bcc$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $46f4e6f775f39bcc$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $46f4e6f775f39bcc$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $46f4e6f775f39bcc$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $46f4e6f775f39bcc$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($46f4e6f775f39bcc$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $46f4e6f775f39bcc$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $46f4e6f775f39bcc$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $46f4e6f775f39bcc$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $46f4e6f775f39bcc$var$base64ToBytes(str) {
    return $9c5d6f32ba272209$export$d622b2ad8d90c771($46f4e6f775f39bcc$var$base64clean(str));
}
function $46f4e6f775f39bcc$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $46f4e6f775f39bcc$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $46f4e6f775f39bcc$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $46f4e6f775f39bcc$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $46f4e6f775f39bcc$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $46f4e6f775f39bcc$var$BufferBigIntNotDefined : fn;
}
function $46f4e6f775f39bcc$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $4a53fa63e204171d$require$Buffer = $46f4e6f775f39bcc$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $4a53fa63e204171d$var$isVisitable(thing) {
    return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $4a53fa63e204171d$var$removeBrackets(key) {
    return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $4a53fa63e204171d$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $4a53fa63e204171d$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $4a53fa63e204171d$var$isFlatArray(arr) {
    return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(arr) && !arr.some($4a53fa63e204171d$var$isVisitable);
}
const $4a53fa63e204171d$var$predicates = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).toFlatObject((0, $f3e9057162ef2db7$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $4a53fa63e204171d$var$toFormData(obj, formData, options) {
    if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $d62ba1ad41be4098$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $4a53fa63e204171d$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isReactNative(formData) && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($4a53fa63e204171d$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(value) && $4a53fa63e204171d$var$isFlatArray(value) || ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFileList(value) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $4a53fa63e204171d$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $4a53fa63e204171d$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($4a53fa63e204171d$var$isVisitable(value)) return true;
        formData.append($4a53fa63e204171d$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($4a53fa63e204171d$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $4a53fa63e204171d$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $4a53fa63e204171d$export$2e2bcd8739ae039 = $4a53fa63e204171d$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $86dbef06dac22741$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $86dbef06dac22741$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $4a53fa63e204171d$export$2e2bcd8739ae039)(params, this, options);
}
const $86dbef06dac22741$var$prototype = $86dbef06dac22741$var$AxiosURLSearchParams.prototype;
$86dbef06dac22741$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$86dbef06dac22741$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $86dbef06dac22741$var$encode);
    } : $86dbef06dac22741$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $86dbef06dac22741$export$2e2bcd8739ae039 = $86dbef06dac22741$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $268f44f728a303fa$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $268f44f728a303fa$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $268f44f728a303fa$var$encode;
    const _options = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $86dbef06dac22741$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $49aefdad4dc758e2$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $49aefdad4dc758e2$export$2e2bcd8739ae039 = $49aefdad4dc758e2$var$InterceptorManager;





'use strict';
var $c3d1dec6fbfaafdd$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};








'use strict';
var $9aeaf0641e56d58b$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $86dbef06dac22741$export$2e2bcd8739ae039);


'use strict';
var $cc48ce28a81fe0a7$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $135289c80d670d54$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $9a7113483be2caff$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9aeaf0641e56d58b$export$2e2bcd8739ae039,
        FormData: $cc48ce28a81fe0a7$export$2e2bcd8739ae039,
        Blob: $135289c80d670d54$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $8cdec53657e7933b$exports = {};

$parcel$export($8cdec53657e7933b$exports, "hasBrowserEnv", function () { return $8cdec53657e7933b$export$c4996c4b7b93b0bf; });
$parcel$export($8cdec53657e7933b$exports, "navigator", function () { return $8cdec53657e7933b$export$ec7c8efa7f5790ae; });
$parcel$export($8cdec53657e7933b$exports, "hasStandardBrowserEnv", function () { return $8cdec53657e7933b$export$c0bcc9250309d66; });
$parcel$export($8cdec53657e7933b$exports, "hasStandardBrowserWebWorkerEnv", function () { return $8cdec53657e7933b$export$c81692cf5af97dac; });
$parcel$export($8cdec53657e7933b$exports, "origin", function () { return $8cdec53657e7933b$export$f710a83a91838a36; });
const $8cdec53657e7933b$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $8cdec53657e7933b$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $8cdec53657e7933b$export$c0bcc9250309d66 = $8cdec53657e7933b$export$c4996c4b7b93b0bf && (!$8cdec53657e7933b$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($8cdec53657e7933b$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $8cdec53657e7933b$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $8cdec53657e7933b$export$f710a83a91838a36 = $8cdec53657e7933b$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $ac9d742af613de74$export$2e2bcd8739ae039 = (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, $8cdec53657e7933b$exports, (0, $9a7113483be2caff$export$2e2bcd8739ae039));


'use strict';
function $450b53b6c98f3de6$export$2e2bcd8739ae039(data, options) {
    return (0, $4a53fa63e204171d$export$2e2bcd8739ae039)(data, new (0, $ac9d742af613de74$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({
        visitor: function(value, key, path, helpers) {
            if ((0, $ac9d742af613de74$export$2e2bcd8739ae039).isNode && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $6d775bf3d5be3017$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $6d775bf3d5be3017$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $6d775bf3d5be3017$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $6d775bf3d5be3017$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFormData(formData) && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($6d775bf3d5be3017$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $6d775bf3d5be3017$export$2e2bcd8739ae039 = $6d775bf3d5be3017$var$formDataToJSON;


'use strict';
const $9edd4aac4d64fcab$var$own = (obj, key)=>obj != null && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $9edd4aac4d64fcab$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $9edd4aac4d64fcab$var$defaults = {
    transitional: (0, $c3d1dec6fbfaafdd$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $6d775bf3d5be3017$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isBuffer(data) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isStream(data) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFile(data) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isBlob(data) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $9edd4aac4d64fcab$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $450b53b6c98f3de6$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $9edd4aac4d64fcab$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $4a53fa63e204171d$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $9edd4aac4d64fcab$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $9edd4aac4d64fcab$var$own(this, 'transitional') || $9edd4aac4d64fcab$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $9edd4aac4d64fcab$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isResponse(data) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $9edd4aac4d64fcab$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).from(e, (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $9edd4aac4d64fcab$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $ac9d742af613de74$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $ac9d742af613de74$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $9edd4aac4d64fcab$var$defaults.headers[method] = {};
});
var $9edd4aac4d64fcab$export$2e2bcd8739ae039 = $9edd4aac4d64fcab$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $8c227899d6eccd9b$var$ignoreDuplicateOf = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $8c227899d6eccd9b$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $8c227899d6eccd9b$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $cf89430a6c69b919$var$$internals = Symbol('internals');
const $cf89430a6c69b919$var$INVALID_HEADER_VALUE_CHARS_RE = /[^\x09\x20-\x7E\x80-\xFF]/g;
function $cf89430a6c69b919$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
function $cf89430a6c69b919$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $cf89430a6c69b919$var$sanitizeHeaderValue(str) {
    return $cf89430a6c69b919$var$trimSPorHTAB(str.replace($cf89430a6c69b919$var$INVALID_HEADER_VALUE_CHARS_RE, ''));
}
function $cf89430a6c69b919$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(value) ? value.map($cf89430a6c69b919$var$normalizeValue) : $cf89430a6c69b919$var$sanitizeHeaderValue(String(value));
}
function $cf89430a6c69b919$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $cf89430a6c69b919$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $cf89430a6c69b919$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $cf89430a6c69b919$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $cf89430a6c69b919$var$buildAccessors(obj, header) {
    const accessorName = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $cf89430a6c69b919$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $cf89430a6c69b919$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $cf89430a6c69b919$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$cf89430a6c69b919$var$isValidHeaderName(header)) setHeaders((0, $8c227899d6eccd9b$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isObject(header) && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $cf89430a6c69b919$var$normalizeHeader(header);
        if (header) {
            const key = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $cf89430a6c69b919$var$parseTokens(value);
                if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $cf89430a6c69b919$var$normalizeHeader(header);
        if (header) {
            const key = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $cf89430a6c69b919$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $cf89430a6c69b919$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $cf89430a6c69b919$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $cf89430a6c69b919$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $cf89430a6c69b919$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $cf89430a6c69b919$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $cf89430a6c69b919$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$cf89430a6c69b919$var$$internals] = this[$cf89430a6c69b919$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $cf89430a6c69b919$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $cf89430a6c69b919$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$cf89430a6c69b919$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).reduceDescriptors($cf89430a6c69b919$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).freezeMethods($cf89430a6c69b919$var$AxiosHeaders);
var $cf89430a6c69b919$export$2e2bcd8739ae039 = $cf89430a6c69b919$var$AxiosHeaders;


'use strict';
function $cc5547703f7ac620$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $9edd4aac4d64fcab$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $cf89430a6c69b919$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $048bfeb3954ab572$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $2b69ea0f9449ba85$var$CanceledError extends (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $2b69ea0f9449ba85$export$2e2bcd8739ae039 = $2b69ea0f9449ba85$var$CanceledError;







'use strict';
function $062c49b1bcfdf32e$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $1fbbc4935da7ca8e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0e9bf8256e6ff732$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0e9bf8256e6ff732$export$2e2bcd8739ae039 = $0e9bf8256e6ff732$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $8f68884d4bd80a9a$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $8f68884d4bd80a9a$export$2e2bcd8739ae039 = $8f68884d4bd80a9a$var$throttle;



const $dbec198340202d17$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $0e9bf8256e6ff732$export$2e2bcd8739ae039)(50, 250);
    return (0, $8f68884d4bd80a9a$export$2e2bcd8739ae039)((e)=>{
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $dbec198340202d17$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $dbec198340202d17$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $228314bde0320583$export$2e2bcd8739ae039 = (0, $ac9d742af613de74$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $ac9d742af613de74$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $ac9d742af613de74$export$2e2bcd8739ae039).origin), (0, $ac9d742af613de74$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $ac9d742af613de74$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $4b8290b90213285a$export$2e2bcd8739ae039 = (0, $ac9d742af613de74$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $c3b0192922a69033$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $89b854a7009f2b89$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $d0418f47bf916ae5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $c3b0192922a69033$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $89b854a7009f2b89$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





'use strict';
const $7082e6945216db1b$var$headersToObject = (thing)=>thing instanceof (0, $cf89430a6c69b919$export$2e2bcd8739ae039) ? (0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, thing) : thing;
function $7082e6945216db1b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype
    // (see GHSA-q8qp-cvcw-x6jj). `hasOwnProperty` is restored as a non-enumerable
    // own slot to preserve ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isPlainObject(target) && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($7082e6945216db1b$var$headersToObject(a), $7082e6945216db1b$var$headersToObject(b), prop, true)
    };
    (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach(Object.keys((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $0deae8574a585f3d$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $7082e6945216db1b$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com'). See GHSA-q8qp-cvcw-x6jj.
    const own = (key)=>(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $cf89430a6c69b919$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $268f44f728a303fa$export$2e2bcd8739ae039)((0, $d0418f47bf916ae5$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $ac9d742af613de74$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $ac9d742af613de74$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $ac9d742af613de74$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin. See GHSA-xx6v-rp6x-q39c.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $228314bde0320583$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $4b8290b90213285a$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $50cebd336b2b3bfe$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $50cebd336b2b3bfe$export$2e2bcd8739ae039 = $50cebd336b2b3bfe$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $0deae8574a585f3d$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $cf89430a6c69b919$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $cf89430a6c69b919$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $062c49b1bcfdf32e$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('Request aborted', (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)(msg, (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $c3d1dec6fbfaafdd$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ETIMEDOUT : (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $dbec198340202d17$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $dbec198340202d17$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $2b69ea0f9449ba85$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $1fbbc4935da7ca8e$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $ac9d742af613de74$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};










const $22704df088ddcdb3$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039) ? err : new (0, $2b69ea0f9449ba85$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $22704df088ddcdb3$export$2e2bcd8739ae039 = $22704df088ddcdb3$var$composeSignals;


const $0828c0190ef331fb$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $0828c0190ef331fb$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $0828c0190ef331fb$var$readStream(iterable))yield* $0828c0190ef331fb$export$71b051935044bd5d(chunk, chunkSize);
};
const $0828c0190ef331fb$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $0828c0190ef331fb$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $0828c0190ef331fb$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $5f85901ed2cd3bea$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $5f85901ed2cd3bea$var$isFunction } = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039);
const $5f85901ed2cd3bea$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).global);
const { ReadableStream: $5f85901ed2cd3bea$var$ReadableStream, TextEncoder: $5f85901ed2cd3bea$var$TextEncoder } = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).global;
const $5f85901ed2cd3bea$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $5f85901ed2cd3bea$var$factory = (env)=>{
    env = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $5f85901ed2cd3bea$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $5f85901ed2cd3bea$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $5f85901ed2cd3bea$var$isFunction(Request);
    const isResponseSupported = $5f85901ed2cd3bea$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $5f85901ed2cd3bea$var$isFunction($5f85901ed2cd3bea$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $5f85901ed2cd3bea$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $5f85901ed2cd3bea$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $5f85901ed2cd3bea$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $ac9d742af613de74$export$2e2bcd8739ae039).origin, {
            body: new $5f85901ed2cd3bea$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $5f85901ed2cd3bea$var$test(()=>(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $ac9d742af613de74$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $0deae8574a585f3d$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $22704df088ddcdb3$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $dbec198340202d17$export$d9fadd12586c18d6)(requestContentLength, (0, $dbec198340202d17$export$c1b28109d46c3592)((0, $dbec198340202d17$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $0828c0190ef331fb$export$b0119225647bd83)(_request.body, $5f85901ed2cd3bea$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            const resolvedOptions = (0, $3abb53145a9155ce$export$71511d61b312f219)((0, $c9ae1c59a9c2cb2f$export$71511d61b312f219)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $dbec198340202d17$export$d9fadd12586c18d6)(responseContentLength, (0, $dbec198340202d17$export$c1b28109d46c3592)((0, $dbec198340202d17$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $0828c0190ef331fb$export$b0119225647bd83)(response.body, $5f85901ed2cd3bea$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $062c49b1bcfdf32e$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $cf89430a6c69b919$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('Network Error', (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $5f85901ed2cd3bea$var$seedCache = new Map();
const $5f85901ed2cd3bea$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $5f85901ed2cd3bea$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $5f85901ed2cd3bea$var$factory(env));
        map = target;
    }
    return target;
};
const $5f85901ed2cd3bea$var$adapter = $5f85901ed2cd3bea$export$3105c6651375d4fa();
var $5f85901ed2cd3bea$export$2e2bcd8739ae039 = $5f85901ed2cd3bea$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $26c229a6563be6c6$var$knownAdapters = {
    http: (0, $d62ba1ad41be4098$export$2e2bcd8739ae039),
    xhr: (0, $50cebd336b2b3bfe$export$2e2bcd8739ae039),
    fetch: {
        get: $5f85901ed2cd3bea$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach($26c229a6563be6c6$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $26c229a6563be6c6$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $26c229a6563be6c6$var$isResolvedHandle = (adapter)=>(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $26c229a6563be6c6$var$getAdapter(adapters, config) {
    adapters = (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$26c229a6563be6c6$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $26c229a6563be6c6$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($26c229a6563be6c6$var$renderReason).join('\n') : ' ' + $26c229a6563be6c6$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $26c229a6563be6c6$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $26c229a6563be6c6$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $26c229a6563be6c6$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $c9bef082d2424465$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $2b69ea0f9449ba85$export$2e2bcd8739ae039)(null, config);
}
function $c9bef082d2424465$export$2e2bcd8739ae039(config) {
    $c9bef082d2424465$var$throwIfCancellationRequested(config);
    config.headers = (0, $cf89430a6c69b919$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $cc5547703f7ac620$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $26c229a6563be6c6$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $9edd4aac4d64fcab$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $c9bef082d2424465$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $cc5547703f7ac620$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $cf89430a6c69b919$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $048bfeb3954ab572$export$2e2bcd8739ae039)(reason)) {
            $c9bef082d2424465$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $cc5547703f7ac620$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $cf89430a6c69b919$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $74a866ff11348a8c$export$a4ad2735b021c132 = "1.15.2";



'use strict';
const $ed85e72b05eb59c9$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $ed85e72b05eb59c9$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $ed85e72b05eb59c9$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $ed85e72b05eb59c9$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $74a866ff11348a8c$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$ed85e72b05eb59c9$var$deprecatedWarnings[opt]) {
            $ed85e72b05eb59c9$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$ed85e72b05eb59c9$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $ed85e72b05eb59c9$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('options must be an object', (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError. See GHSA-q8qp-cvcw-x6jj.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $ed85e72b05eb59c9$export$2e2bcd8739ae039 = {
    assertOptions: $ed85e72b05eb59c9$var$assertOptions,
    validators: $ed85e72b05eb59c9$var$validators
};




'use strict';
const $3eaaaf774d15f6a6$var$validators = (0, $ed85e72b05eb59c9$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $3eaaaf774d15f6a6$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $7082e6945216db1b$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $ed85e72b05eb59c9$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $3eaaaf774d15f6a6$var$validators.transitional($3eaaaf774d15f6a6$var$validators.boolean),
            forcedJSONParsing: $3eaaaf774d15f6a6$var$validators.transitional($3eaaaf774d15f6a6$var$validators.boolean),
            clarifyTimeoutError: $3eaaaf774d15f6a6$var$validators.transitional($3eaaaf774d15f6a6$var$validators.boolean),
            legacyInterceptorReqResOrdering: $3eaaaf774d15f6a6$var$validators.transitional($3eaaaf774d15f6a6$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $ed85e72b05eb59c9$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $3eaaaf774d15f6a6$var$validators.function,
                serialize: $3eaaaf774d15f6a6$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $ed85e72b05eb59c9$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $3eaaaf774d15f6a6$var$validators.spelling('baseURL'),
            withXsrfToken: $3eaaaf774d15f6a6$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $cf89430a6c69b919$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $c3d1dec6fbfaafdd$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $c9bef082d2424465$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $c9bef082d2424465$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $7082e6945216db1b$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $d0418f47bf916ae5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $268f44f728a303fa$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $49aefdad4dc758e2$export$2e2bcd8739ae039)(),
            response: new (0, $49aefdad4dc758e2$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $3eaaaf774d15f6a6$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $7082e6945216db1b$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $f3e9057162ef2db7$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $7082e6945216db1b$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $3eaaaf774d15f6a6$var$Axios.prototype[method] = generateHTTPMethod();
    $3eaaaf774d15f6a6$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $3eaaaf774d15f6a6$export$2e2bcd8739ae039 = $3eaaaf774d15f6a6$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $e1e778ac79a2992a$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $e1e778ac79a2992a$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $2b69ea0f9449ba85$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $e1e778ac79a2992a$export$2e2bcd8739ae039 = $e1e778ac79a2992a$var$CancelToken;






'use strict';
function $439121a70726764a$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $c33fe872cc0e4517$export$2e2bcd8739ae039(payload) {
    return (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $feb30eb39d6c7984$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($feb30eb39d6c7984$var$HttpStatusCode).forEach(([key, value])=>{
    $feb30eb39d6c7984$var$HttpStatusCode[value] = key;
});
var $feb30eb39d6c7984$export$2e2bcd8739ae039 = $feb30eb39d6c7984$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $b0d63a15c4f58406$var$createInstance(defaultConfig) {
    const context = new (0, $3eaaaf774d15f6a6$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $f447dd3acd4e15d9$export$2e2bcd8739ae039)((0, $3eaaaf774d15f6a6$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).extend(instance, (0, $3eaaaf774d15f6a6$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $f3e9057162ef2db7$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $b0d63a15c4f58406$var$createInstance((0, $7082e6945216db1b$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $b0d63a15c4f58406$var$axios = $b0d63a15c4f58406$var$createInstance((0, $9edd4aac4d64fcab$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$b0d63a15c4f58406$var$axios.Axios = (0, $3eaaaf774d15f6a6$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$b0d63a15c4f58406$var$axios.CanceledError = (0, $2b69ea0f9449ba85$export$2e2bcd8739ae039);
$b0d63a15c4f58406$var$axios.CancelToken = (0, $e1e778ac79a2992a$export$2e2bcd8739ae039);
$b0d63a15c4f58406$var$axios.isCancel = (0, $048bfeb3954ab572$export$2e2bcd8739ae039);
$b0d63a15c4f58406$var$axios.VERSION = (0, $74a866ff11348a8c$export$a4ad2735b021c132);
$b0d63a15c4f58406$var$axios.toFormData = (0, $4a53fa63e204171d$export$2e2bcd8739ae039);
// Expose AxiosError class
$b0d63a15c4f58406$var$axios.AxiosError = (0, $f6bb2823c2fb0c18$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$b0d63a15c4f58406$var$axios.Cancel = $b0d63a15c4f58406$var$axios.CanceledError;
// Expose all/spread
$b0d63a15c4f58406$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$b0d63a15c4f58406$var$axios.spread = (0, $439121a70726764a$export$2e2bcd8739ae039);
// Expose isAxiosError
$b0d63a15c4f58406$var$axios.isAxiosError = (0, $c33fe872cc0e4517$export$2e2bcd8739ae039);
// Expose mergeConfig
$b0d63a15c4f58406$var$axios.mergeConfig = (0, $7082e6945216db1b$export$2e2bcd8739ae039);
$b0d63a15c4f58406$var$axios.AxiosHeaders = (0, $cf89430a6c69b919$export$2e2bcd8739ae039);
$b0d63a15c4f58406$var$axios.formToJSON = (thing)=>(0, $6d775bf3d5be3017$export$2e2bcd8739ae039)((0, $f3e9057162ef2db7$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$b0d63a15c4f58406$var$axios.getAdapter = (0, $26c229a6563be6c6$export$2e2bcd8739ae039).getAdapter;
$b0d63a15c4f58406$var$axios.HttpStatusCode = (0, $feb30eb39d6c7984$export$2e2bcd8739ae039);
$b0d63a15c4f58406$var$axios.default = $b0d63a15c4f58406$var$axios;
var // this module should only have a default export
$b0d63a15c4f58406$export$2e2bcd8739ae039 = $b0d63a15c4f58406$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $45c9ee20de9f1526$export$1c00760e9e5a4e95, AxiosError: $45c9ee20de9f1526$export$c1fbed17c2f6a328, CanceledError: $45c9ee20de9f1526$export$1ab0c6b20d94fa14, isCancel: $45c9ee20de9f1526$export$3b22524397b493c6, CancelToken: $45c9ee20de9f1526$export$fd08e3cb425f0d61, VERSION: $45c9ee20de9f1526$export$a4ad2735b021c132, all: $45c9ee20de9f1526$export$84bf76cd7afc7469, Cancel: $45c9ee20de9f1526$export$848c9b7ead0df967, isAxiosError: $45c9ee20de9f1526$export$fbafdbe06a5b5a9a, spread: $45c9ee20de9f1526$export$3ae0fd4797ed47c8, toFormData: $45c9ee20de9f1526$export$10ae0d317ea97f8b, AxiosHeaders: $45c9ee20de9f1526$export$4e7d6ff0f3e6520, HttpStatusCode: $45c9ee20de9f1526$export$a972f69c851492b3, formToJSON: $45c9ee20de9f1526$export$86d7c59254d6a2c9, getAdapter: $45c9ee20de9f1526$export$17ddc20a97d669e2, mergeConfig: $45c9ee20de9f1526$export$7ec1ebcfa9d8bd6a } = (0, $b0d63a15c4f58406$export$2e2bcd8739ae039);



var $cQNHH = parcelRequire("cQNHH");

const $3a41811dd1249fd3$var$ImagePreview = (props)=>{
    const { addImages: wsAddImages } = (0, $40a70c7aae85df93$export$ef4944d05bd3db0)();
    const [progressText, setProgressText] = (0, $cQNHH.useState)('');
    const [saving, setSaving] = (0, $cQNHH.useState)(false);
    const [saved, setSaved] = (0, $cQNHH.useState)(false);
    /** images_uuid must be an array - sends via WebSocket */ const addImages = (id, id_lieu, images_uuid)=>{
        try {
            wsAddImages(id, id_lieu, images_uuid);
            setProgressText("Photo compl\xe9tement enregistr\xe9e");
            setSaved(true);
        } catch (error) {
            console.log('Error adding images:', error);
            setProgressText("Erreur pendant l'attribution de l'image");
        }
    };
    const dataURLtoFile = (dataurl, filename)=>{
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while(n){
            u8arr[n - 1] = bstr.charCodeAt(n - 1);
            n -= 1 // to make eslint happy
            ;
        }
        return new File([
            u8arr
        ], filename, {
            type: mime
        });
    };
    const saveImage = (apikey, dataUri, id, id_lieu)=>{
        const file = dataURLtoFile(dataUri, 'newfile');
        const data = new FormData();
        data.append('images[]', file, file.name);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        setProgressText("Envoi de l'image sur le serveur");
        setSaving(true);
        (0, $b0d63a15c4f58406$export$2e2bcd8739ae039).postForm($d0560eaae19deb97$export$739733bcb6130343 + '/api/imagesproxy.php', data, config).then((response)=>{
            console.log('response %o', response);
            console.log('uuid ' + response.data.uuid[0]);
            setProgressText("Attribution de l'image au bulletin correspondant");
            addImages(id, id_lieu, response.data.uuid);
        }).catch((error)=>{
            console.log('error %o', error);
            setProgressText('Erreur de transfert ', error);
            setSaving(false);
        });
    };
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)("div", {
                className: "d-flex flex-row justify-content-start align-items-center",
                children: [
                    !saving && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                className: "p-2",
                                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $6ac1e09dec856e2e$export$2e2bcd8739ae039), {
                                    variant: "danger",
                                    size: "lg",
                                    onClick: ()=>props.setDataUri(''),
                                    children: "Recommencer"
                                })
                            }),
                            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                                className: "p-2",
                                children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $6ac1e09dec856e2e$export$2e2bcd8739ae039), {
                                    variant: "success",
                                    size: "lg",
                                    onClick: ()=>saveImage(props.apikey, props.dataUri, props.id, props.id_lieu),
                                    children: "Enregistrer la photo"
                                })
                            })
                        ]
                    }),
                    saved && /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $716072e90fe46d73$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                            className: "p-2",
                            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $6ac1e09dec856e2e$export$2e2bcd8739ae039), {
                                variant: "primary",
                                size: "lg",
                                onClick: ()=>{
                                    props.setDataUri('');
                                    setSaved(false);
                                    setSaving(false);
                                },
                                children: "Ajouter une autre photo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)("div", {
                        className: "p-2 flex-grow-1",
                        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $629fe0b1bdf276d1$export$2e2bcd8739ae039), {
                            variant: "info",
                            className: "mb-0",
                            children: [
                                "Etat : ",
                                progressText
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $76e4a1ba004aadc7$export$2e2bcd8739ae039), {
                src: props.dataUri,
                fluid: true
            }),
            ' '
        ]
    });
};
$3a41811dd1249fd3$var$ImagePreview.propTypes = {
    dataUri: (0, (/*@__PURE__*/$parcel$interopDefault($11f8a89d85a36f13$exports))).string
};
var $3a41811dd1249fd3$export$2e2bcd8739ae039 = $3a41811dd1249fd3$var$ImagePreview;


const $fabe5ee8a1fb5ebb$var$CameraPage = ()=>{
    const [dataUri, setDataUri] = (0, $cQNHH.useState)('');
    const location = (0, $0426bdd60799df9e$export$45d76561a5302f2b)();
    function handleTakePhoto(dataUri) {
        setDataUri(dataUri);
    }
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $e436d619efaf7134$export$2e2bcd8739ae039), {
        fluid: "xl",
        className: "mt-4",
        children: dataUri ? /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $716072e90fe46d73$exports.Fragment), {
            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $3a41811dd1249fd3$export$2e2bcd8739ae039), {
                dataUri: dataUri,
                setDataUri: setDataUri,
                id: location.state.id,
                id_lieu: location.state.id_lieu,
                apikey: location.state.apikey
            })
        }) : /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2d451a4cdf0d942d$exports))), {
            onTakePhoto: (dataUri)=>{
                handleTakePhoto(dataUri);
            },
            idealFacingMode: (0, $2d451a4cdf0d942d$exports.FACING_MODES).ENVIRONMENT,
            isMaxResolution: true,
            imageCompression: 0.6
        })
    });
};
var $fabe5ee8a1fb5ebb$export$2e2bcd8739ae039 = $fabe5ee8a1fb5ebb$var$CameraPage;



const $7f43f642c5f7bfaa$var$App = ()=>{
    const [apikey, setApikey] = (0, $cQNHH.useState)(localStorage.getItem('apikey'));
    const manualApikey = (e)=>{
        e.preventDefault();
        let userKey = prompt('apikey', apikey ? apikey : '');
        if (userKey != null && userKey.length == 13) {
            localStorage.setItem('apikey', userKey);
            setApikey(userKey);
        // WebSocket will reconnect automatically via useEffect in WebSocketProvider
        }
    };
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $40a70c7aae85df93$export$bfafe629242f30bd), {
        apikey: apikey,
        children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $a77787966cb87b36$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)($7f43f642c5f7bfaa$var$AppContent, {
                apikey: apikey,
                manualApikey: manualApikey
            })
        })
    });
};
const $7f43f642c5f7bfaa$var$AppContent = ({ apikey: apikey, manualApikey: manualApikey })=>{
    const { config: config, connectionState: connectionState, error: error } = (0, $40a70c7aae85df93$export$ef4944d05bd3db0)();
    const [sentinel, setSentinel] = (0, $cQNHH.useState)(null);
    // Derive oldData from connection state
    const oldData = connectionState !== 'connected';
    const machineName = config.name;
    let wakeLock = null;
    (0, $cQNHH.useEffect)(()=>{
        requireWakeLock();
    }, []);
    function requireWakeLock() {
        if (!navigator.wakeLock) {
            console.log('WakeLock API non disponible');
            return;
        }
        wakeLock = navigator.wakeLock.request('screen').then((res)=>setSentinel(res));
        console.log('wakelock promise : %o', wakeLock);
    }
    return /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $716072e90fe46d73$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $b77c9cd1ab7710c3$export$2e2bcd8739ae039), {
                oldData: oldData,
                apikey: apikey,
                manualApikey: manualApikey,
                machineName: machineName,
                sentinel: sentinel,
                connectionState: connectionState
            }),
            /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsxs)((0, $0426bdd60799df9e$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $0426bdd60799df9e$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $6a772d7f25f6a077$export$2e2bcd8739ae039), {
                            apikey: apikey,
                            error: error
                        })
                    }),
                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $0426bdd60799df9e$export$e7b0ac011bb776c6), {
                        path: "/photos",
                        element: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $c5de6da1aa9d12a8$export$2e2bcd8739ae039), {
                            apikey: apikey
                        })
                    }),
                    /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $0426bdd60799df9e$export$e7b0ac011bb776c6), {
                        path: "/camera",
                        element: /*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $fabe5ee8a1fb5ebb$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $7f43f642c5f7bfaa$export$2e2bcd8739ae039 = $7f43f642c5f7bfaa$var$App;



const $242b7cedb0c1491e$var$container = document.getElementById('root');
const $242b7cedb0c1491e$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($0e5729790c839e67$exports))).createRoot($242b7cedb0c1491e$var$container);
$242b7cedb0c1491e$var$root.render(/*#__PURE__*/ (0, $716072e90fe46d73$exports.jsx)((0, $7f43f642c5f7bfaa$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=html.4edc8820.js.map
